var _regeneratorRuntime = require("/buddy/table512ans/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");
module.exports = function (t) {
  var e = {};
  function i(s) {
    if (e[s]) return e[s].exports;
    var o = e[s] = {
      i: s,
      l: !1,
      exports: {}
    };
    return t[s].call(o.exports, o, o.exports, i), o.l = !0, o.exports;
  }
  return i.m = t, i.c = e, i.d = function (t, e, s) {
    i.o(t, e) || Object.defineProperty(t, e, {
      enumerable: !0,
      get: s
    });
  }, i.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, i.t = function (t, e) {
    if (1 & e && (t = i(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var s = Object.create(null);
    if (i.r(s), Object.defineProperty(s, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var o in t) i.d(s, o, function (e) {
      return t[e];
    }.bind(null, o));
    return s;
  }, i.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };
    return i.d(e, "a", e), e;
  }, i.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, i.p = "", i(i.s = 5);
}([function (t, e, i) {
  t.exports = i(3)();
}, function (t, e, i) {
  !function (t) {
    "use strict";

    function e(t, e) {
      return void 0 !== t ? t : e;
    }
    const i = 1e37,
      s = 1e-5,
      o = s * s,
      n = 3.14159265359,
      r = 2,
      a = 8,
      l = .1,
      m = 2,
      h = .008,
      _ = 2 / 180 * n,
      c = 2 * h,
      u = 8,
      d = 32,
      p = 1,
      f = .2,
      y = 8 / 180 * n,
      x = 2,
      B = x * x,
      S = .5 * n,
      b = S * S,
      A = .2,
      C = .75,
      V = -1,
      g = .75,
      w = 1,
      v = .25,
      M = .5,
      P = 4,
      I = 256,
      G = 2.5,
      D = .5,
      F = .01,
      T = 2 / 180 * n;
    class L {
      constructor() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        let i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        this.major = 0, this.minor = 0, this.revision = 0, this.major = t, this.minor = e, this.revision = i;
      }
      toString() {
        return this.major + "." + this.minor + "." + this.revision;
      }
    }
    const R = new L(2, 3, 2);
    function k(t, e) {
      const i = [];
      for (let s = 0; s < t; ++s) i.push(e(s));
      return i;
    }
    function q(t) {
      let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      const i = [];
      for (let s = 0; s < t; ++s) i.push(e);
      return i;
    }
    const z = n / 180,
      E = 180 / n,
      J = 2 * n,
      O = Math.abs,
      j = Math.min,
      N = Math.max;
    function X(t, e, i) {
      return t < e ? e : t > i ? i : t;
    }
    const U = isFinite;
    function W(t) {
      return t * t;
    }
    function Z(t) {
      return 1 / Math.sqrt(t);
    }
    const H = Math.sqrt,
      Q = Math.pow,
      Y = Math.cos,
      K = Math.sin,
      $ = Math.acos,
      tt = Math.asin,
      et = Math.atan2;
    class it {
      constructor() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        this.x = t, this.y = e;
      }
      Clone() {
        return new it(this.x, this.y);
      }
      SetZero() {
        return this.x = 0, this.y = 0, this;
      }
      Set(t, e) {
        return this.x = t, this.y = e, this;
      }
      Copy(t) {
        return this.x = t.x, this.y = t.y, this;
      }
      SelfAdd(t) {
        return this.x += t.x, this.y += t.y, this;
      }
      SelfAddXY(t, e) {
        return this.x += t, this.y += e, this;
      }
      SelfSub(t) {
        return this.x -= t.x, this.y -= t.y, this;
      }
      SelfSubXY(t, e) {
        return this.x -= t, this.y -= e, this;
      }
      SelfMul(t) {
        return this.x *= t, this.y *= t, this;
      }
      SelfMulAdd(t, e) {
        return this.x += t * e.x, this.y += t * e.y, this;
      }
      SelfMulSub(t, e) {
        return this.x -= t * e.x, this.y -= t * e.y, this;
      }
      Dot(t) {
        return this.x * t.x + this.y * t.y;
      }
      Cross(t) {
        return this.x * t.y - this.y * t.x;
      }
      Length() {
        const t = this.x,
          e = this.y;
        return Math.sqrt(t * t + e * e);
      }
      LengthSquared() {
        const t = this.x,
          e = this.y;
        return t * t + e * e;
      }
      Normalize() {
        const t = this.Length();
        if (t >= s) {
          const e = 1 / t;
          this.x *= e, this.y *= e;
        }
        return t;
      }
      SelfNormalize() {
        const t = this.Length();
        if (t >= s) {
          const e = 1 / t;
          this.x *= e, this.y *= e;
        }
        return this;
      }
      SelfRotate(t) {
        const e = Math.cos(t),
          i = Math.sin(t),
          s = this.x;
        return this.x = e * s - i * this.y, this.y = i * s + e * this.y, this;
      }
      SelfRotateCosSin(t, e) {
        const i = this.x;
        return this.x = t * i - e * this.y, this.y = e * i + t * this.y, this;
      }
      IsValid() {
        return isFinite(this.x) && isFinite(this.y);
      }
      SelfCrossVS(t) {
        const e = this.x;
        return this.x = t * this.y, this.y = -t * e, this;
      }
      SelfCrossSV(t) {
        const e = this.x;
        return this.x = -t * this.y, this.y = t * e, this;
      }
      SelfMinV(t) {
        return this.x = j(this.x, t.x), this.y = j(this.y, t.y), this;
      }
      SelfMaxV(t) {
        return this.x = N(this.x, t.x), this.y = N(this.y, t.y), this;
      }
      SelfAbs() {
        return this.x = O(this.x), this.y = O(this.y), this;
      }
      SelfNeg() {
        return this.x = -this.x, this.y = -this.y, this;
      }
      SelfSkew() {
        const t = this.x;
        return this.x = -this.y, this.y = t, this;
      }
      static MakeArray(t) {
        return k(t, t => new it());
      }
      static AbsV(t, e) {
        return e.x = O(t.x), e.y = O(t.y), e;
      }
      static MinV(t, e, i) {
        return i.x = j(t.x, e.x), i.y = j(t.y, e.y), i;
      }
      static MaxV(t, e, i) {
        return i.x = N(t.x, e.x), i.y = N(t.y, e.y), i;
      }
      static ClampV(t, e, i, s) {
        return s.x = X(t.x, e.x, i.x), s.y = X(t.y, e.y, i.y), s;
      }
      static RotateV(t, e, i) {
        const s = t.x,
          o = t.y,
          n = Math.cos(e),
          r = Math.sin(e);
        return i.x = n * s - r * o, i.y = r * s + n * o, i;
      }
      static DotVV(t, e) {
        return t.x * e.x + t.y * e.y;
      }
      static CrossVV(t, e) {
        return t.x * e.y - t.y * e.x;
      }
      static CrossVS(t, e, i) {
        const s = t.x;
        return i.x = e * t.y, i.y = -e * s, i;
      }
      static CrossVOne(t, e) {
        const i = t.x;
        return e.x = t.y, e.y = -i, e;
      }
      static CrossSV(t, e, i) {
        const s = e.x;
        return i.x = -t * e.y, i.y = t * s, i;
      }
      static CrossOneV(t, e) {
        const i = t.x;
        return e.x = -t.y, e.y = i, e;
      }
      static AddVV(t, e, i) {
        return i.x = t.x + e.x, i.y = t.y + e.y, i;
      }
      static SubVV(t, e, i) {
        return i.x = t.x - e.x, i.y = t.y - e.y, i;
      }
      static MulSV(t, e, i) {
        return i.x = e.x * t, i.y = e.y * t, i;
      }
      static MulVS(t, e, i) {
        return i.x = t.x * e, i.y = t.y * e, i;
      }
      static AddVMulSV(t, e, i, s) {
        return s.x = t.x + e * i.x, s.y = t.y + e * i.y, s;
      }
      static SubVMulSV(t, e, i, s) {
        return s.x = t.x - e * i.x, s.y = t.y - e * i.y, s;
      }
      static AddVCrossSV(t, e, i, s) {
        const o = i.x;
        return s.x = t.x - e * i.y, s.y = t.y + e * o, s;
      }
      static MidVV(t, e, i) {
        return i.x = .5 * (t.x + e.x), i.y = .5 * (t.y + e.y), i;
      }
      static ExtVV(t, e, i) {
        return i.x = .5 * (e.x - t.x), i.y = .5 * (e.y - t.y), i;
      }
      static IsEqualToV(t, e) {
        return t.x === e.x && t.y === e.y;
      }
      static DistanceVV(t, e) {
        const i = t.x - e.x,
          s = t.y - e.y;
        return Math.sqrt(i * i + s * s);
      }
      static DistanceSquaredVV(t, e) {
        const i = t.x - e.x,
          s = t.y - e.y;
        return i * i + s * s;
      }
      static NegV(t, e) {
        return e.x = -t.x, e.y = -t.y, e;
      }
    }
    it.ZERO = new it(0, 0), it.UNITX = new it(1, 0), it.UNITY = new it(0, 1), it.s_t0 = new it(), it.s_t1 = new it(), it.s_t2 = new it(), it.s_t3 = new it();
    const st = new it(0, 0);
    class ot {
      constructor() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        let i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        this.x = t, this.y = e, this.z = i;
      }
      Clone() {
        return new ot(this.x, this.y, this.z);
      }
      SetZero() {
        return this.x = 0, this.y = 0, this.z = 0, this;
      }
      SetXYZ(t, e, i) {
        return this.x = t, this.y = e, this.z = i, this;
      }
      Copy(t) {
        return this.x = t.x, this.y = t.y, this.z = t.z, this;
      }
      SelfNeg() {
        return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
      }
      SelfAdd(t) {
        return this.x += t.x, this.y += t.y, this.z += t.z, this;
      }
      SelfAddXYZ(t, e, i) {
        return this.x += t, this.y += e, this.z += i, this;
      }
      SelfSub(t) {
        return this.x -= t.x, this.y -= t.y, this.z -= t.z, this;
      }
      SelfSubXYZ(t, e, i) {
        return this.x -= t, this.y -= e, this.z -= i, this;
      }
      SelfMul(t) {
        return this.x *= t, this.y *= t, this.z *= t, this;
      }
      static DotV3V3(t, e) {
        return t.x * e.x + t.y * e.y + t.z * e.z;
      }
      static CrossV3V3(t, e, i) {
        const s = t.x,
          o = t.y,
          n = t.z,
          r = e.x,
          a = e.y,
          l = e.z;
        return i.x = o * l - n * a, i.y = n * r - s * l, i.z = s * a - o * r, i;
      }
    }
    ot.ZERO = new ot(0, 0, 0), ot.s_t0 = new ot();
    class nt {
      constructor() {
        this.ex = new it(1, 0), this.ey = new it(0, 1);
      }
      Clone() {
        return new nt().Copy(this);
      }
      static FromVV(t, e) {
        return new nt().SetVV(t, e);
      }
      static FromSSSS(t, e, i, s) {
        return new nt().SetSSSS(t, e, i, s);
      }
      static FromAngle(t) {
        return new nt().SetAngle(t);
      }
      SetSSSS(t, e, i, s) {
        return this.ex.Set(t, i), this.ey.Set(e, s), this;
      }
      SetVV(t, e) {
        return this.ex.Copy(t), this.ey.Copy(e), this;
      }
      SetAngle(t) {
        const e = Math.cos(t),
          i = Math.sin(t);
        return this.ex.Set(e, i), this.ey.Set(-i, e), this;
      }
      Copy(t) {
        return this.ex.Copy(t.ex), this.ey.Copy(t.ey), this;
      }
      SetIdentity() {
        return this.ex.Set(1, 0), this.ey.Set(0, 1), this;
      }
      SetZero() {
        return this.ex.SetZero(), this.ey.SetZero(), this;
      }
      GetAngle() {
        return Math.atan2(this.ex.y, this.ex.x);
      }
      GetInverse(t) {
        const e = this.ex.x,
          i = this.ey.x,
          s = this.ex.y,
          o = this.ey.y;
        let n = e * o - i * s;
        return 0 !== n && (n = 1 / n), t.ex.x = n * o, t.ey.x = -n * i, t.ex.y = -n * s, t.ey.y = n * e, t;
      }
      Solve(t, e, i) {
        const s = this.ex.x,
          o = this.ey.x,
          n = this.ex.y,
          r = this.ey.y;
        let a = s * r - o * n;
        return 0 !== a && (a = 1 / a), i.x = a * (r * t - o * e), i.y = a * (s * e - n * t), i;
      }
      SelfAbs() {
        return this.ex.SelfAbs(), this.ey.SelfAbs(), this;
      }
      SelfInv() {
        return this.GetInverse(this), this;
      }
      SelfAddM(t) {
        return this.ex.SelfAdd(t.ex), this.ey.SelfAdd(t.ey), this;
      }
      SelfSubM(t) {
        return this.ex.SelfSub(t.ex), this.ey.SelfSub(t.ey), this;
      }
      static AbsM(t, e) {
        const i = t.ex,
          s = t.ey;
        return e.ex.x = O(i.x), e.ex.y = O(i.y), e.ey.x = O(s.x), e.ey.y = O(s.y), e;
      }
      static MulMV(t, e, i) {
        const s = t.ex,
          o = t.ey,
          n = e.x,
          r = e.y;
        return i.x = s.x * n + o.x * r, i.y = s.y * n + o.y * r, i;
      }
      static MulTMV(t, e, i) {
        const s = t.ex,
          o = t.ey,
          n = e.x,
          r = e.y;
        return i.x = s.x * n + s.y * r, i.y = o.x * n + o.y * r, i;
      }
      static AddMM(t, e, i) {
        const s = t.ex,
          o = t.ey,
          n = e.ex,
          r = e.ey;
        return i.ex.x = s.x + n.x, i.ex.y = s.y + n.y, i.ey.x = o.x + r.x, i.ey.y = o.y + r.y, i;
      }
      static MulMM(t, e, i) {
        const s = t.ex.x,
          o = t.ex.y,
          n = t.ey.x,
          r = t.ey.y,
          a = e.ex.x,
          l = e.ex.y,
          m = e.ey.x,
          h = e.ey.y;
        return i.ex.x = s * a + n * l, i.ex.y = o * a + r * l, i.ey.x = s * m + n * h, i.ey.y = o * m + r * h, i;
      }
      static MulTMM(t, e, i) {
        const s = t.ex.x,
          o = t.ex.y,
          n = t.ey.x,
          r = t.ey.y,
          a = e.ex.x,
          l = e.ex.y,
          m = e.ey.x,
          h = e.ey.y;
        return i.ex.x = s * a + o * l, i.ex.y = n * a + r * l, i.ey.x = s * m + o * h, i.ey.y = n * m + r * h, i;
      }
    }
    nt.IDENTITY = new nt();
    class rt {
      constructor() {
        this.ex = new ot(1, 0, 0), this.ey = new ot(0, 1, 0), this.ez = new ot(0, 0, 1);
      }
      Clone() {
        return new rt().Copy(this);
      }
      SetVVV(t, e, i) {
        return this.ex.Copy(t), this.ey.Copy(e), this.ez.Copy(i), this;
      }
      Copy(t) {
        return this.ex.Copy(t.ex), this.ey.Copy(t.ey), this.ez.Copy(t.ez), this;
      }
      SetIdentity() {
        return this.ex.SetXYZ(1, 0, 0), this.ey.SetXYZ(0, 1, 0), this.ez.SetXYZ(0, 0, 1), this;
      }
      SetZero() {
        return this.ex.SetZero(), this.ey.SetZero(), this.ez.SetZero(), this;
      }
      SelfAddM(t) {
        return this.ex.SelfAdd(t.ex), this.ey.SelfAdd(t.ey), this.ez.SelfAdd(t.ez), this;
      }
      Solve33(t, e, i, s) {
        const o = this.ex.x,
          n = this.ex.y,
          r = this.ex.z,
          a = this.ey.x,
          l = this.ey.y,
          m = this.ey.z,
          h = this.ez.x,
          _ = this.ez.y,
          c = this.ez.z;
        let u = o * (l * c - m * _) + n * (m * h - a * c) + r * (a * _ - l * h);
        return 0 !== u && (u = 1 / u), s.x = u * (t * (l * c - m * _) + e * (m * h - a * c) + i * (a * _ - l * h)), s.y = u * (o * (e * c - i * _) + n * (i * h - t * c) + r * (t * _ - e * h)), s.z = u * (o * (l * i - m * e) + n * (m * t - a * i) + r * (a * e - l * t)), s;
      }
      Solve22(t, e, i) {
        const s = this.ex.x,
          o = this.ey.x,
          n = this.ex.y,
          r = this.ey.y;
        let a = s * r - o * n;
        return 0 !== a && (a = 1 / a), i.x = a * (r * t - o * e), i.y = a * (s * e - n * t), i;
      }
      GetInverse22(t) {
        const e = this.ex.x,
          i = this.ey.x,
          s = this.ex.y,
          o = this.ey.y;
        let n = e * o - i * s;
        0 !== n && (n = 1 / n), t.ex.x = n * o, t.ey.x = -n * i, t.ex.z = 0, t.ex.y = -n * s, t.ey.y = n * e, t.ey.z = 0, t.ez.x = 0, t.ez.y = 0, t.ez.z = 0;
      }
      GetSymInverse33(t) {
        let e = ot.DotV3V3(this.ex, ot.CrossV3V3(this.ey, this.ez, ot.s_t0));
        0 !== e && (e = 1 / e);
        const i = this.ex.x,
          s = this.ey.x,
          o = this.ez.x,
          n = this.ey.y,
          r = this.ez.y,
          a = this.ez.z;
        t.ex.x = e * (n * a - r * r), t.ex.y = e * (o * r - s * a), t.ex.z = e * (s * r - o * n), t.ey.x = t.ex.y, t.ey.y = e * (i * a - o * o), t.ey.z = e * (o * s - i * r), t.ez.x = t.ex.z, t.ez.y = t.ey.z, t.ez.z = e * (i * n - s * s);
      }
      static MulM33V3(t, e, i) {
        const s = e.x,
          o = e.y,
          n = e.z;
        return i.x = t.ex.x * s + t.ey.x * o + t.ez.x * n, i.y = t.ex.y * s + t.ey.y * o + t.ez.y * n, i.z = t.ex.z * s + t.ey.z * o + t.ez.z * n, i;
      }
      static MulM33XYZ(t, e, i, s, o) {
        return o.x = t.ex.x * e + t.ey.x * i + t.ez.x * s, o.y = t.ex.y * e + t.ey.y * i + t.ez.y * s, o.z = t.ex.z * e + t.ey.z * i + t.ez.z * s, o;
      }
      static MulM33V2(t, e, i) {
        const s = e.x,
          o = e.y;
        return i.x = t.ex.x * s + t.ey.x * o, i.y = t.ex.y * s + t.ey.y * o, i;
      }
      static MulM33XY(t, e, i, s) {
        return s.x = t.ex.x * e + t.ey.x * i, s.y = t.ex.y * e + t.ey.y * i, s;
      }
    }
    rt.IDENTITY = new rt();
    class at {
      constructor() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        this.s = 0, this.c = 1, t && (this.s = Math.sin(t), this.c = Math.cos(t));
      }
      Clone() {
        return new at().Copy(this);
      }
      Copy(t) {
        return this.s = t.s, this.c = t.c, this;
      }
      SetAngle(t) {
        return this.s = Math.sin(t), this.c = Math.cos(t), this;
      }
      SetIdentity() {
        return this.s = 0, this.c = 1, this;
      }
      GetAngle() {
        return Math.atan2(this.s, this.c);
      }
      GetXAxis(t) {
        return t.x = this.c, t.y = this.s, t;
      }
      GetYAxis(t) {
        return t.x = -this.s, t.y = this.c, t;
      }
      static MulRR(t, e, i) {
        const s = t.c,
          o = t.s,
          n = e.c,
          r = e.s;
        return i.s = o * n + s * r, i.c = s * n - o * r, i;
      }
      static MulTRR(t, e, i) {
        const s = t.c,
          o = t.s,
          n = e.c,
          r = e.s;
        return i.s = s * r - o * n, i.c = s * n + o * r, i;
      }
      static MulRV(t, e, i) {
        const s = t.c,
          o = t.s,
          n = e.x,
          r = e.y;
        return i.x = s * n - o * r, i.y = o * n + s * r, i;
      }
      static MulTRV(t, e, i) {
        const s = t.c,
          o = t.s,
          n = e.x,
          r = e.y;
        return i.x = s * n + o * r, i.y = -o * n + s * r, i;
      }
    }
    at.IDENTITY = new at();
    class lt {
      constructor() {
        this.p = new it(), this.q = new at();
      }
      Clone() {
        return new lt().Copy(this);
      }
      Copy(t) {
        return this.p.Copy(t.p), this.q.Copy(t.q), this;
      }
      SetIdentity() {
        return this.p.SetZero(), this.q.SetIdentity(), this;
      }
      SetPositionRotation(t, e) {
        return this.p.Copy(t), this.q.Copy(e), this;
      }
      SetPositionAngle(t, e) {
        return this.p.Copy(t), this.q.SetAngle(e), this;
      }
      SetPosition(t) {
        return this.p.Copy(t), this;
      }
      SetPositionXY(t, e) {
        return this.p.Set(t, e), this;
      }
      SetRotation(t) {
        return this.q.Copy(t), this;
      }
      SetRotationAngle(t) {
        return this.q.SetAngle(t), this;
      }
      GetPosition() {
        return this.p;
      }
      GetRotation() {
        return this.q;
      }
      GetRotationAngle() {
        return this.q.GetAngle();
      }
      GetAngle() {
        return this.q.GetAngle();
      }
      static MulXV(t, e, i) {
        const s = t.q.c,
          o = t.q.s,
          n = e.x,
          r = e.y;
        return i.x = s * n - o * r + t.p.x, i.y = o * n + s * r + t.p.y, i;
      }
      static MulTXV(t, e, i) {
        const s = t.q.c,
          o = t.q.s,
          n = e.x - t.p.x,
          r = e.y - t.p.y;
        return i.x = s * n + o * r, i.y = -o * n + s * r, i;
      }
      static MulXX(t, e, i) {
        return at.MulRR(t.q, e.q, i.q), it.AddVV(at.MulRV(t.q, e.p, i.p), t.p, i.p), i;
      }
      static MulTXX(t, e, i) {
        return at.MulTRR(t.q, e.q, i.q), at.MulTRV(t.q, it.SubVV(e.p, t.p, i.p), i.p), i;
      }
    }
    lt.IDENTITY = new lt();
    class mt {
      constructor() {
        this.localCenter = new it(), this.c0 = new it(), this.c = new it(), this.a0 = 0, this.a = 0, this.alpha0 = 0;
      }
      Clone() {
        return new mt().Copy(this);
      }
      Copy(t) {
        return this.localCenter.Copy(t.localCenter), this.c0.Copy(t.c0), this.c.Copy(t.c), this.a0 = t.a0, this.a = t.a, this.alpha0 = t.alpha0, this;
      }
      GetTransform(t, e) {
        const i = 1 - e;
        t.p.x = i * this.c0.x + e * this.c.x, t.p.y = i * this.c0.y + e * this.c.y;
        const s = i * this.a0 + e * this.a;
        return t.q.SetAngle(s), t.p.SelfSub(at.MulRV(t.q, this.localCenter, it.s_t0)), t;
      }
      Advance(t) {
        const e = (t - this.alpha0) / (1 - this.alpha0),
          i = 1 - e;
        this.c0.x = i * this.c0.x + e * this.c.x, this.c0.y = i * this.c0.y + e * this.c.y, this.a0 = i * this.a0 + e * this.a, this.alpha0 = t;
      }
      Normalize() {
        const t = J * Math.floor(this.a0 / J);
        this.a0 -= t, this.a -= t;
      }
    }
    class ht {
      constructor() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : .5;
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : .5;
        let i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : .5;
        let s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
        this.r = t, this.g = e, this.b = i, this.a = s;
      }
      Clone() {
        return new ht().Copy(this);
      }
      Copy(t) {
        return this.r = t.r, this.g = t.g, this.b = t.b, this.a = t.a, this;
      }
      IsEqual(t) {
        return this.r === t.r && this.g === t.g && this.b === t.b && this.a === t.a;
      }
      IsZero() {
        return 0 === this.r && 0 === this.g && 0 === this.b && 0 === this.a;
      }
      Set(t, e, i) {
        let s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.a;
        this.SetRGBA(t, e, i, s);
      }
      SetByteRGB(t, e, i) {
        return this.r = t / 255, this.g = e / 255, this.b = i / 255, this;
      }
      SetByteRGBA(t, e, i, s) {
        return this.r = t / 255, this.g = e / 255, this.b = i / 255, this.a = s / 255, this;
      }
      SetRGB(t, e, i) {
        return this.r = t, this.g = e, this.b = i, this;
      }
      SetRGBA(t, e, i, s) {
        return this.r = t, this.g = e, this.b = i, this.a = s, this;
      }
      SelfAdd(t) {
        return this.r += t.r, this.g += t.g, this.b += t.b, this.a += t.a, this;
      }
      Add(t, e) {
        return e.r = this.r + t.r, e.g = this.g + t.g, e.b = this.b + t.b, e.a = this.a + t.a, e;
      }
      SelfSub(t) {
        return this.r -= t.r, this.g -= t.g, this.b -= t.b, this.a -= t.a, this;
      }
      Sub(t, e) {
        return e.r = this.r - t.r, e.g = this.g - t.g, e.b = this.b - t.b, e.a = this.a - t.a, e;
      }
      SelfMul(t) {
        return this.r *= t, this.g *= t, this.b *= t, this.a *= t, this;
      }
      Mul(t, e) {
        return e.r = this.r * t, e.g = this.g * t, e.b = this.b * t, e.a = this.a * t, e;
      }
      Mix(t, e) {
        ht.MixColors(this, t, e);
      }
      static MixColors(t, e, i) {
        const s = i * (e.r - t.r),
          o = i * (e.g - t.g),
          n = i * (e.b - t.b),
          r = i * (e.a - t.a);
        t.r += s, t.g += o, t.b += n, t.a += r, e.r -= s, e.g -= o, e.b -= n, e.a -= r;
      }
      MakeStyleString() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.a;
        return ht.MakeStyleString(this.r, this.g, this.b, t);
      }
      static MakeStyleString(t, e, i) {
        let s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
        return t *= 255, e *= 255, i *= 255, s < 1 ? `rgba(${t},${e},${i},${s})` : `rgb(${t},${e},${i})`;
      }
    }
    var _t;
    ht.ZERO = new ht(0, 0, 0, 0), ht.RED = new ht(1, 0, 0), ht.GREEN = new ht(0, 1, 0), ht.BLUE = new ht(0, 0, 1), (_t = t.b2DrawFlags || (t.b2DrawFlags = {}))[_t.e_none = 0] = "e_none", _t[_t.e_shapeBit = 1] = "e_shapeBit", _t[_t.e_jointBit = 2] = "e_jointBit", _t[_t.e_aabbBit = 4] = "e_aabbBit", _t[_t.e_pairBit = 8] = "e_pairBit", _t[_t.e_centerOfMassBit = 16] = "e_centerOfMassBit", _t[_t.e_particleBit = 32] = "e_particleBit", _t[_t.e_controllerBit = 64] = "e_controllerBit", _t[_t.e_all = 63] = "e_all";
    class ct {
      constructor() {
        this.m_start = Date.now();
      }
      Reset() {
        return this.m_start = Date.now(), this;
      }
      GetMilliseconds() {
        return Date.now() - this.m_start;
      }
    }
    class ut {
      constructor(t) {
        this.m_stack = [], this.m_count = 0, this.m_stack = k(t, t => null), this.m_count = 0;
      }
      Reset() {
        return this.m_count = 0, this;
      }
      Push(t) {
        this.m_stack[this.m_count] = t, this.m_count++;
      }
      Pop() {
        this.m_count--;
        const t = this.m_stack[this.m_count];
        if (this.m_stack[this.m_count] = null, null === t) throw new Error();
        return t;
      }
      GetCount() {
        return this.m_count;
      }
    }
    class dt {
      constructor() {
        this.m_buffer = it.MakeArray(2), this.m_vertices = this.m_buffer, this.m_count = 0, this.m_radius = 0;
      }
      Copy(t) {
        return t.m_vertices === t.m_buffer ? (this.m_vertices = this.m_buffer, this.m_buffer[0].Copy(t.m_buffer[0]), this.m_buffer[1].Copy(t.m_buffer[1])) : this.m_vertices = t.m_vertices, this.m_count = t.m_count, this.m_radius = t.m_radius, this;
      }
      Reset() {
        return this.m_vertices = this.m_buffer, this.m_count = 0, this.m_radius = 0, this;
      }
      SetShape(t, e) {
        t.SetupDistanceProxy(this, e);
      }
      SetVerticesRadius(t, e, i) {
        this.m_vertices = t, this.m_count = e, this.m_radius = i;
      }
      GetSupport(t) {
        let e = 0,
          i = it.DotVV(this.m_vertices[0], t);
        for (let s = 1; s < this.m_count; ++s) {
          const o = it.DotVV(this.m_vertices[s], t);
          o > i && (e = s, i = o);
        }
        return e;
      }
      GetSupportVertex(t) {
        let e = 0,
          i = it.DotVV(this.m_vertices[0], t);
        for (let s = 1; s < this.m_count; ++s) {
          const o = it.DotVV(this.m_vertices[s], t);
          o > i && (e = s, i = o);
        }
        return this.m_vertices[e];
      }
      GetVertexCount() {
        return this.m_count;
      }
      GetVertex(t) {
        return this.m_vertices[t];
      }
    }
    class pt {
      constructor() {
        this.metric = 0, this.count = 0, this.indexA = [0, 0, 0], this.indexB = [0, 0, 0];
      }
      Reset() {
        return this.metric = 0, this.count = 0, this;
      }
    }
    class ft {
      constructor() {
        this.proxyA = new dt(), this.proxyB = new dt(), this.transformA = new lt(), this.transformB = new lt(), this.useRadii = !1;
      }
      Reset() {
        return this.proxyA.Reset(), this.proxyB.Reset(), this.transformA.SetIdentity(), this.transformB.SetIdentity(), this.useRadii = !1, this;
      }
    }
    class yt {
      constructor() {
        this.pointA = new it(), this.pointB = new it(), this.distance = 0, this.iterations = 0;
      }
      Reset() {
        return this.pointA.SetZero(), this.pointB.SetZero(), this.distance = 0, this.iterations = 0, this;
      }
    }
    t.b2_gjkCalls = 0, t.b2_gjkIters = 0, t.b2_gjkMaxIters = 0;
    class xt {
      constructor() {
        this.wA = new it(), this.wB = new it(), this.w = new it(), this.a = 0, this.indexA = 0, this.indexB = 0;
      }
      Copy(t) {
        return this.wA.Copy(t.wA), this.wB.Copy(t.wB), this.w.Copy(t.w), this.a = t.a, this.indexA = t.indexA, this.indexB = t.indexB, this;
      }
    }
    class Bt {
      constructor() {
        this.m_v1 = new xt(), this.m_v2 = new xt(), this.m_v3 = new xt(), this.m_vertices = [], this.m_count = 0, this.m_vertices[0] = this.m_v1, this.m_vertices[1] = this.m_v2, this.m_vertices[2] = this.m_v3;
      }
      ReadCache(t, e, i, o, n) {
        this.m_count = t.count;
        const r = this.m_vertices;
        for (let s = 0; s < this.m_count; ++s) {
          const a = r[s];
          a.indexA = t.indexA[s], a.indexB = t.indexB[s];
          const l = e.GetVertex(a.indexA),
            m = o.GetVertex(a.indexB);
          lt.MulXV(i, l, a.wA), lt.MulXV(n, m, a.wB), it.SubVV(a.wB, a.wA, a.w), a.a = 0;
        }
        if (this.m_count > 1) {
          const e = t.metric,
            i = this.GetMetric();
          (i < .5 * e || 2 * e < i || i < s) && (this.m_count = 0);
        }
        if (0 === this.m_count) {
          const t = r[0];
          t.indexA = 0, t.indexB = 0;
          const s = e.GetVertex(0),
            a = o.GetVertex(0);
          lt.MulXV(i, s, t.wA), lt.MulXV(n, a, t.wB), it.SubVV(t.wB, t.wA, t.w), t.a = 1, this.m_count = 1;
        }
      }
      WriteCache(t) {
        t.metric = this.GetMetric(), t.count = this.m_count;
        const e = this.m_vertices;
        for (let i = 0; i < this.m_count; ++i) t.indexA[i] = e[i].indexA, t.indexB[i] = e[i].indexB;
      }
      GetSearchDirection(t) {
        switch (this.m_count) {
          case 1:
            return it.NegV(this.m_v1.w, t);
          case 2:
            {
              const e = it.SubVV(this.m_v2.w, this.m_v1.w, t),
                i = it.CrossVV(e, it.NegV(this.m_v1.w, it.s_t0));
              return i > 0 ? it.CrossOneV(e, t) : it.CrossVOne(e, t);
            }
          default:
            return t.SetZero();
        }
      }
      GetClosestPoint(t) {
        switch (this.m_count) {
          case 0:
            return t.SetZero();
          case 1:
            return t.Copy(this.m_v1.w);
          case 2:
            return t.Set(this.m_v1.a * this.m_v1.w.x + this.m_v2.a * this.m_v2.w.x, this.m_v1.a * this.m_v1.w.y + this.m_v2.a * this.m_v2.w.y);
          case 3:
          default:
            return t.SetZero();
        }
      }
      GetWitnessPoints(t, e) {
        switch (this.m_count) {
          case 0:
            break;
          case 1:
            t.Copy(this.m_v1.wA), e.Copy(this.m_v1.wB);
            break;
          case 2:
            t.x = this.m_v1.a * this.m_v1.wA.x + this.m_v2.a * this.m_v2.wA.x, t.y = this.m_v1.a * this.m_v1.wA.y + this.m_v2.a * this.m_v2.wA.y, e.x = this.m_v1.a * this.m_v1.wB.x + this.m_v2.a * this.m_v2.wB.x, e.y = this.m_v1.a * this.m_v1.wB.y + this.m_v2.a * this.m_v2.wB.y;
            break;
          case 3:
            e.x = t.x = this.m_v1.a * this.m_v1.wA.x + this.m_v2.a * this.m_v2.wA.x + this.m_v3.a * this.m_v3.wA.x, e.y = t.y = this.m_v1.a * this.m_v1.wA.y + this.m_v2.a * this.m_v2.wA.y + this.m_v3.a * this.m_v3.wA.y;
        }
      }
      GetMetric() {
        switch (this.m_count) {
          case 0:
          case 1:
            return 0;
          case 2:
            return it.DistanceVV(this.m_v1.w, this.m_v2.w);
          case 3:
            return it.CrossVV(it.SubVV(this.m_v2.w, this.m_v1.w, it.s_t0), it.SubVV(this.m_v3.w, this.m_v1.w, it.s_t1));
          default:
            return 0;
        }
      }
      Solve2() {
        const t = this.m_v1.w,
          e = this.m_v2.w,
          i = it.SubVV(e, t, Bt.s_e12),
          s = -it.DotVV(t, i);
        if (s <= 0) return this.m_v1.a = 1, void (this.m_count = 1);
        const o = it.DotVV(e, i);
        if (o <= 0) return this.m_v2.a = 1, this.m_count = 1, void this.m_v1.Copy(this.m_v2);
        const n = 1 / (o + s);
        this.m_v1.a = o * n, this.m_v2.a = s * n, this.m_count = 2;
      }
      Solve3() {
        const t = this.m_v1.w,
          e = this.m_v2.w,
          i = this.m_v3.w,
          s = it.SubVV(e, t, Bt.s_e12),
          o = it.DotVV(t, s),
          n = it.DotVV(e, s),
          r = n,
          a = -o,
          l = it.SubVV(i, t, Bt.s_e13),
          m = it.DotVV(t, l),
          h = it.DotVV(i, l),
          _ = h,
          c = -m,
          u = it.SubVV(i, e, Bt.s_e23),
          d = it.DotVV(e, u),
          p = it.DotVV(i, u),
          f = p,
          y = -d,
          x = it.CrossVV(s, l),
          B = x * it.CrossVV(e, i),
          S = x * it.CrossVV(i, t),
          b = x * it.CrossVV(t, e);
        if (a <= 0 && c <= 0) return this.m_v1.a = 1, void (this.m_count = 1);
        if (r > 0 && a > 0 && b <= 0) {
          const t = 1 / (r + a);
          return this.m_v1.a = r * t, this.m_v2.a = a * t, void (this.m_count = 2);
        }
        if (_ > 0 && c > 0 && S <= 0) {
          const t = 1 / (_ + c);
          return this.m_v1.a = _ * t, this.m_v3.a = c * t, this.m_count = 2, void this.m_v2.Copy(this.m_v3);
        }
        if (r <= 0 && y <= 0) return this.m_v2.a = 1, this.m_count = 1, void this.m_v1.Copy(this.m_v2);
        if (_ <= 0 && f <= 0) return this.m_v3.a = 1, this.m_count = 1, void this.m_v1.Copy(this.m_v3);
        if (f > 0 && y > 0 && B <= 0) {
          const t = 1 / (f + y);
          return this.m_v2.a = f * t, this.m_v3.a = y * t, this.m_count = 2, void this.m_v1.Copy(this.m_v3);
        }
        const A = 1 / (B + S + b);
        this.m_v1.a = B * A, this.m_v2.a = S * A, this.m_v3.a = b * A, this.m_count = 3;
      }
    }
    Bt.s_e12 = new it(), Bt.s_e13 = new it(), Bt.s_e23 = new it();
    const St = new Bt(),
      bt = [0, 0, 0],
      At = [0, 0, 0],
      Ct = new it(),
      Vt = new it(),
      gt = new it(),
      wt = new it(),
      vt = new it();
    function Mt(e, i, n) {
      ++t.b2_gjkCalls;
      const r = n.proxyA,
        a = n.proxyB,
        l = n.transformA,
        m = n.transformB,
        h = St;
      h.ReadCache(i, r, l, a, m);
      const _ = h.m_vertices,
        c = bt,
        u = At;
      let d = 0,
        p = 0;
      for (; p < 20;) {
        d = h.m_count;
        for (let t = 0; t < d; ++t) c[t] = _[t].indexA, u[t] = _[t].indexB;
        switch (h.m_count) {
          case 1:
            break;
          case 2:
            h.Solve2();
            break;
          case 3:
            h.Solve3();
        }
        if (3 === h.m_count) break;
        const e = h.GetSearchDirection(Vt);
        if (e.LengthSquared() < o) break;
        const i = _[h.m_count];
        i.indexA = r.GetSupport(at.MulTRV(l.q, it.NegV(e, it.s_t0), wt)), lt.MulXV(l, r.GetVertex(i.indexA), i.wA), i.indexB = a.GetSupport(at.MulTRV(m.q, e, vt)), lt.MulXV(m, a.GetVertex(i.indexB), i.wB), it.SubVV(i.wB, i.wA, i.w), ++p, ++t.b2_gjkIters;
        let s = !1;
        for (let t = 0; t < d; ++t) if (i.indexA === c[t] && i.indexB === u[t]) {
          s = !0;
          break;
        }
        if (s) break;
        ++h.m_count;
      }
      if (t.b2_gjkMaxIters = N(t.b2_gjkMaxIters, p), h.GetWitnessPoints(e.pointA, e.pointB), e.distance = it.DistanceVV(e.pointA, e.pointB), e.iterations = p, h.WriteCache(i), n.useRadii) {
        const t = r.m_radius,
          i = a.m_radius;
        if (e.distance > t + i && e.distance > s) {
          e.distance -= t + i;
          const s = it.SubVV(e.pointB, e.pointA, gt);
          s.Normalize(), e.pointA.SelfMulAdd(t, s), e.pointB.SelfMulSub(i, s);
        } else {
          const t = it.MidVV(e.pointA, e.pointB, Ct);
          e.pointA.Copy(t), e.pointB.Copy(t), e.distance = 0;
        }
      }
    }
    const Pt = new it(),
      It = new Bt(),
      Gt = new it(),
      Dt = new it(),
      Ft = new it(),
      Tt = new it(),
      Lt = new it(),
      Rt = new it();
    var kt, qt, zt;
    (kt = t.b2ContactFeatureType || (t.b2ContactFeatureType = {}))[kt.e_vertex = 0] = "e_vertex", kt[kt.e_face = 1] = "e_face";
    class Et {
      constructor() {
        this._key = 0, this._key_invalid = !1, this._indexA = 0, this._indexB = 0, this._typeA = 0, this._typeB = 0;
      }
      get key() {
        return this._key_invalid && (this._key_invalid = !1, this._key = this._indexA | this._indexB << 8 | this._typeA << 16 | this._typeB << 24), this._key;
      }
      set key(t) {
        this._key = t, this._key_invalid = !1, this._indexA = 255 & this._key, this._indexB = this._key >> 8 & 255, this._typeA = this._key >> 16 & 255, this._typeB = this._key >> 24 & 255;
      }
      get indexA() {
        return this._indexA;
      }
      set indexA(t) {
        this._indexA = t, this._key_invalid = !0;
      }
      get indexB() {
        return this._indexB;
      }
      set indexB(t) {
        this._indexB = t, this._key_invalid = !0;
      }
      get typeA() {
        return this._typeA;
      }
      set typeA(t) {
        this._typeA = t, this._key_invalid = !0;
      }
      get typeB() {
        return this._typeB;
      }
      set typeB(t) {
        this._typeB = t, this._key_invalid = !0;
      }
    }
    class Jt {
      constructor() {
        this.cf = new Et();
      }
      Copy(t) {
        return this.key = t.key, this;
      }
      Clone() {
        return new Jt().Copy(this);
      }
      get key() {
        return this.cf.key;
      }
      set key(t) {
        this.cf.key = t;
      }
    }
    class Ot {
      constructor() {
        this.localPoint = new it(), this.normalImpulse = 0, this.tangentImpulse = 0, this.id = new Jt();
      }
      static MakeArray(t) {
        return k(t, t => new Ot());
      }
      Reset() {
        this.localPoint.SetZero(), this.normalImpulse = 0, this.tangentImpulse = 0, this.id.key = 0;
      }
      Copy(t) {
        return this.localPoint.Copy(t.localPoint), this.normalImpulse = t.normalImpulse, this.tangentImpulse = t.tangentImpulse, this.id.Copy(t.id), this;
      }
    }
    (qt = t.b2ManifoldType || (t.b2ManifoldType = {}))[qt.e_unknown = -1] = "e_unknown", qt[qt.e_circles = 0] = "e_circles", qt[qt.e_faceA = 1] = "e_faceA", qt[qt.e_faceB = 2] = "e_faceB";
    class jt {
      constructor() {
        this.points = Ot.MakeArray(r), this.localNormal = new it(), this.localPoint = new it(), this.type = t.b2ManifoldType.e_unknown, this.pointCount = 0;
      }
      Reset() {
        for (let t = 0; t < r; ++t) this.points[t].Reset();
        this.localNormal.SetZero(), this.localPoint.SetZero(), this.type = t.b2ManifoldType.e_unknown, this.pointCount = 0;
      }
      Copy(t) {
        this.pointCount = t.pointCount;
        for (let e = 0; e < r; ++e) this.points[e].Copy(t.points[e]);
        return this.localNormal.Copy(t.localNormal), this.localPoint.Copy(t.localPoint), this.type = t.type, this;
      }
      Clone() {
        return new jt().Copy(this);
      }
    }
    class Nt {
      constructor() {
        this.normal = new it(), this.points = it.MakeArray(r), this.separations = q(r);
      }
      Initialize(e, i, s, n, r) {
        if (0 !== e.pointCount) switch (e.type) {
          case t.b2ManifoldType.e_circles:
            {
              this.normal.Set(1, 0);
              const t = lt.MulXV(i, e.localPoint, Nt.Initialize_s_pointA),
                a = lt.MulXV(n, e.points[0].localPoint, Nt.Initialize_s_pointB);
              it.DistanceSquaredVV(t, a) > o && it.SubVV(a, t, this.normal).SelfNormalize();
              const l = it.AddVMulSV(t, s, this.normal, Nt.Initialize_s_cA),
                m = it.SubVMulSV(a, r, this.normal, Nt.Initialize_s_cB);
              it.MidVV(l, m, this.points[0]), this.separations[0] = it.DotVV(it.SubVV(m, l, it.s_t0), this.normal);
              break;
            }
          case t.b2ManifoldType.e_faceA:
            {
              at.MulRV(i.q, e.localNormal, this.normal);
              const t = lt.MulXV(i, e.localPoint, Nt.Initialize_s_planePoint);
              for (let i = 0; i < e.pointCount; ++i) {
                const o = lt.MulXV(n, e.points[i].localPoint, Nt.Initialize_s_clipPoint),
                  a = s - it.DotVV(it.SubVV(o, t, it.s_t0), this.normal),
                  l = it.AddVMulSV(o, a, this.normal, Nt.Initialize_s_cA),
                  m = it.SubVMulSV(o, r, this.normal, Nt.Initialize_s_cB);
                it.MidVV(l, m, this.points[i]), this.separations[i] = it.DotVV(it.SubVV(m, l, it.s_t0), this.normal);
              }
              break;
            }
          case t.b2ManifoldType.e_faceB:
            {
              at.MulRV(n.q, e.localNormal, this.normal);
              const t = lt.MulXV(n, e.localPoint, Nt.Initialize_s_planePoint);
              for (let o = 0; o < e.pointCount; ++o) {
                const n = lt.MulXV(i, e.points[o].localPoint, Nt.Initialize_s_clipPoint),
                  a = r - it.DotVV(it.SubVV(n, t, it.s_t0), this.normal),
                  l = it.AddVMulSV(n, a, this.normal, Nt.Initialize_s_cB),
                  m = it.SubVMulSV(n, s, this.normal, Nt.Initialize_s_cA);
                it.MidVV(m, l, this.points[o]), this.separations[o] = it.DotVV(it.SubVV(m, l, it.s_t0), this.normal);
              }
              this.normal.SelfNeg();
              break;
            }
        }
      }
    }
    Nt.Initialize_s_pointA = new it(), Nt.Initialize_s_pointB = new it(), Nt.Initialize_s_cA = new it(), Nt.Initialize_s_cB = new it(), Nt.Initialize_s_planePoint = new it(), Nt.Initialize_s_clipPoint = new it(), (zt = t.b2PointState || (t.b2PointState = {}))[zt.b2_nullState = 0] = "b2_nullState", zt[zt.b2_addState = 1] = "b2_addState", zt[zt.b2_persistState = 2] = "b2_persistState", zt[zt.b2_removeState = 3] = "b2_removeState";
    class Xt {
      constructor() {
        this.v = new it(), this.id = new Jt();
      }
      static MakeArray(t) {
        return k(t, t => new Xt());
      }
      Copy(t) {
        return this.v.Copy(t.v), this.id.Copy(t.id), this;
      }
    }
    class Ut {
      constructor() {
        this.p1 = new it(), this.p2 = new it(), this.maxFraction = 1;
      }
      Copy(t) {
        return this.p1.Copy(t.p1), this.p2.Copy(t.p2), this.maxFraction = t.maxFraction, this;
      }
    }
    class Wt {
      constructor() {
        this.normal = new it(), this.fraction = 0;
      }
      Copy(t) {
        return this.normal.Copy(t.normal), this.fraction = t.fraction, this;
      }
    }
    class Zt {
      constructor() {
        this.lowerBound = new it(), this.upperBound = new it(), this.m_cache_center = new it(), this.m_cache_extent = new it();
      }
      Copy(t) {
        return this.lowerBound.Copy(t.lowerBound), this.upperBound.Copy(t.upperBound), this;
      }
      IsValid() {
        const t = this.upperBound.x - this.lowerBound.x,
          e = this.upperBound.y - this.lowerBound.y;
        let i = t >= 0 && e >= 0;
        return i = i && this.lowerBound.IsValid() && this.upperBound.IsValid();
      }
      GetCenter() {
        return it.MidVV(this.lowerBound, this.upperBound, this.m_cache_center);
      }
      GetExtents() {
        return it.ExtVV(this.lowerBound, this.upperBound, this.m_cache_extent);
      }
      GetPerimeter() {
        const t = this.upperBound.x - this.lowerBound.x,
          e = this.upperBound.y - this.lowerBound.y;
        return 2 * (t + e);
      }
      Combine1(t) {
        return this.lowerBound.x = j(this.lowerBound.x, t.lowerBound.x), this.lowerBound.y = j(this.lowerBound.y, t.lowerBound.y), this.upperBound.x = N(this.upperBound.x, t.upperBound.x), this.upperBound.y = N(this.upperBound.y, t.upperBound.y), this;
      }
      Combine2(t, e) {
        return this.lowerBound.x = j(t.lowerBound.x, e.lowerBound.x), this.lowerBound.y = j(t.lowerBound.y, e.lowerBound.y), this.upperBound.x = N(t.upperBound.x, e.upperBound.x), this.upperBound.y = N(t.upperBound.y, e.upperBound.y), this;
      }
      static Combine(t, e, i) {
        return i.Combine2(t, e), i;
      }
      Contains(t) {
        let e = !0;
        return e = (e = (e = (e = e && this.lowerBound.x <= t.lowerBound.x) && this.lowerBound.y <= t.lowerBound.y) && t.upperBound.x <= this.upperBound.x) && t.upperBound.y <= this.upperBound.y;
      }
      RayCast(t, e) {
        let o = -i,
          n = i;
        const r = e.p1.x,
          a = e.p1.y,
          l = e.p2.x - e.p1.x,
          m = e.p2.y - e.p1.y,
          h = O(l),
          _ = O(m),
          c = t.normal;
        if (h < s) {
          if (r < this.lowerBound.x || this.upperBound.x < r) return !1;
        } else {
          const t = 1 / l;
          let e = (this.lowerBound.x - r) * t,
            i = (this.upperBound.x - r) * t,
            s = -1;
          if (e > i) {
            const t = e;
            e = i, i = t, s = 1;
          }
          if (e > o && (c.x = s, c.y = 0, o = e), n = j(n, i), o > n) return !1;
        }
        if (_ < s) {
          if (a < this.lowerBound.y || this.upperBound.y < a) return !1;
        } else {
          const t = 1 / m;
          let e = (this.lowerBound.y - a) * t,
            i = (this.upperBound.y - a) * t,
            s = -1;
          if (e > i) {
            const t = e;
            e = i, i = t, s = 1;
          }
          if (e > o && (c.x = 0, c.y = s, o = e), n = j(n, i), o > n) return !1;
        }
        return !(o < 0 || e.maxFraction < o || (t.fraction = o, 0));
      }
      TestContain(t) {
        return !(t.x < this.lowerBound.x || this.upperBound.x < t.x || t.y < this.lowerBound.y || this.upperBound.y < t.y);
      }
      TestOverlap(t) {
        const e = t.lowerBound.x - this.upperBound.x,
          i = t.lowerBound.y - this.upperBound.y,
          s = this.lowerBound.x - t.upperBound.x,
          o = this.lowerBound.y - t.upperBound.y;
        return !(e > 0 || i > 0 || s > 0 || o > 0);
      }
    }
    function Ht(t, e) {
      const i = e.lowerBound.x - t.upperBound.x,
        s = e.lowerBound.y - t.upperBound.y,
        o = t.lowerBound.x - e.upperBound.x,
        n = t.lowerBound.y - e.upperBound.y;
      return !(i > 0 || s > 0 || o > 0 || n > 0);
    }
    function Qt(e, i, s, o, n) {
      let r = 0;
      const a = i[0],
        l = i[1],
        m = it.DotVV(s, a.v) - o,
        h = it.DotVV(s, l.v) - o;
      if (m <= 0 && e[r++].Copy(a), h <= 0 && e[r++].Copy(l), m * h < 0) {
        const i = m / (m - h),
          s = e[r].v;
        s.x = a.v.x + i * (l.v.x - a.v.x), s.y = a.v.y + i * (l.v.y - a.v.y);
        const o = e[r].id;
        o.cf.indexA = n, o.cf.indexB = a.id.cf.indexB, o.cf.typeA = t.b2ContactFeatureType.e_vertex, o.cf.typeB = t.b2ContactFeatureType.e_face, ++r;
      }
      return r;
    }
    const Yt = new ft(),
      Kt = new pt(),
      $t = new yt();
    function te(t, e, i, o, n, r) {
      const a = Yt.Reset();
      a.proxyA.SetShape(t, e), a.proxyB.SetShape(i, o), a.transformA.Copy(n), a.transformB.Copy(r), a.useRadii = !0;
      const l = Kt.Reset();
      l.count = 0;
      const m = $t.Reset();
      return Mt(m, l, a), m.distance < 10 * s;
    }
    function ee(t) {
      if (null === t) throw new Error();
      return t;
    }
    class ie {
      constructor() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        this.m_id = 0, this.aabb = new Zt(), this.parent = null, this.child1 = null, this.child2 = null, this.height = 0, this.m_id = t;
      }
      IsLeaf() {
        return null === this.child1;
      }
    }
    class se {
      constructor() {
        this.m_root = null, this.m_freeList = null, this.m_path = 0, this.m_insertionCount = 0, this.m_stack = new ut(256);
      }
      Query(t, e) {
        if (null === this.m_root) return;
        const i = this.m_stack.Reset();
        for (i.Push(this.m_root); i.GetCount() > 0;) {
          const s = i.Pop();
          if (s.aabb.TestOverlap(t)) if (s.IsLeaf()) {
            const t = e(s);
            if (!t) return;
          } else i.Push(ee(s.child1)), i.Push(ee(s.child2));
        }
      }
      QueryPoint(t, e) {
        if (null === this.m_root) return;
        const i = this.m_stack.Reset();
        for (i.Push(this.m_root); i.GetCount() > 0;) {
          const s = i.Pop();
          if (s.aabb.TestContain(t)) if (s.IsLeaf()) {
            const t = e(s);
            if (!t) return;
          } else i.Push(ee(s.child1)), i.Push(ee(s.child2));
        }
      }
      RayCast(t, e) {
        if (null === this.m_root) return;
        const i = t.p1,
          s = t.p2,
          o = it.SubVV(s, i, se.s_r);
        o.Normalize();
        const n = it.CrossOneV(o, se.s_v),
          r = it.AbsV(n, se.s_abs_v);
        let a = t.maxFraction;
        const l = se.s_segmentAABB;
        let m = i.x + a * (s.x - i.x),
          h = i.y + a * (s.y - i.y);
        l.lowerBound.x = j(i.x, m), l.lowerBound.y = j(i.y, h), l.upperBound.x = N(i.x, m), l.upperBound.y = N(i.y, h);
        const _ = this.m_stack.Reset();
        for (_.Push(this.m_root); _.GetCount() > 0;) {
          const o = _.Pop();
          if (!Ht(o.aabb, l)) continue;
          const c = o.aabb.GetCenter(),
            u = o.aabb.GetExtents(),
            d = O(it.DotVV(n, it.SubVV(i, c, it.s_t0))) - it.DotVV(r, u);
          if (!(d > 0)) if (o.IsLeaf()) {
            const n = se.s_subInput;
            n.p1.Copy(t.p1), n.p2.Copy(t.p2), n.maxFraction = a;
            const r = e(n, o);
            if (0 === r) return;
            r > 0 && (a = r, m = i.x + a * (s.x - i.x), h = i.y + a * (s.y - i.y), l.lowerBound.x = j(i.x, m), l.lowerBound.y = j(i.y, h), l.upperBound.x = N(i.x, m), l.upperBound.y = N(i.y, h));
          } else _.Push(ee(o.child1)), _.Push(ee(o.child2));
        }
      }
      AllocateNode() {
        if (this.m_freeList) {
          const t = this.m_freeList;
          return this.m_freeList = t.parent, t.parent = null, t.child1 = null, t.child2 = null, t.height = 0, delete t.userData, t;
        }
        return new ie(se.s_node_id++);
      }
      FreeNode(t) {
        t.parent = this.m_freeList, t.child1 = null, t.child2 = null, t.height = -1, delete t.userData, this.m_freeList = t;
      }
      CreateProxy(t, e) {
        const i = this.AllocateNode(),
          s = l,
          o = l;
        return i.aabb.lowerBound.x = t.lowerBound.x - s, i.aabb.lowerBound.y = t.lowerBound.y - o, i.aabb.upperBound.x = t.upperBound.x + s, i.aabb.upperBound.y = t.upperBound.y + o, i.userData = e, i.height = 0, this.InsertLeaf(i), i;
      }
      DestroyProxy(t) {
        this.RemoveLeaf(t), this.FreeNode(t);
      }
      MoveProxy(t, e, i) {
        if (t.aabb.Contains(e)) return !1;
        this.RemoveLeaf(t);
        const s = l + m * (i.x > 0 ? i.x : -i.x),
          o = l + m * (i.y > 0 ? i.y : -i.y);
        return t.aabb.lowerBound.x = e.lowerBound.x - s, t.aabb.lowerBound.y = e.lowerBound.y - o, t.aabb.upperBound.x = e.upperBound.x + s, t.aabb.upperBound.y = e.upperBound.y + o, this.InsertLeaf(t), !0;
      }
      InsertLeaf(t) {
        if (++this.m_insertionCount, null === this.m_root) return this.m_root = t, void (this.m_root.parent = null);
        const e = t.aabb;
        let i = this.m_root;
        for (; !i.IsLeaf();) {
          const t = ee(i.child1),
            s = ee(i.child2),
            o = i.aabb.GetPerimeter(),
            n = se.s_combinedAABB;
          n.Combine2(i.aabb, e);
          const r = n.GetPerimeter(),
            a = 2 * r,
            l = 2 * (r - o);
          let m;
          const h = se.s_aabb;
          let _, c, u;
          if (t.IsLeaf() ? (h.Combine2(e, t.aabb), m = h.GetPerimeter() + l) : (h.Combine2(e, t.aabb), _ = t.aabb.GetPerimeter(), c = h.GetPerimeter(), m = c - _ + l), s.IsLeaf() ? (h.Combine2(e, s.aabb), u = h.GetPerimeter() + l) : (h.Combine2(e, s.aabb), _ = s.aabb.GetPerimeter(), c = h.GetPerimeter(), u = c - _ + l), a < m && a < u) break;
          i = m < u ? t : s;
        }
        const s = i,
          o = s.parent,
          n = this.AllocateNode();
        n.parent = o, delete n.userData, n.aabb.Combine2(e, s.aabb), n.height = s.height + 1, o ? (o.child1 === s ? o.child1 = n : o.child2 = n, n.child1 = s, n.child2 = t, s.parent = n, t.parent = n) : (n.child1 = s, n.child2 = t, s.parent = n, t.parent = n, this.m_root = n);
        let r = t.parent;
        for (; null !== r;) {
          const t = ee((r = this.Balance(r)).child1),
            e = ee(r.child2);
          r.height = 1 + N(t.height, e.height), r.aabb.Combine2(t.aabb, e.aabb), r = r.parent;
        }
      }
      RemoveLeaf(t) {
        if (t === this.m_root) return void (this.m_root = null);
        const e = ee(t.parent),
          i = e && e.parent;
        let s;
        if (s = e.child1 === t ? ee(e.child2) : ee(e.child1), i) {
          i.child1 === e ? i.child1 = s : i.child2 = s, s.parent = i, this.FreeNode(e);
          let t = i;
          for (; t;) {
            const e = ee((t = this.Balance(t)).child1),
              i = ee(t.child2);
            t.aabb.Combine2(e.aabb, i.aabb), t.height = 1 + N(e.height, i.height), t = t.parent;
          }
        } else this.m_root = s, s.parent = null, this.FreeNode(e);
      }
      Balance(t) {
        if (t.IsLeaf() || t.height < 2) return t;
        const e = ee(t.child1),
          i = ee(t.child2),
          s = i.height - e.height;
        if (s > 1) {
          const s = ee(i.child1),
            o = ee(i.child2);
          return i.child1 = t, i.parent = t.parent, t.parent = i, null !== i.parent ? i.parent.child1 === t ? i.parent.child1 = i : i.parent.child2 = i : this.m_root = i, s.height > o.height ? (i.child2 = s, t.child2 = o, o.parent = t, t.aabb.Combine2(e.aabb, o.aabb), i.aabb.Combine2(t.aabb, s.aabb), t.height = 1 + N(e.height, o.height), i.height = 1 + N(t.height, s.height)) : (i.child2 = o, t.child2 = s, s.parent = t, t.aabb.Combine2(e.aabb, s.aabb), i.aabb.Combine2(t.aabb, o.aabb), t.height = 1 + N(e.height, s.height), i.height = 1 + N(t.height, o.height)), i;
        }
        if (s < -1) {
          const s = ee(e.child1),
            o = ee(e.child2);
          return e.child1 = t, e.parent = t.parent, t.parent = e, null !== e.parent ? e.parent.child1 === t ? e.parent.child1 = e : e.parent.child2 = e : this.m_root = e, s.height > o.height ? (e.child2 = s, t.child1 = o, o.parent = t, t.aabb.Combine2(i.aabb, o.aabb), e.aabb.Combine2(t.aabb, s.aabb), t.height = 1 + N(i.height, o.height), e.height = 1 + N(t.height, s.height)) : (e.child2 = o, t.child1 = s, s.parent = t, t.aabb.Combine2(i.aabb, s.aabb), e.aabb.Combine2(t.aabb, o.aabb), t.height = 1 + N(i.height, s.height), e.height = 1 + N(t.height, o.height)), e;
        }
        return t;
      }
      GetHeight() {
        return null === this.m_root ? 0 : this.m_root.height;
      }
      static GetAreaNode(t) {
        if (null === t) return 0;
        if (t.IsLeaf()) return 0;
        let e = t.aabb.GetPerimeter();
        return e += se.GetAreaNode(t.child1), e += se.GetAreaNode(t.child2);
      }
      GetAreaRatio() {
        if (null === this.m_root) return 0;
        const t = this.m_root,
          e = t.aabb.GetPerimeter(),
          i = se.GetAreaNode(this.m_root);
        return i / e;
      }
      ComputeHeightNode(t) {
        if (!t || t.IsLeaf()) return 0;
        const e = this.ComputeHeightNode(t.child1),
          i = this.ComputeHeightNode(t.child2);
        return 1 + N(e, i);
      }
      ComputeHeight() {
        const t = this.ComputeHeightNode(this.m_root);
        return t;
      }
      ValidateStructure(t) {
        if (null === t) return;
        this.m_root;
        const e = t;
        if (e.IsLeaf()) return;
        const i = ee(e.child1),
          s = ee(e.child2);
        this.ValidateStructure(i), this.ValidateStructure(s);
      }
      ValidateMetrics(t) {
        if (null === t) return;
        const e = t;
        if (e.IsLeaf()) return;
        const i = ee(e.child1),
          s = ee(e.child2),
          o = se.s_aabb;
        o.Combine2(i.aabb, s.aabb), this.ValidateMetrics(i), this.ValidateMetrics(s);
      }
      Validate() {}
      static GetMaxBalanceNode(t, e) {
        if (null === t) return e;
        if (t.height <= 1) return e;
        const i = ee(t.child1),
          s = ee(t.child2),
          o = O(s.height - i.height);
        return N(e, o);
      }
      GetMaxBalance() {
        const t = se.GetMaxBalanceNode(this.m_root, 0);
        return t;
      }
      RebuildBottomUp() {
        this.Validate();
      }
      static ShiftOriginNode(t, e) {
        if (null === t) return;
        if (t.height <= 1) return;
        const i = t.child1,
          s = t.child2;
        se.ShiftOriginNode(i, e), se.ShiftOriginNode(s, e), t.aabb.lowerBound.SelfSub(e), t.aabb.upperBound.SelfSub(e);
      }
      ShiftOrigin(t) {
        se.ShiftOriginNode(this.m_root, t);
      }
    }
    se.s_r = new it(), se.s_v = new it(), se.s_abs_v = new it(), se.s_segmentAABB = new Zt(), se.s_subInput = new Ut(), se.s_combinedAABB = new Zt(), se.s_aabb = new Zt(), se.s_node_id = 0;
    class oe {
      constructor(t, e) {
        this.proxyA = t, this.proxyB = e;
      }
    }
    class ne {
      constructor() {
        this.m_tree = new se(), this.m_proxyCount = 0, this.m_moveCount = 0, this.m_moveBuffer = [], this.m_pairCount = 0, this.m_pairBuffer = [];
      }
      CreateProxy(t, e) {
        const i = this.m_tree.CreateProxy(t, e);
        return ++this.m_proxyCount, this.BufferMove(i), i;
      }
      DestroyProxy(t) {
        this.UnBufferMove(t), --this.m_proxyCount, this.m_tree.DestroyProxy(t);
      }
      MoveProxy(t, e, i) {
        const s = this.m_tree.MoveProxy(t, e, i);
        s && this.BufferMove(t);
      }
      TouchProxy(t) {
        this.BufferMove(t);
      }
      GetProxyCount() {
        return this.m_proxyCount;
      }
      UpdatePairs(t) {
        this.m_pairCount = 0;
        for (let t = 0; t < this.m_moveCount; ++t) {
          const e = this.m_moveBuffer[t];
          if (null === e) continue;
          const i = e.aabb;
          this.m_tree.Query(i, t => {
            if (t.m_id === e.m_id) return !0;
            let i, s;
            if (t.m_id < e.m_id ? (i = t, s = e) : (i = e, s = t), this.m_pairCount === this.m_pairBuffer.length) this.m_pairBuffer[this.m_pairCount] = new oe(i, s);else {
              const t = this.m_pairBuffer[this.m_pairCount];
              t.proxyA = i, t.proxyB = s;
            }
            return ++this.m_pairCount, !0;
          });
        }
        this.m_moveCount = 0, this.m_pairBuffer.length = this.m_pairCount, this.m_pairBuffer.sort(re);
        let e = 0;
        for (; e < this.m_pairCount;) {
          const i = this.m_pairBuffer[e],
            s = i.proxyA.userData,
            o = i.proxyB.userData;
          for (t(s, o), ++e; e < this.m_pairCount;) {
            const t = this.m_pairBuffer[e];
            if (t.proxyA.m_id !== i.proxyA.m_id || t.proxyB.m_id !== i.proxyB.m_id) break;
            ++e;
          }
        }
      }
      Query(t, e) {
        this.m_tree.Query(t, e);
      }
      QueryPoint(t, e) {
        this.m_tree.QueryPoint(t, e);
      }
      RayCast(t, e) {
        this.m_tree.RayCast(t, e);
      }
      GetTreeHeight() {
        return this.m_tree.GetHeight();
      }
      GetTreeBalance() {
        return this.m_tree.GetMaxBalance();
      }
      GetTreeQuality() {
        return this.m_tree.GetAreaRatio();
      }
      ShiftOrigin(t) {
        this.m_tree.ShiftOrigin(t);
      }
      BufferMove(t) {
        this.m_moveBuffer[this.m_moveCount] = t, ++this.m_moveCount;
      }
      UnBufferMove(t) {
        const e = this.m_moveBuffer.indexOf(t);
        this.m_moveBuffer[e] = null;
      }
    }
    function re(t, e) {
      return t.proxyA.m_id === e.proxyA.m_id ? t.proxyB.m_id - e.proxyB.m_id : t.proxyA.m_id - e.proxyA.m_id;
    }
    t.b2_toiTime = 0, t.b2_toiMaxTime = 0, t.b2_toiCalls = 0, t.b2_toiIters = 0, t.b2_toiMaxIters = 0, t.b2_toiRootIters = 0, t.b2_toiMaxRootIters = 0;
    const ae = new lt(),
      le = new lt(),
      me = new it(),
      he = new it(),
      _e = new it(),
      ce = new it(),
      ue = new it();
    class de {
      constructor() {
        this.proxyA = new dt(), this.proxyB = new dt(), this.sweepA = new mt(), this.sweepB = new mt(), this.tMax = 0;
      }
    }
    var pe, fe;
    (pe = t.b2TOIOutputState || (t.b2TOIOutputState = {}))[pe.e_unknown = 0] = "e_unknown", pe[pe.e_failed = 1] = "e_failed", pe[pe.e_overlapped = 2] = "e_overlapped", pe[pe.e_touching = 3] = "e_touching", pe[pe.e_separated = 4] = "e_separated";
    class ye {
      constructor() {
        this.state = t.b2TOIOutputState.e_unknown, this.t = 0;
      }
    }
    (fe = t.b2SeparationFunctionType || (t.b2SeparationFunctionType = {}))[fe.e_unknown = -1] = "e_unknown", fe[fe.e_points = 0] = "e_points", fe[fe.e_faceA = 1] = "e_faceA", fe[fe.e_faceB = 2] = "e_faceB";
    class xe {
      constructor() {
        this.m_sweepA = new mt(), this.m_sweepB = new mt(), this.m_type = t.b2SeparationFunctionType.e_unknown, this.m_localPoint = new it(), this.m_axis = new it();
      }
      Initialize(e, i, s, o, n, r) {
        this.m_proxyA = i, this.m_proxyB = o;
        const a = e.count;
        this.m_sweepA.Copy(s), this.m_sweepB.Copy(n);
        const l = ae,
          m = le;
        if (this.m_sweepA.GetTransform(l, r), this.m_sweepB.GetTransform(m, r), 1 === a) {
          this.m_type = t.b2SeparationFunctionType.e_points;
          const i = this.m_proxyA.GetVertex(e.indexA[0]),
            s = this.m_proxyB.GetVertex(e.indexB[0]),
            o = lt.MulXV(l, i, me),
            n = lt.MulXV(m, s, he);
          it.SubVV(n, o, this.m_axis);
          const r = this.m_axis.Normalize();
          return this.m_localPoint.SetZero(), r;
        }
        if (e.indexA[0] === e.indexA[1]) {
          this.m_type = t.b2SeparationFunctionType.e_faceB;
          const i = this.m_proxyB.GetVertex(e.indexB[0]),
            s = this.m_proxyB.GetVertex(e.indexB[1]);
          it.CrossVOne(it.SubVV(s, i, it.s_t0), this.m_axis).SelfNormalize();
          const o = at.MulRV(m.q, this.m_axis, _e);
          it.MidVV(i, s, this.m_localPoint);
          const n = lt.MulXV(m, this.m_localPoint, he),
            r = this.m_proxyA.GetVertex(e.indexA[0]),
            a = lt.MulXV(l, r, me);
          let h = it.DotVV(it.SubVV(a, n, it.s_t0), o);
          return h < 0 && (this.m_axis.SelfNeg(), h = -h), h;
        }
        {
          this.m_type = t.b2SeparationFunctionType.e_faceA;
          const i = this.m_proxyA.GetVertex(e.indexA[0]),
            s = this.m_proxyA.GetVertex(e.indexA[1]);
          it.CrossVOne(it.SubVV(s, i, it.s_t0), this.m_axis).SelfNormalize();
          const o = at.MulRV(l.q, this.m_axis, _e);
          it.MidVV(i, s, this.m_localPoint);
          const n = lt.MulXV(l, this.m_localPoint, me),
            r = this.m_proxyB.GetVertex(e.indexB[0]),
            a = lt.MulXV(m, r, he);
          let h = it.DotVV(it.SubVV(a, n, it.s_t0), o);
          return h < 0 && (this.m_axis.SelfNeg(), h = -h), h;
        }
      }
      FindMinSeparation(e, i, s) {
        const o = ae,
          n = le;
        switch (this.m_sweepA.GetTransform(o, s), this.m_sweepB.GetTransform(n, s), this.m_type) {
          case t.b2SeparationFunctionType.e_points:
            {
              const t = at.MulTRV(o.q, this.m_axis, ce),
                s = at.MulTRV(n.q, it.NegV(this.m_axis, it.s_t0), ue);
              e[0] = this.m_proxyA.GetSupport(t), i[0] = this.m_proxyB.GetSupport(s);
              const r = this.m_proxyA.GetVertex(e[0]),
                a = this.m_proxyB.GetVertex(i[0]),
                l = lt.MulXV(o, r, me),
                m = lt.MulXV(n, a, he),
                h = it.DotVV(it.SubVV(m, l, it.s_t0), this.m_axis);
              return h;
            }
          case t.b2SeparationFunctionType.e_faceA:
            {
              const t = at.MulRV(o.q, this.m_axis, _e),
                s = lt.MulXV(o, this.m_localPoint, me),
                r = at.MulTRV(n.q, it.NegV(t, it.s_t0), ue);
              e[0] = -1, i[0] = this.m_proxyB.GetSupport(r);
              const a = this.m_proxyB.GetVertex(i[0]),
                l = lt.MulXV(n, a, he),
                m = it.DotVV(it.SubVV(l, s, it.s_t0), t);
              return m;
            }
          case t.b2SeparationFunctionType.e_faceB:
            {
              const t = at.MulRV(n.q, this.m_axis, _e),
                s = lt.MulXV(n, this.m_localPoint, he),
                r = at.MulTRV(o.q, it.NegV(t, it.s_t0), ce);
              i[0] = -1, e[0] = this.m_proxyA.GetSupport(r);
              const a = this.m_proxyA.GetVertex(e[0]),
                l = lt.MulXV(o, a, me),
                m = it.DotVV(it.SubVV(l, s, it.s_t0), t);
              return m;
            }
          default:
            return e[0] = -1, i[0] = -1, 0;
        }
      }
      Evaluate(e, i, s) {
        const o = ae,
          n = le;
        switch (this.m_sweepA.GetTransform(o, s), this.m_sweepB.GetTransform(n, s), this.m_type) {
          case t.b2SeparationFunctionType.e_points:
            {
              const t = this.m_proxyA.GetVertex(e),
                s = this.m_proxyB.GetVertex(i),
                r = lt.MulXV(o, t, me),
                a = lt.MulXV(n, s, he),
                l = it.DotVV(it.SubVV(a, r, it.s_t0), this.m_axis);
              return l;
            }
          case t.b2SeparationFunctionType.e_faceA:
            {
              const t = at.MulRV(o.q, this.m_axis, _e),
                e = lt.MulXV(o, this.m_localPoint, me),
                s = this.m_proxyB.GetVertex(i),
                r = lt.MulXV(n, s, he),
                a = it.DotVV(it.SubVV(r, e, it.s_t0), t);
              return a;
            }
          case t.b2SeparationFunctionType.e_faceB:
            {
              const t = at.MulRV(n.q, this.m_axis, _e),
                i = lt.MulXV(n, this.m_localPoint, he),
                s = this.m_proxyA.GetVertex(e),
                r = lt.MulXV(o, s, me),
                a = it.DotVV(it.SubVV(r, i, it.s_t0), t);
              return a;
            }
          default:
            return 0;
        }
      }
    }
    const Be = new ct(),
      Se = new pt(),
      be = new ft(),
      Ae = new yt(),
      Ce = new xe(),
      Ve = [0],
      ge = [0],
      we = new mt(),
      ve = new mt();
    function Me(e, i) {
      const s = Be.Reset();
      ++t.b2_toiCalls, e.state = t.b2TOIOutputState.e_unknown, e.t = i.tMax;
      const o = i.proxyA,
        n = i.proxyB,
        r = N(a, o.m_count, n.m_count),
        l = we.Copy(i.sweepA),
        m = ve.Copy(i.sweepB);
      l.Normalize(), m.Normalize();
      const _ = i.tMax,
        c = o.m_radius + n.m_radius,
        u = N(h, c - 3 * h),
        d = .25 * h;
      let p = 0,
        f = 0;
      const y = Se;
      y.count = 0;
      const x = be;
      for (x.proxyA.Copy(i.proxyA), x.proxyB.Copy(i.proxyB), x.useRadii = !1;;) {
        const i = ae,
          s = le;
        l.GetTransform(i, p), m.GetTransform(s, p), x.transformA.Copy(i), x.transformB.Copy(s);
        const a = Ae;
        if (Mt(a, y, x), a.distance <= 0) {
          e.state = t.b2TOIOutputState.e_overlapped, e.t = 0;
          break;
        }
        if (a.distance < u + d) {
          e.state = t.b2TOIOutputState.e_touching, e.t = p;
          break;
        }
        const h = Ce;
        h.Initialize(y, o, l, n, m, p);
        let c = !1,
          B = _,
          S = 0;
        for (;;) {
          const i = Ve,
            s = ge;
          let o = h.FindMinSeparation(i, s, B);
          if (o > u + d) {
            e.state = t.b2TOIOutputState.e_separated, e.t = _, c = !0;
            break;
          }
          if (o > u - d) {
            p = B;
            break;
          }
          let n = h.Evaluate(i[0], s[0], p);
          if (n < u - d) {
            e.state = t.b2TOIOutputState.e_failed, e.t = p, c = !0;
            break;
          }
          if (n <= u + d) {
            e.state = t.b2TOIOutputState.e_touching, e.t = p, c = !0;
            break;
          }
          let a = 0,
            l = p,
            m = B;
          for (;;) {
            let e = 0;
            e = 1 & a ? l + (u - n) * (m - l) / (o - n) : .5 * (l + m), ++a, ++t.b2_toiRootIters;
            const r = h.Evaluate(i[0], s[0], e);
            if (O(r - u) < d) {
              B = e;
              break;
            }
            if (r > u ? (l = e, n = r) : (m = e, o = r), 50 === a) break;
          }
          if (t.b2_toiMaxRootIters = N(t.b2_toiMaxRootIters, a), ++S === r) break;
        }
        if (++f, ++t.b2_toiIters, c) break;
        if (20 === f) {
          e.state = t.b2TOIOutputState.e_failed, e.t = p;
          break;
        }
      }
      t.b2_toiMaxIters = N(t.b2_toiMaxIters, f);
      const B = s.GetMilliseconds();
      t.b2_toiMaxTime = N(t.b2_toiMaxTime, B), t.b2_toiTime += B;
    }
    const Pe = new it(),
      Ie = new it();
    function Ge(e, i, s, o, n) {
      e.pointCount = 0;
      const r = lt.MulXV(s, i.m_p, Pe),
        a = lt.MulXV(n, o.m_p, Ie),
        l = it.DistanceSquaredVV(r, a),
        m = i.m_radius + o.m_radius;
      l > m * m || (e.type = t.b2ManifoldType.e_circles, e.localPoint.Copy(i.m_p), e.localNormal.SetZero(), e.pointCount = 1, e.points[0].localPoint.Copy(o.m_p), e.points[0].id.key = 0);
    }
    const De = new it(),
      Fe = new it(),
      Te = new it();
    function Le(e, o, n, r, a) {
      e.pointCount = 0;
      const l = lt.MulXV(a, r.m_p, De),
        m = lt.MulTXV(n, l, Fe);
      let h = 0,
        _ = -i;
      const c = o.m_radius + r.m_radius,
        u = o.m_count,
        d = o.m_vertices,
        p = o.m_normals;
      for (let t = 0; t < u; ++t) {
        const e = it.DotVV(p[t], it.SubVV(m, d[t], it.s_t0));
        if (e > c) return;
        e > _ && (_ = e, h = t);
      }
      const f = h,
        y = (f + 1) % u,
        x = d[f],
        B = d[y];
      if (_ < s) return e.pointCount = 1, e.type = t.b2ManifoldType.e_faceA, e.localNormal.Copy(p[h]), it.MidVV(x, B, e.localPoint), e.points[0].localPoint.Copy(r.m_p), void (e.points[0].id.key = 0);
      const S = it.DotVV(it.SubVV(m, x, it.s_t0), it.SubVV(B, x, it.s_t1)),
        b = it.DotVV(it.SubVV(m, B, it.s_t0), it.SubVV(x, B, it.s_t1));
      if (S <= 0) {
        if (it.DistanceSquaredVV(m, x) > c * c) return;
        e.pointCount = 1, e.type = t.b2ManifoldType.e_faceA, it.SubVV(m, x, e.localNormal).SelfNormalize(), e.localPoint.Copy(x), e.points[0].localPoint.Copy(r.m_p), e.points[0].id.key = 0;
      } else if (b <= 0) {
        if (it.DistanceSquaredVV(m, B) > c * c) return;
        e.pointCount = 1, e.type = t.b2ManifoldType.e_faceA, it.SubVV(m, B, e.localNormal).SelfNormalize(), e.localPoint.Copy(B), e.points[0].localPoint.Copy(r.m_p), e.points[0].id.key = 0;
      } else {
        const i = it.MidVV(x, B, Te),
          s = it.DotVV(it.SubVV(m, i, it.s_t1), p[f]);
        if (s > c) return;
        e.pointCount = 1, e.type = t.b2ManifoldType.e_faceA, e.localNormal.Copy(p[f]).SelfNormalize(), e.localPoint.Copy(i), e.points[0].localPoint.Copy(r.m_p), e.points[0].id.key = 0;
      }
    }
    const Re = new it(),
      ke = new it(),
      qe = new it(),
      ze = new it();
    function Ee(t, e, s, o, n) {
      const r = t.m_vertices,
        a = t.m_normals,
        l = o.m_count,
        m = o.m_vertices,
        h = at.MulRV(e.q, a[s], Re),
        _ = at.MulTRV(n.q, h, ke);
      let c = 0,
        u = i;
      for (let t = 0; t < l; ++t) {
        const e = it.DotVV(m[t], _);
        e < u && (u = e, c = t);
      }
      const d = lt.MulXV(e, r[s], qe),
        p = lt.MulXV(n, m[c], ze),
        f = it.DotVV(it.SubVV(p, d, it.s_t0), h);
      return f;
    }
    const Je = new it(),
      Oe = new it();
    function je(t, e, s, o, n) {
      const r = e.m_count,
        a = e.m_normals,
        l = it.SubVV(lt.MulXV(n, o.m_centroid, it.s_t0), lt.MulXV(s, e.m_centroid, it.s_t1), Je),
        m = at.MulTRV(s.q, l, Oe);
      let h = 0,
        _ = -i;
      for (let t = 0; t < r; ++t) {
        const e = it.DotVV(a[t], m);
        e > _ && (_ = e, h = t);
      }
      let c = Ee(e, s, h, o, n);
      const u = (h + r - 1) % r,
        d = Ee(e, s, u, o, n),
        p = (h + 1) % r,
        f = Ee(e, s, p, o, n);
      let y = 0,
        x = 0,
        B = 0;
      if (d > c && d > f) B = -1, y = u, x = d;else {
        if (!(f > c)) return t[0] = h, c;
        B = 1, y = p, x = f;
      }
      for (; (c = Ee(e, s, h = -1 === B ? (y + r - 1) % r : (y + 1) % r, o, n)) > x;) y = h, x = c;
      return t[0] = y, x;
    }
    const Ne = new it(),
      Xe = Xt.MakeArray(2),
      Ue = Xt.MakeArray(2),
      We = Xt.MakeArray(2),
      Ze = [0],
      He = [0],
      Qe = new it(),
      Ye = new it(),
      Ke = new it(),
      $e = new it(),
      ti = new it(),
      ei = new it(),
      ii = new it(),
      si = new it();
    function oi(e, s, o, n, a) {
      e.pointCount = 0;
      const l = s.m_radius + n.m_radius,
        m = Ze;
      m[0] = 0;
      const h = je(m, s, o, n, a);
      if (h > l) return;
      const _ = He;
      _[0] = 0;
      const c = je(_, n, a, s, o);
      if (c > l) return;
      let u,
        d,
        p,
        f,
        y = 0,
        x = 0;
      c > .98 * h + .001 ? (u = n, d = s, p = a, f = o, y = _[0], e.type = t.b2ManifoldType.e_faceB, x = 1) : (u = s, d = n, p = o, f = a, y = m[0], e.type = t.b2ManifoldType.e_faceA, x = 0);
      const B = Xe;
      !function (e, s, o, n, r, a) {
        const l = s.m_normals,
          m = r.m_count,
          h = r.m_vertices,
          _ = r.m_normals,
          c = at.MulTRV(a.q, at.MulRV(o.q, l[n], it.s_t0), Ne);
        let u = 0,
          d = i;
        for (let t = 0; t < m; ++t) {
          const e = it.DotVV(c, _[t]);
          e < d && (d = e, u = t);
        }
        const p = u,
          f = (p + 1) % m,
          y = e[0];
        lt.MulXV(a, h[p], y.v);
        const x = y.id.cf;
        x.indexA = n, x.indexB = p, x.typeA = t.b2ContactFeatureType.e_face, x.typeB = t.b2ContactFeatureType.e_vertex;
        const B = e[1];
        lt.MulXV(a, h[f], B.v);
        const S = B.id.cf;
        S.indexA = n, S.indexB = f, S.typeA = t.b2ContactFeatureType.e_face, S.typeB = t.b2ContactFeatureType.e_vertex;
      }(B, u, p, y, d, f);
      const S = u.m_count,
        b = u.m_vertices,
        A = y,
        C = (y + 1) % S,
        V = b[A],
        g = b[C],
        w = it.SubVV(g, V, Qe);
      w.Normalize();
      const v = it.CrossVOne(w, Ye),
        M = it.MidVV(V, g, Ke),
        P = at.MulRV(p.q, w, ti),
        I = it.CrossVOne(P, $e),
        G = lt.MulXV(p, V, ii),
        D = lt.MulXV(p, g, si),
        F = it.DotVV(I, G),
        T = -it.DotVV(P, G) + l,
        L = it.DotVV(P, D) + l,
        R = Ue,
        k = We;
      let q;
      const z = it.NegV(P, ei);
      if ((q = Qt(R, B, z, T, A)) < 2) return;
      if ((q = Qt(k, R, P, L, C)) < 2) return;
      e.localNormal.Copy(v), e.localPoint.Copy(M);
      let E = 0;
      for (let t = 0; t < r; ++t) {
        const i = k[t],
          s = it.DotVV(I, i.v) - F;
        if (s <= l) {
          const t = e.points[E];
          if (lt.MulTXV(f, i.v, t.localPoint), t.id.Copy(i.id), x) {
            const e = t.id.cf;
            t.id.cf.indexA = e.indexB, t.id.cf.indexB = e.indexA, t.id.cf.typeA = e.typeB, t.id.cf.typeB = e.typeA;
          }
          ++E;
        }
      }
      e.pointCount = E;
    }
    const ni = new it(),
      ri = new it(),
      ai = new it(),
      li = new it(),
      mi = new it(),
      hi = new it(),
      _i = new it(),
      ci = new Jt();
    function ui(e, i, s, o, n) {
      e.pointCount = 0;
      const r = lt.MulTXV(s, lt.MulXV(n, o.m_p, it.s_t0), ni),
        a = i.m_vertex1,
        l = i.m_vertex2,
        m = it.SubVV(l, a, ri),
        h = it.DotVV(m, it.SubVV(l, r, it.s_t0)),
        _ = it.DotVV(m, it.SubVV(r, a, it.s_t0)),
        c = i.m_radius + o.m_radius,
        u = ci;
      if (u.cf.indexB = 0, u.cf.typeB = t.b2ContactFeatureType.e_vertex, _ <= 0) {
        const s = a,
          n = it.SubVV(r, s, ai),
          l = it.DotVV(n, n);
        if (l > c * c) return;
        if (i.m_hasVertex0) {
          const t = i.m_vertex0,
            e = a,
            s = it.SubVV(e, t, li),
            o = it.DotVV(s, it.SubVV(e, r, it.s_t0));
          if (o > 0) return;
        }
        return u.cf.indexA = 0, u.cf.typeA = t.b2ContactFeatureType.e_vertex, e.pointCount = 1, e.type = t.b2ManifoldType.e_circles, e.localNormal.SetZero(), e.localPoint.Copy(s), e.points[0].id.Copy(u), void e.points[0].localPoint.Copy(o.m_p);
      }
      if (h <= 0) {
        const s = l,
          n = it.SubVV(r, s, ai),
          a = it.DotVV(n, n);
        if (a > c * c) return;
        if (i.m_hasVertex3) {
          const t = i.m_vertex3,
            e = l,
            s = it.SubVV(t, e, mi),
            o = it.DotVV(s, it.SubVV(r, e, it.s_t0));
          if (o > 0) return;
        }
        return u.cf.indexA = 1, u.cf.typeA = t.b2ContactFeatureType.e_vertex, e.pointCount = 1, e.type = t.b2ManifoldType.e_circles, e.localNormal.SetZero(), e.localPoint.Copy(s), e.points[0].id.Copy(u), void e.points[0].localPoint.Copy(o.m_p);
      }
      const d = it.DotVV(m, m),
        p = hi;
      p.x = 1 / d * (h * a.x + _ * l.x), p.y = 1 / d * (h * a.y + _ * l.y);
      const f = it.SubVV(r, p, ai),
        y = it.DotVV(f, f);
      if (y > c * c) return;
      const x = _i.Set(-m.y, m.x);
      it.DotVV(x, it.SubVV(r, a, it.s_t0)) < 0 && x.Set(-x.x, -x.y), x.Normalize(), u.cf.indexA = 0, u.cf.typeA = t.b2ContactFeatureType.e_face, e.pointCount = 1, e.type = t.b2ManifoldType.e_faceA, e.localNormal.Copy(x), e.localPoint.Copy(a), e.points[0].id.Copy(u), e.points[0].localPoint.Copy(o.m_p);
    }
    class di {
      constructor() {
        this.type = 0, this.index = 0, this.separation = 0;
      }
    }
    class pi {
      constructor() {
        this.vertices = [], this.normals = [], this.count = 0;
      }
    }
    class fi {
      constructor() {
        this.m_polygonB = new pi(), this.m_xf = new lt(), this.m_centroidB = new it(), this.m_v0 = new it(), this.m_v1 = new it(), this.m_v2 = new it(), this.m_v3 = new it(), this.m_normal0 = new it(), this.m_normal1 = new it(), this.m_normal2 = new it(), this.m_normal = new it(), this.m_type1 = 0, this.m_type2 = 0, this.m_lowerLimit = new it(), this.m_upperLimit = new it(), this.m_radius = 0, this.m_front = !1;
      }
      Collide(e, i, s, o, n) {
        lt.MulTXX(s, n, this.m_xf), lt.MulXV(this.m_xf, o.m_centroid, this.m_centroidB), this.m_v0.Copy(i.m_vertex0), this.m_v1.Copy(i.m_vertex1), this.m_v2.Copy(i.m_vertex2), this.m_v3.Copy(i.m_vertex3);
        const a = i.m_hasVertex0,
          l = i.m_hasVertex3,
          m = it.SubVV(this.m_v2, this.m_v1, fi.s_edge1);
        m.Normalize(), this.m_normal1.Set(m.y, -m.x);
        const h = it.DotVV(this.m_normal1, it.SubVV(this.m_centroidB, this.m_v1, it.s_t0));
        let _ = 0,
          c = 0,
          u = !1,
          d = !1;
        if (a) {
          const t = it.SubVV(this.m_v1, this.m_v0, fi.s_edge0);
          t.Normalize(), this.m_normal0.Set(t.y, -t.x), u = it.CrossVV(t, m) >= 0, _ = it.DotVV(this.m_normal0, it.SubVV(this.m_centroidB, this.m_v0, it.s_t0));
        }
        if (l) {
          const t = it.SubVV(this.m_v3, this.m_v2, fi.s_edge2);
          t.Normalize(), this.m_normal2.Set(t.y, -t.x), d = it.CrossVV(m, t) > 0, c = it.DotVV(this.m_normal2, it.SubVV(this.m_centroidB, this.m_v2, it.s_t0));
        }
        a && l ? u && d ? (this.m_front = _ >= 0 || h >= 0 || c >= 0, this.m_front ? (this.m_normal.Copy(this.m_normal1), this.m_lowerLimit.Copy(this.m_normal0), this.m_upperLimit.Copy(this.m_normal2)) : (this.m_normal.Copy(this.m_normal1).SelfNeg(), this.m_lowerLimit.Copy(this.m_normal1).SelfNeg(), this.m_upperLimit.Copy(this.m_normal1).SelfNeg())) : u ? (this.m_front = _ >= 0 || h >= 0 && c >= 0, this.m_front ? (this.m_normal.Copy(this.m_normal1), this.m_lowerLimit.Copy(this.m_normal0), this.m_upperLimit.Copy(this.m_normal1)) : (this.m_normal.Copy(this.m_normal1).SelfNeg(), this.m_lowerLimit.Copy(this.m_normal2).SelfNeg(), this.m_upperLimit.Copy(this.m_normal1).SelfNeg())) : d ? (this.m_front = c >= 0 || _ >= 0 && h >= 0, this.m_front ? (this.m_normal.Copy(this.m_normal1), this.m_lowerLimit.Copy(this.m_normal1), this.m_upperLimit.Copy(this.m_normal2)) : (this.m_normal.Copy(this.m_normal1).SelfNeg(), this.m_lowerLimit.Copy(this.m_normal1).SelfNeg(), this.m_upperLimit.Copy(this.m_normal0).SelfNeg())) : (this.m_front = _ >= 0 && h >= 0 && c >= 0, this.m_front ? (this.m_normal.Copy(this.m_normal1), this.m_lowerLimit.Copy(this.m_normal1), this.m_upperLimit.Copy(this.m_normal1)) : (this.m_normal.Copy(this.m_normal1).SelfNeg(), this.m_lowerLimit.Copy(this.m_normal2).SelfNeg(), this.m_upperLimit.Copy(this.m_normal0).SelfNeg())) : a ? u ? (this.m_front = _ >= 0 || h >= 0, this.m_front ? (this.m_normal.Copy(this.m_normal1), this.m_lowerLimit.Copy(this.m_normal0), this.m_upperLimit.Copy(this.m_normal1).SelfNeg()) : (this.m_normal.Copy(this.m_normal1).SelfNeg(), this.m_lowerLimit.Copy(this.m_normal1), this.m_upperLimit.Copy(this.m_normal1).SelfNeg())) : (this.m_front = _ >= 0 && h >= 0, this.m_front ? (this.m_normal.Copy(this.m_normal1), this.m_lowerLimit.Copy(this.m_normal1), this.m_upperLimit.Copy(this.m_normal1).SelfNeg()) : (this.m_normal.Copy(this.m_normal1).SelfNeg(), this.m_lowerLimit.Copy(this.m_normal1), this.m_upperLimit.Copy(this.m_normal0).SelfNeg())) : l ? d ? (this.m_front = h >= 0 || c >= 0, this.m_front ? (this.m_normal.Copy(this.m_normal1), this.m_lowerLimit.Copy(this.m_normal1).SelfNeg(), this.m_upperLimit.Copy(this.m_normal2)) : (this.m_normal.Copy(this.m_normal1).SelfNeg(), this.m_lowerLimit.Copy(this.m_normal1).SelfNeg(), this.m_upperLimit.Copy(this.m_normal1))) : (this.m_front = h >= 0 && c >= 0, this.m_front ? (this.m_normal.Copy(this.m_normal1), this.m_lowerLimit.Copy(this.m_normal1).SelfNeg(), this.m_upperLimit.Copy(this.m_normal1)) : (this.m_normal.Copy(this.m_normal1).SelfNeg(), this.m_lowerLimit.Copy(this.m_normal2).SelfNeg(), this.m_upperLimit.Copy(this.m_normal1))) : (this.m_front = h >= 0, this.m_front ? (this.m_normal.Copy(this.m_normal1), this.m_lowerLimit.Copy(this.m_normal1).SelfNeg(), this.m_upperLimit.Copy(this.m_normal1).SelfNeg()) : (this.m_normal.Copy(this.m_normal1).SelfNeg(), this.m_lowerLimit.Copy(this.m_normal1), this.m_upperLimit.Copy(this.m_normal1))), this.m_polygonB.count = o.m_count;
        for (let t = 0; t < o.m_count; ++t) this.m_polygonB.vertices.length <= t && this.m_polygonB.vertices.push(new it()), this.m_polygonB.normals.length <= t && this.m_polygonB.normals.push(new it()), lt.MulXV(this.m_xf, o.m_vertices[t], this.m_polygonB.vertices[t]), at.MulRV(this.m_xf.q, o.m_normals[t], this.m_polygonB.normals[t]);
        this.m_radius = o.m_radius + i.m_radius, e.pointCount = 0;
        const p = this.ComputeEdgeSeparation(fi.s_edgeAxis);
        if (0 === p.type) return;
        if (p.separation > this.m_radius) return;
        const f = this.ComputePolygonSeparation(fi.s_polygonAxis);
        if (0 !== f.type && f.separation > this.m_radius) return;
        let y;
        y = 0 === f.type ? p : f.separation > .98 * p.separation + .001 ? f : p;
        const x = fi.s_ie,
          B = fi.s_rf;
        if (1 === y.type) {
          e.type = t.b2ManifoldType.e_faceA;
          let i = 0,
            s = it.DotVV(this.m_normal, this.m_polygonB.normals[0]);
          for (let t = 1; t < this.m_polygonB.count; ++t) {
            const e = it.DotVV(this.m_normal, this.m_polygonB.normals[t]);
            e < s && (s = e, i = t);
          }
          const o = i,
            n = (o + 1) % this.m_polygonB.count,
            r = x[0];
          r.v.Copy(this.m_polygonB.vertices[o]), r.id.cf.indexA = 0, r.id.cf.indexB = o, r.id.cf.typeA = t.b2ContactFeatureType.e_face, r.id.cf.typeB = t.b2ContactFeatureType.e_vertex;
          const a = x[1];
          a.v.Copy(this.m_polygonB.vertices[n]), a.id.cf.indexA = 0, a.id.cf.indexB = n, a.id.cf.typeA = t.b2ContactFeatureType.e_face, a.id.cf.typeB = t.b2ContactFeatureType.e_vertex, this.m_front ? (B.i1 = 0, B.i2 = 1, B.v1.Copy(this.m_v1), B.v2.Copy(this.m_v2), B.normal.Copy(this.m_normal1)) : (B.i1 = 1, B.i2 = 0, B.v1.Copy(this.m_v2), B.v2.Copy(this.m_v1), B.normal.Copy(this.m_normal1).SelfNeg());
        } else {
          e.type = t.b2ManifoldType.e_faceB;
          const i = x[0];
          i.v.Copy(this.m_v1), i.id.cf.indexA = 0, i.id.cf.indexB = y.index, i.id.cf.typeA = t.b2ContactFeatureType.e_vertex, i.id.cf.typeB = t.b2ContactFeatureType.e_face;
          const s = x[1];
          s.v.Copy(this.m_v2), s.id.cf.indexA = 0, s.id.cf.indexB = y.index, s.id.cf.typeA = t.b2ContactFeatureType.e_vertex, s.id.cf.typeB = t.b2ContactFeatureType.e_face, B.i1 = y.index, B.i2 = (B.i1 + 1) % this.m_polygonB.count, B.v1.Copy(this.m_polygonB.vertices[B.i1]), B.v2.Copy(this.m_polygonB.vertices[B.i2]), B.normal.Copy(this.m_polygonB.normals[B.i1]);
        }
        B.sideNormal1.Set(B.normal.y, -B.normal.x), B.sideNormal2.Copy(B.sideNormal1).SelfNeg(), B.sideOffset1 = it.DotVV(B.sideNormal1, B.v1), B.sideOffset2 = it.DotVV(B.sideNormal2, B.v2);
        const S = fi.s_clipPoints1,
          b = fi.s_clipPoints2;
        let A = 0;
        if ((A = Qt(S, x, B.sideNormal1, B.sideOffset1, B.i1)) < r) return;
        if ((A = Qt(b, S, B.sideNormal2, B.sideOffset2, B.i2)) < r) return;
        1 === y.type ? (e.localNormal.Copy(B.normal), e.localPoint.Copy(B.v1)) : (e.localNormal.Copy(o.m_normals[B.i1]), e.localPoint.Copy(o.m_vertices[B.i1]));
        let C = 0;
        for (let t = 0; t < r; ++t) {
          let i;
          if ((i = it.DotVV(B.normal, it.SubVV(b[t].v, B.v1, it.s_t0))) <= this.m_radius) {
            const i = e.points[C];
            1 === y.type ? (lt.MulTXV(this.m_xf, b[t].v, i.localPoint), i.id = b[t].id) : (i.localPoint.Copy(b[t].v), i.id.cf.typeA = b[t].id.cf.typeB, i.id.cf.typeB = b[t].id.cf.typeA, i.id.cf.indexA = b[t].id.cf.indexB, i.id.cf.indexB = b[t].id.cf.indexA), ++C;
          }
        }
        e.pointCount = C;
      }
      ComputeEdgeSeparation(t) {
        const e = t;
        e.type = 1, e.index = this.m_front ? 0 : 1, e.separation = i;
        for (let t = 0; t < this.m_polygonB.count; ++t) {
          const i = it.DotVV(this.m_normal, it.SubVV(this.m_polygonB.vertices[t], this.m_v1, it.s_t0));
          i < e.separation && (e.separation = i);
        }
        return e;
      }
      ComputePolygonSeparation(t) {
        const e = t;
        e.type = 0, e.index = -1, e.separation = -i;
        const s = fi.s_perp.Set(-this.m_normal.y, this.m_normal.x);
        for (let t = 0; t < this.m_polygonB.count; ++t) {
          const i = it.NegV(this.m_polygonB.normals[t], fi.s_n),
            o = it.DotVV(i, it.SubVV(this.m_polygonB.vertices[t], this.m_v1, it.s_t0)),
            n = it.DotVV(i, it.SubVV(this.m_polygonB.vertices[t], this.m_v2, it.s_t0)),
            r = j(o, n);
          if (r > this.m_radius) return e.type = 2, e.index = t, e.separation = r, e;
          if (it.DotVV(i, s) >= 0) {
            if (it.DotVV(it.SubVV(i, this.m_upperLimit, it.s_t0), this.m_normal) < -_) continue;
          } else if (it.DotVV(it.SubVV(i, this.m_lowerLimit, it.s_t0), this.m_normal) < -_) continue;
          r > e.separation && (e.type = 2, e.index = t, e.separation = r);
        }
        return e;
      }
    }
    fi.s_edge1 = new it(), fi.s_edge0 = new it(), fi.s_edge2 = new it(), fi.s_ie = Xt.MakeArray(2), fi.s_rf = new class {
      constructor() {
        this.i1 = 0, this.i2 = 0, this.v1 = new it(), this.v2 = new it(), this.normal = new it(), this.sideNormal1 = new it(), this.sideOffset1 = 0, this.sideNormal2 = new it(), this.sideOffset2 = 0;
      }
    }(), fi.s_clipPoints1 = Xt.MakeArray(2), fi.s_clipPoints2 = Xt.MakeArray(2), fi.s_edgeAxis = new di(), fi.s_polygonAxis = new di(), fi.s_n = new it(), fi.s_perp = new it();
    const yi = new fi();
    function xi(t, e, i, s, o) {
      const n = yi;
      n.Collide(t, e, i, s, o);
    }
    class Bi {
      constructor() {
        this.mass = 0, this.center = new it(0, 0), this.I = 0;
      }
    }
    var Si, bi, Ai, Ci;
    (Si = t.b2ShapeType || (t.b2ShapeType = {}))[Si.e_unknown = -1] = "e_unknown", Si[Si.e_circleShape = 0] = "e_circleShape", Si[Si.e_edgeShape = 1] = "e_edgeShape", Si[Si.e_polygonShape = 2] = "e_polygonShape", Si[Si.e_chainShape = 3] = "e_chainShape", Si[Si.e_shapeTypeCount = 4] = "e_shapeTypeCount";
    class Vi {
      constructor(e, i) {
        this.m_type = t.b2ShapeType.e_unknown, this.m_radius = 0, this.m_type = e, this.m_radius = i;
      }
      Copy(t) {
        return this.m_radius = t.m_radius, this;
      }
      GetType() {
        return this.m_type;
      }
    }
    class gi extends Vi {
      constructor() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        super(t.b2ShapeType.e_circleShape, e), this.m_p = new it();
      }
      Set(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.m_radius;
        return this.m_p.Copy(t), this.m_radius = e, this;
      }
      Clone() {
        return new gi().Copy(this);
      }
      Copy(t) {
        return super.Copy(t), this.m_p.Copy(t.m_p), this;
      }
      GetChildCount() {
        return 1;
      }
      TestPoint(t, e) {
        const i = lt.MulXV(t, this.m_p, gi.TestPoint_s_center),
          s = it.SubVV(e, i, gi.TestPoint_s_d);
        return it.DotVV(s, s) <= W(this.m_radius);
      }
      ComputeDistance(t, e, i, s) {
        const o = lt.MulXV(t, this.m_p, gi.ComputeDistance_s_center);
        return it.SubVV(e, o, i), i.Normalize() - this.m_radius;
      }
      RayCast(t, e, i, o) {
        const n = lt.MulXV(i, this.m_p, gi.RayCast_s_position),
          r = it.SubVV(e.p1, n, gi.RayCast_s_s),
          a = it.DotVV(r, r) - W(this.m_radius),
          l = it.SubVV(e.p2, e.p1, gi.RayCast_s_r),
          m = it.DotVV(r, l),
          h = it.DotVV(l, l),
          _ = m * m - h * a;
        if (_ < 0 || h < s) return !1;
        let c = -(m + H(_));
        return 0 <= c && c <= e.maxFraction * h && (c /= h, t.fraction = c, it.AddVMulSV(r, c, l, t.normal).SelfNormalize(), !0);
      }
      ComputeAABB(t, e, i) {
        const s = lt.MulXV(e, this.m_p, gi.ComputeAABB_s_p);
        t.lowerBound.Set(s.x - this.m_radius, s.y - this.m_radius), t.upperBound.Set(s.x + this.m_radius, s.y + this.m_radius);
      }
      ComputeMass(t, e) {
        const i = W(this.m_radius);
        t.mass = e * n * i, t.center.Copy(this.m_p), t.I = t.mass * (.5 * i + it.DotVV(this.m_p, this.m_p));
      }
      SetupDistanceProxy(t, e) {
        t.m_vertices = t.m_buffer, t.m_vertices[0].Copy(this.m_p), t.m_count = 1, t.m_radius = this.m_radius;
      }
      ComputeSubmergedArea(t, e, i, o) {
        const r = lt.MulXV(i, this.m_p, new it()),
          a = -(it.DotVV(t, r) - e);
        if (a < -this.m_radius + s) return 0;
        if (a > this.m_radius) return o.Copy(r), n * this.m_radius * this.m_radius;
        const l = this.m_radius * this.m_radius,
          m = a * a,
          h = l * (tt(a / this.m_radius) + n / 2) + a * H(l - m),
          _ = -2 / 3 * Q(l - m, 1.5) / h;
        return o.x = r.x + t.x * _, o.y = r.y + t.y * _, h;
      }
      Dump(t) {
        t("    const shape: b2CircleShape = new b2CircleShape();\n"), t("    shape.m_radius = %.15f;\n", this.m_radius), t("    shape.m_p.Set(%.15f, %.15f);\n", this.m_p.x, this.m_p.y);
      }
    }
    gi.TestPoint_s_center = new it(), gi.TestPoint_s_d = new it(), gi.ComputeDistance_s_center = new it(), gi.RayCast_s_position = new it(), gi.RayCast_s_s = new it(), gi.RayCast_s_r = new it(), gi.ComputeAABB_s_p = new it();
    class wi extends Vi {
      constructor() {
        super(t.b2ShapeType.e_polygonShape, c), this.m_centroid = new it(0, 0), this.m_vertices = [], this.m_normals = [], this.m_count = 0;
      }
      Clone() {
        return new wi().Copy(this);
      }
      Copy(t) {
        super.Copy(t), this.m_centroid.Copy(t.m_centroid), this.m_count = t.m_count, this.m_vertices = it.MakeArray(this.m_count), this.m_normals = it.MakeArray(this.m_count);
        for (let e = 0; e < this.m_count; ++e) this.m_vertices[e].Copy(t.m_vertices[e]), this.m_normals[e].Copy(t.m_normals[e]);
        return this;
      }
      GetChildCount() {
        return 1;
      }
      Set(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : t.length;
        let i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        if (e < 3) return this.SetAsBox(1, 1);
        let s = e;
        const o = [];
        for (let e = 0; e < s; ++e) {
          const s = t[i + e];
          let n = !0;
          for (let t = 0; t < o.length; ++t) if (it.DistanceSquaredVV(s, o[t]) < .5 * h * (.5 * h)) {
            n = !1;
            break;
          }
          n && o.push(s);
        }
        if ((s = o.length) < 3) return this.SetAsBox(1, 1);
        let n = 0,
          r = o[0].x;
        for (let t = 1; t < s; ++t) {
          const e = o[t].x;
          (e > r || e === r && o[t].y < o[n].y) && (n = t, r = e);
        }
        const a = [];
        let l = 0,
          m = n;
        for (;;) {
          a[l] = m;
          let t = 0;
          for (let e = 1; e < s; ++e) {
            if (t === m) {
              t = e;
              continue;
            }
            const i = it.SubVV(o[t], o[a[l]], wi.Set_s_r),
              s = it.SubVV(o[e], o[a[l]], wi.Set_s_v),
              n = it.CrossVV(i, s);
            n < 0 && (t = e), 0 === n && s.LengthSquared() > i.LengthSquared() && (t = e);
          }
          if (++l, m = t, t === n) break;
        }
        this.m_count = l, this.m_vertices = it.MakeArray(this.m_count), this.m_normals = it.MakeArray(this.m_count);
        for (let t = 0; t < l; ++t) this.m_vertices[t].Copy(o[a[t]]);
        for (let t = 0; t < l; ++t) {
          const e = this.m_vertices[t],
            i = this.m_vertices[(t + 1) % l],
            s = it.SubVV(i, e, it.s_t0);
          it.CrossVOne(s, this.m_normals[t]).SelfNormalize();
        }
        return wi.ComputeCentroid(this.m_vertices, l, this.m_centroid), this;
      }
      SetAsArray(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : t.length;
        return this.Set(t, e);
      }
      SetAsBox(t, e, i) {
        let s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        if (this.m_count = 4, this.m_vertices = it.MakeArray(this.m_count), this.m_normals = it.MakeArray(this.m_count), this.m_vertices[0].Set(-t, -e), this.m_vertices[1].Set(t, -e), this.m_vertices[2].Set(t, e), this.m_vertices[3].Set(-t, e), this.m_normals[0].Set(0, -1), this.m_normals[1].Set(1, 0), this.m_normals[2].Set(0, 1), this.m_normals[3].Set(-1, 0), this.m_centroid.SetZero(), i) {
          this.m_centroid.Copy(i);
          const t = new lt();
          t.SetPosition(i), t.SetRotationAngle(s);
          for (let e = 0; e < this.m_count; ++e) lt.MulXV(t, this.m_vertices[e], this.m_vertices[e]), at.MulRV(t.q, this.m_normals[e], this.m_normals[e]);
        }
        return this;
      }
      TestPoint(t, e) {
        const i = lt.MulTXV(t, e, wi.TestPoint_s_pLocal);
        for (let t = 0; t < this.m_count; ++t) {
          const e = it.DotVV(this.m_normals[t], it.SubVV(i, this.m_vertices[t], it.s_t0));
          if (e > 0) return !1;
        }
        return !0;
      }
      ComputeDistance(t, e, s, o) {
        const n = lt.MulTXV(t, e, wi.ComputeDistance_s_pLocal);
        let r = -i;
        const a = wi.ComputeDistance_s_normalForMaxDistance.Copy(n);
        for (let t = 0; t < this.m_count; ++t) {
          const e = it.DotVV(this.m_normals[t], it.SubVV(n, this.m_vertices[t], it.s_t0));
          e > r && (r = e, a.Copy(this.m_normals[t]));
        }
        if (r > 0) {
          const e = wi.ComputeDistance_s_minDistance.Copy(a);
          let i = r * r;
          for (let t = 0; t < this.m_count; ++t) {
            const s = it.SubVV(n, this.m_vertices[t], wi.ComputeDistance_s_distance),
              o = s.LengthSquared();
            i > o && (e.Copy(s), i = o);
          }
          return at.MulRV(t.q, e, s), s.Normalize(), Math.sqrt(i);
        }
        return at.MulRV(t.q, a, s), r;
      }
      RayCast(t, e, i, s) {
        const o = lt.MulTXV(i, e.p1, wi.RayCast_s_p1),
          n = lt.MulTXV(i, e.p2, wi.RayCast_s_p2),
          r = it.SubVV(n, o, wi.RayCast_s_d);
        let a = 0,
          l = e.maxFraction,
          m = -1;
        for (let t = 0; t < this.m_count; ++t) {
          const e = it.DotVV(this.m_normals[t], it.SubVV(this.m_vertices[t], o, it.s_t0)),
            i = it.DotVV(this.m_normals[t], r);
          if (0 === i) {
            if (e < 0) return !1;
          } else i < 0 && e < a * i ? (a = e / i, m = t) : i > 0 && e < l * i && (l = e / i);
          if (l < a) return !1;
        }
        return m >= 0 && (t.fraction = a, at.MulRV(i.q, this.m_normals[m], t.normal), !0);
      }
      ComputeAABB(t, e, i) {
        const s = lt.MulXV(e, this.m_vertices[0], t.lowerBound),
          o = t.upperBound.Copy(s);
        for (let t = 0; t < this.m_count; ++t) {
          const i = lt.MulXV(e, this.m_vertices[t], wi.ComputeAABB_s_v);
          it.MinV(i, s, s), it.MaxV(i, o, o);
        }
        const n = this.m_radius;
        s.SelfSubXY(n, n), o.SelfAddXY(n, n);
      }
      ComputeMass(t, e) {
        const i = wi.ComputeMass_s_center.SetZero();
        let s = 0,
          o = 0;
        const n = wi.ComputeMass_s_s.SetZero();
        for (let t = 0; t < this.m_count; ++t) n.SelfAdd(this.m_vertices[t]);
        n.SelfMul(1 / this.m_count);
        for (let t = 0; t < this.m_count; ++t) {
          const e = it.SubVV(this.m_vertices[t], n, wi.ComputeMass_s_e1),
            r = it.SubVV(this.m_vertices[(t + 1) % this.m_count], n, wi.ComputeMass_s_e2),
            a = it.CrossVV(e, r),
            l = .5 * a;
          s += l, i.SelfAdd(it.MulSV(l * (1 / 3), it.AddVV(e, r, it.s_t0), it.s_t1));
          const m = e.x,
            h = e.y,
            _ = r.x,
            c = r.y,
            u = m * m + _ * m + _ * _,
            d = h * h + c * h + c * c;
          o += 1 / 3 * .25 * a * (u + d);
        }
        t.mass = e * s, i.SelfMul(1 / s), it.AddVV(i, n, t.center), t.I = e * o, t.I += t.mass * (it.DotVV(t.center, t.center) - it.DotVV(i, i));
      }
      Validate() {
        for (let t = 0; t < this.m_count; ++t) {
          const e = t,
            i = (t + 1) % this.m_count,
            s = this.m_vertices[e],
            o = it.SubVV(this.m_vertices[i], s, wi.Validate_s_e);
          for (let t = 0; t < this.m_count; ++t) {
            if (t === e || t === i) continue;
            const n = it.SubVV(this.m_vertices[t], s, wi.Validate_s_v),
              r = it.CrossVV(o, n);
            if (r < 0) return !1;
          }
        }
        return !0;
      }
      SetupDistanceProxy(t, e) {
        t.m_vertices = this.m_vertices, t.m_count = this.m_count, t.m_radius = this.m_radius;
      }
      ComputeSubmergedArea(t, e, i, o) {
        const n = at.MulTRV(i.q, t, wi.ComputeSubmergedArea_s_normalL),
          r = e - it.DotVV(t, i.p),
          a = [];
        let l = 0,
          m = -1,
          h = -1,
          _ = !1;
        for (let t = 0; t < this.m_count; ++t) {
          a[t] = it.DotVV(n, this.m_vertices[t]) - r;
          const e = a[t] < -s;
          t > 0 && (e ? _ || (m = t - 1, l++) : _ && (h = t - 1, l++)), _ = e;
        }
        switch (l) {
          case 0:
            if (_) {
              const t = wi.ComputeSubmergedArea_s_md;
              return this.ComputeMass(t, 1), lt.MulXV(i, t.center, o), t.mass;
            }
            return 0;
          case 1:
            -1 === m ? m = this.m_count - 1 : h = this.m_count - 1;
        }
        const c = (m + 1) % this.m_count,
          u = (h + 1) % this.m_count,
          d = (0 - a[m]) / (a[c] - a[m]),
          p = (0 - a[h]) / (a[u] - a[h]),
          f = wi.ComputeSubmergedArea_s_intoVec.Set(this.m_vertices[m].x * (1 - d) + this.m_vertices[c].x * d, this.m_vertices[m].y * (1 - d) + this.m_vertices[c].y * d),
          y = wi.ComputeSubmergedArea_s_outoVec.Set(this.m_vertices[h].x * (1 - p) + this.m_vertices[u].x * p, this.m_vertices[h].y * (1 - p) + this.m_vertices[u].y * p);
        let x = 0;
        const B = wi.ComputeSubmergedArea_s_center.SetZero();
        let S,
          b = this.m_vertices[c],
          A = c;
        for (; A !== u;) {
          A = (A + 1) % this.m_count, S = A === u ? y : this.m_vertices[A];
          const t = .5 * ((b.x - f.x) * (S.y - f.y) - (b.y - f.y) * (S.x - f.x));
          x += t, B.x += t * (f.x + b.x + S.x) / 3, B.y += t * (f.y + b.y + S.y) / 3, b = S;
        }
        return B.SelfMul(1 / x), lt.MulXV(i, B, o), x;
      }
      Dump(t) {
        t("    const shape: b2PolygonShape = new b2PolygonShape();\n"), t("    const vs: b2Vec2[] = [];\n");
        for (let e = 0; e < this.m_count; ++e) t("    vs[%d] = new b2Vec2(%.15f, %.15f);\n", e, this.m_vertices[e].x, this.m_vertices[e].y);
        t("    shape.Set(vs, %d);\n", this.m_count);
      }
      static ComputeCentroid(t, e, i) {
        const s = i;
        s.SetZero();
        let o = 0;
        const n = wi.ComputeCentroid_s_pRef.SetZero();
        for (let i = 0; i < e; ++i) {
          const r = n,
            a = t[i],
            l = t[(i + 1) % e],
            m = it.SubVV(a, r, wi.ComputeCentroid_s_e1),
            h = it.SubVV(l, r, wi.ComputeCentroid_s_e2),
            _ = it.CrossVV(m, h),
            c = .5 * _;
          o += c, s.x += c * (1 / 3) * (r.x + a.x + l.x), s.y += c * (1 / 3) * (r.y + a.y + l.y);
        }
        return s.SelfMul(1 / o), s;
      }
    }
    wi.Set_s_r = new it(), wi.Set_s_v = new it(), wi.TestPoint_s_pLocal = new it(), wi.ComputeDistance_s_pLocal = new it(), wi.ComputeDistance_s_normalForMaxDistance = new it(), wi.ComputeDistance_s_minDistance = new it(), wi.ComputeDistance_s_distance = new it(), wi.RayCast_s_p1 = new it(), wi.RayCast_s_p2 = new it(), wi.RayCast_s_d = new it(), wi.ComputeAABB_s_v = new it(), wi.ComputeMass_s_center = new it(), wi.ComputeMass_s_s = new it(), wi.ComputeMass_s_e1 = new it(), wi.ComputeMass_s_e2 = new it(), wi.Validate_s_e = new it(), wi.Validate_s_v = new it(), wi.ComputeSubmergedArea_s_normalL = new it(), wi.ComputeSubmergedArea_s_md = new Bi(), wi.ComputeSubmergedArea_s_intoVec = new it(), wi.ComputeSubmergedArea_s_outoVec = new it(), wi.ComputeSubmergedArea_s_center = new it(), wi.ComputeCentroid_s_pRef = new it(), wi.ComputeCentroid_s_e1 = new it(), wi.ComputeCentroid_s_e2 = new it();
    class vi extends Vi {
      constructor() {
        super(t.b2ShapeType.e_edgeShape, c), this.m_vertex1 = new it(), this.m_vertex2 = new it(), this.m_vertex0 = new it(), this.m_vertex3 = new it(), this.m_hasVertex0 = !1, this.m_hasVertex3 = !1;
      }
      Set(t, e) {
        return this.m_vertex1.Copy(t), this.m_vertex2.Copy(e), this.m_hasVertex0 = !1, this.m_hasVertex3 = !1, this;
      }
      Clone() {
        return new vi().Copy(this);
      }
      Copy(t) {
        return super.Copy(t), this.m_vertex1.Copy(t.m_vertex1), this.m_vertex2.Copy(t.m_vertex2), this.m_vertex0.Copy(t.m_vertex0), this.m_vertex3.Copy(t.m_vertex3), this.m_hasVertex0 = t.m_hasVertex0, this.m_hasVertex3 = t.m_hasVertex3, this;
      }
      GetChildCount() {
        return 1;
      }
      TestPoint(t, e) {
        return !1;
      }
      ComputeDistance(t, e, i, s) {
        const o = lt.MulXV(t, this.m_vertex1, vi.ComputeDistance_s_v1),
          n = lt.MulXV(t, this.m_vertex2, vi.ComputeDistance_s_v2),
          r = it.SubVV(e, o, vi.ComputeDistance_s_d),
          a = it.SubVV(n, o, vi.ComputeDistance_s_s),
          l = it.DotVV(r, a);
        if (l > 0) {
          const t = it.DotVV(a, a);
          l > t ? it.SubVV(e, n, r) : r.SelfMulSub(l / t, a);
        }
        return i.Copy(r), i.Normalize();
      }
      RayCast(t, e, i, s) {
        const o = lt.MulTXV(i, e.p1, vi.RayCast_s_p1),
          n = lt.MulTXV(i, e.p2, vi.RayCast_s_p2),
          r = it.SubVV(n, o, vi.RayCast_s_d),
          a = this.m_vertex1,
          l = this.m_vertex2,
          m = it.SubVV(l, a, vi.RayCast_s_e),
          h = t.normal.Set(m.y, -m.x).SelfNormalize(),
          _ = it.DotVV(h, it.SubVV(a, o, it.s_t0)),
          c = it.DotVV(h, r);
        if (0 === c) return !1;
        const u = _ / c;
        if (u < 0 || e.maxFraction < u) return !1;
        const d = it.AddVMulSV(o, u, r, vi.RayCast_s_q),
          p = it.SubVV(l, a, vi.RayCast_s_r),
          f = it.DotVV(p, p);
        if (0 === f) return !1;
        const y = it.DotVV(it.SubVV(d, a, it.s_t0), p) / f;
        return !(y < 0 || 1 < y || (t.fraction = u, at.MulRV(i.q, t.normal, t.normal), _ > 0 && t.normal.SelfNeg(), 0));
      }
      ComputeAABB(t, e, i) {
        const s = lt.MulXV(e, this.m_vertex1, vi.ComputeAABB_s_v1),
          o = lt.MulXV(e, this.m_vertex2, vi.ComputeAABB_s_v2);
        it.MinV(s, o, t.lowerBound), it.MaxV(s, o, t.upperBound);
        const n = this.m_radius;
        t.lowerBound.SelfSubXY(n, n), t.upperBound.SelfAddXY(n, n);
      }
      ComputeMass(t, e) {
        t.mass = 0, it.MidVV(this.m_vertex1, this.m_vertex2, t.center), t.I = 0;
      }
      SetupDistanceProxy(t, e) {
        t.m_vertices = t.m_buffer, t.m_vertices[0].Copy(this.m_vertex1), t.m_vertices[1].Copy(this.m_vertex2), t.m_count = 2, t.m_radius = this.m_radius;
      }
      ComputeSubmergedArea(t, e, i, s) {
        return s.SetZero(), 0;
      }
      Dump(t) {
        t("    const shape: b2EdgeShape = new b2EdgeShape();\n"), t("    shape.m_radius = %.15f;\n", this.m_radius), t("    shape.m_vertex0.Set(%.15f, %.15f);\n", this.m_vertex0.x, this.m_vertex0.y), t("    shape.m_vertex1.Set(%.15f, %.15f);\n", this.m_vertex1.x, this.m_vertex1.y), t("    shape.m_vertex2.Set(%.15f, %.15f);\n", this.m_vertex2.x, this.m_vertex2.y), t("    shape.m_vertex3.Set(%.15f, %.15f);\n", this.m_vertex3.x, this.m_vertex3.y), t("    shape.m_hasVertex0 = %s;\n", this.m_hasVertex0), t("    shape.m_hasVertex3 = %s;\n", this.m_hasVertex3);
      }
    }
    vi.ComputeDistance_s_v1 = new it(), vi.ComputeDistance_s_v2 = new it(), vi.ComputeDistance_s_d = new it(), vi.ComputeDistance_s_s = new it(), vi.RayCast_s_p1 = new it(), vi.RayCast_s_p2 = new it(), vi.RayCast_s_d = new it(), vi.RayCast_s_e = new it(), vi.RayCast_s_q = new it(), vi.RayCast_s_r = new it(), vi.ComputeAABB_s_v1 = new it(), vi.ComputeAABB_s_v2 = new it();
    class Mi extends Vi {
      constructor() {
        super(t.b2ShapeType.e_chainShape, c), this.m_vertices = [], this.m_count = 0, this.m_prevVertex = new it(), this.m_nextVertex = new it(), this.m_hasPrevVertex = !1, this.m_hasNextVertex = !1;
      }
      CreateLoop(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : t.length;
        let i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        if (e < 3) return this;
        this.m_count = e + 1, this.m_vertices = it.MakeArray(this.m_count);
        for (let s = 0; s < e; ++s) this.m_vertices[s].Copy(t[i + s]);
        return this.m_vertices[e].Copy(this.m_vertices[0]), this.m_prevVertex.Copy(this.m_vertices[this.m_count - 2]), this.m_nextVertex.Copy(this.m_vertices[1]), this.m_hasPrevVertex = !0, this.m_hasNextVertex = !0, this;
      }
      CreateChain(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : t.length;
        let i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        this.m_count = e, this.m_vertices = it.MakeArray(e);
        for (let s = 0; s < e; ++s) this.m_vertices[s].Copy(t[i + s]);
        return this.m_hasPrevVertex = !1, this.m_hasNextVertex = !1, this.m_prevVertex.SetZero(), this.m_nextVertex.SetZero(), this;
      }
      SetPrevVertex(t) {
        return this.m_prevVertex.Copy(t), this.m_hasPrevVertex = !0, this;
      }
      SetNextVertex(t) {
        return this.m_nextVertex.Copy(t), this.m_hasNextVertex = !0, this;
      }
      Clone() {
        return new Mi().Copy(this);
      }
      Copy(t) {
        return super.Copy(t), this.CreateChain(t.m_vertices, t.m_count), this.m_prevVertex.Copy(t.m_prevVertex), this.m_nextVertex.Copy(t.m_nextVertex), this.m_hasPrevVertex = t.m_hasPrevVertex, this.m_hasNextVertex = t.m_hasNextVertex, this;
      }
      GetChildCount() {
        return this.m_count - 1;
      }
      GetChildEdge(e, i) {
        e.m_type = t.b2ShapeType.e_edgeShape, e.m_radius = this.m_radius, e.m_vertex1.Copy(this.m_vertices[i]), e.m_vertex2.Copy(this.m_vertices[i + 1]), i > 0 ? (e.m_vertex0.Copy(this.m_vertices[i - 1]), e.m_hasVertex0 = !0) : (e.m_vertex0.Copy(this.m_prevVertex), e.m_hasVertex0 = this.m_hasPrevVertex), i < this.m_count - 2 ? (e.m_vertex3.Copy(this.m_vertices[i + 2]), e.m_hasVertex3 = !0) : (e.m_vertex3.Copy(this.m_nextVertex), e.m_hasVertex3 = this.m_hasNextVertex);
      }
      TestPoint(t, e) {
        return !1;
      }
      ComputeDistance(t, e, i, s) {
        const o = Mi.ComputeDistance_s_edgeShape;
        return this.GetChildEdge(o, s), o.ComputeDistance(t, e, i, 0);
      }
      RayCast(t, e, i, s) {
        const o = Mi.RayCast_s_edgeShape;
        return o.m_vertex1.Copy(this.m_vertices[s]), o.m_vertex2.Copy(this.m_vertices[(s + 1) % this.m_count]), o.RayCast(t, e, i, 0);
      }
      ComputeAABB(t, e, i) {
        const s = this.m_vertices[i],
          o = this.m_vertices[(i + 1) % this.m_count],
          n = lt.MulXV(e, s, Mi.ComputeAABB_s_v1),
          r = lt.MulXV(e, o, Mi.ComputeAABB_s_v2);
        it.MinV(n, r, t.lowerBound), it.MaxV(n, r, t.upperBound);
      }
      ComputeMass(t, e) {
        t.mass = 0, t.center.SetZero(), t.I = 0;
      }
      SetupDistanceProxy(t, e) {
        t.m_vertices = t.m_buffer, t.m_vertices[0].Copy(this.m_vertices[e]), e + 1 < this.m_count ? t.m_vertices[1].Copy(this.m_vertices[e + 1]) : t.m_vertices[1].Copy(this.m_vertices[0]), t.m_count = 2, t.m_radius = this.m_radius;
      }
      ComputeSubmergedArea(t, e, i, s) {
        return s.SetZero(), 0;
      }
      Dump(t) {
        t("    const shape: b2ChainShape = new b2ChainShape();\n"), t("    const vs: b2Vec2[] = [];\n");
        for (let e = 0; e < this.m_count; ++e) t("    vs[%d] = new bVec2(%.15f, %.15f);\n", e, this.m_vertices[e].x, this.m_vertices[e].y);
        t("    shape.CreateChain(vs, %d);\n", this.m_count), t("    shape.m_prevVertex.Set(%.15f, %.15f);\n", this.m_prevVertex.x, this.m_prevVertex.y), t("    shape.m_nextVertex.Set(%.15f, %.15f);\n", this.m_nextVertex.x, this.m_nextVertex.y), t("    shape.m_hasPrevVertex = %s;\n", this.m_hasPrevVertex ? "true" : "false"), t("    shape.m_hasNextVertex = %s;\n", this.m_hasNextVertex ? "true" : "false");
      }
    }
    Mi.ComputeDistance_s_edgeShape = new vi(), Mi.RayCast_s_edgeShape = new vi(), Mi.ComputeAABB_s_v1 = new it(), Mi.ComputeAABB_s_v2 = new it();
    class Pi {
      constructor() {
        this.categoryBits = 1, this.maskBits = 65535, this.groupIndex = 0;
      }
      Clone() {
        return new Pi().Copy(this);
      }
      Copy(t) {
        return this.categoryBits = t.categoryBits, this.maskBits = t.maskBits, this.groupIndex = t.groupIndex || 0, this;
      }
    }
    Pi.DEFAULT = new Pi();
    class Ii {
      constructor() {
        this.userData = null, this.friction = .2, this.restitution = 0, this.density = 0, this.isSensor = !1, this.filter = new Pi();
      }
    }
    class Gi {
      constructor(t) {
        this.aabb = new Zt(), this.childIndex = 0, this.fixture = t;
      }
    }
    class Di {
      constructor(t, e) {
        this.m_density = 0, this.m_next = null, this.m_friction = 0, this.m_restitution = 0, this.m_proxies = [], this.m_proxyCount = 0, this.m_filter = new Pi(), this.m_isSensor = !1, this.m_userData = null, this.m_body = e, this.m_shape = t.shape.Clone();
      }
      GetType() {
        return this.m_shape.GetType();
      }
      GetShape() {
        return this.m_shape;
      }
      SetSensor(t) {
        t !== this.m_isSensor && (this.m_body.SetAwake(!0), this.m_isSensor = t);
      }
      IsSensor() {
        return this.m_isSensor;
      }
      SetFilterData(t) {
        this.m_filter.Copy(t), this.Refilter();
      }
      GetFilterData() {
        return this.m_filter;
      }
      Refilter() {
        let t = this.m_body.GetContactList();
        for (; t;) {
          const e = t.contact,
            i = e.GetFixtureA(),
            s = e.GetFixtureB();
          i !== this && s !== this || e.FlagForFiltering(), t = t.next;
        }
        const e = this.m_body.GetWorld();
        if (null === e) return;
        const i = e.m_contactManager.m_broadPhase;
        for (let t = 0; t < this.m_proxyCount; ++t) i.TouchProxy(this.m_proxies[t].treeNode);
      }
      GetBody() {
        return this.m_body;
      }
      GetNext() {
        return this.m_next;
      }
      GetUserData() {
        return this.m_userData;
      }
      SetUserData(t) {
        this.m_userData = t;
      }
      TestPoint(t) {
        return this.m_shape.TestPoint(this.m_body.GetTransform(), t);
      }
      ComputeDistance(t, e, i) {
        return this.m_shape.ComputeDistance(this.m_body.GetTransform(), t, e, i);
      }
      RayCast(t, e, i) {
        return this.m_shape.RayCast(t, e, this.m_body.GetTransform(), i);
      }
      GetMassData() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Bi();
        return this.m_shape.ComputeMass(t, this.m_density), t;
      }
      SetDensity(t) {
        this.m_density = t;
      }
      GetDensity() {
        return this.m_density;
      }
      GetFriction() {
        return this.m_friction;
      }
      SetFriction(t) {
        this.m_friction = t;
      }
      GetRestitution() {
        return this.m_restitution;
      }
      SetRestitution(t) {
        this.m_restitution = t;
      }
      GetAABB(t) {
        return this.m_proxies[t].aabb;
      }
      Dump(t, e) {
        t("    const fd: b2FixtureDef = new b2FixtureDef();\n"), t("    fd.friction = %.15f;\n", this.m_friction), t("    fd.restitution = %.15f;\n", this.m_restitution), t("    fd.density = %.15f;\n", this.m_density), t("    fd.isSensor = %s;\n", this.m_isSensor ? "true" : "false"), t("    fd.filter.categoryBits = %d;\n", this.m_filter.categoryBits), t("    fd.filter.maskBits = %d;\n", this.m_filter.maskBits), t("    fd.filter.groupIndex = %d;\n", this.m_filter.groupIndex), this.m_shape.Dump(t), t("\n"), t("    fd.shape = shape;\n"), t("\n"), t("    bodies[%d].CreateFixture(fd);\n", e);
      }
      Create(t) {
        this.m_userData = t.userData, this.m_friction = e(t.friction, .2), this.m_restitution = e(t.restitution, 0), this.m_next = null, this.m_filter.Copy(e(t.filter, Pi.DEFAULT)), this.m_isSensor = e(t.isSensor, !1), this.m_proxies = k(this.m_shape.GetChildCount(), t => new Gi(this)), this.m_proxyCount = 0, this.m_density = e(t.density, 0);
      }
      Destroy() {}
      CreateProxies(t) {
        const e = this.m_body.m_world.m_contactManager.m_broadPhase;
        this.m_proxyCount = this.m_shape.GetChildCount();
        for (let i = 0; i < this.m_proxyCount; ++i) {
          const s = this.m_proxies[i] = new Gi(this);
          this.m_shape.ComputeAABB(s.aabb, t, i), s.treeNode = e.CreateProxy(s.aabb, s), s.childIndex = i;
        }
      }
      DestroyProxies() {
        const t = this.m_body.m_world.m_contactManager.m_broadPhase;
        for (let e = 0; e < this.m_proxyCount; ++e) {
          const i = this.m_proxies[e];
          delete i.treeNode.userData, t.DestroyProxy(i.treeNode), delete i.treeNode;
        }
        this.m_proxyCount = 0;
      }
      TouchProxies() {
        const t = this.m_body.m_world.m_contactManager.m_broadPhase,
          e = this.m_proxyCount;
        for (let i = 0; i < e; ++i) t.TouchProxy(this.m_proxies[i].treeNode);
      }
      Synchronize(t, e) {
        if (0 === this.m_proxyCount) return;
        const i = this.m_body.m_world.m_contactManager.m_broadPhase;
        for (let s = 0; s < this.m_proxyCount; ++s) {
          const o = this.m_proxies[s],
            n = Di.Synchronize_s_aabb1,
            r = Di.Synchronize_s_aabb2;
          this.m_shape.ComputeAABB(n, t, s), this.m_shape.ComputeAABB(r, e, s), o.aabb.Combine2(n, r);
          const a = it.SubVV(e.p, t.p, Di.Synchronize_s_displacement);
          i.MoveProxy(o.treeNode, o.aabb, a);
        }
      }
    }
    Di.Synchronize_s_aabb1 = new Zt(), Di.Synchronize_s_aabb2 = new Zt(), Di.Synchronize_s_displacement = new it(), (bi = t.b2BodyType || (t.b2BodyType = {}))[bi.b2_unknown = -1] = "b2_unknown", bi[bi.b2_staticBody = 0] = "b2_staticBody", bi[bi.b2_kinematicBody = 1] = "b2_kinematicBody", bi[bi.b2_dynamicBody = 2] = "b2_dynamicBody";
    class Fi {
      constructor(i, s) {
        this.m_type = t.b2BodyType.b2_staticBody, this.m_islandFlag = !1, this.m_awakeFlag = !1, this.m_autoSleepFlag = !1, this.m_bulletFlag = !1, this.m_fixedRotationFlag = !1, this.m_activeFlag = !1, this.m_toiFlag = !1, this.m_islandIndex = 0, this.m_xf = new lt(), this.m_xf0 = new lt(), this.m_sweep = new mt(), this.m_linearVelocity = new it(), this.m_angularVelocity = 0, this.m_force = new it(), this.m_torque = 0, this.m_prev = null, this.m_next = null, this.m_fixtureList = null, this.m_fixtureCount = 0, this.m_jointList = null, this.m_contactList = null, this.m_mass = 1, this.m_invMass = 1, this.m_I = 0, this.m_invI = 0, this.m_linearDamping = 0, this.m_angularDamping = 0, this.m_gravityScale = 1, this.m_sleepTime = 0, this.m_userData = null, this.m_controllerList = null, this.m_controllerCount = 0, this.m_bulletFlag = e(i.bullet, !1), this.m_fixedRotationFlag = e(i.fixedRotation, !1), this.m_autoSleepFlag = e(i.allowSleep, !0), this.m_awakeFlag = e(i.awake, !0), this.m_activeFlag = e(i.active, !0), this.m_world = s, this.m_xf.p.Copy(e(i.position, it.ZERO)), this.m_xf.q.SetAngle(e(i.angle, 0)), this.m_xf0.Copy(this.m_xf), this.m_sweep.localCenter.SetZero(), this.m_sweep.c0.Copy(this.m_xf.p), this.m_sweep.c.Copy(this.m_xf.p), this.m_sweep.a0 = this.m_sweep.a = this.m_xf.q.GetAngle(), this.m_sweep.alpha0 = 0, this.m_linearVelocity.Copy(e(i.linearVelocity, it.ZERO)), this.m_angularVelocity = e(i.angularVelocity, 0), this.m_linearDamping = e(i.linearDamping, 0), this.m_angularDamping = e(i.angularDamping, 0), this.m_gravityScale = e(i.gravityScale, 1), this.m_force.SetZero(), this.m_torque = 0, this.m_sleepTime = 0, this.m_type = e(i.type, t.b2BodyType.b2_staticBody), i.type === t.b2BodyType.b2_dynamicBody ? (this.m_mass = 1, this.m_invMass = 1) : (this.m_mass = 0, this.m_invMass = 0), this.m_I = 0, this.m_invI = 0, this.m_userData = i.userData, this.m_fixtureList = null, this.m_fixtureCount = 0, this.m_controllerList = null, this.m_controllerCount = 0;
      }
      CreateFixture(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return t instanceof Vi ? this.CreateFixtureShapeDensity(t, e) : this.CreateFixtureDef(t);
      }
      CreateFixtureDef(t) {
        if (this.m_world.IsLocked()) throw new Error();
        const e = new Di(t, this);
        return e.Create(t), this.m_activeFlag && e.CreateProxies(this.m_xf), e.m_next = this.m_fixtureList, this.m_fixtureList = e, ++this.m_fixtureCount, e.m_density > 0 && this.ResetMassData(), this.m_world.m_newFixture = !0, e;
      }
      CreateFixtureShapeDensity(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        const i = Fi.CreateFixtureShapeDensity_s_def;
        return i.shape = t, i.density = e, this.CreateFixtureDef(i);
      }
      DestroyFixture(t) {
        if (this.m_world.IsLocked()) throw new Error();
        let e = this.m_fixtureList,
          i = null;
        for (; null !== e;) {
          if (e === t) {
            i ? i.m_next = t.m_next : this.m_fixtureList = t.m_next;
            break;
          }
          i = e, e = e.m_next;
        }
        let s = this.m_contactList;
        for (; s;) {
          const e = s.contact;
          s = s.next;
          const i = e.GetFixtureA(),
            o = e.GetFixtureB();
          t !== i && t !== o || this.m_world.m_contactManager.Destroy(e);
        }
        this.m_activeFlag && t.DestroyProxies(), t.m_next = null, t.Destroy(), --this.m_fixtureCount, this.ResetMassData();
      }
      SetTransformVec(t, e) {
        this.SetTransformXY(t.x, t.y, e);
      }
      SetTransformXY(t, e, i) {
        if (this.m_world.IsLocked()) throw new Error();
        this.m_xf.q.SetAngle(i), this.m_xf.p.Set(t, e), this.m_xf0.Copy(this.m_xf), lt.MulXV(this.m_xf, this.m_sweep.localCenter, this.m_sweep.c), this.m_sweep.a = i, this.m_sweep.c0.Copy(this.m_sweep.c), this.m_sweep.a0 = i;
        for (let t = this.m_fixtureList; t; t = t.m_next) t.Synchronize(this.m_xf, this.m_xf);
        this.m_world.m_contactManager.FindNewContacts();
      }
      SetTransform(t) {
        this.SetTransformVec(t.p, t.GetAngle());
      }
      GetTransform() {
        return this.m_xf;
      }
      GetPosition() {
        return this.m_xf.p;
      }
      SetPosition(t) {
        this.SetTransformVec(t, this.GetAngle());
      }
      SetPositionXY(t, e) {
        this.SetTransformXY(t, e, this.GetAngle());
      }
      GetAngle() {
        return this.m_sweep.a;
      }
      SetAngle(t) {
        this.SetTransformVec(this.GetPosition(), t);
      }
      GetWorldCenter() {
        return this.m_sweep.c;
      }
      GetLocalCenter() {
        return this.m_sweep.localCenter;
      }
      SetLinearVelocity(e) {
        this.m_type !== t.b2BodyType.b2_staticBody && (it.DotVV(e, e) > 0 && this.SetAwake(!0), this.m_linearVelocity.Copy(e));
      }
      GetLinearVelocity() {
        return this.m_linearVelocity;
      }
      SetAngularVelocity(e) {
        this.m_type !== t.b2BodyType.b2_staticBody && (e * e > 0 && this.SetAwake(!0), this.m_angularVelocity = e);
      }
      GetAngularVelocity() {
        return this.m_angularVelocity;
      }
      GetDefinition(t) {
        return t.type = this.GetType(), t.allowSleep = this.m_autoSleepFlag, t.angle = this.GetAngle(), t.angularDamping = this.m_angularDamping, t.gravityScale = this.m_gravityScale, t.angularVelocity = this.m_angularVelocity, t.fixedRotation = this.m_fixedRotationFlag, t.bullet = this.m_bulletFlag, t.awake = this.m_awakeFlag, t.linearDamping = this.m_linearDamping, t.linearVelocity.Copy(this.GetLinearVelocity()), t.position.Copy(this.GetPosition()), t.userData = this.GetUserData(), t;
      }
      ApplyForce(e, i) {
        let s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
        this.m_type === t.b2BodyType.b2_dynamicBody && (s && !this.m_awakeFlag && this.SetAwake(!0), this.m_awakeFlag && (this.m_force.x += e.x, this.m_force.y += e.y, this.m_torque += (i.x - this.m_sweep.c.x) * e.y - (i.y - this.m_sweep.c.y) * e.x));
      }
      ApplyForceToCenter(e) {
        let i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
        this.m_type === t.b2BodyType.b2_dynamicBody && (i && !this.m_awakeFlag && this.SetAwake(!0), this.m_awakeFlag && (this.m_force.x += e.x, this.m_force.y += e.y));
      }
      ApplyTorque(e) {
        let i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
        this.m_type === t.b2BodyType.b2_dynamicBody && (i && !this.m_awakeFlag && this.SetAwake(!0), this.m_awakeFlag && (this.m_torque += e));
      }
      ApplyLinearImpulse(e, i) {
        let s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
        this.m_type === t.b2BodyType.b2_dynamicBody && (s && !this.m_awakeFlag && this.SetAwake(!0), this.m_awakeFlag && (this.m_linearVelocity.x += this.m_invMass * e.x, this.m_linearVelocity.y += this.m_invMass * e.y, this.m_angularVelocity += this.m_invI * ((i.x - this.m_sweep.c.x) * e.y - (i.y - this.m_sweep.c.y) * e.x)));
      }
      ApplyLinearImpulseToCenter(e) {
        let i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
        this.m_type === t.b2BodyType.b2_dynamicBody && (i && !this.m_awakeFlag && this.SetAwake(!0), this.m_awakeFlag && (this.m_linearVelocity.x += this.m_invMass * e.x, this.m_linearVelocity.y += this.m_invMass * e.y));
      }
      ApplyAngularImpulse(e) {
        let i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
        this.m_type === t.b2BodyType.b2_dynamicBody && (i && !this.m_awakeFlag && this.SetAwake(!0), this.m_awakeFlag && (this.m_angularVelocity += this.m_invI * e));
      }
      GetMass() {
        return this.m_mass;
      }
      GetInertia() {
        return this.m_I + this.m_mass * it.DotVV(this.m_sweep.localCenter, this.m_sweep.localCenter);
      }
      GetMassData(t) {
        return t.mass = this.m_mass, t.I = this.m_I + this.m_mass * it.DotVV(this.m_sweep.localCenter, this.m_sweep.localCenter), t.center.Copy(this.m_sweep.localCenter), t;
      }
      SetMassData(e) {
        if (this.m_world.IsLocked()) throw new Error();
        if (this.m_type !== t.b2BodyType.b2_dynamicBody) return;
        this.m_invMass = 0, this.m_I = 0, this.m_invI = 0, this.m_mass = e.mass, this.m_mass <= 0 && (this.m_mass = 1), this.m_invMass = 1 / this.m_mass, e.I > 0 && !this.m_fixedRotationFlag && (this.m_I = e.I - this.m_mass * it.DotVV(e.center, e.center), this.m_invI = 1 / this.m_I);
        const i = Fi.SetMassData_s_oldCenter.Copy(this.m_sweep.c);
        this.m_sweep.localCenter.Copy(e.center), lt.MulXV(this.m_xf, this.m_sweep.localCenter, this.m_sweep.c), this.m_sweep.c0.Copy(this.m_sweep.c), it.AddVCrossSV(this.m_linearVelocity, this.m_angularVelocity, it.SubVV(this.m_sweep.c, i, it.s_t0), this.m_linearVelocity);
      }
      ResetMassData() {
        if (this.m_mass = 0, this.m_invMass = 0, this.m_I = 0, this.m_invI = 0, this.m_sweep.localCenter.SetZero(), this.m_type === t.b2BodyType.b2_staticBody || this.m_type === t.b2BodyType.b2_kinematicBody) return this.m_sweep.c0.Copy(this.m_xf.p), this.m_sweep.c.Copy(this.m_xf.p), void (this.m_sweep.a0 = this.m_sweep.a);
        const e = Fi.ResetMassData_s_localCenter.SetZero();
        for (let t = this.m_fixtureList; t; t = t.m_next) {
          if (0 === t.m_density) continue;
          const i = t.GetMassData(Fi.ResetMassData_s_massData);
          this.m_mass += i.mass, e.x += i.center.x * i.mass, e.y += i.center.y * i.mass, this.m_I += i.I;
        }
        this.m_mass > 0 ? (this.m_invMass = 1 / this.m_mass, e.x *= this.m_invMass, e.y *= this.m_invMass) : (this.m_mass = 1, this.m_invMass = 1), this.m_I > 0 && !this.m_fixedRotationFlag ? (this.m_I -= this.m_mass * it.DotVV(e, e), this.m_invI = 1 / this.m_I) : (this.m_I = 0, this.m_invI = 0);
        const i = Fi.ResetMassData_s_oldCenter.Copy(this.m_sweep.c);
        this.m_sweep.localCenter.Copy(e), lt.MulXV(this.m_xf, this.m_sweep.localCenter, this.m_sweep.c), this.m_sweep.c0.Copy(this.m_sweep.c), it.AddVCrossSV(this.m_linearVelocity, this.m_angularVelocity, it.SubVV(this.m_sweep.c, i, it.s_t0), this.m_linearVelocity);
      }
      GetWorldPoint(t, e) {
        return lt.MulXV(this.m_xf, t, e);
      }
      GetWorldVector(t, e) {
        return at.MulRV(this.m_xf.q, t, e);
      }
      GetLocalPoint(t, e) {
        return lt.MulTXV(this.m_xf, t, e);
      }
      GetLocalVector(t, e) {
        return at.MulTRV(this.m_xf.q, t, e);
      }
      GetLinearVelocityFromWorldPoint(t, e) {
        return it.AddVCrossSV(this.m_linearVelocity, this.m_angularVelocity, it.SubVV(t, this.m_sweep.c, it.s_t0), e);
      }
      GetLinearVelocityFromLocalPoint(t, e) {
        return this.GetLinearVelocityFromWorldPoint(this.GetWorldPoint(t, e), e);
      }
      GetLinearDamping() {
        return this.m_linearDamping;
      }
      SetLinearDamping(t) {
        this.m_linearDamping = t;
      }
      GetAngularDamping() {
        return this.m_angularDamping;
      }
      SetAngularDamping(t) {
        this.m_angularDamping = t;
      }
      GetGravityScale() {
        return this.m_gravityScale;
      }
      SetGravityScale(t) {
        this.m_gravityScale = t;
      }
      SetType(e) {
        if (this.m_world.IsLocked()) throw new Error();
        if (this.m_type === e) return;
        this.m_type = e, this.ResetMassData(), this.m_type === t.b2BodyType.b2_staticBody && (this.m_linearVelocity.SetZero(), this.m_angularVelocity = 0, this.m_sweep.a0 = this.m_sweep.a, this.m_sweep.c0.Copy(this.m_sweep.c), this.SynchronizeFixtures()), this.SetAwake(!0), this.m_force.SetZero(), this.m_torque = 0;
        let i = this.m_contactList;
        for (; i;) {
          const t = i;
          i = i.next, this.m_world.m_contactManager.Destroy(t.contact);
        }
        this.m_contactList = null;
        for (let t = this.m_fixtureList; t; t = t.m_next) t.TouchProxies();
      }
      GetType() {
        return this.m_type;
      }
      SetBullet(t) {
        this.m_bulletFlag = t;
      }
      IsBullet() {
        return this.m_bulletFlag;
      }
      SetSleepingAllowed(t) {
        this.m_autoSleepFlag = t, t || this.SetAwake(!0);
      }
      IsSleepingAllowed() {
        return this.m_autoSleepFlag;
      }
      SetAwake(t) {
        t ? (this.m_awakeFlag = !0, this.m_sleepTime = 0) : (this.m_awakeFlag = !1, this.m_sleepTime = 0, this.m_linearVelocity.SetZero(), this.m_angularVelocity = 0, this.m_force.SetZero(), this.m_torque = 0);
      }
      IsAwake() {
        return this.m_awakeFlag;
      }
      SetActive(t) {
        if (this.m_world.IsLocked()) throw new Error();
        if (t !== this.IsActive()) if (this.m_activeFlag = t, t) for (let t = this.m_fixtureList; t; t = t.m_next) t.CreateProxies(this.m_xf);else {
          for (let t = this.m_fixtureList; t; t = t.m_next) t.DestroyProxies();
          let t = this.m_contactList;
          for (; t;) {
            const e = t;
            t = t.next, this.m_world.m_contactManager.Destroy(e.contact);
          }
          this.m_contactList = null;
        }
      }
      IsActive() {
        return this.m_activeFlag;
      }
      SetFixedRotation(t) {
        this.m_fixedRotationFlag !== t && (this.m_fixedRotationFlag = t, this.m_angularVelocity = 0, this.ResetMassData());
      }
      IsFixedRotation() {
        return this.m_fixedRotationFlag;
      }
      GetFixtureList() {
        return this.m_fixtureList;
      }
      GetJointList() {
        return this.m_jointList;
      }
      GetContactList() {
        return this.m_contactList;
      }
      GetNext() {
        return this.m_next;
      }
      GetUserData() {
        return this.m_userData;
      }
      SetUserData(t) {
        this.m_userData = t;
      }
      GetWorld() {
        return this.m_world;
      }
      Dump(e) {
        const i = this.m_islandIndex;
        e("{\n"), e("  const bd: b2BodyDef = new b2BodyDef();\n");
        let s = "";
        switch (this.m_type) {
          case t.b2BodyType.b2_staticBody:
            s = "b2BodyType.b2_staticBody";
            break;
          case t.b2BodyType.b2_kinematicBody:
            s = "b2BodyType.b2_kinematicBody";
            break;
          case t.b2BodyType.b2_dynamicBody:
            s = "b2BodyType.b2_dynamicBody";
        }
        e("  bd.type = %s;\n", s), e("  bd.position.Set(%.15f, %.15f);\n", this.m_xf.p.x, this.m_xf.p.y), e("  bd.angle = %.15f;\n", this.m_sweep.a), e("  bd.linearVelocity.Set(%.15f, %.15f);\n", this.m_linearVelocity.x, this.m_linearVelocity.y), e("  bd.angularVelocity = %.15f;\n", this.m_angularVelocity), e("  bd.linearDamping = %.15f;\n", this.m_linearDamping), e("  bd.angularDamping = %.15f;\n", this.m_angularDamping), e("  bd.allowSleep = %s;\n", this.m_autoSleepFlag ? "true" : "false"), e("  bd.awake = %s;\n", this.m_awakeFlag ? "true" : "false"), e("  bd.fixedRotation = %s;\n", this.m_fixedRotationFlag ? "true" : "false"), e("  bd.bullet = %s;\n", this.m_bulletFlag ? "true" : "false"), e("  bd.active = %s;\n", this.m_activeFlag ? "true" : "false"), e("  bd.gravityScale = %.15f;\n", this.m_gravityScale), e("\n"), e("  bodies[%d] = this.m_world.CreateBody(bd);\n", this.m_islandIndex), e("\n");
        for (let t = this.m_fixtureList; t; t = t.m_next) e("  {\n"), t.Dump(e, i), e("  }\n");
        e("}\n");
      }
      SynchronizeFixtures() {
        const t = Fi.SynchronizeFixtures_s_xf1;
        t.q.SetAngle(this.m_sweep.a0), at.MulRV(t.q, this.m_sweep.localCenter, t.p), it.SubVV(this.m_sweep.c0, t.p, t.p);
        for (let e = this.m_fixtureList; e; e = e.m_next) e.Synchronize(t, this.m_xf);
      }
      SynchronizeTransform() {
        this.m_xf.q.SetAngle(this.m_sweep.a), at.MulRV(this.m_xf.q, this.m_sweep.localCenter, this.m_xf.p), it.SubVV(this.m_sweep.c, this.m_xf.p, this.m_xf.p);
      }
      ShouldCollide(e) {
        return (this.m_type !== t.b2BodyType.b2_staticBody || e.m_type !== t.b2BodyType.b2_staticBody) && this.ShouldCollideConnected(e);
      }
      ShouldCollideConnected(t) {
        for (let e = this.m_jointList; e; e = e.next) if (e.other === t && !e.joint.m_collideConnected) return !1;
        return !0;
      }
      Advance(t) {
        this.m_sweep.Advance(t), this.m_sweep.c.Copy(this.m_sweep.c0), this.m_sweep.a = this.m_sweep.a0, this.m_xf.q.SetAngle(this.m_sweep.a), at.MulRV(this.m_xf.q, this.m_sweep.localCenter, this.m_xf.p), it.SubVV(this.m_sweep.c, this.m_xf.p, this.m_xf.p);
      }
      GetControllerList() {
        return this.m_controllerList;
      }
      GetControllerCount() {
        return this.m_controllerCount;
      }
    }
    Fi.CreateFixtureShapeDensity_s_def = new Ii(), Fi.SetMassData_s_oldCenter = new it(), Fi.ResetMassData_s_localCenter = new it(), Fi.ResetMassData_s_oldCenter = new it(), Fi.ResetMassData_s_massData = new Bi(), Fi.SynchronizeFixtures_s_xf1 = new lt(), (Ci = t.b2JointType || (t.b2JointType = {}))[Ci.e_unknownJoint = 0] = "e_unknownJoint", Ci[Ci.e_revoluteJoint = 1] = "e_revoluteJoint", Ci[Ci.e_prismaticJoint = 2] = "e_prismaticJoint", Ci[Ci.e_distanceJoint = 3] = "e_distanceJoint", Ci[Ci.e_pulleyJoint = 4] = "e_pulleyJoint", Ci[Ci.e_mouseJoint = 5] = "e_mouseJoint", Ci[Ci.e_gearJoint = 6] = "e_gearJoint", Ci[Ci.e_wheelJoint = 7] = "e_wheelJoint", Ci[Ci.e_weldJoint = 8] = "e_weldJoint", Ci[Ci.e_frictionJoint = 9] = "e_frictionJoint", Ci[Ci.e_ropeJoint = 10] = "e_ropeJoint", Ci[Ci.e_motorJoint = 11] = "e_motorJoint", Ci[Ci.e_areaJoint = 12] = "e_areaJoint", (Ai = t.b2LimitState || (t.b2LimitState = {}))[Ai.e_inactiveLimit = 0] = "e_inactiveLimit", Ai[Ai.e_atLowerLimit = 1] = "e_atLowerLimit", Ai[Ai.e_atUpperLimit = 2] = "e_atUpperLimit", Ai[Ai.e_equalLimits = 3] = "e_equalLimits";
    class Ti {
      constructor(t, e) {
        this.prev = null, this.next = null, this.joint = t, this.other = e;
      }
    }
    class Li {
      constructor(e) {
        this.type = t.b2JointType.e_unknownJoint, this.userData = null, this.collideConnected = !1, this.type = e;
      }
    }
    class Ri {
      constructor(i) {
        this.m_type = t.b2JointType.e_unknownJoint, this.m_prev = null, this.m_next = null, this.m_index = 0, this.m_islandFlag = !1, this.m_collideConnected = !1, this.m_userData = null, this.m_type = i.type, this.m_edgeA = new Ti(this, i.bodyB), this.m_edgeB = new Ti(this, i.bodyA), this.m_bodyA = i.bodyA, this.m_bodyB = i.bodyB, this.m_collideConnected = e(i.collideConnected, !1), this.m_userData = i.userData;
      }
      GetType() {
        return this.m_type;
      }
      GetBodyA() {
        return this.m_bodyA;
      }
      GetBodyB() {
        return this.m_bodyB;
      }
      GetNext() {
        return this.m_next;
      }
      GetUserData() {
        return this.m_userData;
      }
      SetUserData(t) {
        this.m_userData = t;
      }
      IsActive() {
        return this.m_bodyA.IsActive() && this.m_bodyB.IsActive();
      }
      GetCollideConnected() {
        return this.m_collideConnected;
      }
      Dump(t) {
        t("// Dump is not supported for this joint type.\n");
      }
      ShiftOrigin(t) {}
    }
    class ki extends Li {
      constructor() {
        super(t.b2JointType.e_distanceJoint), this.localAnchorA = new it(), this.localAnchorB = new it(), this.length = 1, this.frequencyHz = 0, this.dampingRatio = 0;
      }
      Initialize(t, e, i, s) {
        this.bodyA = t, this.bodyB = e, this.bodyA.GetLocalPoint(i, this.localAnchorA), this.bodyB.GetLocalPoint(s, this.localAnchorB), this.length = it.DistanceVV(i, s), this.frequencyHz = 0, this.dampingRatio = 0;
      }
    }
    class qi extends Ri {
      constructor(t) {
        super(t), this.m_frequencyHz = 0, this.m_dampingRatio = 0, this.m_bias = 0, this.m_localAnchorA = new it(), this.m_localAnchorB = new it(), this.m_gamma = 0, this.m_impulse = 0, this.m_length = 0, this.m_indexA = 0, this.m_indexB = 0, this.m_u = new it(), this.m_rA = new it(), this.m_rB = new it(), this.m_localCenterA = new it(), this.m_localCenterB = new it(), this.m_invMassA = 0, this.m_invMassB = 0, this.m_invIA = 0, this.m_invIB = 0, this.m_mass = 0, this.m_qA = new at(), this.m_qB = new at(), this.m_lalcA = new it(), this.m_lalcB = new it(), this.m_frequencyHz = e(t.frequencyHz, 0), this.m_dampingRatio = e(t.dampingRatio, 0), this.m_localAnchorA.Copy(t.localAnchorA), this.m_localAnchorB.Copy(t.localAnchorB), this.m_length = t.length;
      }
      GetAnchorA(t) {
        return this.m_bodyA.GetWorldPoint(this.m_localAnchorA, t);
      }
      GetAnchorB(t) {
        return this.m_bodyB.GetWorldPoint(this.m_localAnchorB, t);
      }
      GetReactionForce(t, e) {
        return e.x = t * this.m_impulse * this.m_u.x, e.y = t * this.m_impulse * this.m_u.y, e;
      }
      GetReactionTorque(t) {
        return 0;
      }
      GetLocalAnchorA() {
        return this.m_localAnchorA;
      }
      GetLocalAnchorB() {
        return this.m_localAnchorB;
      }
      SetLength(t) {
        this.m_length = t;
      }
      Length() {
        return this.m_length;
      }
      SetFrequency(t) {
        this.m_frequencyHz = t;
      }
      GetFrequency() {
        return this.m_frequencyHz;
      }
      SetDampingRatio(t) {
        this.m_dampingRatio = t;
      }
      GetDampingRatio() {
        return this.m_dampingRatio;
      }
      Dump(t) {
        const e = this.m_bodyA.m_islandIndex,
          i = this.m_bodyB.m_islandIndex;
        t("  const jd: b2DistanceJointDef = new b2DistanceJointDef();\n"), t("  jd.bodyA = bodies[%d];\n", e), t("  jd.bodyB = bodies[%d];\n", i), t("  jd.collideConnected = %s;\n", this.m_collideConnected ? "true" : "false"), t("  jd.localAnchorA.Set(%.15f, %.15f);\n", this.m_localAnchorA.x, this.m_localAnchorA.y), t("  jd.localAnchorB.Set(%.15f, %.15f);\n", this.m_localAnchorB.x, this.m_localAnchorB.y), t("  jd.length = %.15f;\n", this.m_length), t("  jd.frequencyHz = %.15f;\n", this.m_frequencyHz), t("  jd.dampingRatio = %.15f;\n", this.m_dampingRatio), t("  joints[%d] = this.m_world.CreateJoint(jd);\n", this.m_index);
      }
      InitVelocityConstraints(t) {
        this.m_indexA = this.m_bodyA.m_islandIndex, this.m_indexB = this.m_bodyB.m_islandIndex, this.m_localCenterA.Copy(this.m_bodyA.m_sweep.localCenter), this.m_localCenterB.Copy(this.m_bodyB.m_sweep.localCenter), this.m_invMassA = this.m_bodyA.m_invMass, this.m_invMassB = this.m_bodyB.m_invMass, this.m_invIA = this.m_bodyA.m_invI, this.m_invIB = this.m_bodyB.m_invI;
        const e = t.positions[this.m_indexA].c,
          i = t.positions[this.m_indexA].a,
          s = t.velocities[this.m_indexA].v;
        let o = t.velocities[this.m_indexA].w;
        const r = t.positions[this.m_indexB].c,
          a = t.positions[this.m_indexB].a,
          l = t.velocities[this.m_indexB].v;
        let m = t.velocities[this.m_indexB].w;
        const _ = this.m_qA.SetAngle(i),
          c = this.m_qB.SetAngle(a);
        it.SubVV(this.m_localAnchorA, this.m_localCenterA, this.m_lalcA), at.MulRV(_, this.m_lalcA, this.m_rA), it.SubVV(this.m_localAnchorB, this.m_localCenterB, this.m_lalcB), at.MulRV(c, this.m_lalcB, this.m_rB), this.m_u.x = r.x + this.m_rB.x - e.x - this.m_rA.x, this.m_u.y = r.y + this.m_rB.y - e.y - this.m_rA.y;
        const u = this.m_u.Length();
        u > h ? this.m_u.SelfMul(1 / u) : this.m_u.SetZero();
        const d = it.CrossVV(this.m_rA, this.m_u),
          p = it.CrossVV(this.m_rB, this.m_u);
        let f = this.m_invMassA + this.m_invIA * d * d + this.m_invMassB + this.m_invIB * p * p;
        if (this.m_mass = 0 !== f ? 1 / f : 0, this.m_frequencyHz > 0) {
          const e = u - this.m_length,
            i = 2 * n * this.m_frequencyHz,
            s = 2 * this.m_mass * this.m_dampingRatio * i,
            o = this.m_mass * i * i,
            r = t.step.dt;
          this.m_gamma = r * (s + r * o), this.m_gamma = 0 !== this.m_gamma ? 1 / this.m_gamma : 0, this.m_bias = e * r * o * this.m_gamma, f += this.m_gamma, this.m_mass = 0 !== f ? 1 / f : 0;
        } else this.m_gamma = 0, this.m_bias = 0;
        if (t.step.warmStarting) {
          this.m_impulse *= t.step.dtRatio;
          const e = it.MulSV(this.m_impulse, this.m_u, qi.InitVelocityConstraints_s_P);
          s.SelfMulSub(this.m_invMassA, e), o -= this.m_invIA * it.CrossVV(this.m_rA, e), l.SelfMulAdd(this.m_invMassB, e), m += this.m_invIB * it.CrossVV(this.m_rB, e);
        } else this.m_impulse = 0;
        t.velocities[this.m_indexA].w = o, t.velocities[this.m_indexB].w = m;
      }
      SolveVelocityConstraints(t) {
        const e = t.velocities[this.m_indexA].v;
        let i = t.velocities[this.m_indexA].w;
        const s = t.velocities[this.m_indexB].v;
        let o = t.velocities[this.m_indexB].w;
        const n = it.AddVCrossSV(e, i, this.m_rA, qi.SolveVelocityConstraints_s_vpA),
          r = it.AddVCrossSV(s, o, this.m_rB, qi.SolveVelocityConstraints_s_vpB),
          a = it.DotVV(this.m_u, it.SubVV(r, n, it.s_t0)),
          l = -this.m_mass * (a + this.m_bias + this.m_gamma * this.m_impulse);
        this.m_impulse += l;
        const m = it.MulSV(l, this.m_u, qi.SolveVelocityConstraints_s_P);
        e.SelfMulSub(this.m_invMassA, m), i -= this.m_invIA * it.CrossVV(this.m_rA, m), s.SelfMulAdd(this.m_invMassB, m), o += this.m_invIB * it.CrossVV(this.m_rB, m), t.velocities[this.m_indexA].w = i, t.velocities[this.m_indexB].w = o;
      }
      SolvePositionConstraints(t) {
        if (this.m_frequencyHz > 0) return !0;
        const e = t.positions[this.m_indexA].c;
        let i = t.positions[this.m_indexA].a;
        const s = t.positions[this.m_indexB].c;
        let o = t.positions[this.m_indexB].a;
        const n = this.m_qA.SetAngle(i),
          r = this.m_qB.SetAngle(o),
          a = at.MulRV(n, this.m_lalcA, this.m_rA),
          l = at.MulRV(r, this.m_lalcB, this.m_rB),
          m = this.m_u;
        m.x = s.x + l.x - e.x - a.x, m.y = s.y + l.y - e.y - a.y;
        const _ = this.m_u.Normalize();
        let c = _ - this.m_length;
        c = X(c, -f, f);
        const u = -this.m_mass * c,
          d = it.MulSV(u, m, qi.SolvePositionConstraints_s_P);
        return e.SelfMulSub(this.m_invMassA, d), i -= this.m_invIA * it.CrossVV(a, d), s.SelfMulAdd(this.m_invMassB, d), o += this.m_invIB * it.CrossVV(l, d), t.positions[this.m_indexA].a = i, t.positions[this.m_indexB].a = o, O(c) < h;
      }
    }
    qi.InitVelocityConstraints_s_P = new it(), qi.SolveVelocityConstraints_s_vpA = new it(), qi.SolveVelocityConstraints_s_vpB = new it(), qi.SolveVelocityConstraints_s_P = new it(), qi.SolvePositionConstraints_s_P = new it();
    class zi extends Ri {
      constructor(t) {
        super(t), this.m_frequencyHz = 0, this.m_dampingRatio = 0, this.m_impulse = 0, this.m_targetArea = 0, this.m_bodies = t.bodies, this.m_frequencyHz = e(t.frequencyHz, 0), this.m_dampingRatio = e(t.dampingRatio, 0), this.m_targetLengths = q(t.bodies.length), this.m_normals = it.MakeArray(t.bodies.length), this.m_joints = [], this.m_deltas = it.MakeArray(t.bodies.length), this.m_delta = new it();
        const i = new ki();
        i.frequencyHz = this.m_frequencyHz, i.dampingRatio = this.m_dampingRatio, this.m_targetArea = 0;
        for (let t = 0; t < this.m_bodies.length; ++t) {
          const e = this.m_bodies[t],
            s = this.m_bodies[(t + 1) % this.m_bodies.length],
            o = e.GetWorldCenter(),
            n = s.GetWorldCenter();
          this.m_targetLengths[t] = it.DistanceVV(o, n), this.m_targetArea += it.CrossVV(o, n), i.Initialize(e, s, o, n), this.m_joints[t] = e.GetWorld().CreateJoint(i);
        }
        this.m_targetArea *= .5;
      }
      GetAnchorA(t) {
        return t;
      }
      GetAnchorB(t) {
        return t;
      }
      GetReactionForce(t, e) {
        return e;
      }
      GetReactionTorque(t) {
        return 0;
      }
      SetFrequency(t) {
        this.m_frequencyHz = t;
        for (let e = 0; e < this.m_joints.length; ++e) this.m_joints[e].SetFrequency(t);
      }
      GetFrequency() {
        return this.m_frequencyHz;
      }
      SetDampingRatio(t) {
        this.m_dampingRatio = t;
        for (let e = 0; e < this.m_joints.length; ++e) this.m_joints[e].SetDampingRatio(t);
      }
      GetDampingRatio() {
        return this.m_dampingRatio;
      }
      Dump(t) {
        t("Area joint dumping is not supported.\n");
      }
      InitVelocityConstraints(t) {
        for (let e = 0; e < this.m_bodies.length; ++e) {
          const i = this.m_bodies[(e + this.m_bodies.length - 1) % this.m_bodies.length],
            s = this.m_bodies[(e + 1) % this.m_bodies.length],
            o = t.positions[i.m_islandIndex].c,
            n = t.positions[s.m_islandIndex].c,
            r = this.m_deltas[e];
          it.SubVV(n, o, r);
        }
        if (t.step.warmStarting) {
          this.m_impulse *= t.step.dtRatio;
          for (let e = 0; e < this.m_bodies.length; ++e) {
            const i = this.m_bodies[e],
              s = t.velocities[i.m_islandIndex].v,
              o = this.m_deltas[e];
            s.x += i.m_invMass * o.y * .5 * this.m_impulse, s.y += i.m_invMass * -o.x * .5 * this.m_impulse;
          }
        } else this.m_impulse = 0;
      }
      SolveVelocityConstraints(t) {
        let e = 0,
          i = 0;
        for (let s = 0; s < this.m_bodies.length; ++s) {
          const o = this.m_bodies[s],
            n = t.velocities[o.m_islandIndex].v,
            r = this.m_deltas[s];
          e += r.LengthSquared() / o.GetMass(), i += it.CrossVV(n, r);
        }
        const s = -2 * i / e;
        this.m_impulse += s;
        for (let e = 0; e < this.m_bodies.length; ++e) {
          const i = this.m_bodies[e],
            o = t.velocities[i.m_islandIndex].v,
            n = this.m_deltas[e];
          o.x += i.m_invMass * n.y * .5 * s, o.y += i.m_invMass * -n.x * .5 * s;
        }
      }
      SolvePositionConstraints(t) {
        let e = 0,
          i = 0;
        for (let o = 0; o < this.m_bodies.length; ++o) {
          const n = this.m_bodies[o],
            r = this.m_bodies[(o + 1) % this.m_bodies.length],
            a = t.positions[n.m_islandIndex].c,
            l = t.positions[r.m_islandIndex].c,
            m = it.SubVV(l, a, this.m_delta);
          let h = m.Length();
          h < s && (h = 1), this.m_normals[o].x = m.y / h, this.m_normals[o].y = -m.x / h, e += h, i += it.CrossVV(a, l);
        }
        i *= .5;
        const o = this.m_targetArea - i,
          n = .5 * o / e;
        let r = !0;
        for (let e = 0; e < this.m_bodies.length; ++e) {
          const i = this.m_bodies[e],
            s = t.positions[i.m_islandIndex].c,
            o = (e + 1) % this.m_bodies.length,
            a = it.AddVV(this.m_normals[e], this.m_normals[o], this.m_delta);
          a.SelfMul(n);
          const l = a.LengthSquared();
          l > W(f) && a.SelfMul(f / H(l)), l > W(h) && (r = !1), s.x += a.x, s.y += a.y;
        }
        return r;
      }
    }
    class Ei extends Ri {
      constructor(t) {
        super(t), this.m_localAnchorA = new it(), this.m_localAnchorB = new it(), this.m_linearImpulse = new it(), this.m_angularImpulse = 0, this.m_maxForce = 0, this.m_maxTorque = 0, this.m_indexA = 0, this.m_indexB = 0, this.m_rA = new it(), this.m_rB = new it(), this.m_localCenterA = new it(), this.m_localCenterB = new it(), this.m_invMassA = 0, this.m_invMassB = 0, this.m_invIA = 0, this.m_invIB = 0, this.m_linearMass = new nt(), this.m_angularMass = 0, this.m_qA = new at(), this.m_qB = new at(), this.m_lalcA = new it(), this.m_lalcB = new it(), this.m_K = new nt(), this.m_localAnchorA.Copy(t.localAnchorA), this.m_localAnchorB.Copy(t.localAnchorB), this.m_linearImpulse.SetZero(), this.m_maxForce = e(t.maxForce, 0), this.m_maxTorque = e(t.maxTorque, 0), this.m_linearMass.SetZero();
      }
      InitVelocityConstraints(t) {
        this.m_indexA = this.m_bodyA.m_islandIndex, this.m_indexB = this.m_bodyB.m_islandIndex, this.m_localCenterA.Copy(this.m_bodyA.m_sweep.localCenter), this.m_localCenterB.Copy(this.m_bodyB.m_sweep.localCenter), this.m_invMassA = this.m_bodyA.m_invMass, this.m_invMassB = this.m_bodyB.m_invMass, this.m_invIA = this.m_bodyA.m_invI, this.m_invIB = this.m_bodyB.m_invI;
        const e = t.positions[this.m_indexA].a,
          i = t.velocities[this.m_indexA].v;
        let s = t.velocities[this.m_indexA].w;
        const o = t.positions[this.m_indexB].a,
          n = t.velocities[this.m_indexB].v;
        let r = t.velocities[this.m_indexB].w;
        const a = this.m_qA.SetAngle(e),
          l = this.m_qB.SetAngle(o);
        it.SubVV(this.m_localAnchorA, this.m_localCenterA, this.m_lalcA);
        const m = at.MulRV(a, this.m_lalcA, this.m_rA);
        it.SubVV(this.m_localAnchorB, this.m_localCenterB, this.m_lalcB);
        const h = at.MulRV(l, this.m_lalcB, this.m_rB),
          _ = this.m_invMassA,
          c = this.m_invMassB,
          u = this.m_invIA,
          d = this.m_invIB,
          p = this.m_K;
        if (p.ex.x = _ + c + u * m.y * m.y + d * h.y * h.y, p.ex.y = -u * m.x * m.y - d * h.x * h.y, p.ey.x = p.ex.y, p.ey.y = _ + c + u * m.x * m.x + d * h.x * h.x, p.GetInverse(this.m_linearMass), this.m_angularMass = u + d, this.m_angularMass > 0 && (this.m_angularMass = 1 / this.m_angularMass), t.step.warmStarting) {
          this.m_linearImpulse.SelfMul(t.step.dtRatio), this.m_angularImpulse *= t.step.dtRatio;
          const e = this.m_linearImpulse;
          i.SelfMulSub(_, e), s -= u * (it.CrossVV(this.m_rA, e) + this.m_angularImpulse), n.SelfMulAdd(c, e), r += d * (it.CrossVV(this.m_rB, e) + this.m_angularImpulse);
        } else this.m_linearImpulse.SetZero(), this.m_angularImpulse = 0;
        t.velocities[this.m_indexA].w = s, t.velocities[this.m_indexB].w = r;
      }
      SolveVelocityConstraints(t) {
        const e = t.velocities[this.m_indexA].v;
        let i = t.velocities[this.m_indexA].w;
        const s = t.velocities[this.m_indexB].v;
        let o = t.velocities[this.m_indexB].w;
        const n = this.m_invMassA,
          r = this.m_invMassB,
          a = this.m_invIA,
          l = this.m_invIB,
          m = t.step.dt;
        {
          const t = o - i;
          let e = -this.m_angularMass * t;
          const s = this.m_angularImpulse,
            n = m * this.m_maxTorque;
          this.m_angularImpulse = X(this.m_angularImpulse + e, -n, n), e = this.m_angularImpulse - s, i -= a * e, o += l * e;
        }
        {
          const t = it.SubVV(it.AddVCrossSV(s, o, this.m_rB, it.s_t0), it.AddVCrossSV(e, i, this.m_rA, it.s_t1), Ei.SolveVelocityConstraints_s_Cdot_v2),
            h = nt.MulMV(this.m_linearMass, t, Ei.SolveVelocityConstraints_s_impulseV).SelfNeg(),
            _ = Ei.SolveVelocityConstraints_s_oldImpulseV.Copy(this.m_linearImpulse);
          this.m_linearImpulse.SelfAdd(h);
          const c = m * this.m_maxForce;
          this.m_linearImpulse.LengthSquared() > c * c && (this.m_linearImpulse.Normalize(), this.m_linearImpulse.SelfMul(c)), it.SubVV(this.m_linearImpulse, _, h), e.SelfMulSub(n, h), i -= a * it.CrossVV(this.m_rA, h), s.SelfMulAdd(r, h), o += l * it.CrossVV(this.m_rB, h);
        }
        t.velocities[this.m_indexA].w = i, t.velocities[this.m_indexB].w = o;
      }
      SolvePositionConstraints(t) {
        return !0;
      }
      GetAnchorA(t) {
        return this.m_bodyA.GetWorldPoint(this.m_localAnchorA, t);
      }
      GetAnchorB(t) {
        return this.m_bodyB.GetWorldPoint(this.m_localAnchorB, t);
      }
      GetReactionForce(t, e) {
        return e.x = t * this.m_linearImpulse.x, e.y = t * this.m_linearImpulse.y, e;
      }
      GetReactionTorque(t) {
        return t * this.m_angularImpulse;
      }
      GetLocalAnchorA() {
        return this.m_localAnchorA;
      }
      GetLocalAnchorB() {
        return this.m_localAnchorB;
      }
      SetMaxForce(t) {
        this.m_maxForce = t;
      }
      GetMaxForce() {
        return this.m_maxForce;
      }
      SetMaxTorque(t) {
        this.m_maxTorque = t;
      }
      GetMaxTorque() {
        return this.m_maxTorque;
      }
      Dump(t) {
        const e = this.m_bodyA.m_islandIndex,
          i = this.m_bodyB.m_islandIndex;
        t("  const jd: b2FrictionJointDef = new b2FrictionJointDef();\n"), t("  jd.bodyA = bodies[%d];\n", e), t("  jd.bodyB = bodies[%d];\n", i), t("  jd.collideConnected = %s;\n", this.m_collideConnected ? "true" : "false"), t("  jd.localAnchorA.Set(%.15f, %.15f);\n", this.m_localAnchorA.x, this.m_localAnchorA.y), t("  jd.localAnchorB.Set(%.15f, %.15f);\n", this.m_localAnchorB.x, this.m_localAnchorB.y), t("  jd.maxForce = %.15f;\n", this.m_maxForce), t("  jd.maxTorque = %.15f;\n", this.m_maxTorque), t("  joints[%d] = this.m_world.CreateJoint(jd);\n", this.m_index);
      }
    }
    Ei.SolveVelocityConstraints_s_Cdot_v2 = new it(), Ei.SolveVelocityConstraints_s_impulseV = new it(), Ei.SolveVelocityConstraints_s_oldImpulseV = new it();
    class Ji extends Ri {
      constructor(i) {
        let s, o;
        super(i), this.m_typeA = t.b2JointType.e_unknownJoint, this.m_typeB = t.b2JointType.e_unknownJoint, this.m_localAnchorA = new it(), this.m_localAnchorB = new it(), this.m_localAnchorC = new it(), this.m_localAnchorD = new it(), this.m_localAxisC = new it(), this.m_localAxisD = new it(), this.m_referenceAngleA = 0, this.m_referenceAngleB = 0, this.m_constant = 0, this.m_ratio = 0, this.m_impulse = 0, this.m_indexA = 0, this.m_indexB = 0, this.m_indexC = 0, this.m_indexD = 0, this.m_lcA = new it(), this.m_lcB = new it(), this.m_lcC = new it(), this.m_lcD = new it(), this.m_mA = 0, this.m_mB = 0, this.m_mC = 0, this.m_mD = 0, this.m_iA = 0, this.m_iB = 0, this.m_iC = 0, this.m_iD = 0, this.m_JvAC = new it(), this.m_JvBD = new it(), this.m_JwA = 0, this.m_JwB = 0, this.m_JwC = 0, this.m_JwD = 0, this.m_mass = 0, this.m_qA = new at(), this.m_qB = new at(), this.m_qC = new at(), this.m_qD = new at(), this.m_lalcA = new it(), this.m_lalcB = new it(), this.m_lalcC = new it(), this.m_lalcD = new it(), this.m_joint1 = i.joint1, this.m_joint2 = i.joint2, this.m_typeA = this.m_joint1.GetType(), this.m_typeB = this.m_joint2.GetType(), this.m_bodyC = this.m_joint1.GetBodyA(), this.m_bodyA = this.m_joint1.GetBodyB();
        const n = this.m_bodyA.m_xf,
          r = this.m_bodyA.m_sweep.a,
          a = this.m_bodyC.m_xf,
          l = this.m_bodyC.m_sweep.a;
        if (this.m_typeA === t.b2JointType.e_revoluteJoint) {
          const t = i.joint1;
          this.m_localAnchorC.Copy(t.m_localAnchorA), this.m_localAnchorA.Copy(t.m_localAnchorB), this.m_referenceAngleA = t.m_referenceAngle, this.m_localAxisC.SetZero(), s = r - l - this.m_referenceAngleA;
        } else {
          const t = i.joint1;
          this.m_localAnchorC.Copy(t.m_localAnchorA), this.m_localAnchorA.Copy(t.m_localAnchorB), this.m_referenceAngleA = t.m_referenceAngle, this.m_localAxisC.Copy(t.m_localXAxisA);
          const e = this.m_localAnchorC,
            o = at.MulTRV(a.q, it.AddVV(at.MulRV(n.q, this.m_localAnchorA, it.s_t0), it.SubVV(n.p, a.p, it.s_t1), it.s_t0), it.s_t0);
          s = it.DotVV(it.SubVV(o, e, it.s_t0), this.m_localAxisC);
        }
        this.m_bodyD = this.m_joint2.GetBodyA(), this.m_bodyB = this.m_joint2.GetBodyB();
        const m = this.m_bodyB.m_xf,
          h = this.m_bodyB.m_sweep.a,
          _ = this.m_bodyD.m_xf,
          c = this.m_bodyD.m_sweep.a;
        if (this.m_typeB === t.b2JointType.e_revoluteJoint) {
          const t = i.joint2;
          this.m_localAnchorD.Copy(t.m_localAnchorA), this.m_localAnchorB.Copy(t.m_localAnchorB), this.m_referenceAngleB = t.m_referenceAngle, this.m_localAxisD.SetZero(), o = h - c - this.m_referenceAngleB;
        } else {
          const t = i.joint2;
          this.m_localAnchorD.Copy(t.m_localAnchorA), this.m_localAnchorB.Copy(t.m_localAnchorB), this.m_referenceAngleB = t.m_referenceAngle, this.m_localAxisD.Copy(t.m_localXAxisA);
          const e = this.m_localAnchorD,
            s = at.MulTRV(_.q, it.AddVV(at.MulRV(m.q, this.m_localAnchorB, it.s_t0), it.SubVV(m.p, _.p, it.s_t1), it.s_t0), it.s_t0);
          o = it.DotVV(it.SubVV(s, e, it.s_t0), this.m_localAxisD);
        }
        this.m_ratio = e(i.ratio, 1), this.m_constant = s + this.m_ratio * o, this.m_impulse = 0;
      }
      InitVelocityConstraints(e) {
        this.m_indexA = this.m_bodyA.m_islandIndex, this.m_indexB = this.m_bodyB.m_islandIndex, this.m_indexC = this.m_bodyC.m_islandIndex, this.m_indexD = this.m_bodyD.m_islandIndex, this.m_lcA.Copy(this.m_bodyA.m_sweep.localCenter), this.m_lcB.Copy(this.m_bodyB.m_sweep.localCenter), this.m_lcC.Copy(this.m_bodyC.m_sweep.localCenter), this.m_lcD.Copy(this.m_bodyD.m_sweep.localCenter), this.m_mA = this.m_bodyA.m_invMass, this.m_mB = this.m_bodyB.m_invMass, this.m_mC = this.m_bodyC.m_invMass, this.m_mD = this.m_bodyD.m_invMass, this.m_iA = this.m_bodyA.m_invI, this.m_iB = this.m_bodyB.m_invI, this.m_iC = this.m_bodyC.m_invI, this.m_iD = this.m_bodyD.m_invI;
        const i = e.positions[this.m_indexA].a,
          s = e.velocities[this.m_indexA].v;
        let o = e.velocities[this.m_indexA].w;
        const n = e.positions[this.m_indexB].a,
          r = e.velocities[this.m_indexB].v;
        let a = e.velocities[this.m_indexB].w;
        const l = e.positions[this.m_indexC].a,
          m = e.velocities[this.m_indexC].v;
        let h = e.velocities[this.m_indexC].w;
        const _ = e.positions[this.m_indexD].a,
          c = e.velocities[this.m_indexD].v;
        let u = e.velocities[this.m_indexD].w;
        const d = this.m_qA.SetAngle(i),
          p = this.m_qB.SetAngle(n),
          f = this.m_qC.SetAngle(l),
          y = this.m_qD.SetAngle(_);
        if (this.m_mass = 0, this.m_typeA === t.b2JointType.e_revoluteJoint) this.m_JvAC.SetZero(), this.m_JwA = 1, this.m_JwC = 1, this.m_mass += this.m_iA + this.m_iC;else {
          const t = at.MulRV(f, this.m_localAxisC, Ji.InitVelocityConstraints_s_u);
          it.SubVV(this.m_localAnchorC, this.m_lcC, this.m_lalcC);
          const e = at.MulRV(f, this.m_lalcC, Ji.InitVelocityConstraints_s_rC);
          it.SubVV(this.m_localAnchorA, this.m_lcA, this.m_lalcA);
          const i = at.MulRV(d, this.m_lalcA, Ji.InitVelocityConstraints_s_rA);
          this.m_JvAC.Copy(t), this.m_JwC = it.CrossVV(e, t), this.m_JwA = it.CrossVV(i, t), this.m_mass += this.m_mC + this.m_mA + this.m_iC * this.m_JwC * this.m_JwC + this.m_iA * this.m_JwA * this.m_JwA;
        }
        if (this.m_typeB === t.b2JointType.e_revoluteJoint) this.m_JvBD.SetZero(), this.m_JwB = this.m_ratio, this.m_JwD = this.m_ratio, this.m_mass += this.m_ratio * this.m_ratio * (this.m_iB + this.m_iD);else {
          const t = at.MulRV(y, this.m_localAxisD, Ji.InitVelocityConstraints_s_u);
          it.SubVV(this.m_localAnchorD, this.m_lcD, this.m_lalcD);
          const e = at.MulRV(y, this.m_lalcD, Ji.InitVelocityConstraints_s_rD);
          it.SubVV(this.m_localAnchorB, this.m_lcB, this.m_lalcB);
          const i = at.MulRV(p, this.m_lalcB, Ji.InitVelocityConstraints_s_rB);
          it.MulSV(this.m_ratio, t, this.m_JvBD), this.m_JwD = this.m_ratio * it.CrossVV(e, t), this.m_JwB = this.m_ratio * it.CrossVV(i, t), this.m_mass += this.m_ratio * this.m_ratio * (this.m_mD + this.m_mB) + this.m_iD * this.m_JwD * this.m_JwD + this.m_iB * this.m_JwB * this.m_JwB;
        }
        this.m_mass = this.m_mass > 0 ? 1 / this.m_mass : 0, e.step.warmStarting ? (s.SelfMulAdd(this.m_mA * this.m_impulse, this.m_JvAC), o += this.m_iA * this.m_impulse * this.m_JwA, r.SelfMulAdd(this.m_mB * this.m_impulse, this.m_JvBD), a += this.m_iB * this.m_impulse * this.m_JwB, m.SelfMulSub(this.m_mC * this.m_impulse, this.m_JvAC), h -= this.m_iC * this.m_impulse * this.m_JwC, c.SelfMulSub(this.m_mD * this.m_impulse, this.m_JvBD), u -= this.m_iD * this.m_impulse * this.m_JwD) : this.m_impulse = 0, e.velocities[this.m_indexA].w = o, e.velocities[this.m_indexB].w = a, e.velocities[this.m_indexC].w = h, e.velocities[this.m_indexD].w = u;
      }
      SolveVelocityConstraints(t) {
        const e = t.velocities[this.m_indexA].v;
        let i = t.velocities[this.m_indexA].w;
        const s = t.velocities[this.m_indexB].v;
        let o = t.velocities[this.m_indexB].w;
        const n = t.velocities[this.m_indexC].v;
        let r = t.velocities[this.m_indexC].w;
        const a = t.velocities[this.m_indexD].v;
        let l = t.velocities[this.m_indexD].w,
          m = it.DotVV(this.m_JvAC, it.SubVV(e, n, it.s_t0)) + it.DotVV(this.m_JvBD, it.SubVV(s, a, it.s_t0));
        m += this.m_JwA * i - this.m_JwC * r + (this.m_JwB * o - this.m_JwD * l);
        const h = -this.m_mass * m;
        this.m_impulse += h, e.SelfMulAdd(this.m_mA * h, this.m_JvAC), i += this.m_iA * h * this.m_JwA, s.SelfMulAdd(this.m_mB * h, this.m_JvBD), o += this.m_iB * h * this.m_JwB, n.SelfMulSub(this.m_mC * h, this.m_JvAC), r -= this.m_iC * h * this.m_JwC, a.SelfMulSub(this.m_mD * h, this.m_JvBD), l -= this.m_iD * h * this.m_JwD, t.velocities[this.m_indexA].w = i, t.velocities[this.m_indexB].w = o, t.velocities[this.m_indexC].w = r, t.velocities[this.m_indexD].w = l;
      }
      SolvePositionConstraints(e) {
        const i = e.positions[this.m_indexA].c;
        let s = e.positions[this.m_indexA].a;
        const o = e.positions[this.m_indexB].c;
        let n = e.positions[this.m_indexB].a;
        const r = e.positions[this.m_indexC].c;
        let a = e.positions[this.m_indexC].a;
        const l = e.positions[this.m_indexD].c;
        let m = e.positions[this.m_indexD].a;
        const _ = this.m_qA.SetAngle(s),
          c = this.m_qB.SetAngle(n),
          u = this.m_qC.SetAngle(a),
          d = this.m_qD.SetAngle(m);
        let p, f;
        const y = this.m_JvAC,
          x = this.m_JvBD;
        let B,
          S,
          b,
          A,
          C = 0;
        if (this.m_typeA === t.b2JointType.e_revoluteJoint) y.SetZero(), B = 1, b = 1, C += this.m_iA + this.m_iC, p = s - a - this.m_referenceAngleA;else {
          const t = at.MulRV(u, this.m_localAxisC, Ji.SolvePositionConstraints_s_u),
            e = at.MulRV(u, this.m_lalcC, Ji.SolvePositionConstraints_s_rC),
            s = at.MulRV(_, this.m_lalcA, Ji.SolvePositionConstraints_s_rA);
          y.Copy(t), b = it.CrossVV(e, t), B = it.CrossVV(s, t), C += this.m_mC + this.m_mA + this.m_iC * b * b + this.m_iA * B * B;
          const o = this.m_lalcC,
            n = at.MulTRV(u, it.AddVV(s, it.SubVV(i, r, it.s_t0), it.s_t0), it.s_t0);
          p = it.DotVV(it.SubVV(n, o, it.s_t0), this.m_localAxisC);
        }
        if (this.m_typeB === t.b2JointType.e_revoluteJoint) x.SetZero(), S = this.m_ratio, A = this.m_ratio, C += this.m_ratio * this.m_ratio * (this.m_iB + this.m_iD), f = n - m - this.m_referenceAngleB;else {
          const t = at.MulRV(d, this.m_localAxisD, Ji.SolvePositionConstraints_s_u),
            e = at.MulRV(d, this.m_lalcD, Ji.SolvePositionConstraints_s_rD),
            i = at.MulRV(c, this.m_lalcB, Ji.SolvePositionConstraints_s_rB);
          it.MulSV(this.m_ratio, t, x), A = this.m_ratio * it.CrossVV(e, t), S = this.m_ratio * it.CrossVV(i, t), C += this.m_ratio * this.m_ratio * (this.m_mD + this.m_mB) + this.m_iD * A * A + this.m_iB * S * S;
          const s = this.m_lalcD,
            n = at.MulTRV(d, it.AddVV(i, it.SubVV(o, l, it.s_t0), it.s_t0), it.s_t0);
          f = it.DotVV(it.SubVV(n, s, it.s_t0), this.m_localAxisD);
        }
        const V = p + this.m_ratio * f - this.m_constant;
        let g = 0;
        return C > 0 && (g = -V / C), i.SelfMulAdd(this.m_mA * g, y), s += this.m_iA * g * B, o.SelfMulAdd(this.m_mB * g, x), n += this.m_iB * g * S, r.SelfMulSub(this.m_mC * g, y), a -= this.m_iC * g * b, l.SelfMulSub(this.m_mD * g, x), m -= this.m_iD * g * A, e.positions[this.m_indexA].a = s, e.positions[this.m_indexB].a = n, e.positions[this.m_indexC].a = a, e.positions[this.m_indexD].a = m, 0 < h;
      }
      GetAnchorA(t) {
        return this.m_bodyA.GetWorldPoint(this.m_localAnchorA, t);
      }
      GetAnchorB(t) {
        return this.m_bodyB.GetWorldPoint(this.m_localAnchorB, t);
      }
      GetReactionForce(t, e) {
        return it.MulSV(t * this.m_impulse, this.m_JvAC, e);
      }
      GetReactionTorque(t) {
        return t * this.m_impulse * this.m_JwA;
      }
      GetJoint1() {
        return this.m_joint1;
      }
      GetJoint2() {
        return this.m_joint2;
      }
      GetRatio() {
        return this.m_ratio;
      }
      SetRatio(t) {
        this.m_ratio = t;
      }
      Dump(t) {
        const e = this.m_bodyA.m_islandIndex,
          i = this.m_bodyB.m_islandIndex,
          s = this.m_joint1.m_index,
          o = this.m_joint2.m_index;
        t("  const jd: b2GearJointDef = new b2GearJointDef();\n"), t("  jd.bodyA = bodies[%d];\n", e), t("  jd.bodyB = bodies[%d];\n", i), t("  jd.collideConnected = %s;\n", this.m_collideConnected ? "true" : "false"), t("  jd.joint1 = joints[%d];\n", s), t("  jd.joint2 = joints[%d];\n", o), t("  jd.ratio = %.15f;\n", this.m_ratio), t("  joints[%d] = this.m_world.CreateJoint(jd);\n", this.m_index);
      }
    }
    Ji.InitVelocityConstraints_s_u = new it(), Ji.InitVelocityConstraints_s_rA = new it(), Ji.InitVelocityConstraints_s_rB = new it(), Ji.InitVelocityConstraints_s_rC = new it(), Ji.InitVelocityConstraints_s_rD = new it(), Ji.SolvePositionConstraints_s_u = new it(), Ji.SolvePositionConstraints_s_rA = new it(), Ji.SolvePositionConstraints_s_rB = new it(), Ji.SolvePositionConstraints_s_rC = new it(), Ji.SolvePositionConstraints_s_rD = new it();
    class Oi extends Ri {
      constructor(t) {
        super(t), this.m_linearOffset = new it(), this.m_angularOffset = 0, this.m_linearImpulse = new it(), this.m_angularImpulse = 0, this.m_maxForce = 0, this.m_maxTorque = 0, this.m_correctionFactor = .3, this.m_indexA = 0, this.m_indexB = 0, this.m_rA = new it(), this.m_rB = new it(), this.m_localCenterA = new it(), this.m_localCenterB = new it(), this.m_linearError = new it(), this.m_angularError = 0, this.m_invMassA = 0, this.m_invMassB = 0, this.m_invIA = 0, this.m_invIB = 0, this.m_linearMass = new nt(), this.m_angularMass = 0, this.m_qA = new at(), this.m_qB = new at(), this.m_K = new nt(), this.m_linearOffset.Copy(e(t.linearOffset, it.ZERO)), this.m_linearImpulse.SetZero(), this.m_maxForce = e(t.maxForce, 0), this.m_maxTorque = e(t.maxTorque, 0), this.m_correctionFactor = e(t.correctionFactor, .3);
      }
      GetAnchorA(t) {
        const e = this.m_bodyA.GetPosition();
        return t.x = e.x, t.y = e.y, t;
      }
      GetAnchorB(t) {
        const e = this.m_bodyB.GetPosition();
        return t.x = e.x, t.y = e.y, t;
      }
      GetReactionForce(t, e) {
        return it.MulSV(t, this.m_linearImpulse, e);
      }
      GetReactionTorque(t) {
        return t * this.m_angularImpulse;
      }
      SetLinearOffset(t) {
        it.IsEqualToV(t, this.m_linearOffset) || (this.m_bodyA.SetAwake(!0), this.m_bodyB.SetAwake(!0), this.m_linearOffset.Copy(t));
      }
      GetLinearOffset() {
        return this.m_linearOffset;
      }
      SetAngularOffset(t) {
        t !== this.m_angularOffset && (this.m_bodyA.SetAwake(!0), this.m_bodyB.SetAwake(!0), this.m_angularOffset = t);
      }
      GetAngularOffset() {
        return this.m_angularOffset;
      }
      SetMaxForce(t) {
        this.m_maxForce = t;
      }
      GetMaxForce() {
        return this.m_maxForce;
      }
      SetMaxTorque(t) {
        this.m_maxTorque = t;
      }
      GetMaxTorque() {
        return this.m_maxTorque;
      }
      InitVelocityConstraints(t) {
        this.m_indexA = this.m_bodyA.m_islandIndex, this.m_indexB = this.m_bodyB.m_islandIndex, this.m_localCenterA.Copy(this.m_bodyA.m_sweep.localCenter), this.m_localCenterB.Copy(this.m_bodyB.m_sweep.localCenter), this.m_invMassA = this.m_bodyA.m_invMass, this.m_invMassB = this.m_bodyB.m_invMass, this.m_invIA = this.m_bodyA.m_invI, this.m_invIB = this.m_bodyB.m_invI;
        const e = t.positions[this.m_indexA].c,
          i = t.positions[this.m_indexA].a,
          s = t.velocities[this.m_indexA].v;
        let o = t.velocities[this.m_indexA].w;
        const n = t.positions[this.m_indexB].c,
          r = t.positions[this.m_indexB].a,
          a = t.velocities[this.m_indexB].v;
        let l = t.velocities[this.m_indexB].w;
        const m = this.m_qA.SetAngle(i),
          h = this.m_qB.SetAngle(r),
          _ = at.MulRV(m, it.SubVV(this.m_linearOffset, this.m_localCenterA, it.s_t0), this.m_rA),
          c = at.MulRV(h, it.NegV(this.m_localCenterB, it.s_t0), this.m_rB),
          u = this.m_invMassA,
          d = this.m_invMassB,
          p = this.m_invIA,
          f = this.m_invIB,
          y = this.m_K;
        if (y.ex.x = u + d + p * _.y * _.y + f * c.y * c.y, y.ex.y = -p * _.x * _.y - f * c.x * c.y, y.ey.x = y.ex.y, y.ey.y = u + d + p * _.x * _.x + f * c.x * c.x, y.GetInverse(this.m_linearMass), this.m_angularMass = p + f, this.m_angularMass > 0 && (this.m_angularMass = 1 / this.m_angularMass), it.SubVV(it.AddVV(n, c, it.s_t0), it.AddVV(e, _, it.s_t1), this.m_linearError), this.m_angularError = r - i - this.m_angularOffset, t.step.warmStarting) {
          this.m_linearImpulse.SelfMul(t.step.dtRatio), this.m_angularImpulse *= t.step.dtRatio;
          const e = this.m_linearImpulse;
          s.SelfMulSub(u, e), o -= p * (it.CrossVV(_, e) + this.m_angularImpulse), a.SelfMulAdd(d, e), l += f * (it.CrossVV(c, e) + this.m_angularImpulse);
        } else this.m_linearImpulse.SetZero(), this.m_angularImpulse = 0;
        t.velocities[this.m_indexA].w = o, t.velocities[this.m_indexB].w = l;
      }
      SolveVelocityConstraints(t) {
        const e = t.velocities[this.m_indexA].v;
        let i = t.velocities[this.m_indexA].w;
        const s = t.velocities[this.m_indexB].v;
        let o = t.velocities[this.m_indexB].w;
        const n = this.m_invMassA,
          r = this.m_invMassB,
          a = this.m_invIA,
          l = this.m_invIB,
          m = t.step.dt,
          h = t.step.inv_dt;
        {
          const t = o - i + h * this.m_correctionFactor * this.m_angularError;
          let e = -this.m_angularMass * t;
          const s = this.m_angularImpulse,
            n = m * this.m_maxTorque;
          this.m_angularImpulse = X(this.m_angularImpulse + e, -n, n), e = this.m_angularImpulse - s, i -= a * e, o += l * e;
        }
        {
          const t = this.m_rA,
            _ = this.m_rB,
            c = it.AddVV(it.SubVV(it.AddVV(s, it.CrossSV(o, _, it.s_t0), it.s_t0), it.AddVV(e, it.CrossSV(i, t, it.s_t1), it.s_t1), it.s_t2), it.MulSV(h * this.m_correctionFactor, this.m_linearError, it.s_t3), Oi.SolveVelocityConstraints_s_Cdot_v2),
            u = nt.MulMV(this.m_linearMass, c, Oi.SolveVelocityConstraints_s_impulse_v2).SelfNeg(),
            d = Oi.SolveVelocityConstraints_s_oldImpulse_v2.Copy(this.m_linearImpulse);
          this.m_linearImpulse.SelfAdd(u);
          const p = m * this.m_maxForce;
          this.m_linearImpulse.LengthSquared() > p * p && (this.m_linearImpulse.Normalize(), this.m_linearImpulse.SelfMul(p)), it.SubVV(this.m_linearImpulse, d, u), e.SelfMulSub(n, u), i -= a * it.CrossVV(t, u), s.SelfMulAdd(r, u), o += l * it.CrossVV(_, u);
        }
        t.velocities[this.m_indexA].w = i, t.velocities[this.m_indexB].w = o;
      }
      SolvePositionConstraints(t) {
        return !0;
      }
      Dump(t) {
        const e = this.m_bodyA.m_islandIndex,
          i = this.m_bodyB.m_islandIndex;
        t("  const jd: b2MotorJointDef = new b2MotorJointDef();\n"), t("  jd.bodyA = bodies[%d];\n", e), t("  jd.bodyB = bodies[%d];\n", i), t("  jd.collideConnected = %s;\n", this.m_collideConnected ? "true" : "false"), t("  jd.linearOffset.Set(%.15f, %.15f);\n", this.m_linearOffset.x, this.m_linearOffset.y), t("  jd.angularOffset = %.15f;\n", this.m_angularOffset), t("  jd.maxForce = %.15f;\n", this.m_maxForce), t("  jd.maxTorque = %.15f;\n", this.m_maxTorque), t("  jd.correctionFactor = %.15f;\n", this.m_correctionFactor), t("  joints[%d] = this.m_world.CreateJoint(jd);\n", this.m_index);
      }
    }
    Oi.SolveVelocityConstraints_s_Cdot_v2 = new it(), Oi.SolveVelocityConstraints_s_impulse_v2 = new it(), Oi.SolveVelocityConstraints_s_oldImpulse_v2 = new it();
    class ji extends Ri {
      constructor(t) {
        super(t), this.m_localAnchorB = new it(), this.m_targetA = new it(), this.m_frequencyHz = 0, this.m_dampingRatio = 0, this.m_beta = 0, this.m_impulse = new it(), this.m_maxForce = 0, this.m_gamma = 0, this.m_indexA = 0, this.m_indexB = 0, this.m_rB = new it(), this.m_localCenterB = new it(), this.m_invMassB = 0, this.m_invIB = 0, this.m_mass = new nt(), this.m_C = new it(), this.m_qB = new at(), this.m_lalcB = new it(), this.m_K = new nt(), this.m_targetA.Copy(e(t.target, it.ZERO)), lt.MulTXV(this.m_bodyB.GetTransform(), this.m_targetA, this.m_localAnchorB), this.m_maxForce = e(t.maxForce, 0), this.m_impulse.SetZero(), this.m_frequencyHz = e(t.frequencyHz, 0), this.m_dampingRatio = e(t.dampingRatio, 0), this.m_beta = 0, this.m_gamma = 0;
      }
      SetTarget(t) {
        this.m_bodyB.IsAwake() || this.m_bodyB.SetAwake(!0), this.m_targetA.Copy(t);
      }
      GetTarget() {
        return this.m_targetA;
      }
      SetMaxForce(t) {
        this.m_maxForce = t;
      }
      GetMaxForce() {
        return this.m_maxForce;
      }
      SetFrequency(t) {
        this.m_frequencyHz = t;
      }
      GetFrequency() {
        return this.m_frequencyHz;
      }
      SetDampingRatio(t) {
        this.m_dampingRatio = t;
      }
      GetDampingRatio() {
        return this.m_dampingRatio;
      }
      InitVelocityConstraints(t) {
        this.m_indexB = this.m_bodyB.m_islandIndex, this.m_localCenterB.Copy(this.m_bodyB.m_sweep.localCenter), this.m_invMassB = this.m_bodyB.m_invMass, this.m_invIB = this.m_bodyB.m_invI;
        const e = t.positions[this.m_indexB].c,
          i = t.positions[this.m_indexB].a,
          s = t.velocities[this.m_indexB].v;
        let o = t.velocities[this.m_indexB].w;
        const r = this.m_qB.SetAngle(i),
          a = this.m_bodyB.GetMass(),
          l = 2 * n * this.m_frequencyHz,
          m = 2 * a * this.m_dampingRatio * l,
          h = a * (l * l),
          _ = t.step.dt;
        this.m_gamma = _ * (m + _ * h), 0 !== this.m_gamma && (this.m_gamma = 1 / this.m_gamma), this.m_beta = _ * h * this.m_gamma, it.SubVV(this.m_localAnchorB, this.m_localCenterB, this.m_lalcB), at.MulRV(r, this.m_lalcB, this.m_rB);
        const c = this.m_K;
        c.ex.x = this.m_invMassB + this.m_invIB * this.m_rB.y * this.m_rB.y + this.m_gamma, c.ex.y = -this.m_invIB * this.m_rB.x * this.m_rB.y, c.ey.x = c.ex.y, c.ey.y = this.m_invMassB + this.m_invIB * this.m_rB.x * this.m_rB.x + this.m_gamma, c.GetInverse(this.m_mass), this.m_C.x = e.x + this.m_rB.x - this.m_targetA.x, this.m_C.y = e.y + this.m_rB.y - this.m_targetA.y, this.m_C.SelfMul(this.m_beta), o *= .98, t.step.warmStarting ? (this.m_impulse.SelfMul(t.step.dtRatio), s.x += this.m_invMassB * this.m_impulse.x, s.y += this.m_invMassB * this.m_impulse.y, o += this.m_invIB * it.CrossVV(this.m_rB, this.m_impulse)) : this.m_impulse.SetZero(), t.velocities[this.m_indexB].w = o;
      }
      SolveVelocityConstraints(t) {
        const e = t.velocities[this.m_indexB].v;
        let i = t.velocities[this.m_indexB].w;
        const s = it.AddVCrossSV(e, i, this.m_rB, ji.SolveVelocityConstraints_s_Cdot),
          o = nt.MulMV(this.m_mass, it.AddVV(s, it.AddVV(this.m_C, it.MulSV(this.m_gamma, this.m_impulse, it.s_t0), it.s_t0), it.s_t0).SelfNeg(), ji.SolveVelocityConstraints_s_impulse),
          n = ji.SolveVelocityConstraints_s_oldImpulse.Copy(this.m_impulse);
        this.m_impulse.SelfAdd(o);
        const r = t.step.dt * this.m_maxForce;
        this.m_impulse.LengthSquared() > r * r && this.m_impulse.SelfMul(r / this.m_impulse.Length()), it.SubVV(this.m_impulse, n, o), e.SelfMulAdd(this.m_invMassB, o), i += this.m_invIB * it.CrossVV(this.m_rB, o), t.velocities[this.m_indexB].w = i;
      }
      SolvePositionConstraints(t) {
        return !0;
      }
      GetAnchorA(t) {
        return t.x = this.m_targetA.x, t.y = this.m_targetA.y, t;
      }
      GetAnchorB(t) {
        return this.m_bodyB.GetWorldPoint(this.m_localAnchorB, t);
      }
      GetReactionForce(t, e) {
        return it.MulSV(t, this.m_impulse, e);
      }
      GetReactionTorque(t) {
        return 0;
      }
      Dump(t) {
        t("Mouse joint dumping is not supported.\n");
      }
      ShiftOrigin(t) {
        this.m_targetA.SelfSub(t);
      }
    }
    ji.SolveVelocityConstraints_s_Cdot = new it(), ji.SolveVelocityConstraints_s_impulse = new it(), ji.SolveVelocityConstraints_s_oldImpulse = new it();
    class Ni extends Ri {
      constructor(i) {
        super(i), this.m_localAnchorA = new it(), this.m_localAnchorB = new it(), this.m_localXAxisA = new it(), this.m_localYAxisA = new it(), this.m_referenceAngle = 0, this.m_impulse = new ot(0, 0, 0), this.m_motorImpulse = 0, this.m_lowerTranslation = 0, this.m_upperTranslation = 0, this.m_maxMotorForce = 0, this.m_motorSpeed = 0, this.m_enableLimit = !1, this.m_enableMotor = !1, this.m_limitState = t.b2LimitState.e_inactiveLimit, this.m_indexA = 0, this.m_indexB = 0, this.m_localCenterA = new it(), this.m_localCenterB = new it(), this.m_invMassA = 0, this.m_invMassB = 0, this.m_invIA = 0, this.m_invIB = 0, this.m_axis = new it(0, 0), this.m_perp = new it(0, 0), this.m_s1 = 0, this.m_s2 = 0, this.m_a1 = 0, this.m_a2 = 0, this.m_K = new rt(), this.m_K3 = new rt(), this.m_K2 = new nt(), this.m_motorMass = 0, this.m_qA = new at(), this.m_qB = new at(), this.m_lalcA = new it(), this.m_lalcB = new it(), this.m_rA = new it(), this.m_rB = new it(), this.m_localAnchorA.Copy(e(i.localAnchorA, it.ZERO)), this.m_localAnchorB.Copy(e(i.localAnchorB, it.ZERO)), this.m_localXAxisA.Copy(e(i.localAxisA, new it(1, 0))).SelfNormalize(), it.CrossOneV(this.m_localXAxisA, this.m_localYAxisA), this.m_referenceAngle = e(i.referenceAngle, 0), this.m_lowerTranslation = e(i.lowerTranslation, 0), this.m_upperTranslation = e(i.upperTranslation, 0), this.m_maxMotorForce = e(i.maxMotorForce, 0), this.m_motorSpeed = e(i.motorSpeed, 0), this.m_enableLimit = e(i.enableLimit, !1), this.m_enableMotor = e(i.enableMotor, !1);
      }
      InitVelocityConstraints(e) {
        this.m_indexA = this.m_bodyA.m_islandIndex, this.m_indexB = this.m_bodyB.m_islandIndex, this.m_localCenterA.Copy(this.m_bodyA.m_sweep.localCenter), this.m_localCenterB.Copy(this.m_bodyB.m_sweep.localCenter), this.m_invMassA = this.m_bodyA.m_invMass, this.m_invMassB = this.m_bodyB.m_invMass, this.m_invIA = this.m_bodyA.m_invI, this.m_invIB = this.m_bodyB.m_invI;
        const i = e.positions[this.m_indexA].c,
          s = e.positions[this.m_indexA].a,
          o = e.velocities[this.m_indexA].v;
        let n = e.velocities[this.m_indexA].w;
        const r = e.positions[this.m_indexB].c,
          a = e.positions[this.m_indexB].a,
          l = e.velocities[this.m_indexB].v;
        let m = e.velocities[this.m_indexB].w;
        const _ = this.m_qA.SetAngle(s),
          c = this.m_qB.SetAngle(a);
        it.SubVV(this.m_localAnchorA, this.m_localCenterA, this.m_lalcA);
        const u = at.MulRV(_, this.m_lalcA, this.m_rA);
        it.SubVV(this.m_localAnchorB, this.m_localCenterB, this.m_lalcB);
        const d = at.MulRV(c, this.m_lalcB, this.m_rB),
          p = it.AddVV(it.SubVV(r, i, it.s_t0), it.SubVV(d, u, it.s_t1), Ni.InitVelocityConstraints_s_d),
          f = this.m_invMassA,
          y = this.m_invMassB,
          x = this.m_invIA,
          B = this.m_invIB;
        if (at.MulRV(_, this.m_localXAxisA, this.m_axis), this.m_a1 = it.CrossVV(it.AddVV(p, u, it.s_t0), this.m_axis), this.m_a2 = it.CrossVV(d, this.m_axis), this.m_motorMass = f + y + x * this.m_a1 * this.m_a1 + B * this.m_a2 * this.m_a2, this.m_motorMass > 0 && (this.m_motorMass = 1 / this.m_motorMass), at.MulRV(_, this.m_localYAxisA, this.m_perp), this.m_s1 = it.CrossVV(it.AddVV(p, u, it.s_t0), this.m_perp), this.m_s2 = it.CrossVV(d, this.m_perp), this.m_K.ex.x = f + y + x * this.m_s1 * this.m_s1 + B * this.m_s2 * this.m_s2, this.m_K.ex.y = x * this.m_s1 + B * this.m_s2, this.m_K.ex.z = x * this.m_s1 * this.m_a1 + B * this.m_s2 * this.m_a2, this.m_K.ey.x = this.m_K.ex.y, this.m_K.ey.y = x + B, 0 === this.m_K.ey.y && (this.m_K.ey.y = 1), this.m_K.ey.z = x * this.m_a1 + B * this.m_a2, this.m_K.ez.x = this.m_K.ex.z, this.m_K.ez.y = this.m_K.ey.z, this.m_K.ez.z = f + y + x * this.m_a1 * this.m_a1 + B * this.m_a2 * this.m_a2, this.m_enableLimit) {
          const e = it.DotVV(this.m_axis, p);
          O(this.m_upperTranslation - this.m_lowerTranslation) < 2 * h ? this.m_limitState = t.b2LimitState.e_equalLimits : e <= this.m_lowerTranslation ? this.m_limitState !== t.b2LimitState.e_atLowerLimit && (this.m_limitState = t.b2LimitState.e_atLowerLimit, this.m_impulse.z = 0) : e >= this.m_upperTranslation ? this.m_limitState !== t.b2LimitState.e_atUpperLimit && (this.m_limitState = t.b2LimitState.e_atUpperLimit, this.m_impulse.z = 0) : (this.m_limitState = t.b2LimitState.e_inactiveLimit, this.m_impulse.z = 0);
        } else this.m_limitState = t.b2LimitState.e_inactiveLimit, this.m_impulse.z = 0;
        if (this.m_enableMotor || (this.m_motorImpulse = 0), e.step.warmStarting) {
          this.m_impulse.SelfMul(e.step.dtRatio), this.m_motorImpulse *= e.step.dtRatio;
          const t = it.AddVV(it.MulSV(this.m_impulse.x, this.m_perp, it.s_t0), it.MulSV(this.m_motorImpulse + this.m_impulse.z, this.m_axis, it.s_t1), Ni.InitVelocityConstraints_s_P),
            i = this.m_impulse.x * this.m_s1 + this.m_impulse.y + (this.m_motorImpulse + this.m_impulse.z) * this.m_a1,
            s = this.m_impulse.x * this.m_s2 + this.m_impulse.y + (this.m_motorImpulse + this.m_impulse.z) * this.m_a2;
          o.SelfMulSub(f, t), n -= x * i, l.SelfMulAdd(y, t), m += B * s;
        } else this.m_impulse.SetZero(), this.m_motorImpulse = 0;
        e.velocities[this.m_indexA].w = n, e.velocities[this.m_indexB].w = m;
      }
      SolveVelocityConstraints(e) {
        const i = e.velocities[this.m_indexA].v;
        let s = e.velocities[this.m_indexA].w;
        const o = e.velocities[this.m_indexB].v;
        let n = e.velocities[this.m_indexB].w;
        const r = this.m_invMassA,
          a = this.m_invMassB,
          l = this.m_invIA,
          m = this.m_invIB;
        if (this.m_enableMotor && this.m_limitState !== t.b2LimitState.e_equalLimits) {
          const t = it.DotVV(this.m_axis, it.SubVV(o, i, it.s_t0)) + this.m_a2 * n - this.m_a1 * s;
          let h = this.m_motorMass * (this.m_motorSpeed - t);
          const _ = this.m_motorImpulse,
            c = e.step.dt * this.m_maxMotorForce;
          this.m_motorImpulse = X(this.m_motorImpulse + h, -c, c), h = this.m_motorImpulse - _;
          const u = it.MulSV(h, this.m_axis, Ni.SolveVelocityConstraints_s_P),
            d = h * this.m_a1,
            p = h * this.m_a2;
          i.SelfMulSub(r, u), s -= l * d, o.SelfMulAdd(a, u), n += m * p;
        }
        const h = it.DotVV(this.m_perp, it.SubVV(o, i, it.s_t0)) + this.m_s2 * n - this.m_s1 * s,
          _ = n - s;
        if (this.m_enableLimit && this.m_limitState !== t.b2LimitState.e_inactiveLimit) {
          const e = it.DotVV(this.m_axis, it.SubVV(o, i, it.s_t0)) + this.m_a2 * n - this.m_a1 * s,
            c = Ni.SolveVelocityConstraints_s_f1.Copy(this.m_impulse),
            u = this.m_K.Solve33(-h, -_, -e, Ni.SolveVelocityConstraints_s_df3);
          this.m_impulse.SelfAdd(u), this.m_limitState === t.b2LimitState.e_atLowerLimit ? this.m_impulse.z = N(this.m_impulse.z, 0) : this.m_limitState === t.b2LimitState.e_atUpperLimit && (this.m_impulse.z = j(this.m_impulse.z, 0));
          const d = -h - (this.m_impulse.z - c.z) * this.m_K.ez.x,
            p = -_ - (this.m_impulse.z - c.z) * this.m_K.ez.y,
            f = this.m_K.Solve22(d, p, Ni.SolveVelocityConstraints_s_f2r);
          f.x += c.x, f.y += c.y, this.m_impulse.x = f.x, this.m_impulse.y = f.y, u.x = this.m_impulse.x - c.x, u.y = this.m_impulse.y - c.y, u.z = this.m_impulse.z - c.z;
          const y = it.AddVV(it.MulSV(u.x, this.m_perp, it.s_t0), it.MulSV(u.z, this.m_axis, it.s_t1), Ni.SolveVelocityConstraints_s_P),
            x = u.x * this.m_s1 + u.y + u.z * this.m_a1,
            B = u.x * this.m_s2 + u.y + u.z * this.m_a2;
          i.SelfMulSub(r, y), s -= l * x, o.SelfMulAdd(a, y), n += m * B;
        } else {
          const t = this.m_K.Solve22(-h, -_, Ni.SolveVelocityConstraints_s_df2);
          this.m_impulse.x += t.x, this.m_impulse.y += t.y;
          const e = it.MulSV(t.x, this.m_perp, Ni.SolveVelocityConstraints_s_P),
            c = t.x * this.m_s1 + t.y,
            u = t.x * this.m_s2 + t.y;
          i.SelfMulSub(r, e), s -= l * c, o.SelfMulAdd(a, e), n += m * u;
        }
        e.velocities[this.m_indexA].w = s, e.velocities[this.m_indexB].w = n;
      }
      SolvePositionConstraints(t) {
        const e = t.positions[this.m_indexA].c;
        let i = t.positions[this.m_indexA].a;
        const s = t.positions[this.m_indexB].c;
        let o = t.positions[this.m_indexB].a;
        const n = this.m_qA.SetAngle(i),
          r = this.m_qB.SetAngle(o),
          a = this.m_invMassA,
          l = this.m_invMassB,
          m = this.m_invIA,
          c = this.m_invIB,
          u = at.MulRV(n, this.m_lalcA, this.m_rA),
          d = at.MulRV(r, this.m_lalcB, this.m_rB),
          p = it.SubVV(it.AddVV(s, d, it.s_t0), it.AddVV(e, u, it.s_t1), Ni.SolvePositionConstraints_s_d),
          y = at.MulRV(n, this.m_localXAxisA, this.m_axis),
          x = it.CrossVV(it.AddVV(p, u, it.s_t0), y),
          B = it.CrossVV(d, y),
          S = at.MulRV(n, this.m_localYAxisA, this.m_perp),
          b = it.CrossVV(it.AddVV(p, u, it.s_t0), S),
          A = it.CrossVV(d, S);
        let C = Ni.SolvePositionConstraints_s_impulse;
        const V = it.DotVV(S, p),
          g = o - i - this.m_referenceAngle;
        let w = O(V);
        const v = O(g);
        let M = !1,
          P = 0;
        if (this.m_enableLimit) {
          const t = it.DotVV(y, p);
          O(this.m_upperTranslation - this.m_lowerTranslation) < 2 * h ? (P = X(t, -f, f), w = N(w, O(t)), M = !0) : t <= this.m_lowerTranslation ? (P = X(t - this.m_lowerTranslation + h, -f, 0), w = N(w, this.m_lowerTranslation - t), M = !0) : t >= this.m_upperTranslation && (P = X(t - this.m_upperTranslation - h, 0, f), w = N(w, t - this.m_upperTranslation), M = !0);
        }
        if (M) {
          const t = a + l + m * b * b + c * A * A,
            e = m * b + c * A,
            i = m * b * x + c * A * B;
          let s = m + c;
          0 === s && (s = 1);
          const o = m * x + c * B,
            n = a + l + m * x * x + c * B * B,
            r = this.m_K3;
          r.ex.SetXYZ(t, e, i), r.ey.SetXYZ(e, s, o), r.ez.SetXYZ(i, o, n), C = r.Solve33(-V, -g, -P, C);
        } else {
          const t = a + l + m * b * b + c * A * A,
            e = m * b + c * A;
          let i = m + c;
          0 === i && (i = 1);
          const s = this.m_K2;
          s.ex.Set(t, e), s.ey.Set(e, i);
          const o = s.Solve(-V, -g, Ni.SolvePositionConstraints_s_impulse1);
          C.x = o.x, C.y = o.y, C.z = 0;
        }
        const I = it.AddVV(it.MulSV(C.x, S, it.s_t0), it.MulSV(C.z, y, it.s_t1), Ni.SolvePositionConstraints_s_P),
          G = C.x * b + C.y + C.z * x,
          D = C.x * A + C.y + C.z * B;
        return e.SelfMulSub(a, I), i -= m * G, s.SelfMulAdd(l, I), o += c * D, t.positions[this.m_indexA].a = i, t.positions[this.m_indexB].a = o, w <= h && v <= _;
      }
      GetAnchorA(t) {
        return this.m_bodyA.GetWorldPoint(this.m_localAnchorA, t);
      }
      GetAnchorB(t) {
        return this.m_bodyB.GetWorldPoint(this.m_localAnchorB, t);
      }
      GetReactionForce(t, e) {
        return e.x = t * (this.m_impulse.x * this.m_perp.x + (this.m_motorImpulse + this.m_impulse.z) * this.m_axis.x), e.y = t * (this.m_impulse.x * this.m_perp.y + (this.m_motorImpulse + this.m_impulse.z) * this.m_axis.y), e;
      }
      GetReactionTorque(t) {
        return t * this.m_impulse.y;
      }
      GetLocalAnchorA() {
        return this.m_localAnchorA;
      }
      GetLocalAnchorB() {
        return this.m_localAnchorB;
      }
      GetLocalAxisA() {
        return this.m_localXAxisA;
      }
      GetReferenceAngle() {
        return this.m_referenceAngle;
      }
      GetJointTranslation() {
        const t = this.m_bodyA.GetWorldPoint(this.m_localAnchorA, Ni.GetJointTranslation_s_pA),
          e = this.m_bodyB.GetWorldPoint(this.m_localAnchorB, Ni.GetJointTranslation_s_pB),
          i = it.SubVV(e, t, Ni.GetJointTranslation_s_d),
          s = this.m_bodyA.GetWorldVector(this.m_localXAxisA, Ni.GetJointTranslation_s_axis),
          o = it.DotVV(i, s);
        return o;
      }
      GetJointSpeed() {
        const t = this.m_bodyA,
          e = this.m_bodyB;
        it.SubVV(this.m_localAnchorA, t.m_sweep.localCenter, this.m_lalcA);
        const i = at.MulRV(t.m_xf.q, this.m_lalcA, this.m_rA);
        it.SubVV(this.m_localAnchorB, e.m_sweep.localCenter, this.m_lalcB);
        const s = at.MulRV(e.m_xf.q, this.m_lalcB, this.m_rB),
          o = it.AddVV(t.m_sweep.c, i, it.s_t0),
          n = it.AddVV(e.m_sweep.c, s, it.s_t1),
          r = it.SubVV(n, o, it.s_t2),
          a = t.GetWorldVector(this.m_localXAxisA, this.m_axis),
          l = t.m_linearVelocity,
          m = e.m_linearVelocity,
          h = t.m_angularVelocity,
          _ = e.m_angularVelocity,
          c = it.DotVV(r, it.CrossSV(h, a, it.s_t0)) + it.DotVV(a, it.SubVV(it.AddVCrossSV(m, _, s, it.s_t0), it.AddVCrossSV(l, h, i, it.s_t1), it.s_t0));
        return c;
      }
      IsLimitEnabled() {
        return this.m_enableLimit;
      }
      EnableLimit(t) {
        t !== this.m_enableLimit && (this.m_bodyA.SetAwake(!0), this.m_bodyB.SetAwake(!0), this.m_enableLimit = t, this.m_impulse.z = 0);
      }
      GetLowerLimit() {
        return this.m_lowerTranslation;
      }
      GetUpperLimit() {
        return this.m_upperTranslation;
      }
      SetLimits(t, e) {
        t === this.m_lowerTranslation && e === this.m_upperTranslation || (this.m_bodyA.SetAwake(!0), this.m_bodyB.SetAwake(!0), this.m_lowerTranslation = t, this.m_upperTranslation = e, this.m_impulse.z = 0);
      }
      IsMotorEnabled() {
        return this.m_enableMotor;
      }
      EnableMotor(t) {
        t !== this.m_enableMotor && (this.m_bodyA.SetAwake(!0), this.m_bodyB.SetAwake(!0), this.m_enableMotor = t);
      }
      SetMotorSpeed(t) {
        t !== this.m_motorSpeed && (this.m_bodyA.SetAwake(!0), this.m_bodyB.SetAwake(!0), this.m_motorSpeed = t);
      }
      GetMotorSpeed() {
        return this.m_motorSpeed;
      }
      SetMaxMotorForce(t) {
        t !== this.m_maxMotorForce && (this.m_bodyA.SetAwake(!0), this.m_bodyB.SetAwake(!0), this.m_maxMotorForce = t);
      }
      GetMaxMotorForce() {
        return this.m_maxMotorForce;
      }
      GetMotorForce(t) {
        return t * this.m_motorImpulse;
      }
      Dump(t) {
        const e = this.m_bodyA.m_islandIndex,
          i = this.m_bodyB.m_islandIndex;
        t("  const jd: b2PrismaticJointDef = new b2PrismaticJointDef();\n"), t("  jd.bodyA = bodies[%d];\n", e), t("  jd.bodyB = bodies[%d];\n", i), t("  jd.collideConnected = %s;\n", this.m_collideConnected ? "true" : "false"), t("  jd.localAnchorA.Set(%.15f, %.15f);\n", this.m_localAnchorA.x, this.m_localAnchorA.y), t("  jd.localAnchorB.Set(%.15f, %.15f);\n", this.m_localAnchorB.x, this.m_localAnchorB.y), t("  jd.localAxisA.Set(%.15f, %.15f);\n", this.m_localXAxisA.x, this.m_localXAxisA.y), t("  jd.referenceAngle = %.15f;\n", this.m_referenceAngle), t("  jd.enableLimit = %s;\n", this.m_enableLimit ? "true" : "false"), t("  jd.lowerTranslation = %.15f;\n", this.m_lowerTranslation), t("  jd.upperTranslation = %.15f;\n", this.m_upperTranslation), t("  jd.enableMotor = %s;\n", this.m_enableMotor ? "true" : "false"), t("  jd.motorSpeed = %.15f;\n", this.m_motorSpeed), t("  jd.maxMotorForce = %.15f;\n", this.m_maxMotorForce), t("  joints[%d] = this.m_world.CreateJoint(jd);\n", this.m_index);
      }
    }
    Ni.InitVelocityConstraints_s_d = new it(), Ni.InitVelocityConstraints_s_P = new it(), Ni.SolveVelocityConstraints_s_P = new it(), Ni.SolveVelocityConstraints_s_f2r = new it(), Ni.SolveVelocityConstraints_s_f1 = new ot(), Ni.SolveVelocityConstraints_s_df3 = new ot(), Ni.SolveVelocityConstraints_s_df2 = new it(), Ni.SolvePositionConstraints_s_d = new it(), Ni.SolvePositionConstraints_s_impulse = new ot(), Ni.SolvePositionConstraints_s_impulse1 = new it(), Ni.SolvePositionConstraints_s_P = new it(), Ni.GetJointTranslation_s_pA = new it(), Ni.GetJointTranslation_s_pB = new it(), Ni.GetJointTranslation_s_d = new it(), Ni.GetJointTranslation_s_axis = new it();
    class Xi extends Ri {
      constructor(t) {
        super(t), this.m_groundAnchorA = new it(), this.m_groundAnchorB = new it(), this.m_lengthA = 0, this.m_lengthB = 0, this.m_localAnchorA = new it(), this.m_localAnchorB = new it(), this.m_constant = 0, this.m_ratio = 0, this.m_impulse = 0, this.m_indexA = 0, this.m_indexB = 0, this.m_uA = new it(), this.m_uB = new it(), this.m_rA = new it(), this.m_rB = new it(), this.m_localCenterA = new it(), this.m_localCenterB = new it(), this.m_invMassA = 0, this.m_invMassB = 0, this.m_invIA = 0, this.m_invIB = 0, this.m_mass = 0, this.m_qA = new at(), this.m_qB = new at(), this.m_lalcA = new it(), this.m_lalcB = new it(), this.m_groundAnchorA.Copy(e(t.groundAnchorA, new it(-1, 1))), this.m_groundAnchorB.Copy(e(t.groundAnchorB, new it(1, 0))), this.m_localAnchorA.Copy(e(t.localAnchorA, new it(-1, 0))), this.m_localAnchorB.Copy(e(t.localAnchorB, new it(1, 0))), this.m_lengthA = e(t.lengthA, 0), this.m_lengthB = e(t.lengthB, 0), this.m_ratio = e(t.ratio, 1), this.m_constant = e(t.lengthA, 0) + this.m_ratio * e(t.lengthB, 0), this.m_impulse = 0;
      }
      InitVelocityConstraints(t) {
        this.m_indexA = this.m_bodyA.m_islandIndex, this.m_indexB = this.m_bodyB.m_islandIndex, this.m_localCenterA.Copy(this.m_bodyA.m_sweep.localCenter), this.m_localCenterB.Copy(this.m_bodyB.m_sweep.localCenter), this.m_invMassA = this.m_bodyA.m_invMass, this.m_invMassB = this.m_bodyB.m_invMass, this.m_invIA = this.m_bodyA.m_invI, this.m_invIB = this.m_bodyB.m_invI;
        const e = t.positions[this.m_indexA].c,
          i = t.positions[this.m_indexA].a,
          s = t.velocities[this.m_indexA].v;
        let o = t.velocities[this.m_indexA].w;
        const n = t.positions[this.m_indexB].c,
          r = t.positions[this.m_indexB].a,
          a = t.velocities[this.m_indexB].v;
        let l = t.velocities[this.m_indexB].w;
        const m = this.m_qA.SetAngle(i),
          _ = this.m_qB.SetAngle(r);
        it.SubVV(this.m_localAnchorA, this.m_localCenterA, this.m_lalcA), at.MulRV(m, this.m_lalcA, this.m_rA), it.SubVV(this.m_localAnchorB, this.m_localCenterB, this.m_lalcB), at.MulRV(_, this.m_lalcB, this.m_rB), this.m_uA.Copy(e).SelfAdd(this.m_rA).SelfSub(this.m_groundAnchorA), this.m_uB.Copy(n).SelfAdd(this.m_rB).SelfSub(this.m_groundAnchorB);
        const c = this.m_uA.Length(),
          u = this.m_uB.Length();
        c > 10 * h ? this.m_uA.SelfMul(1 / c) : this.m_uA.SetZero(), u > 10 * h ? this.m_uB.SelfMul(1 / u) : this.m_uB.SetZero();
        const d = it.CrossVV(this.m_rA, this.m_uA),
          p = it.CrossVV(this.m_rB, this.m_uB),
          f = this.m_invMassA + this.m_invIA * d * d,
          y = this.m_invMassB + this.m_invIB * p * p;
        if (this.m_mass = f + this.m_ratio * this.m_ratio * y, this.m_mass > 0 && (this.m_mass = 1 / this.m_mass), t.step.warmStarting) {
          this.m_impulse *= t.step.dtRatio;
          const e = it.MulSV(-this.m_impulse, this.m_uA, Xi.InitVelocityConstraints_s_PA),
            i = it.MulSV(-this.m_ratio * this.m_impulse, this.m_uB, Xi.InitVelocityConstraints_s_PB);
          s.SelfMulAdd(this.m_invMassA, e), o += this.m_invIA * it.CrossVV(this.m_rA, e), a.SelfMulAdd(this.m_invMassB, i), l += this.m_invIB * it.CrossVV(this.m_rB, i);
        } else this.m_impulse = 0;
        t.velocities[this.m_indexA].w = o, t.velocities[this.m_indexB].w = l;
      }
      SolveVelocityConstraints(t) {
        const e = t.velocities[this.m_indexA].v;
        let i = t.velocities[this.m_indexA].w;
        const s = t.velocities[this.m_indexB].v;
        let o = t.velocities[this.m_indexB].w;
        const n = it.AddVCrossSV(e, i, this.m_rA, Xi.SolveVelocityConstraints_s_vpA),
          r = it.AddVCrossSV(s, o, this.m_rB, Xi.SolveVelocityConstraints_s_vpB),
          a = -it.DotVV(this.m_uA, n) - this.m_ratio * it.DotVV(this.m_uB, r),
          l = -this.m_mass * a;
        this.m_impulse += l;
        const m = it.MulSV(-l, this.m_uA, Xi.SolveVelocityConstraints_s_PA),
          h = it.MulSV(-this.m_ratio * l, this.m_uB, Xi.SolveVelocityConstraints_s_PB);
        e.SelfMulAdd(this.m_invMassA, m), i += this.m_invIA * it.CrossVV(this.m_rA, m), s.SelfMulAdd(this.m_invMassB, h), o += this.m_invIB * it.CrossVV(this.m_rB, h), t.velocities[this.m_indexA].w = i, t.velocities[this.m_indexB].w = o;
      }
      SolvePositionConstraints(t) {
        const e = t.positions[this.m_indexA].c;
        let i = t.positions[this.m_indexA].a;
        const s = t.positions[this.m_indexB].c;
        let o = t.positions[this.m_indexB].a;
        const n = this.m_qA.SetAngle(i),
          r = this.m_qB.SetAngle(o);
        it.SubVV(this.m_localAnchorA, this.m_localCenterA, this.m_lalcA);
        const a = at.MulRV(n, this.m_lalcA, this.m_rA);
        it.SubVV(this.m_localAnchorB, this.m_localCenterB, this.m_lalcB);
        const l = at.MulRV(r, this.m_lalcB, this.m_rB),
          m = this.m_uA.Copy(e).SelfAdd(a).SelfSub(this.m_groundAnchorA),
          _ = this.m_uB.Copy(s).SelfAdd(l).SelfSub(this.m_groundAnchorB),
          c = m.Length(),
          u = _.Length();
        c > 10 * h ? m.SelfMul(1 / c) : m.SetZero(), u > 10 * h ? _.SelfMul(1 / u) : _.SetZero();
        const d = it.CrossVV(a, m),
          p = it.CrossVV(l, _),
          f = this.m_invMassA + this.m_invIA * d * d,
          y = this.m_invMassB + this.m_invIB * p * p;
        let x = f + this.m_ratio * this.m_ratio * y;
        x > 0 && (x = 1 / x);
        const B = this.m_constant - c - this.m_ratio * u,
          S = O(B),
          b = -x * B,
          A = it.MulSV(-b, m, Xi.SolvePositionConstraints_s_PA),
          C = it.MulSV(-this.m_ratio * b, _, Xi.SolvePositionConstraints_s_PB);
        return e.SelfMulAdd(this.m_invMassA, A), i += this.m_invIA * it.CrossVV(a, A), s.SelfMulAdd(this.m_invMassB, C), o += this.m_invIB * it.CrossVV(l, C), t.positions[this.m_indexA].a = i, t.positions[this.m_indexB].a = o, S < h;
      }
      GetAnchorA(t) {
        return this.m_bodyA.GetWorldPoint(this.m_localAnchorA, t);
      }
      GetAnchorB(t) {
        return this.m_bodyB.GetWorldPoint(this.m_localAnchorB, t);
      }
      GetReactionForce(t, e) {
        return e.x = t * this.m_impulse * this.m_uB.x, e.y = t * this.m_impulse * this.m_uB.y, e;
      }
      GetReactionTorque(t) {
        return 0;
      }
      GetGroundAnchorA() {
        return this.m_groundAnchorA;
      }
      GetGroundAnchorB() {
        return this.m_groundAnchorB;
      }
      GetLengthA() {
        return this.m_lengthA;
      }
      GetLengthB() {
        return this.m_lengthB;
      }
      GetRatio() {
        return this.m_ratio;
      }
      GetCurrentLengthA() {
        const t = this.m_bodyA.GetWorldPoint(this.m_localAnchorA, Xi.GetCurrentLengthA_s_p),
          e = this.m_groundAnchorA;
        return it.DistanceVV(t, e);
      }
      GetCurrentLengthB() {
        const t = this.m_bodyB.GetWorldPoint(this.m_localAnchorB, Xi.GetCurrentLengthB_s_p),
          e = this.m_groundAnchorB;
        return it.DistanceVV(t, e);
      }
      Dump(t) {
        const e = this.m_bodyA.m_islandIndex,
          i = this.m_bodyB.m_islandIndex;
        t("  const jd: b2PulleyJointDef = new b2PulleyJointDef();\n"), t("  jd.bodyA = bodies[%d];\n", e), t("  jd.bodyB = bodies[%d];\n", i), t("  jd.collideConnected = %s;\n", this.m_collideConnected ? "true" : "false"), t("  jd.groundAnchorA.Set(%.15f, %.15f);\n", this.m_groundAnchorA.x, this.m_groundAnchorA.y), t("  jd.groundAnchorB.Set(%.15f, %.15f);\n", this.m_groundAnchorB.x, this.m_groundAnchorB.y), t("  jd.localAnchorA.Set(%.15f, %.15f);\n", this.m_localAnchorA.x, this.m_localAnchorA.y), t("  jd.localAnchorB.Set(%.15f, %.15f);\n", this.m_localAnchorB.x, this.m_localAnchorB.y), t("  jd.lengthA = %.15f;\n", this.m_lengthA), t("  jd.lengthB = %.15f;\n", this.m_lengthB), t("  jd.ratio = %.15f;\n", this.m_ratio), t("  joints[%d] = this.m_world.CreateJoint(jd);\n", this.m_index);
      }
      ShiftOrigin(t) {
        this.m_groundAnchorA.SelfSub(t), this.m_groundAnchorB.SelfSub(t);
      }
    }
    Xi.InitVelocityConstraints_s_PA = new it(), Xi.InitVelocityConstraints_s_PB = new it(), Xi.SolveVelocityConstraints_s_vpA = new it(), Xi.SolveVelocityConstraints_s_vpB = new it(), Xi.SolveVelocityConstraints_s_PA = new it(), Xi.SolveVelocityConstraints_s_PB = new it(), Xi.SolvePositionConstraints_s_PA = new it(), Xi.SolvePositionConstraints_s_PB = new it(), Xi.GetCurrentLengthA_s_p = new it(), Xi.GetCurrentLengthB_s_p = new it();
    class Ui extends Ri {
      constructor(i) {
        super(i), this.m_localAnchorA = new it(), this.m_localAnchorB = new it(), this.m_impulse = new ot(), this.m_motorImpulse = 0, this.m_enableMotor = !1, this.m_maxMotorTorque = 0, this.m_motorSpeed = 0, this.m_enableLimit = !1, this.m_referenceAngle = 0, this.m_lowerAngle = 0, this.m_upperAngle = 0, this.m_indexA = 0, this.m_indexB = 0, this.m_rA = new it(), this.m_rB = new it(), this.m_localCenterA = new it(), this.m_localCenterB = new it(), this.m_invMassA = 0, this.m_invMassB = 0, this.m_invIA = 0, this.m_invIB = 0, this.m_mass = new rt(), this.m_motorMass = 0, this.m_limitState = t.b2LimitState.e_inactiveLimit, this.m_qA = new at(), this.m_qB = new at(), this.m_lalcA = new it(), this.m_lalcB = new it(), this.m_K = new nt(), this.m_localAnchorA.Copy(e(i.localAnchorA, it.ZERO)), this.m_localAnchorB.Copy(e(i.localAnchorB, it.ZERO)), this.m_referenceAngle = e(i.referenceAngle, 0), this.m_impulse.SetZero(), this.m_motorImpulse = 0, this.m_lowerAngle = e(i.lowerAngle, 0), this.m_upperAngle = e(i.upperAngle, 0), this.m_maxMotorTorque = e(i.maxMotorTorque, 0), this.m_motorSpeed = e(i.motorSpeed, 0), this.m_enableLimit = e(i.enableLimit, !1), this.m_enableMotor = e(i.enableMotor, !1), this.m_limitState = t.b2LimitState.e_inactiveLimit;
      }
      InitVelocityConstraints(e) {
        this.m_indexA = this.m_bodyA.m_islandIndex, this.m_indexB = this.m_bodyB.m_islandIndex, this.m_localCenterA.Copy(this.m_bodyA.m_sweep.localCenter), this.m_localCenterB.Copy(this.m_bodyB.m_sweep.localCenter), this.m_invMassA = this.m_bodyA.m_invMass, this.m_invMassB = this.m_bodyB.m_invMass, this.m_invIA = this.m_bodyA.m_invI, this.m_invIB = this.m_bodyB.m_invI;
        const i = e.positions[this.m_indexA].a,
          s = e.velocities[this.m_indexA].v;
        let o = e.velocities[this.m_indexA].w;
        const n = e.positions[this.m_indexB].a,
          r = e.velocities[this.m_indexB].v;
        let a = e.velocities[this.m_indexB].w;
        const l = this.m_qA.SetAngle(i),
          m = this.m_qB.SetAngle(n);
        it.SubVV(this.m_localAnchorA, this.m_localCenterA, this.m_lalcA), at.MulRV(l, this.m_lalcA, this.m_rA), it.SubVV(this.m_localAnchorB, this.m_localCenterB, this.m_lalcB), at.MulRV(m, this.m_lalcB, this.m_rB);
        const h = this.m_invMassA,
          c = this.m_invMassB,
          u = this.m_invIA,
          d = this.m_invIB,
          p = u + d === 0;
        if (this.m_mass.ex.x = h + c + this.m_rA.y * this.m_rA.y * u + this.m_rB.y * this.m_rB.y * d, this.m_mass.ey.x = -this.m_rA.y * this.m_rA.x * u - this.m_rB.y * this.m_rB.x * d, this.m_mass.ez.x = -this.m_rA.y * u - this.m_rB.y * d, this.m_mass.ex.y = this.m_mass.ey.x, this.m_mass.ey.y = h + c + this.m_rA.x * this.m_rA.x * u + this.m_rB.x * this.m_rB.x * d, this.m_mass.ez.y = this.m_rA.x * u + this.m_rB.x * d, this.m_mass.ex.z = this.m_mass.ez.x, this.m_mass.ey.z = this.m_mass.ez.y, this.m_mass.ez.z = u + d, this.m_motorMass = u + d, this.m_motorMass > 0 && (this.m_motorMass = 1 / this.m_motorMass), this.m_enableMotor && !p || (this.m_motorImpulse = 0), this.m_enableLimit && !p) {
          const e = n - i - this.m_referenceAngle;
          O(this.m_upperAngle - this.m_lowerAngle) < 2 * _ ? this.m_limitState = t.b2LimitState.e_equalLimits : e <= this.m_lowerAngle ? (this.m_limitState !== t.b2LimitState.e_atLowerLimit && (this.m_impulse.z = 0), this.m_limitState = t.b2LimitState.e_atLowerLimit) : e >= this.m_upperAngle ? (this.m_limitState !== t.b2LimitState.e_atUpperLimit && (this.m_impulse.z = 0), this.m_limitState = t.b2LimitState.e_atUpperLimit) : (this.m_limitState = t.b2LimitState.e_inactiveLimit, this.m_impulse.z = 0);
        } else this.m_limitState = t.b2LimitState.e_inactiveLimit;
        if (e.step.warmStarting) {
          this.m_impulse.SelfMul(e.step.dtRatio), this.m_motorImpulse *= e.step.dtRatio;
          const t = Ui.InitVelocityConstraints_s_P.Set(this.m_impulse.x, this.m_impulse.y);
          s.SelfMulSub(h, t), o -= u * (it.CrossVV(this.m_rA, t) + this.m_motorImpulse + this.m_impulse.z), r.SelfMulAdd(c, t), a += d * (it.CrossVV(this.m_rB, t) + this.m_motorImpulse + this.m_impulse.z);
        } else this.m_impulse.SetZero(), this.m_motorImpulse = 0;
        e.velocities[this.m_indexA].w = o, e.velocities[this.m_indexB].w = a;
      }
      SolveVelocityConstraints(e) {
        const i = e.velocities[this.m_indexA].v;
        let s = e.velocities[this.m_indexA].w;
        const o = e.velocities[this.m_indexB].v;
        let n = e.velocities[this.m_indexB].w;
        const r = this.m_invMassA,
          a = this.m_invMassB,
          l = this.m_invIA,
          m = this.m_invIB,
          h = l + m === 0;
        if (this.m_enableMotor && this.m_limitState !== t.b2LimitState.e_equalLimits && !h) {
          const t = n - s - this.m_motorSpeed;
          let i = -this.m_motorMass * t;
          const o = this.m_motorImpulse,
            r = e.step.dt * this.m_maxMotorTorque;
          this.m_motorImpulse = X(this.m_motorImpulse + i, -r, r), i = this.m_motorImpulse - o, s -= l * i, n += m * i;
        }
        if (this.m_enableLimit && this.m_limitState !== t.b2LimitState.e_inactiveLimit && !h) {
          const e = it.SubVV(it.AddVCrossSV(o, n, this.m_rB, it.s_t0), it.AddVCrossSV(i, s, this.m_rA, it.s_t1), Ui.SolveVelocityConstraints_s_Cdot1),
            h = n - s,
            _ = this.m_mass.Solve33(e.x, e.y, h, Ui.SolveVelocityConstraints_s_impulse_v3).SelfNeg();
          if (this.m_limitState === t.b2LimitState.e_equalLimits) this.m_impulse.SelfAdd(_);else if (this.m_limitState === t.b2LimitState.e_atLowerLimit) {
            const t = this.m_impulse.z + _.z;
            if (t < 0) {
              const t = -e.x + this.m_impulse.z * this.m_mass.ez.x,
                i = -e.y + this.m_impulse.z * this.m_mass.ez.y,
                s = this.m_mass.Solve22(t, i, Ui.SolveVelocityConstraints_s_reduced_v2);
              _.x = s.x, _.y = s.y, _.z = -this.m_impulse.z, this.m_impulse.x += s.x, this.m_impulse.y += s.y, this.m_impulse.z = 0;
            } else this.m_impulse.SelfAdd(_);
          } else if (this.m_limitState === t.b2LimitState.e_atUpperLimit) {
            const t = this.m_impulse.z + _.z;
            if (t > 0) {
              const t = -e.x + this.m_impulse.z * this.m_mass.ez.x,
                i = -e.y + this.m_impulse.z * this.m_mass.ez.y,
                s = this.m_mass.Solve22(t, i, Ui.SolveVelocityConstraints_s_reduced_v2);
              _.x = s.x, _.y = s.y, _.z = -this.m_impulse.z, this.m_impulse.x += s.x, this.m_impulse.y += s.y, this.m_impulse.z = 0;
            } else this.m_impulse.SelfAdd(_);
          }
          const c = Ui.SolveVelocityConstraints_s_P.Set(_.x, _.y);
          i.SelfMulSub(r, c), s -= l * (it.CrossVV(this.m_rA, c) + _.z), o.SelfMulAdd(a, c), n += m * (it.CrossVV(this.m_rB, c) + _.z);
        } else {
          const t = it.SubVV(it.AddVCrossSV(o, n, this.m_rB, it.s_t0), it.AddVCrossSV(i, s, this.m_rA, it.s_t1), Ui.SolveVelocityConstraints_s_Cdot_v2),
            e = this.m_mass.Solve22(-t.x, -t.y, Ui.SolveVelocityConstraints_s_impulse_v2);
          this.m_impulse.x += e.x, this.m_impulse.y += e.y, i.SelfMulSub(r, e), s -= l * it.CrossVV(this.m_rA, e), o.SelfMulAdd(a, e), n += m * it.CrossVV(this.m_rB, e);
        }
        e.velocities[this.m_indexA].w = s, e.velocities[this.m_indexB].w = n;
      }
      SolvePositionConstraints(e) {
        const i = e.positions[this.m_indexA].c;
        let s = e.positions[this.m_indexA].a;
        const o = e.positions[this.m_indexB].c;
        let n = e.positions[this.m_indexB].a;
        const r = this.m_qA.SetAngle(s),
          a = this.m_qB.SetAngle(n);
        let l = 0,
          m = 0;
        const c = this.m_invIA + this.m_invIB === 0;
        if (this.m_enableLimit && this.m_limitState !== t.b2LimitState.e_inactiveLimit && !c) {
          const e = n - s - this.m_referenceAngle;
          let i = 0;
          if (this.m_limitState === t.b2LimitState.e_equalLimits) {
            const t = X(e - this.m_lowerAngle, -y, y);
            i = -this.m_motorMass * t, l = O(t);
          } else if (this.m_limitState === t.b2LimitState.e_atLowerLimit) {
            let t = e - this.m_lowerAngle;
            l = -t, t = X(t + _, -y, 0), i = -this.m_motorMass * t;
          } else if (this.m_limitState === t.b2LimitState.e_atUpperLimit) {
            let t = e - this.m_upperAngle;
            l = t, t = X(t - _, 0, y), i = -this.m_motorMass * t;
          }
          s -= this.m_invIA * i, n += this.m_invIB * i;
        }
        {
          r.SetAngle(s), a.SetAngle(n), it.SubVV(this.m_localAnchorA, this.m_localCenterA, this.m_lalcA);
          const t = at.MulRV(r, this.m_lalcA, this.m_rA);
          it.SubVV(this.m_localAnchorB, this.m_localCenterB, this.m_lalcB);
          const e = at.MulRV(a, this.m_lalcB, this.m_rB),
            l = it.SubVV(it.AddVV(o, e, it.s_t0), it.AddVV(i, t, it.s_t1), Ui.SolvePositionConstraints_s_C_v2);
          m = l.Length();
          const h = this.m_invMassA,
            _ = this.m_invMassB,
            c = this.m_invIA,
            u = this.m_invIB,
            d = this.m_K;
          d.ex.x = h + _ + c * t.y * t.y + u * e.y * e.y, d.ex.y = -c * t.x * t.y - u * e.x * e.y, d.ey.x = d.ex.y, d.ey.y = h + _ + c * t.x * t.x + u * e.x * e.x;
          const p = d.Solve(l.x, l.y, Ui.SolvePositionConstraints_s_impulse).SelfNeg();
          i.SelfMulSub(h, p), s -= c * it.CrossVV(t, p), o.SelfMulAdd(_, p), n += u * it.CrossVV(e, p);
        }
        return e.positions[this.m_indexA].a = s, e.positions[this.m_indexB].a = n, m <= h && l <= _;
      }
      GetAnchorA(t) {
        return this.m_bodyA.GetWorldPoint(this.m_localAnchorA, t);
      }
      GetAnchorB(t) {
        return this.m_bodyB.GetWorldPoint(this.m_localAnchorB, t);
      }
      GetReactionForce(t, e) {
        return e.x = t * this.m_impulse.x, e.y = t * this.m_impulse.y, e;
      }
      GetReactionTorque(t) {
        return t * this.m_impulse.z;
      }
      GetLocalAnchorA() {
        return this.m_localAnchorA;
      }
      GetLocalAnchorB() {
        return this.m_localAnchorB;
      }
      GetReferenceAngle() {
        return this.m_referenceAngle;
      }
      GetJointAngle() {
        return this.m_bodyB.m_sweep.a - this.m_bodyA.m_sweep.a - this.m_referenceAngle;
      }
      GetJointSpeed() {
        return this.m_bodyB.m_angularVelocity - this.m_bodyA.m_angularVelocity;
      }
      IsMotorEnabled() {
        return this.m_enableMotor;
      }
      EnableMotor(t) {
        t !== this.m_enableMotor && (this.m_bodyA.SetAwake(!0), this.m_bodyB.SetAwake(!0), this.m_enableMotor = t);
      }
      GetMotorTorque(t) {
        return t * this.m_motorImpulse;
      }
      GetMotorSpeed() {
        return this.m_motorSpeed;
      }
      SetMaxMotorTorque(t) {
        t !== this.m_maxMotorTorque && (this.m_bodyA.SetAwake(!0), this.m_bodyB.SetAwake(!0), this.m_maxMotorTorque = t);
      }
      GetMaxMotorTorque() {
        return this.m_maxMotorTorque;
      }
      IsLimitEnabled() {
        return this.m_enableLimit;
      }
      EnableLimit(t) {
        t !== this.m_enableLimit && (this.m_bodyA.SetAwake(!0), this.m_bodyB.SetAwake(!0), this.m_enableLimit = t, this.m_impulse.z = 0);
      }
      GetLowerLimit() {
        return this.m_lowerAngle;
      }
      GetUpperLimit() {
        return this.m_upperAngle;
      }
      SetLimits(t, e) {
        t === this.m_lowerAngle && e === this.m_upperAngle || (this.m_bodyA.SetAwake(!0), this.m_bodyB.SetAwake(!0), this.m_impulse.z = 0, this.m_lowerAngle = t, this.m_upperAngle = e);
      }
      SetMotorSpeed(t) {
        t !== this.m_motorSpeed && (this.m_bodyA.SetAwake(!0), this.m_bodyB.SetAwake(!0), this.m_motorSpeed = t);
      }
      Dump(t) {
        const e = this.m_bodyA.m_islandIndex,
          i = this.m_bodyB.m_islandIndex;
        t("  const jd: b2RevoluteJointDef = new b2RevoluteJointDef();\n"), t("  jd.bodyA = bodies[%d];\n", e), t("  jd.bodyB = bodies[%d];\n", i), t("  jd.collideConnected = %s;\n", this.m_collideConnected ? "true" : "false"), t("  jd.localAnchorA.Set(%.15f, %.15f);\n", this.m_localAnchorA.x, this.m_localAnchorA.y), t("  jd.localAnchorB.Set(%.15f, %.15f);\n", this.m_localAnchorB.x, this.m_localAnchorB.y), t("  jd.referenceAngle = %.15f;\n", this.m_referenceAngle), t("  jd.enableLimit = %s;\n", this.m_enableLimit ? "true" : "false"), t("  jd.lowerAngle = %.15f;\n", this.m_lowerAngle), t("  jd.upperAngle = %.15f;\n", this.m_upperAngle), t("  jd.enableMotor = %s;\n", this.m_enableMotor ? "true" : "false"), t("  jd.motorSpeed = %.15f;\n", this.m_motorSpeed), t("  jd.maxMotorTorque = %.15f;\n", this.m_maxMotorTorque), t("  joints[%d] = this.m_world.CreateJoint(jd);\n", this.m_index);
      }
    }
    Ui.InitVelocityConstraints_s_P = new it(), Ui.SolveVelocityConstraints_s_P = new it(), Ui.SolveVelocityConstraints_s_Cdot_v2 = new it(), Ui.SolveVelocityConstraints_s_Cdot1 = new it(), Ui.SolveVelocityConstraints_s_impulse_v3 = new ot(), Ui.SolveVelocityConstraints_s_reduced_v2 = new it(), Ui.SolveVelocityConstraints_s_impulse_v2 = new it(), Ui.SolvePositionConstraints_s_C_v2 = new it(), Ui.SolvePositionConstraints_s_impulse = new it();
    class Wi extends Ri {
      constructor(i) {
        super(i), this.m_localAnchorA = new it(), this.m_localAnchorB = new it(), this.m_maxLength = 0, this.m_length = 0, this.m_impulse = 0, this.m_indexA = 0, this.m_indexB = 0, this.m_u = new it(), this.m_rA = new it(), this.m_rB = new it(), this.m_localCenterA = new it(), this.m_localCenterB = new it(), this.m_invMassA = 0, this.m_invMassB = 0, this.m_invIA = 0, this.m_invIB = 0, this.m_mass = 0, this.m_state = t.b2LimitState.e_inactiveLimit, this.m_qA = new at(), this.m_qB = new at(), this.m_lalcA = new it(), this.m_lalcB = new it(), this.m_localAnchorA.Copy(e(i.localAnchorA, new it(-1, 0))), this.m_localAnchorB.Copy(e(i.localAnchorB, new it(1, 0))), this.m_maxLength = e(i.maxLength, 0);
      }
      InitVelocityConstraints(e) {
        this.m_indexA = this.m_bodyA.m_islandIndex, this.m_indexB = this.m_bodyB.m_islandIndex, this.m_localCenterA.Copy(this.m_bodyA.m_sweep.localCenter), this.m_localCenterB.Copy(this.m_bodyB.m_sweep.localCenter), this.m_invMassA = this.m_bodyA.m_invMass, this.m_invMassB = this.m_bodyB.m_invMass, this.m_invIA = this.m_bodyA.m_invI, this.m_invIB = this.m_bodyB.m_invI;
        const i = e.positions[this.m_indexA].c,
          s = e.positions[this.m_indexA].a,
          o = e.velocities[this.m_indexA].v;
        let n = e.velocities[this.m_indexA].w;
        const r = e.positions[this.m_indexB].c,
          a = e.positions[this.m_indexB].a,
          l = e.velocities[this.m_indexB].v;
        let m = e.velocities[this.m_indexB].w;
        const _ = this.m_qA.SetAngle(s),
          c = this.m_qB.SetAngle(a);
        it.SubVV(this.m_localAnchorA, this.m_localCenterA, this.m_lalcA), at.MulRV(_, this.m_lalcA, this.m_rA), it.SubVV(this.m_localAnchorB, this.m_localCenterB, this.m_lalcB), at.MulRV(c, this.m_lalcB, this.m_rB), this.m_u.Copy(r).SelfAdd(this.m_rB).SelfSub(i).SelfSub(this.m_rA), this.m_length = this.m_u.Length();
        const u = this.m_length - this.m_maxLength;
        if (this.m_state = u > 0 ? t.b2LimitState.e_atUpperLimit : t.b2LimitState.e_inactiveLimit, !(this.m_length > h)) return this.m_u.SetZero(), this.m_mass = 0, void (this.m_impulse = 0);
        this.m_u.SelfMul(1 / this.m_length);
        const d = it.CrossVV(this.m_rA, this.m_u),
          p = it.CrossVV(this.m_rB, this.m_u),
          f = this.m_invMassA + this.m_invIA * d * d + this.m_invMassB + this.m_invIB * p * p;
        if (this.m_mass = 0 !== f ? 1 / f : 0, e.step.warmStarting) {
          this.m_impulse *= e.step.dtRatio;
          const t = it.MulSV(this.m_impulse, this.m_u, Wi.InitVelocityConstraints_s_P);
          o.SelfMulSub(this.m_invMassA, t), n -= this.m_invIA * it.CrossVV(this.m_rA, t), l.SelfMulAdd(this.m_invMassB, t), m += this.m_invIB * it.CrossVV(this.m_rB, t);
        } else this.m_impulse = 0;
        e.velocities[this.m_indexA].w = n, e.velocities[this.m_indexB].w = m;
      }
      SolveVelocityConstraints(t) {
        const e = t.velocities[this.m_indexA].v;
        let i = t.velocities[this.m_indexA].w;
        const s = t.velocities[this.m_indexB].v;
        let o = t.velocities[this.m_indexB].w;
        const n = it.AddVCrossSV(e, i, this.m_rA, Wi.SolveVelocityConstraints_s_vpA),
          r = it.AddVCrossSV(s, o, this.m_rB, Wi.SolveVelocityConstraints_s_vpB),
          a = this.m_length - this.m_maxLength;
        let l = it.DotVV(this.m_u, it.SubVV(r, n, it.s_t0));
        a < 0 && (l += t.step.inv_dt * a);
        let m = -this.m_mass * l;
        const h = this.m_impulse;
        this.m_impulse = j(0, this.m_impulse + m), m = this.m_impulse - h;
        const _ = it.MulSV(m, this.m_u, Wi.SolveVelocityConstraints_s_P);
        e.SelfMulSub(this.m_invMassA, _), i -= this.m_invIA * it.CrossVV(this.m_rA, _), s.SelfMulAdd(this.m_invMassB, _), o += this.m_invIB * it.CrossVV(this.m_rB, _), t.velocities[this.m_indexA].w = i, t.velocities[this.m_indexB].w = o;
      }
      SolvePositionConstraints(t) {
        const e = t.positions[this.m_indexA].c;
        let i = t.positions[this.m_indexA].a;
        const s = t.positions[this.m_indexB].c;
        let o = t.positions[this.m_indexB].a;
        const n = this.m_qA.SetAngle(i),
          r = this.m_qB.SetAngle(o);
        it.SubVV(this.m_localAnchorA, this.m_localCenterA, this.m_lalcA);
        const a = at.MulRV(n, this.m_lalcA, this.m_rA);
        it.SubVV(this.m_localAnchorB, this.m_localCenterB, this.m_lalcB);
        const l = at.MulRV(r, this.m_lalcB, this.m_rB),
          m = this.m_u.Copy(s).SelfAdd(l).SelfSub(e).SelfSub(a),
          _ = m.Normalize();
        let c = _ - this.m_maxLength;
        c = X(c, 0, f);
        const u = -this.m_mass * c,
          d = it.MulSV(u, m, Wi.SolvePositionConstraints_s_P);
        return e.SelfMulSub(this.m_invMassA, d), i -= this.m_invIA * it.CrossVV(a, d), s.SelfMulAdd(this.m_invMassB, d), o += this.m_invIB * it.CrossVV(l, d), t.positions[this.m_indexA].a = i, t.positions[this.m_indexB].a = o, _ - this.m_maxLength < h;
      }
      GetAnchorA(t) {
        return this.m_bodyA.GetWorldPoint(this.m_localAnchorA, t);
      }
      GetAnchorB(t) {
        return this.m_bodyB.GetWorldPoint(this.m_localAnchorB, t);
      }
      GetReactionForce(t, e) {
        return it.MulSV(t * this.m_impulse, this.m_u, e);
      }
      GetReactionTorque(t) {
        return 0;
      }
      GetLocalAnchorA() {
        return this.m_localAnchorA;
      }
      GetLocalAnchorB() {
        return this.m_localAnchorB;
      }
      SetMaxLength(t) {
        this.m_maxLength = t;
      }
      GetMaxLength() {
        return this.m_maxLength;
      }
      GetLimitState() {
        return this.m_state;
      }
      Dump(t) {
        const e = this.m_bodyA.m_islandIndex,
          i = this.m_bodyB.m_islandIndex;
        t("  const jd: b2RopeJointDef = new b2RopeJointDef();\n"), t("  jd.bodyA = bodies[%d];\n", e), t("  jd.bodyB = bodies[%d];\n", i), t("  jd.collideConnected = %s;\n", this.m_collideConnected ? "true" : "false"), t("  jd.localAnchorA.Set(%.15f, %.15f);\n", this.m_localAnchorA.x, this.m_localAnchorA.y), t("  jd.localAnchorB.Set(%.15f, %.15f);\n", this.m_localAnchorB.x, this.m_localAnchorB.y), t("  jd.maxLength = %.15f;\n", this.m_maxLength), t("  joints[%d] = this.m_world.CreateJoint(jd);\n", this.m_index);
      }
    }
    Wi.InitVelocityConstraints_s_P = new it(), Wi.SolveVelocityConstraints_s_vpA = new it(), Wi.SolveVelocityConstraints_s_vpB = new it(), Wi.SolveVelocityConstraints_s_P = new it(), Wi.SolvePositionConstraints_s_P = new it();
    class Zi extends Ri {
      constructor(t) {
        super(t), this.m_frequencyHz = 0, this.m_dampingRatio = 0, this.m_bias = 0, this.m_localAnchorA = new it(), this.m_localAnchorB = new it(), this.m_referenceAngle = 0, this.m_gamma = 0, this.m_impulse = new ot(0, 0, 0), this.m_indexA = 0, this.m_indexB = 0, this.m_rA = new it(), this.m_rB = new it(), this.m_localCenterA = new it(), this.m_localCenterB = new it(), this.m_invMassA = 0, this.m_invMassB = 0, this.m_invIA = 0, this.m_invIB = 0, this.m_mass = new rt(), this.m_qA = new at(), this.m_qB = new at(), this.m_lalcA = new it(), this.m_lalcB = new it(), this.m_K = new rt(), this.m_frequencyHz = e(t.frequencyHz, 0), this.m_dampingRatio = e(t.dampingRatio, 0), this.m_localAnchorA.Copy(e(t.localAnchorA, it.ZERO)), this.m_localAnchorB.Copy(e(t.localAnchorB, it.ZERO)), this.m_referenceAngle = e(t.referenceAngle, 0), this.m_impulse.SetZero();
      }
      InitVelocityConstraints(t) {
        this.m_indexA = this.m_bodyA.m_islandIndex, this.m_indexB = this.m_bodyB.m_islandIndex, this.m_localCenterA.Copy(this.m_bodyA.m_sweep.localCenter), this.m_localCenterB.Copy(this.m_bodyB.m_sweep.localCenter), this.m_invMassA = this.m_bodyA.m_invMass, this.m_invMassB = this.m_bodyB.m_invMass, this.m_invIA = this.m_bodyA.m_invI, this.m_invIB = this.m_bodyB.m_invI;
        const e = t.positions[this.m_indexA].a,
          i = t.velocities[this.m_indexA].v;
        let s = t.velocities[this.m_indexA].w;
        const o = t.positions[this.m_indexB].a,
          r = t.velocities[this.m_indexB].v;
        let a = t.velocities[this.m_indexB].w;
        const l = this.m_qA.SetAngle(e),
          m = this.m_qB.SetAngle(o);
        it.SubVV(this.m_localAnchorA, this.m_localCenterA, this.m_lalcA), at.MulRV(l, this.m_lalcA, this.m_rA), it.SubVV(this.m_localAnchorB, this.m_localCenterB, this.m_lalcB), at.MulRV(m, this.m_lalcB, this.m_rB);
        const h = this.m_invMassA,
          _ = this.m_invMassB,
          c = this.m_invIA,
          u = this.m_invIB,
          d = this.m_K;
        if (d.ex.x = h + _ + this.m_rA.y * this.m_rA.y * c + this.m_rB.y * this.m_rB.y * u, d.ey.x = -this.m_rA.y * this.m_rA.x * c - this.m_rB.y * this.m_rB.x * u, d.ez.x = -this.m_rA.y * c - this.m_rB.y * u, d.ex.y = d.ey.x, d.ey.y = h + _ + this.m_rA.x * this.m_rA.x * c + this.m_rB.x * this.m_rB.x * u, d.ez.y = this.m_rA.x * c + this.m_rB.x * u, d.ex.z = d.ez.x, d.ey.z = d.ez.y, d.ez.z = c + u, this.m_frequencyHz > 0) {
          d.GetInverse22(this.m_mass);
          let i = c + u;
          const s = i > 0 ? 1 / i : 0,
            r = o - e - this.m_referenceAngle,
            a = 2 * n * this.m_frequencyHz,
            l = 2 * s * this.m_dampingRatio * a,
            m = s * a * a,
            h = t.step.dt;
          this.m_gamma = h * (l + h * m), this.m_gamma = 0 !== this.m_gamma ? 1 / this.m_gamma : 0, this.m_bias = r * h * m * this.m_gamma, i += this.m_gamma, this.m_mass.ez.z = 0 !== i ? 1 / i : 0;
        } else d.GetSymInverse33(this.m_mass), this.m_gamma = 0, this.m_bias = 0;
        if (t.step.warmStarting) {
          this.m_impulse.SelfMul(t.step.dtRatio);
          const e = Zi.InitVelocityConstraints_s_P.Set(this.m_impulse.x, this.m_impulse.y);
          i.SelfMulSub(h, e), s -= c * (it.CrossVV(this.m_rA, e) + this.m_impulse.z), r.SelfMulAdd(_, e), a += u * (it.CrossVV(this.m_rB, e) + this.m_impulse.z);
        } else this.m_impulse.SetZero();
        t.velocities[this.m_indexA].w = s, t.velocities[this.m_indexB].w = a;
      }
      SolveVelocityConstraints(t) {
        const e = t.velocities[this.m_indexA].v;
        let i = t.velocities[this.m_indexA].w;
        const s = t.velocities[this.m_indexB].v;
        let o = t.velocities[this.m_indexB].w;
        const n = this.m_invMassA,
          r = this.m_invMassB,
          a = this.m_invIA,
          l = this.m_invIB;
        if (this.m_frequencyHz > 0) {
          const t = o - i,
            m = -this.m_mass.ez.z * (t + this.m_bias + this.m_gamma * this.m_impulse.z);
          this.m_impulse.z += m, i -= a * m, o += l * m;
          const h = it.SubVV(it.AddVCrossSV(s, o, this.m_rB, it.s_t0), it.AddVCrossSV(e, i, this.m_rA, it.s_t1), Zi.SolveVelocityConstraints_s_Cdot1),
            _ = rt.MulM33XY(this.m_mass, h.x, h.y, Zi.SolveVelocityConstraints_s_impulse1).SelfNeg();
          this.m_impulse.x += _.x, this.m_impulse.y += _.y;
          const c = _;
          e.SelfMulSub(n, c), i -= a * it.CrossVV(this.m_rA, c), s.SelfMulAdd(r, c), o += l * it.CrossVV(this.m_rB, c);
        } else {
          const t = it.SubVV(it.AddVCrossSV(s, o, this.m_rB, it.s_t0), it.AddVCrossSV(e, i, this.m_rA, it.s_t1), Zi.SolveVelocityConstraints_s_Cdot1),
            m = o - i,
            h = rt.MulM33XYZ(this.m_mass, t.x, t.y, m, Zi.SolveVelocityConstraints_s_impulse).SelfNeg();
          this.m_impulse.SelfAdd(h);
          const _ = Zi.SolveVelocityConstraints_s_P.Set(h.x, h.y);
          e.SelfMulSub(n, _), i -= a * (it.CrossVV(this.m_rA, _) + h.z), s.SelfMulAdd(r, _), o += l * (it.CrossVV(this.m_rB, _) + h.z);
        }
        t.velocities[this.m_indexA].w = i, t.velocities[this.m_indexB].w = o;
      }
      SolvePositionConstraints(t) {
        const e = t.positions[this.m_indexA].c;
        let i = t.positions[this.m_indexA].a;
        const s = t.positions[this.m_indexB].c;
        let o = t.positions[this.m_indexB].a;
        const n = this.m_qA.SetAngle(i),
          r = this.m_qB.SetAngle(o),
          a = this.m_invMassA,
          l = this.m_invMassB,
          m = this.m_invIA,
          c = this.m_invIB;
        it.SubVV(this.m_localAnchorA, this.m_localCenterA, this.m_lalcA);
        const u = at.MulRV(n, this.m_lalcA, this.m_rA);
        it.SubVV(this.m_localAnchorB, this.m_localCenterB, this.m_lalcB);
        const d = at.MulRV(r, this.m_lalcB, this.m_rB);
        let p, f;
        const y = this.m_K;
        if (y.ex.x = a + l + u.y * u.y * m + d.y * d.y * c, y.ey.x = -u.y * u.x * m - d.y * d.x * c, y.ez.x = -u.y * m - d.y * c, y.ex.y = y.ey.x, y.ey.y = a + l + u.x * u.x * m + d.x * d.x * c, y.ez.y = u.x * m + d.x * c, y.ex.z = y.ez.x, y.ey.z = y.ez.y, y.ez.z = m + c, this.m_frequencyHz > 0) {
          const t = it.SubVV(it.AddVV(s, d, it.s_t0), it.AddVV(e, u, it.s_t1), Zi.SolvePositionConstraints_s_C1);
          p = t.Length(), f = 0;
          const n = y.Solve22(t.x, t.y, Zi.SolvePositionConstraints_s_P).SelfNeg();
          e.SelfMulSub(a, n), i -= m * it.CrossVV(u, n), s.SelfMulAdd(l, n), o += c * it.CrossVV(d, n);
        } else {
          const t = it.SubVV(it.AddVV(s, d, it.s_t0), it.AddVV(e, u, it.s_t1), Zi.SolvePositionConstraints_s_C1),
            n = o - i - this.m_referenceAngle;
          p = t.Length(), f = O(n);
          const r = y.Solve33(t.x, t.y, n, Zi.SolvePositionConstraints_s_impulse).SelfNeg(),
            h = Zi.SolvePositionConstraints_s_P.Set(r.x, r.y);
          e.SelfMulSub(a, h), i -= m * (it.CrossVV(this.m_rA, h) + r.z), s.SelfMulAdd(l, h), o += c * (it.CrossVV(this.m_rB, h) + r.z);
        }
        return t.positions[this.m_indexA].a = i, t.positions[this.m_indexB].a = o, p <= h && f <= _;
      }
      GetAnchorA(t) {
        return this.m_bodyA.GetWorldPoint(this.m_localAnchorA, t);
      }
      GetAnchorB(t) {
        return this.m_bodyB.GetWorldPoint(this.m_localAnchorB, t);
      }
      GetReactionForce(t, e) {
        return e.x = t * this.m_impulse.x, e.y = t * this.m_impulse.y, e;
      }
      GetReactionTorque(t) {
        return t * this.m_impulse.z;
      }
      GetLocalAnchorA() {
        return this.m_localAnchorA;
      }
      GetLocalAnchorB() {
        return this.m_localAnchorB;
      }
      GetReferenceAngle() {
        return this.m_referenceAngle;
      }
      SetFrequency(t) {
        this.m_frequencyHz = t;
      }
      GetFrequency() {
        return this.m_frequencyHz;
      }
      SetDampingRatio(t) {
        this.m_dampingRatio = t;
      }
      GetDampingRatio() {
        return this.m_dampingRatio;
      }
      Dump(t) {
        const e = this.m_bodyA.m_islandIndex,
          i = this.m_bodyB.m_islandIndex;
        t("  const jd: b2WeldJointDef = new b2WeldJointDef();\n"), t("  jd.bodyA = bodies[%d];\n", e), t("  jd.bodyB = bodies[%d];\n", i), t("  jd.collideConnected = %s;\n", this.m_collideConnected ? "true" : "false"), t("  jd.localAnchorA.Set(%.15f, %.15f);\n", this.m_localAnchorA.x, this.m_localAnchorA.y), t("  jd.localAnchorB.Set(%.15f, %.15f);\n", this.m_localAnchorB.x, this.m_localAnchorB.y), t("  jd.referenceAngle = %.15f;\n", this.m_referenceAngle), t("  jd.frequencyHz = %.15f;\n", this.m_frequencyHz), t("  jd.dampingRatio = %.15f;\n", this.m_dampingRatio), t("  joints[%d] = this.m_world.CreateJoint(jd);\n", this.m_index);
      }
    }
    Zi.InitVelocityConstraints_s_P = new it(), Zi.SolveVelocityConstraints_s_Cdot1 = new it(), Zi.SolveVelocityConstraints_s_impulse1 = new it(), Zi.SolveVelocityConstraints_s_impulse = new ot(), Zi.SolveVelocityConstraints_s_P = new it(), Zi.SolvePositionConstraints_s_C1 = new it(), Zi.SolvePositionConstraints_s_P = new it(), Zi.SolvePositionConstraints_s_impulse = new ot();
    class Hi extends Ri {
      constructor(t) {
        super(t), this.m_frequencyHz = 0, this.m_dampingRatio = 0, this.m_localAnchorA = new it(), this.m_localAnchorB = new it(), this.m_localXAxisA = new it(), this.m_localYAxisA = new it(), this.m_impulse = 0, this.m_motorImpulse = 0, this.m_springImpulse = 0, this.m_maxMotorTorque = 0, this.m_motorSpeed = 0, this.m_enableMotor = !1, this.m_indexA = 0, this.m_indexB = 0, this.m_localCenterA = new it(), this.m_localCenterB = new it(), this.m_invMassA = 0, this.m_invMassB = 0, this.m_invIA = 0, this.m_invIB = 0, this.m_ax = new it(), this.m_ay = new it(), this.m_sAx = 0, this.m_sBx = 0, this.m_sAy = 0, this.m_sBy = 0, this.m_mass = 0, this.m_motorMass = 0, this.m_springMass = 0, this.m_bias = 0, this.m_gamma = 0, this.m_qA = new at(), this.m_qB = new at(), this.m_lalcA = new it(), this.m_lalcB = new it(), this.m_rA = new it(), this.m_rB = new it(), this.m_frequencyHz = e(t.frequencyHz, 2), this.m_dampingRatio = e(t.dampingRatio, .7), this.m_localAnchorA.Copy(e(t.localAnchorA, it.ZERO)), this.m_localAnchorB.Copy(e(t.localAnchorB, it.ZERO)), this.m_localXAxisA.Copy(e(t.localAxisA, it.UNITX)), it.CrossOneV(this.m_localXAxisA, this.m_localYAxisA), this.m_maxMotorTorque = e(t.maxMotorTorque, 0), this.m_motorSpeed = e(t.motorSpeed, 0), this.m_enableMotor = e(t.enableMotor, !1), this.m_ax.SetZero(), this.m_ay.SetZero();
      }
      GetMotorSpeed() {
        return this.m_motorSpeed;
      }
      GetMaxMotorTorque() {
        return this.m_maxMotorTorque;
      }
      SetSpringFrequencyHz(t) {
        this.m_frequencyHz = t;
      }
      GetSpringFrequencyHz() {
        return this.m_frequencyHz;
      }
      SetSpringDampingRatio(t) {
        this.m_dampingRatio = t;
      }
      GetSpringDampingRatio() {
        return this.m_dampingRatio;
      }
      InitVelocityConstraints(t) {
        this.m_indexA = this.m_bodyA.m_islandIndex, this.m_indexB = this.m_bodyB.m_islandIndex, this.m_localCenterA.Copy(this.m_bodyA.m_sweep.localCenter), this.m_localCenterB.Copy(this.m_bodyB.m_sweep.localCenter), this.m_invMassA = this.m_bodyA.m_invMass, this.m_invMassB = this.m_bodyB.m_invMass, this.m_invIA = this.m_bodyA.m_invI, this.m_invIB = this.m_bodyB.m_invI;
        const e = this.m_invMassA,
          i = this.m_invMassB,
          s = this.m_invIA,
          o = this.m_invIB,
          r = t.positions[this.m_indexA].c,
          a = t.positions[this.m_indexA].a,
          l = t.velocities[this.m_indexA].v;
        let m = t.velocities[this.m_indexA].w;
        const h = t.positions[this.m_indexB].c,
          _ = t.positions[this.m_indexB].a,
          c = t.velocities[this.m_indexB].v;
        let u = t.velocities[this.m_indexB].w;
        const d = this.m_qA.SetAngle(a),
          p = this.m_qB.SetAngle(_);
        it.SubVV(this.m_localAnchorA, this.m_localCenterA, this.m_lalcA);
        const f = at.MulRV(d, this.m_lalcA, this.m_rA);
        it.SubVV(this.m_localAnchorB, this.m_localCenterB, this.m_lalcB);
        const y = at.MulRV(p, this.m_lalcB, this.m_rB),
          x = it.SubVV(it.AddVV(h, y, it.s_t0), it.AddVV(r, f, it.s_t1), Hi.InitVelocityConstraints_s_d);
        if (at.MulRV(d, this.m_localYAxisA, this.m_ay), this.m_sAy = it.CrossVV(it.AddVV(x, f, it.s_t0), this.m_ay), this.m_sBy = it.CrossVV(y, this.m_ay), this.m_mass = e + i + s * this.m_sAy * this.m_sAy + o * this.m_sBy * this.m_sBy, this.m_mass > 0 && (this.m_mass = 1 / this.m_mass), this.m_springMass = 0, this.m_bias = 0, this.m_gamma = 0, this.m_frequencyHz > 0) {
          at.MulRV(d, this.m_localXAxisA, this.m_ax), this.m_sAx = it.CrossVV(it.AddVV(x, f, it.s_t0), this.m_ax), this.m_sBx = it.CrossVV(y, this.m_ax);
          const r = e + i + s * this.m_sAx * this.m_sAx + o * this.m_sBx * this.m_sBx;
          if (r > 0) {
            this.m_springMass = 1 / r;
            const e = it.DotVV(x, this.m_ax),
              i = 2 * n * this.m_frequencyHz,
              s = 2 * this.m_springMass * this.m_dampingRatio * i,
              o = this.m_springMass * i * i,
              a = t.step.dt;
            this.m_gamma = a * (s + a * o), this.m_gamma > 0 && (this.m_gamma = 1 / this.m_gamma), this.m_bias = e * a * o * this.m_gamma, this.m_springMass = r + this.m_gamma, this.m_springMass > 0 && (this.m_springMass = 1 / this.m_springMass);
          }
        } else this.m_springImpulse = 0;
        if (this.m_enableMotor ? (this.m_motorMass = s + o, this.m_motorMass > 0 && (this.m_motorMass = 1 / this.m_motorMass)) : (this.m_motorMass = 0, this.m_motorImpulse = 0), t.step.warmStarting) {
          this.m_impulse *= t.step.dtRatio, this.m_springImpulse *= t.step.dtRatio, this.m_motorImpulse *= t.step.dtRatio;
          const e = it.AddVV(it.MulSV(this.m_impulse, this.m_ay, it.s_t0), it.MulSV(this.m_springImpulse, this.m_ax, it.s_t1), Hi.InitVelocityConstraints_s_P),
            i = this.m_impulse * this.m_sAy + this.m_springImpulse * this.m_sAx + this.m_motorImpulse,
            s = this.m_impulse * this.m_sBy + this.m_springImpulse * this.m_sBx + this.m_motorImpulse;
          l.SelfMulSub(this.m_invMassA, e), m -= this.m_invIA * i, c.SelfMulAdd(this.m_invMassB, e), u += this.m_invIB * s;
        } else this.m_impulse = 0, this.m_springImpulse = 0, this.m_motorImpulse = 0;
        t.velocities[this.m_indexA].w = m, t.velocities[this.m_indexB].w = u;
      }
      SolveVelocityConstraints(t) {
        const e = this.m_invMassA,
          i = this.m_invMassB,
          s = this.m_invIA,
          o = this.m_invIB,
          n = t.velocities[this.m_indexA].v;
        let r = t.velocities[this.m_indexA].w;
        const a = t.velocities[this.m_indexB].v;
        let l = t.velocities[this.m_indexB].w;
        {
          const t = it.DotVV(this.m_ax, it.SubVV(a, n, it.s_t0)) + this.m_sBx * l - this.m_sAx * r,
            m = -this.m_springMass * (t + this.m_bias + this.m_gamma * this.m_springImpulse);
          this.m_springImpulse += m;
          const h = it.MulSV(m, this.m_ax, Hi.SolveVelocityConstraints_s_P),
            _ = m * this.m_sAx,
            c = m * this.m_sBx;
          n.SelfMulSub(e, h), r -= s * _, a.SelfMulAdd(i, h), l += o * c;
        }
        {
          const e = l - r - this.m_motorSpeed;
          let i = -this.m_motorMass * e;
          const n = this.m_motorImpulse,
            a = t.step.dt * this.m_maxMotorTorque;
          this.m_motorImpulse = X(this.m_motorImpulse + i, -a, a), i = this.m_motorImpulse - n, r -= s * i, l += o * i;
        }
        {
          const t = it.DotVV(this.m_ay, it.SubVV(a, n, it.s_t0)) + this.m_sBy * l - this.m_sAy * r,
            m = -this.m_mass * t;
          this.m_impulse += m;
          const h = it.MulSV(m, this.m_ay, Hi.SolveVelocityConstraints_s_P),
            _ = m * this.m_sAy,
            c = m * this.m_sBy;
          n.SelfMulSub(e, h), r -= s * _, a.SelfMulAdd(i, h), l += o * c;
        }
        t.velocities[this.m_indexA].w = r, t.velocities[this.m_indexB].w = l;
      }
      SolvePositionConstraints(t) {
        const e = t.positions[this.m_indexA].c;
        let i = t.positions[this.m_indexA].a;
        const s = t.positions[this.m_indexB].c;
        let o = t.positions[this.m_indexB].a;
        const n = this.m_qA.SetAngle(i),
          r = this.m_qB.SetAngle(o);
        it.SubVV(this.m_localAnchorA, this.m_localCenterA, this.m_lalcA);
        const a = at.MulRV(n, this.m_lalcA, this.m_rA);
        it.SubVV(this.m_localAnchorB, this.m_localCenterB, this.m_lalcB);
        const l = at.MulRV(r, this.m_lalcB, this.m_rB),
          m = it.AddVV(it.SubVV(s, e, it.s_t0), it.SubVV(l, a, it.s_t1), Hi.SolvePositionConstraints_s_d),
          _ = at.MulRV(n, this.m_localYAxisA, this.m_ay),
          c = it.CrossVV(it.AddVV(m, a, it.s_t0), _),
          u = it.CrossVV(l, _),
          d = it.DotVV(m, this.m_ay),
          p = this.m_invMassA + this.m_invMassB + this.m_invIA * this.m_sAy * this.m_sAy + this.m_invIB * this.m_sBy * this.m_sBy;
        let f;
        f = 0 !== p ? -d / p : 0;
        const y = it.MulSV(f, _, Hi.SolvePositionConstraints_s_P),
          x = f * c,
          B = f * u;
        return e.SelfMulSub(this.m_invMassA, y), i -= this.m_invIA * x, s.SelfMulAdd(this.m_invMassB, y), o += this.m_invIB * B, t.positions[this.m_indexA].a = i, t.positions[this.m_indexB].a = o, O(d) <= h;
      }
      GetDefinition(t) {
        return t;
      }
      GetAnchorA(t) {
        return this.m_bodyA.GetWorldPoint(this.m_localAnchorA, t);
      }
      GetAnchorB(t) {
        return this.m_bodyB.GetWorldPoint(this.m_localAnchorB, t);
      }
      GetReactionForce(t, e) {
        return e.x = t * (this.m_impulse * this.m_ay.x + this.m_springImpulse * this.m_ax.x), e.y = t * (this.m_impulse * this.m_ay.y + this.m_springImpulse * this.m_ax.y), e;
      }
      GetReactionTorque(t) {
        return t * this.m_motorImpulse;
      }
      GetLocalAnchorA() {
        return this.m_localAnchorA;
      }
      GetLocalAnchorB() {
        return this.m_localAnchorB;
      }
      GetLocalAxisA() {
        return this.m_localXAxisA;
      }
      GetJointTranslation() {
        return this.GetPrismaticJointTranslation();
      }
      GetJointLinearSpeed() {
        return this.GetPrismaticJointSpeed();
      }
      GetJointAngle() {
        return this.GetRevoluteJointAngle();
      }
      GetJointAngularSpeed() {
        return this.GetRevoluteJointSpeed();
      }
      GetPrismaticJointTranslation() {
        const t = this.m_bodyA,
          e = this.m_bodyB,
          i = t.GetWorldPoint(this.m_localAnchorA, new it()),
          s = e.GetWorldPoint(this.m_localAnchorB, new it()),
          o = it.SubVV(s, i, new it()),
          n = t.GetWorldVector(this.m_localXAxisA, new it()),
          r = it.DotVV(o, n);
        return r;
      }
      GetPrismaticJointSpeed() {
        const t = this.m_bodyA,
          e = this.m_bodyB;
        it.SubVV(this.m_localAnchorA, t.m_sweep.localCenter, this.m_lalcA);
        const i = at.MulRV(t.m_xf.q, this.m_lalcA, this.m_rA);
        it.SubVV(this.m_localAnchorB, e.m_sweep.localCenter, this.m_lalcB);
        const s = at.MulRV(e.m_xf.q, this.m_lalcB, this.m_rB),
          o = it.AddVV(t.m_sweep.c, i, it.s_t0),
          n = it.AddVV(e.m_sweep.c, s, it.s_t1),
          r = it.SubVV(n, o, it.s_t2),
          a = t.GetWorldVector(this.m_localXAxisA, new it()),
          l = t.m_linearVelocity,
          m = e.m_linearVelocity,
          h = t.m_angularVelocity,
          _ = e.m_angularVelocity,
          c = it.DotVV(r, it.CrossSV(h, a, it.s_t0)) + it.DotVV(a, it.SubVV(it.AddVCrossSV(m, _, s, it.s_t0), it.AddVCrossSV(l, h, i, it.s_t1), it.s_t0));
        return c;
      }
      GetRevoluteJointAngle() {
        return this.m_bodyB.m_sweep.a - this.m_bodyA.m_sweep.a;
      }
      GetRevoluteJointSpeed() {
        const t = this.m_bodyA.m_angularVelocity,
          e = this.m_bodyB.m_angularVelocity;
        return e - t;
      }
      IsMotorEnabled() {
        return this.m_enableMotor;
      }
      EnableMotor(t) {
        t !== this.m_enableMotor && (this.m_bodyA.SetAwake(!0), this.m_bodyB.SetAwake(!0), this.m_enableMotor = t);
      }
      SetMotorSpeed(t) {
        t !== this.m_motorSpeed && (this.m_bodyA.SetAwake(!0), this.m_bodyB.SetAwake(!0), this.m_motorSpeed = t);
      }
      SetMaxMotorTorque(t) {
        t !== this.m_maxMotorTorque && (this.m_bodyA.SetAwake(!0), this.m_bodyB.SetAwake(!0), this.m_maxMotorTorque = t);
      }
      GetMotorTorque(t) {
        return t * this.m_motorImpulse;
      }
      Dump(t) {
        const e = this.m_bodyA.m_islandIndex,
          i = this.m_bodyB.m_islandIndex;
        t("  const jd: b2WheelJointDef = new b2WheelJointDef();\n"), t("  jd.bodyA = bodies[%d];\n", e), t("  jd.bodyB = bodies[%d];\n", i), t("  jd.collideConnected = %s;\n", this.m_collideConnected ? "true" : "false"), t("  jd.localAnchorA.Set(%.15f, %.15f);\n", this.m_localAnchorA.x, this.m_localAnchorA.y), t("  jd.localAnchorB.Set(%.15f, %.15f);\n", this.m_localAnchorB.x, this.m_localAnchorB.y), t("  jd.localAxisA.Set(%.15f, %.15f);\n", this.m_localXAxisA.x, this.m_localXAxisA.y), t("  jd.enableMotor = %s;\n", this.m_enableMotor ? "true" : "false"), t("  jd.motorSpeed = %.15f;\n", this.m_motorSpeed), t("  jd.maxMotorTorque = %.15f;\n", this.m_maxMotorTorque), t("  jd.frequencyHz = %.15f;\n", this.m_frequencyHz), t("  jd.dampingRatio = %.15f;\n", this.m_dampingRatio), t("  joints[%d] = this.m_world.CreateJoint(jd);\n", this.m_index);
      }
    }
    function Qi(t, e) {
      return H(t * e);
    }
    function Yi(t, e) {
      return t > e ? t : e;
    }
    Hi.InitVelocityConstraints_s_d = new it(), Hi.InitVelocityConstraints_s_P = new it(), Hi.SolveVelocityConstraints_s_P = new it(), Hi.SolvePositionConstraints_s_d = new it(), Hi.SolvePositionConstraints_s_P = new it();
    class Ki {
      constructor(t) {
        this.prev = null, this.next = null, this.contact = t;
      }
    }
    class $i {
      constructor() {
        this.m_islandFlag = !1, this.m_touchingFlag = !1, this.m_enabledFlag = !1, this.m_filterFlag = !1, this.m_bulletHitFlag = !1, this.m_toiFlag = !1, this.m_prev = null, this.m_next = null, this.m_indexA = 0, this.m_indexB = 0, this.m_manifold = new jt(), this.m_toiCount = 0, this.m_toi = 0, this.m_friction = 0, this.m_restitution = 0, this.m_tangentSpeed = 0, this.m_oldManifold = new jt(), this.m_nodeA = new Ki(this), this.m_nodeB = new Ki(this);
      }
      GetManifold() {
        return this.m_manifold;
      }
      GetWorldManifold(t) {
        const e = this.m_fixtureA.GetBody(),
          i = this.m_fixtureB.GetBody(),
          s = this.m_fixtureA.GetShape(),
          o = this.m_fixtureB.GetShape();
        t.Initialize(this.m_manifold, e.GetTransform(), s.m_radius, i.GetTransform(), o.m_radius);
      }
      IsTouching() {
        return this.m_touchingFlag;
      }
      SetEnabled(t) {
        this.m_enabledFlag = t;
      }
      IsEnabled() {
        return this.m_enabledFlag;
      }
      GetNext() {
        return this.m_next;
      }
      GetFixtureA() {
        return this.m_fixtureA;
      }
      GetChildIndexA() {
        return this.m_indexA;
      }
      GetFixtureB() {
        return this.m_fixtureB;
      }
      GetChildIndexB() {
        return this.m_indexB;
      }
      FlagForFiltering() {
        this.m_filterFlag = !0;
      }
      SetFriction(t) {
        this.m_friction = t;
      }
      GetFriction() {
        return this.m_friction;
      }
      ResetFriction() {
        this.m_friction = Qi(this.m_fixtureA.m_friction, this.m_fixtureB.m_friction);
      }
      SetRestitution(t) {
        this.m_restitution = t;
      }
      GetRestitution() {
        return this.m_restitution;
      }
      ResetRestitution() {
        this.m_restitution = Yi(this.m_fixtureA.m_restitution, this.m_fixtureB.m_restitution);
      }
      SetTangentSpeed(t) {
        this.m_tangentSpeed = t;
      }
      GetTangentSpeed() {
        return this.m_tangentSpeed;
      }
      Reset(t, e, i, s) {
        this.m_islandFlag = !1, this.m_touchingFlag = !1, this.m_enabledFlag = !0, this.m_filterFlag = !1, this.m_bulletHitFlag = !1, this.m_toiFlag = !1, this.m_fixtureA = t, this.m_fixtureB = i, this.m_indexA = e, this.m_indexB = s, this.m_manifold.pointCount = 0, this.m_prev = null, this.m_next = null, delete this.m_nodeA.contact, this.m_nodeA.prev = null, this.m_nodeA.next = null, delete this.m_nodeA.other, delete this.m_nodeB.contact, this.m_nodeB.prev = null, this.m_nodeB.next = null, delete this.m_nodeB.other, this.m_toiCount = 0, this.m_friction = Qi(this.m_fixtureA.m_friction, this.m_fixtureB.m_friction), this.m_restitution = Yi(this.m_fixtureA.m_restitution, this.m_fixtureB.m_restitution);
      }
      Update(t) {
        const e = this.m_oldManifold;
        this.m_oldManifold = this.m_manifold, this.m_manifold = e, this.m_enabledFlag = !0;
        let i = !1;
        const s = this.m_touchingFlag,
          o = this.m_fixtureA.IsSensor(),
          n = this.m_fixtureB.IsSensor(),
          r = o || n,
          a = this.m_fixtureA.GetBody(),
          l = this.m_fixtureB.GetBody(),
          m = a.GetTransform(),
          h = l.GetTransform();
        if (r) {
          const t = this.m_fixtureA.GetShape(),
            e = this.m_fixtureB.GetShape();
          i = te(t, this.m_indexA, e, this.m_indexB, m, h), this.m_manifold.pointCount = 0;
        } else {
          this.Evaluate(this.m_manifold, m, h), i = this.m_manifold.pointCount > 0;
          for (let t = 0; t < this.m_manifold.pointCount; ++t) {
            const e = this.m_manifold.points[t];
            e.normalImpulse = 0, e.tangentImpulse = 0;
            const i = e.id;
            for (let t = 0; t < this.m_oldManifold.pointCount; ++t) {
              const s = this.m_oldManifold.points[t];
              if (s.id.key === i.key) {
                e.normalImpulse = s.normalImpulse, e.tangentImpulse = s.tangentImpulse;
                break;
              }
            }
          }
          i !== s && (a.SetAwake(!0), l.SetAwake(!0));
        }
        this.m_touchingFlag = i, !s && i && t && t.BeginContact(this), s && !i && t && t.EndContact(this), !r && i && t && t.PreSolve(this, this.m_oldManifold);
      }
      ComputeTOI(t, e) {
        const i = $i.ComputeTOI_s_input;
        i.proxyA.SetShape(this.m_fixtureA.GetShape(), this.m_indexA), i.proxyB.SetShape(this.m_fixtureB.GetShape(), this.m_indexB), i.sweepA.Copy(t), i.sweepB.Copy(e), i.tMax = h;
        const s = $i.ComputeTOI_s_output;
        return Me(s, i), s.t;
      }
    }
    $i.ComputeTOI_s_input = new de(), $i.ComputeTOI_s_output = new ye();
    class ts extends $i {
      constructor() {
        super();
      }
      static Create(t) {
        return new ts();
      }
      static Destroy(t, e) {}
      Reset(t, e, i, s) {
        super.Reset(t, e, i, s);
      }
      Evaluate(t, e, i) {
        const s = this.m_fixtureA.GetShape(),
          o = this.m_fixtureB.GetShape();
        Ge(t, s, e, o, i);
      }
    }
    class es extends $i {
      constructor() {
        super();
      }
      static Create(t) {
        return new es();
      }
      static Destroy(t, e) {}
      Reset(t, e, i, s) {
        super.Reset(t, e, i, s);
      }
      Evaluate(t, e, i) {
        const s = this.m_fixtureA.GetShape(),
          o = this.m_fixtureB.GetShape();
        oi(t, s, e, o, i);
      }
    }
    class is extends $i {
      constructor() {
        super();
      }
      static Create(t) {
        return new is();
      }
      static Destroy(t, e) {}
      Reset(t, e, i, s) {
        super.Reset(t, e, i, s);
      }
      Evaluate(t, e, i) {
        const s = this.m_fixtureA.GetShape(),
          o = this.m_fixtureB.GetShape();
        Le(t, s, e, o, i);
      }
    }
    class ss extends $i {
      constructor() {
        super();
      }
      static Create(t) {
        return new ss();
      }
      static Destroy(t, e) {}
      Reset(t, e, i, s) {
        super.Reset(t, e, i, s);
      }
      Evaluate(t, e, i) {
        const s = this.m_fixtureA.GetShape(),
          o = this.m_fixtureB.GetShape();
        ui(t, s, e, o, i);
      }
    }
    class os extends $i {
      constructor() {
        super();
      }
      static Create(t) {
        return new os();
      }
      static Destroy(t, e) {}
      Reset(t, e, i, s) {
        super.Reset(t, e, i, s);
      }
      Evaluate(t, e, i) {
        const s = this.m_fixtureA.GetShape(),
          o = this.m_fixtureB.GetShape();
        xi(t, s, e, o, i);
      }
    }
    class ns extends $i {
      constructor() {
        super();
      }
      static Create(t) {
        return new ns();
      }
      static Destroy(t, e) {}
      Reset(t, e, i, s) {
        super.Reset(t, e, i, s);
      }
      Evaluate(t, e, i) {
        const s = this.m_fixtureA.GetShape(),
          o = this.m_fixtureB.GetShape(),
          n = s,
          r = ns.Evaluate_s_edge;
        n.GetChildEdge(r, this.m_indexA), ui(t, r, e, o, i);
      }
    }
    ns.Evaluate_s_edge = new vi();
    class rs extends $i {
      constructor() {
        super();
      }
      static Create(t) {
        return new rs();
      }
      static Destroy(t, e) {}
      Reset(t, e, i, s) {
        super.Reset(t, e, i, s);
      }
      Evaluate(t, e, i) {
        const s = this.m_fixtureA.GetShape(),
          o = this.m_fixtureB.GetShape(),
          n = s,
          r = rs.Evaluate_s_edge;
        n.GetChildEdge(r, this.m_indexA), xi(t, r, e, o, i);
      }
    }
    rs.Evaluate_s_edge = new vi();
    class as {
      constructor() {
        this.createFcn = null, this.destroyFcn = null, this.primary = !1;
      }
    }
    class ls {
      constructor(t) {
        this.m_allocator = null, this.m_allocator = t, this.InitializeRegisters();
      }
      AddType(t, e, i, s) {
        const o = k(256, e => t(this.m_allocator));
        function n(e) {
          return o.pop() || t(e);
        }
        function r(t, e) {
          o.push(t);
        }
        this.m_registers[i][s].createFcn = n, this.m_registers[i][s].destroyFcn = r, this.m_registers[i][s].primary = !0, i !== s && (this.m_registers[s][i].createFcn = n, this.m_registers[s][i].destroyFcn = r, this.m_registers[s][i].primary = !1);
      }
      InitializeRegisters() {
        this.m_registers = [];
        for (let e = 0; e < t.b2ShapeType.e_shapeTypeCount; e++) {
          this.m_registers[e] = [];
          for (let i = 0; i < t.b2ShapeType.e_shapeTypeCount; i++) this.m_registers[e][i] = new as();
        }
        this.AddType(ts.Create, ts.Destroy, t.b2ShapeType.e_circleShape, t.b2ShapeType.e_circleShape), this.AddType(is.Create, is.Destroy, t.b2ShapeType.e_polygonShape, t.b2ShapeType.e_circleShape), this.AddType(es.Create, es.Destroy, t.b2ShapeType.e_polygonShape, t.b2ShapeType.e_polygonShape), this.AddType(ss.Create, ss.Destroy, t.b2ShapeType.e_edgeShape, t.b2ShapeType.e_circleShape), this.AddType(os.Create, os.Destroy, t.b2ShapeType.e_edgeShape, t.b2ShapeType.e_polygonShape), this.AddType(ns.Create, ns.Destroy, t.b2ShapeType.e_chainShape, t.b2ShapeType.e_circleShape), this.AddType(rs.Create, rs.Destroy, t.b2ShapeType.e_chainShape, t.b2ShapeType.e_polygonShape);
      }
      Create(t, e, i, s) {
        const o = t.GetType(),
          n = i.GetType(),
          r = this.m_registers[o][n];
        if (r.createFcn) {
          const o = r.createFcn(this.m_allocator);
          return r.primary ? o.Reset(t, e, i, s) : o.Reset(i, s, t, e), o;
        }
        return null;
      }
      Destroy(t) {
        const e = t.m_fixtureA,
          i = t.m_fixtureB;
        t.m_manifold.pointCount > 0 && !e.IsSensor() && !i.IsSensor() && (e.GetBody().SetAwake(!0), i.GetBody().SetAwake(!0));
        const s = e.GetType(),
          o = i.GetType(),
          n = this.m_registers[s][o];
        n.destroyFcn && n.destroyFcn(t, this.m_allocator);
      }
    }
    class ms {
      ShouldCollide(e, i) {
        const s = e.GetBody(),
          o = i.GetBody();
        if (o.GetType() === t.b2BodyType.b2_staticBody && s.GetType() === t.b2BodyType.b2_staticBody) return !1;
        if (!o.ShouldCollideConnected(s)) return !1;
        const n = e.GetFilterData(),
          r = i.GetFilterData();
        if (n.groupIndex === r.groupIndex && 0 !== n.groupIndex) return n.groupIndex > 0;
        const a = 0 != (n.maskBits & r.categoryBits) && 0 != (n.categoryBits & r.maskBits);
        return a;
      }
      ShouldCollideFixtureParticle(t, e, i) {
        return !0;
      }
      ShouldCollideParticleParticle(t, e, i) {
        return !0;
      }
    }
    ms.b2_defaultFilter = new ms();
    class hs {
      constructor() {
        this.normalImpulses = q(r), this.tangentImpulses = q(r), this.count = 0;
      }
    }
    class _s {
      BeginContact(t) {}
      EndContact(t) {}
      BeginContactFixtureParticle(t, e) {}
      EndContactFixtureParticle(t, e) {}
      BeginContactParticleParticle(t, e) {}
      EndContactParticleParticle(t, e) {}
      PreSolve(t, e) {}
      PostSolve(t, e) {}
    }
    _s.b2_defaultListener = new _s();
    class cs {
      ReportFixture(t) {
        return !0;
      }
      ReportParticle(t, e) {
        return !1;
      }
      ShouldQueryParticleSystem(t) {
        return !0;
      }
    }
    class us {
      constructor() {
        this.m_broadPhase = new ne(), this.m_contactList = null, this.m_contactCount = 0, this.m_contactFilter = ms.b2_defaultFilter, this.m_contactListener = _s.b2_defaultListener, this.m_allocator = null, this.m_contactFactory = new ls(this.m_allocator);
      }
      AddPair(t, e) {
        let i = t.fixture,
          s = e.fixture,
          o = t.childIndex,
          n = e.childIndex,
          r = i.GetBody(),
          a = s.GetBody();
        if (r === a) return;
        let l = a.GetContactList();
        for (; l;) {
          if (l.other === r) {
            const t = l.contact.GetFixtureA(),
              e = l.contact.GetFixtureB(),
              r = l.contact.GetChildIndexA(),
              a = l.contact.GetChildIndexB();
            if (t === i && e === s && r === o && a === n) return;
            if (t === s && e === i && r === n && a === o) return;
          }
          l = l.next;
        }
        if (this.m_contactFilter && !this.m_contactFilter.ShouldCollide(i, s)) return;
        const m = this.m_contactFactory.Create(i, o, s, n);
        null !== m && (i = m.GetFixtureA(), s = m.GetFixtureB(), o = m.GetChildIndexA(), n = m.GetChildIndexB(), r = i.m_body, a = s.m_body, m.m_prev = null, m.m_next = this.m_contactList, null !== this.m_contactList && (this.m_contactList.m_prev = m), this.m_contactList = m, m.m_nodeA.contact = m, m.m_nodeA.other = a, m.m_nodeA.prev = null, m.m_nodeA.next = r.m_contactList, null !== r.m_contactList && (r.m_contactList.prev = m.m_nodeA), r.m_contactList = m.m_nodeA, m.m_nodeB.contact = m, m.m_nodeB.other = r, m.m_nodeB.prev = null, m.m_nodeB.next = a.m_contactList, null !== a.m_contactList && (a.m_contactList.prev = m.m_nodeB), a.m_contactList = m.m_nodeB, i.IsSensor() || s.IsSensor() || (r.SetAwake(!0), a.SetAwake(!0)), ++this.m_contactCount);
      }
      FindNewContacts() {
        this.m_broadPhase.UpdatePairs((t, e) => {
          this.AddPair(t, e);
        });
      }
      Destroy(t) {
        const e = t.GetFixtureA(),
          i = t.GetFixtureB(),
          s = e.GetBody(),
          o = i.GetBody();
        this.m_contactListener && t.IsTouching() && this.m_contactListener.EndContact(t), t.m_prev && (t.m_prev.m_next = t.m_next), t.m_next && (t.m_next.m_prev = t.m_prev), t === this.m_contactList && (this.m_contactList = t.m_next), t.m_nodeA.prev && (t.m_nodeA.prev.next = t.m_nodeA.next), t.m_nodeA.next && (t.m_nodeA.next.prev = t.m_nodeA.prev), t.m_nodeA === s.m_contactList && (s.m_contactList = t.m_nodeA.next), t.m_nodeB.prev && (t.m_nodeB.prev.next = t.m_nodeB.next), t.m_nodeB.next && (t.m_nodeB.next.prev = t.m_nodeB.prev), t.m_nodeB === o.m_contactList && (o.m_contactList = t.m_nodeB.next), this.m_contactFactory.Destroy(t), --this.m_contactCount;
      }
      Collide() {
        let e = this.m_contactList;
        for (; e;) {
          const i = e.GetFixtureA(),
            s = e.GetFixtureB(),
            o = e.GetChildIndexA(),
            n = e.GetChildIndexB(),
            r = i.GetBody(),
            a = s.GetBody();
          if (e.m_filterFlag) {
            if (this.m_contactFilter && !this.m_contactFilter.ShouldCollide(i, s)) {
              const t = e;
              e = t.m_next, this.Destroy(t);
              continue;
            }
            e.m_filterFlag = !1;
          }
          const l = r.IsAwake() && r.m_type !== t.b2BodyType.b2_staticBody,
            m = a.IsAwake() && a.m_type !== t.b2BodyType.b2_staticBody;
          if (!l && !m) {
            e = e.m_next;
            continue;
          }
          const h = i.m_proxies[o].treeNode,
            _ = s.m_proxies[n].treeNode,
            c = Ht(h.aabb, _.aabb);
          if (c) e.Update(this.m_contactListener), e = e.m_next;else {
            const t = e;
            e = t.m_next, this.Destroy(t);
          }
        }
      }
    }
    class ds {
      constructor() {
        this.step = 0, this.collide = 0, this.solve = 0, this.solveInit = 0, this.solveVelocity = 0, this.solvePosition = 0, this.broadphase = 0, this.solveTOI = 0;
      }
      Reset() {
        return this.step = 0, this.collide = 0, this.solve = 0, this.solveInit = 0, this.solveVelocity = 0, this.solvePosition = 0, this.broadphase = 0, this.solveTOI = 0, this;
      }
    }
    class ps {
      constructor() {
        this.dt = 0, this.inv_dt = 0, this.dtRatio = 0, this.velocityIterations = 0, this.positionIterations = 0, this.particleIterations = 0, this.warmStarting = !1;
      }
      Copy(t) {
        return this.dt = t.dt, this.inv_dt = t.inv_dt, this.dtRatio = t.dtRatio, this.positionIterations = t.positionIterations, this.velocityIterations = t.velocityIterations, this.particleIterations = t.particleIterations, this.warmStarting = t.warmStarting, this;
      }
    }
    class fs {
      constructor() {
        this.c = new it(), this.a = 0;
      }
      static MakeArray(t) {
        return k(t, t => new fs());
      }
    }
    class ys {
      constructor() {
        this.v = new it(), this.w = 0;
      }
      static MakeArray(t) {
        return k(t, t => new ys());
      }
    }
    class xs {
      constructor() {
        this.step = new ps();
      }
    }
    let Bs = !1;
    class Ss {
      constructor() {
        this.rA = new it(), this.rB = new it(), this.normalImpulse = 0, this.tangentImpulse = 0, this.normalMass = 0, this.tangentMass = 0, this.velocityBias = 0;
      }
      static MakeArray(t) {
        return k(t, t => new Ss());
      }
    }
    class bs {
      constructor() {
        this.points = Ss.MakeArray(r), this.normal = new it(), this.tangent = new it(), this.normalMass = new nt(), this.K = new nt(), this.indexA = 0, this.indexB = 0, this.invMassA = 0, this.invMassB = 0, this.invIA = 0, this.invIB = 0, this.friction = 0, this.restitution = 0, this.tangentSpeed = 0, this.pointCount = 0, this.contactIndex = 0;
      }
      static MakeArray(t) {
        return k(t, t => new bs());
      }
    }
    class As {
      constructor() {
        this.localPoints = it.MakeArray(r), this.localNormal = new it(), this.localPoint = new it(), this.indexA = 0, this.indexB = 0, this.invMassA = 0, this.invMassB = 0, this.localCenterA = new it(), this.localCenterB = new it(), this.invIA = 0, this.invIB = 0, this.type = t.b2ManifoldType.e_unknown, this.radiusA = 0, this.radiusB = 0, this.pointCount = 0;
      }
      static MakeArray(t) {
        return k(t, t => new As());
      }
    }
    class Cs {
      constructor() {
        this.step = new ps(), this.count = 0, this.allocator = null;
      }
    }
    class Vs {
      constructor() {
        this.normal = new it(), this.point = new it(), this.separation = 0;
      }
      Initialize(e, i, s, o) {
        const n = Vs.Initialize_s_pointA,
          r = Vs.Initialize_s_pointB,
          a = Vs.Initialize_s_planePoint,
          l = Vs.Initialize_s_clipPoint;
        switch (e.type) {
          case t.b2ManifoldType.e_circles:
            lt.MulXV(i, e.localPoint, n), lt.MulXV(s, e.localPoints[0], r), it.SubVV(r, n, this.normal).SelfNormalize(), it.MidVV(n, r, this.point), this.separation = it.DotVV(it.SubVV(r, n, it.s_t0), this.normal) - e.radiusA - e.radiusB;
            break;
          case t.b2ManifoldType.e_faceA:
            at.MulRV(i.q, e.localNormal, this.normal), lt.MulXV(i, e.localPoint, a), lt.MulXV(s, e.localPoints[o], l), this.separation = it.DotVV(it.SubVV(l, a, it.s_t0), this.normal) - e.radiusA - e.radiusB, this.point.Copy(l);
            break;
          case t.b2ManifoldType.e_faceB:
            at.MulRV(s.q, e.localNormal, this.normal), lt.MulXV(s, e.localPoint, a), lt.MulXV(i, e.localPoints[o], l), this.separation = it.DotVV(it.SubVV(l, a, it.s_t0), this.normal) - e.radiusA - e.radiusB, this.point.Copy(l), this.normal.SelfNeg();
        }
      }
    }
    Vs.Initialize_s_pointA = new it(), Vs.Initialize_s_pointB = new it(), Vs.Initialize_s_planePoint = new it(), Vs.Initialize_s_clipPoint = new it();
    class gs {
      constructor() {
        this.m_step = new ps(), this.m_allocator = null, this.m_positionConstraints = As.MakeArray(1024), this.m_velocityConstraints = bs.MakeArray(1024), this.m_count = 0;
      }
      Initialize(t) {
        if (this.m_step.Copy(t.step), this.m_allocator = t.allocator, this.m_count = t.count, this.m_positionConstraints.length < this.m_count) {
          const t = N(2 * this.m_positionConstraints.length, this.m_count);
          for (; this.m_positionConstraints.length < t;) this.m_positionConstraints[this.m_positionConstraints.length] = new As();
        }
        if (this.m_velocityConstraints.length < this.m_count) {
          const t = N(2 * this.m_velocityConstraints.length, this.m_count);
          for (; this.m_velocityConstraints.length < t;) this.m_velocityConstraints[this.m_velocityConstraints.length] = new bs();
        }
        this.m_positions = t.positions, this.m_velocities = t.velocities, this.m_contacts = t.contacts;
        for (let t = 0; t < this.m_count; ++t) {
          const e = this.m_contacts[t],
            i = e.m_fixtureA,
            s = e.m_fixtureB,
            o = i.GetShape(),
            n = s.GetShape(),
            r = o.m_radius,
            a = n.m_radius,
            l = i.GetBody(),
            m = s.GetBody(),
            h = e.GetManifold(),
            _ = h.pointCount,
            c = this.m_velocityConstraints[t];
          c.friction = e.m_friction, c.restitution = e.m_restitution, c.tangentSpeed = e.m_tangentSpeed, c.indexA = l.m_islandIndex, c.indexB = m.m_islandIndex, c.invMassA = l.m_invMass, c.invMassB = m.m_invMass, c.invIA = l.m_invI, c.invIB = m.m_invI, c.contactIndex = t, c.pointCount = _, c.K.SetZero(), c.normalMass.SetZero();
          const u = this.m_positionConstraints[t];
          u.indexA = l.m_islandIndex, u.indexB = m.m_islandIndex, u.invMassA = l.m_invMass, u.invMassB = m.m_invMass, u.localCenterA.Copy(l.m_sweep.localCenter), u.localCenterB.Copy(m.m_sweep.localCenter), u.invIA = l.m_invI, u.invIB = m.m_invI, u.localNormal.Copy(h.localNormal), u.localPoint.Copy(h.localPoint), u.pointCount = _, u.radiusA = r, u.radiusB = a, u.type = h.type;
          for (let t = 0; t < _; ++t) {
            const e = h.points[t],
              i = c.points[t];
            this.m_step.warmStarting ? (i.normalImpulse = this.m_step.dtRatio * e.normalImpulse, i.tangentImpulse = this.m_step.dtRatio * e.tangentImpulse) : (i.normalImpulse = 0, i.tangentImpulse = 0), i.rA.SetZero(), i.rB.SetZero(), i.normalMass = 0, i.tangentMass = 0, i.velocityBias = 0, u.localPoints[t].Copy(e.localPoint);
          }
        }
        return this;
      }
      InitializeVelocityConstraints() {
        const t = gs.InitializeVelocityConstraints_s_xfA,
          e = gs.InitializeVelocityConstraints_s_xfB,
          i = gs.InitializeVelocityConstraints_s_worldManifold;
        for (let s = 0; s < this.m_count; ++s) {
          const o = this.m_velocityConstraints[s],
            n = this.m_positionConstraints[s],
            r = n.radiusA,
            a = n.radiusB,
            l = this.m_contacts[o.contactIndex].GetManifold(),
            m = o.indexA,
            h = o.indexB,
            _ = o.invMassA,
            c = o.invMassB,
            u = o.invIA,
            d = o.invIB,
            f = n.localCenterA,
            y = n.localCenterB,
            x = this.m_positions[m].c,
            B = this.m_positions[m].a,
            S = this.m_velocities[m].v,
            b = this.m_velocities[m].w,
            A = this.m_positions[h].c,
            C = this.m_positions[h].a,
            V = this.m_velocities[h].v,
            g = this.m_velocities[h].w;
          t.q.SetAngle(B), e.q.SetAngle(C), it.SubVV(x, at.MulRV(t.q, f, it.s_t0), t.p), it.SubVV(A, at.MulRV(e.q, y, it.s_t0), e.p), i.Initialize(l, t, r, e, a), o.normal.Copy(i.normal), it.CrossVOne(o.normal, o.tangent);
          const w = o.pointCount;
          for (let t = 0; t < w; ++t) {
            const e = o.points[t];
            it.SubVV(i.points[t], x, e.rA), it.SubVV(i.points[t], A, e.rB);
            const s = it.CrossVV(e.rA, o.normal),
              n = it.CrossVV(e.rB, o.normal),
              r = _ + c + u * s * s + d * n * n;
            e.normalMass = r > 0 ? 1 / r : 0;
            const a = o.tangent,
              l = it.CrossVV(e.rA, a),
              m = it.CrossVV(e.rB, a),
              h = _ + c + u * l * l + d * m * m;
            e.tangentMass = h > 0 ? 1 / h : 0, e.velocityBias = 0;
            const f = it.DotVV(o.normal, it.SubVV(it.AddVCrossSV(V, g, e.rB, it.s_t0), it.AddVCrossSV(S, b, e.rA, it.s_t1), it.s_t0));
            f < -p && (e.velocityBias += -o.restitution * f);
          }
          if (2 === o.pointCount && Bs) {
            const t = o.points[0],
              e = o.points[1],
              i = it.CrossVV(t.rA, o.normal),
              s = it.CrossVV(t.rB, o.normal),
              n = it.CrossVV(e.rA, o.normal),
              r = it.CrossVV(e.rB, o.normal),
              a = _ + c + u * i * i + d * s * s,
              l = _ + c + u * n * n + d * r * r,
              m = _ + c + u * i * n + d * s * r;
            a * a < 1e3 * (a * l - m * m) ? (o.K.ex.Set(a, m), o.K.ey.Set(m, l), o.K.GetInverse(o.normalMass)) : o.pointCount = 1;
          }
        }
      }
      WarmStart() {
        const t = gs.WarmStart_s_P;
        for (let e = 0; e < this.m_count; ++e) {
          const i = this.m_velocityConstraints[e],
            s = i.indexA,
            o = i.indexB,
            n = i.invMassA,
            r = i.invIA,
            a = i.invMassB,
            l = i.invIB,
            m = i.pointCount,
            h = this.m_velocities[s].v;
          let _ = this.m_velocities[s].w;
          const c = this.m_velocities[o].v;
          let u = this.m_velocities[o].w;
          const d = i.normal,
            p = i.tangent;
          for (let e = 0; e < m; ++e) {
            const s = i.points[e];
            it.AddVV(it.MulSV(s.normalImpulse, d, it.s_t0), it.MulSV(s.tangentImpulse, p, it.s_t1), t), _ -= r * it.CrossVV(s.rA, t), h.SelfMulSub(n, t), u += l * it.CrossVV(s.rB, t), c.SelfMulAdd(a, t);
          }
          this.m_velocities[s].w = _, this.m_velocities[o].w = u;
        }
      }
      SolveVelocityConstraints() {
        const t = gs.SolveVelocityConstraints_s_dv,
          e = gs.SolveVelocityConstraints_s_dv1,
          i = gs.SolveVelocityConstraints_s_dv2,
          s = gs.SolveVelocityConstraints_s_P,
          o = gs.SolveVelocityConstraints_s_a,
          n = gs.SolveVelocityConstraints_s_b,
          r = gs.SolveVelocityConstraints_s_x,
          a = gs.SolveVelocityConstraints_s_d,
          l = gs.SolveVelocityConstraints_s_P1,
          m = gs.SolveVelocityConstraints_s_P2,
          h = gs.SolveVelocityConstraints_s_P1P2;
        for (let _ = 0; _ < this.m_count; ++_) {
          const c = this.m_velocityConstraints[_],
            u = c.indexA,
            d = c.indexB,
            p = c.invMassA,
            f = c.invIA,
            y = c.invMassB,
            x = c.invIB,
            B = c.pointCount,
            S = this.m_velocities[u].v;
          let b = this.m_velocities[u].w;
          const A = this.m_velocities[d].v;
          let C = this.m_velocities[d].w;
          const V = c.normal,
            g = c.tangent,
            w = c.friction;
          for (let e = 0; e < B; ++e) {
            const i = c.points[e];
            it.SubVV(it.AddVCrossSV(A, C, i.rB, it.s_t0), it.AddVCrossSV(S, b, i.rA, it.s_t1), t);
            const o = it.DotVV(t, g) - c.tangentSpeed;
            let n = i.tangentMass * -o;
            const r = w * i.normalImpulse,
              a = X(i.tangentImpulse + n, -r, r);
            n = a - i.tangentImpulse, i.tangentImpulse = a, it.MulSV(n, g, s), S.SelfMulSub(p, s), b -= f * it.CrossVV(i.rA, s), A.SelfMulAdd(y, s), C += x * it.CrossVV(i.rB, s);
          }
          if (1 === c.pointCount || !1 === Bs) for (let e = 0; e < B; ++e) {
            const i = c.points[e];
            it.SubVV(it.AddVCrossSV(A, C, i.rB, it.s_t0), it.AddVCrossSV(S, b, i.rA, it.s_t1), t);
            const o = it.DotVV(t, V);
            let n = -i.normalMass * (o - i.velocityBias);
            const r = N(i.normalImpulse + n, 0);
            n = r - i.normalImpulse, i.normalImpulse = r, it.MulSV(n, V, s), S.SelfMulSub(p, s), b -= f * it.CrossVV(i.rA, s), A.SelfMulAdd(y, s), C += x * it.CrossVV(i.rB, s);
          } else {
            const t = c.points[0],
              s = c.points[1];
            o.Set(t.normalImpulse, s.normalImpulse), it.SubVV(it.AddVCrossSV(A, C, t.rB, it.s_t0), it.AddVCrossSV(S, b, t.rA, it.s_t1), e), it.SubVV(it.AddVCrossSV(A, C, s.rB, it.s_t0), it.AddVCrossSV(S, b, s.rA, it.s_t1), i);
            let _ = it.DotVV(e, V),
              u = it.DotVV(i, V);
            for (n.x = _ - t.velocityBias, n.y = u - s.velocityBias, n.SelfSub(nt.MulMV(c.K, o, it.s_t0));;) {
              if (nt.MulMV(c.normalMass, n, r).SelfNeg(), r.x >= 0 && r.y >= 0) {
                it.SubVV(r, o, a), it.MulSV(a.x, V, l), it.MulSV(a.y, V, m), it.AddVV(l, m, h), S.SelfMulSub(p, h), b -= f * (it.CrossVV(t.rA, l) + it.CrossVV(s.rA, m)), A.SelfMulAdd(y, h), C += x * (it.CrossVV(t.rB, l) + it.CrossVV(s.rB, m)), t.normalImpulse = r.x, s.normalImpulse = r.y;
                break;
              }
              if (r.x = -t.normalMass * n.x, r.y = 0, _ = 0, u = c.K.ex.y * r.x + n.y, r.x >= 0 && u >= 0) {
                it.SubVV(r, o, a), it.MulSV(a.x, V, l), it.MulSV(a.y, V, m), it.AddVV(l, m, h), S.SelfMulSub(p, h), b -= f * (it.CrossVV(t.rA, l) + it.CrossVV(s.rA, m)), A.SelfMulAdd(y, h), C += x * (it.CrossVV(t.rB, l) + it.CrossVV(s.rB, m)), t.normalImpulse = r.x, s.normalImpulse = r.y;
                break;
              }
              if (r.x = 0, r.y = -s.normalMass * n.y, _ = c.K.ey.x * r.y + n.x, u = 0, r.y >= 0 && _ >= 0) {
                it.SubVV(r, o, a), it.MulSV(a.x, V, l), it.MulSV(a.y, V, m), it.AddVV(l, m, h), S.SelfMulSub(p, h), b -= f * (it.CrossVV(t.rA, l) + it.CrossVV(s.rA, m)), A.SelfMulAdd(y, h), C += x * (it.CrossVV(t.rB, l) + it.CrossVV(s.rB, m)), t.normalImpulse = r.x, s.normalImpulse = r.y;
                break;
              }
              if (r.x = 0, r.y = 0, _ = n.x, u = n.y, _ >= 0 && u >= 0) {
                it.SubVV(r, o, a), it.MulSV(a.x, V, l), it.MulSV(a.y, V, m), it.AddVV(l, m, h), S.SelfMulSub(p, h), b -= f * (it.CrossVV(t.rA, l) + it.CrossVV(s.rA, m)), A.SelfMulAdd(y, h), C += x * (it.CrossVV(t.rB, l) + it.CrossVV(s.rB, m)), t.normalImpulse = r.x, s.normalImpulse = r.y;
                break;
              }
              break;
            }
          }
          this.m_velocities[u].w = b, this.m_velocities[d].w = C;
        }
      }
      StoreImpulses() {
        for (let t = 0; t < this.m_count; ++t) {
          const e = this.m_velocityConstraints[t],
            i = this.m_contacts[e.contactIndex].GetManifold();
          for (let t = 0; t < e.pointCount; ++t) i.points[t].normalImpulse = e.points[t].normalImpulse, i.points[t].tangentImpulse = e.points[t].tangentImpulse;
        }
      }
      SolvePositionConstraints() {
        const t = gs.SolvePositionConstraints_s_xfA,
          e = gs.SolvePositionConstraints_s_xfB,
          i = gs.SolvePositionConstraints_s_psm,
          s = gs.SolvePositionConstraints_s_rA,
          o = gs.SolvePositionConstraints_s_rB,
          n = gs.SolvePositionConstraints_s_P;
        let r = 0;
        for (let a = 0; a < this.m_count; ++a) {
          const l = this.m_positionConstraints[a],
            m = l.indexA,
            _ = l.indexB,
            c = l.localCenterA,
            u = l.invMassA,
            d = l.invIA,
            p = l.localCenterB,
            y = l.invMassB,
            x = l.invIB,
            B = l.pointCount,
            S = this.m_positions[m].c;
          let b = this.m_positions[m].a;
          const C = this.m_positions[_].c;
          let V = this.m_positions[_].a;
          for (let a = 0; a < B; ++a) {
            t.q.SetAngle(b), e.q.SetAngle(V), it.SubVV(S, at.MulRV(t.q, c, it.s_t0), t.p), it.SubVV(C, at.MulRV(e.q, p, it.s_t0), e.p), i.Initialize(l, t, e, a);
            const m = i.normal,
              _ = i.point,
              B = i.separation;
            it.SubVV(_, S, s), it.SubVV(_, C, o), r = j(r, B);
            const g = X(A * (B + h), -f, 0),
              w = it.CrossVV(s, m),
              v = it.CrossVV(o, m),
              M = u + y + d * w * w + x * v * v,
              P = M > 0 ? -g / M : 0;
            it.MulSV(P, m, n), S.SelfMulSub(u, n), b -= d * it.CrossVV(s, n), C.SelfMulAdd(y, n), V += x * it.CrossVV(o, n);
          }
          this.m_positions[m].a = b, this.m_positions[_].a = V;
        }
        return r > -3 * h;
      }
      SolveTOIPositionConstraints(t, e) {
        const i = gs.SolveTOIPositionConstraints_s_xfA,
          s = gs.SolveTOIPositionConstraints_s_xfB,
          o = gs.SolveTOIPositionConstraints_s_psm,
          n = gs.SolveTOIPositionConstraints_s_rA,
          r = gs.SolveTOIPositionConstraints_s_rB,
          a = gs.SolveTOIPositionConstraints_s_P;
        let l = 0;
        for (let m = 0; m < this.m_count; ++m) {
          const _ = this.m_positionConstraints[m],
            c = _.indexA,
            u = _.indexB,
            d = _.localCenterA,
            p = _.localCenterB,
            y = _.pointCount;
          let x = 0,
            B = 0;
          c !== t && c !== e || (x = _.invMassA, B = _.invIA);
          let S = 0,
            b = 0;
          u !== t && u !== e || (S = _.invMassB, b = _.invIB);
          const A = this.m_positions[c].c;
          let V = this.m_positions[c].a;
          const g = this.m_positions[u].c;
          let w = this.m_positions[u].a;
          for (let t = 0; t < y; ++t) {
            i.q.SetAngle(V), s.q.SetAngle(w), it.SubVV(A, at.MulRV(i.q, d, it.s_t0), i.p), it.SubVV(g, at.MulRV(s.q, p, it.s_t0), s.p), o.Initialize(_, i, s, t);
            const e = o.normal,
              m = o.point,
              c = o.separation;
            it.SubVV(m, A, n), it.SubVV(m, g, r), l = j(l, c);
            const u = X(C * (c + h), -f, 0),
              y = it.CrossVV(n, e),
              v = it.CrossVV(r, e),
              M = x + S + B * y * y + b * v * v,
              P = M > 0 ? -u / M : 0;
            it.MulSV(P, e, a), A.SelfMulSub(x, a), V -= B * it.CrossVV(n, a), g.SelfMulAdd(S, a), w += b * it.CrossVV(r, a);
          }
          this.m_positions[c].a = V, this.m_positions[u].a = w;
        }
        return l >= -1.5 * h;
      }
    }
    gs.InitializeVelocityConstraints_s_xfA = new lt(), gs.InitializeVelocityConstraints_s_xfB = new lt(), gs.InitializeVelocityConstraints_s_worldManifold = new Nt(), gs.WarmStart_s_P = new it(), gs.SolveVelocityConstraints_s_dv = new it(), gs.SolveVelocityConstraints_s_dv1 = new it(), gs.SolveVelocityConstraints_s_dv2 = new it(), gs.SolveVelocityConstraints_s_P = new it(), gs.SolveVelocityConstraints_s_a = new it(), gs.SolveVelocityConstraints_s_b = new it(), gs.SolveVelocityConstraints_s_x = new it(), gs.SolveVelocityConstraints_s_d = new it(), gs.SolveVelocityConstraints_s_P1 = new it(), gs.SolveVelocityConstraints_s_P2 = new it(), gs.SolveVelocityConstraints_s_P1P2 = new it(), gs.SolvePositionConstraints_s_xfA = new lt(), gs.SolvePositionConstraints_s_xfB = new lt(), gs.SolvePositionConstraints_s_psm = new Vs(), gs.SolvePositionConstraints_s_rA = new it(), gs.SolvePositionConstraints_s_rB = new it(), gs.SolvePositionConstraints_s_P = new it(), gs.SolveTOIPositionConstraints_s_xfA = new lt(), gs.SolveTOIPositionConstraints_s_xfB = new lt(), gs.SolveTOIPositionConstraints_s_psm = new Vs(), gs.SolveTOIPositionConstraints_s_rA = new it(), gs.SolveTOIPositionConstraints_s_rB = new it(), gs.SolveTOIPositionConstraints_s_P = new it();
    class ws {
      constructor() {
        this.m_allocator = null, this.m_bodies = [], this.m_contacts = [], this.m_joints = [], this.m_positions = fs.MakeArray(1024), this.m_velocities = ys.MakeArray(1024), this.m_bodyCount = 0, this.m_jointCount = 0, this.m_contactCount = 0, this.m_bodyCapacity = 0, this.m_contactCapacity = 0, this.m_jointCapacity = 0;
      }
      Initialize(t, e, i, s, o) {
        if (this.m_bodyCapacity = t, this.m_contactCapacity = e, this.m_jointCapacity = i, this.m_bodyCount = 0, this.m_contactCount = 0, this.m_jointCount = 0, this.m_allocator = s, this.m_listener = o, this.m_positions.length < t) {
          const e = N(2 * this.m_positions.length, t);
          for (; this.m_positions.length < e;) this.m_positions[this.m_positions.length] = new fs();
        }
        if (this.m_velocities.length < t) {
          const e = N(2 * this.m_velocities.length, t);
          for (; this.m_velocities.length < e;) this.m_velocities[this.m_velocities.length] = new ys();
        }
      }
      Clear() {
        this.m_bodyCount = 0, this.m_contactCount = 0, this.m_jointCount = 0;
      }
      AddBody(t) {
        t.m_islandIndex = this.m_bodyCount, this.m_bodies[this.m_bodyCount++] = t;
      }
      AddContact(t) {
        this.m_contacts[this.m_contactCount++] = t;
      }
      AddJoint(t) {
        this.m_joints[this.m_jointCount++] = t;
      }
      Solve(e, s, o, n) {
        const r = ws.s_timer.Reset(),
          a = s.dt;
        for (let e = 0; e < this.m_bodyCount; ++e) {
          const i = this.m_bodies[e];
          this.m_positions[e].c.Copy(i.m_sweep.c);
          const s = i.m_sweep.a,
            n = this.m_velocities[e].v.Copy(i.m_linearVelocity);
          let r = i.m_angularVelocity;
          i.m_sweep.c0.Copy(i.m_sweep.c), i.m_sweep.a0 = i.m_sweep.a, i.m_type === t.b2BodyType.b2_dynamicBody && (n.x += a * (i.m_gravityScale * o.x + i.m_invMass * i.m_force.x), n.y += a * (i.m_gravityScale * o.y + i.m_invMass * i.m_force.y), r += a * i.m_invI * i.m_torque, n.SelfMul(1 / (1 + a * i.m_linearDamping)), r *= 1 / (1 + a * i.m_angularDamping)), this.m_positions[e].a = s, this.m_velocities[e].w = r;
        }
        r.Reset();
        const l = ws.s_solverData;
        l.step.Copy(s), l.positions = this.m_positions, l.velocities = this.m_velocities;
        const m = ws.s_contactSolverDef;
        m.step.Copy(s), m.contacts = this.m_contacts, m.count = this.m_contactCount, m.positions = this.m_positions, m.velocities = this.m_velocities, m.allocator = this.m_allocator;
        const h = ws.s_contactSolver.Initialize(m);
        h.InitializeVelocityConstraints(), s.warmStarting && h.WarmStart();
        for (let t = 0; t < this.m_jointCount; ++t) this.m_joints[t].InitVelocityConstraints(l);
        e.solveInit = r.GetMilliseconds(), r.Reset();
        for (let t = 0; t < s.velocityIterations; ++t) {
          for (let t = 0; t < this.m_jointCount; ++t) this.m_joints[t].SolveVelocityConstraints(l);
          h.SolveVelocityConstraints();
        }
        h.StoreImpulses(), e.solveVelocity = r.GetMilliseconds();
        for (let t = 0; t < this.m_bodyCount; ++t) {
          const e = this.m_positions[t].c;
          let i = this.m_positions[t].a;
          const s = this.m_velocities[t].v;
          let o = this.m_velocities[t].w;
          const n = it.MulSV(a, s, ws.s_translation);
          if (it.DotVV(n, n) > B) {
            const t = x / n.Length();
            s.SelfMul(t);
          }
          const r = a * o;
          if (r * r > b) {
            const t = S / O(r);
            o *= t;
          }
          e.x += a * s.x, e.y += a * s.y, i += a * o, this.m_positions[t].a = i, this.m_velocities[t].w = o;
        }
        r.Reset();
        let _ = !1;
        for (let t = 0; t < s.positionIterations; ++t) {
          const t = h.SolvePositionConstraints();
          let e = !0;
          for (let t = 0; t < this.m_jointCount; ++t) {
            const i = this.m_joints[t].SolvePositionConstraints(l);
            e = e && i;
          }
          if (t && e) {
            _ = !0;
            break;
          }
        }
        for (let t = 0; t < this.m_bodyCount; ++t) {
          const e = this.m_bodies[t];
          e.m_sweep.c.Copy(this.m_positions[t].c), e.m_sweep.a = this.m_positions[t].a, e.m_linearVelocity.Copy(this.m_velocities[t].v), e.m_angularVelocity = this.m_velocities[t].w, e.SynchronizeTransform();
        }
        if (e.solvePosition = r.GetMilliseconds(), this.Report(h.m_velocityConstraints), n) {
          let e = i;
          const s = F * F,
            o = T * T;
          for (let i = 0; i < this.m_bodyCount; ++i) {
            const n = this.m_bodies[i];
            n.GetType() !== t.b2BodyType.b2_staticBody && (!n.m_autoSleepFlag || n.m_angularVelocity * n.m_angularVelocity > o || it.DotVV(n.m_linearVelocity, n.m_linearVelocity) > s ? (n.m_sleepTime = 0, e = 0) : (n.m_sleepTime += a, e = j(e, n.m_sleepTime)));
          }
          if (e >= D && _) for (let t = 0; t < this.m_bodyCount; ++t) {
            const e = this.m_bodies[t];
            e.SetAwake(!1);
          }
        }
      }
      SolveTOI(t, e, i) {
        for (let t = 0; t < this.m_bodyCount; ++t) {
          const e = this.m_bodies[t];
          this.m_positions[t].c.Copy(e.m_sweep.c), this.m_positions[t].a = e.m_sweep.a, this.m_velocities[t].v.Copy(e.m_linearVelocity), this.m_velocities[t].w = e.m_angularVelocity;
        }
        const s = ws.s_contactSolverDef;
        s.contacts = this.m_contacts, s.count = this.m_contactCount, s.allocator = this.m_allocator, s.step.Copy(t), s.positions = this.m_positions, s.velocities = this.m_velocities;
        const o = ws.s_contactSolver.Initialize(s);
        for (let s = 0; s < t.positionIterations; ++s) {
          const t = o.SolveTOIPositionConstraints(e, i);
          if (t) break;
        }
        this.m_bodies[e].m_sweep.c0.Copy(this.m_positions[e].c), this.m_bodies[e].m_sweep.a0 = this.m_positions[e].a, this.m_bodies[i].m_sweep.c0.Copy(this.m_positions[i].c), this.m_bodies[i].m_sweep.a0 = this.m_positions[i].a, o.InitializeVelocityConstraints();
        for (let e = 0; e < t.velocityIterations; ++e) o.SolveVelocityConstraints();
        const n = t.dt;
        for (let t = 0; t < this.m_bodyCount; ++t) {
          const e = this.m_positions[t].c;
          let i = this.m_positions[t].a;
          const s = this.m_velocities[t].v;
          let o = this.m_velocities[t].w;
          const r = it.MulSV(n, s, ws.s_translation);
          if (it.DotVV(r, r) > B) {
            const t = x / r.Length();
            s.SelfMul(t);
          }
          const a = n * o;
          if (a * a > b) {
            const t = S / O(a);
            o *= t;
          }
          e.SelfMulAdd(n, s), i += n * o, this.m_positions[t].a = i, this.m_velocities[t].w = o;
          const l = this.m_bodies[t];
          l.m_sweep.c.Copy(e), l.m_sweep.a = i, l.m_linearVelocity.Copy(s), l.m_angularVelocity = o, l.SynchronizeTransform();
        }
        this.Report(o.m_velocityConstraints);
      }
      Report(t) {
        if (null !== this.m_listener) for (let e = 0; e < this.m_contactCount; ++e) {
          const i = this.m_contacts[e];
          if (!i) continue;
          const s = t[e],
            o = ws.s_impulse;
          o.count = s.pointCount;
          for (let t = 0; t < s.pointCount; ++t) o.normalImpulses[t] = s.points[t].normalImpulse, o.tangentImpulses[t] = s.points[t].tangentImpulse;
          this.m_listener.PostSolve(i, o);
        }
      }
    }
    var vs, Ms;
    ws.s_timer = new ct(), ws.s_solverData = new xs(), ws.s_contactSolverDef = new Cs(), ws.s_contactSolver = new gs(), ws.s_translation = new it(), ws.s_impulse = new hs(), (vs = t.b2ParticleFlag || (t.b2ParticleFlag = {}))[vs.b2_waterParticle = 0] = "b2_waterParticle", vs[vs.b2_zombieParticle = 2] = "b2_zombieParticle", vs[vs.b2_wallParticle = 4] = "b2_wallParticle", vs[vs.b2_springParticle = 8] = "b2_springParticle", vs[vs.b2_elasticParticle = 16] = "b2_elasticParticle", vs[vs.b2_viscousParticle = 32] = "b2_viscousParticle", vs[vs.b2_powderParticle = 64] = "b2_powderParticle", vs[vs.b2_tensileParticle = 128] = "b2_tensileParticle", vs[vs.b2_colorMixingParticle = 256] = "b2_colorMixingParticle", vs[vs.b2_destructionListenerParticle = 512] = "b2_destructionListenerParticle", vs[vs.b2_barrierParticle = 1024] = "b2_barrierParticle", vs[vs.b2_staticPressureParticle = 2048] = "b2_staticPressureParticle", vs[vs.b2_reactiveParticle = 4096] = "b2_reactiveParticle", vs[vs.b2_repulsiveParticle = 8192] = "b2_repulsiveParticle", vs[vs.b2_fixtureContactListenerParticle = 16384] = "b2_fixtureContactListenerParticle", vs[vs.b2_particleContactListenerParticle = 32768] = "b2_particleContactListenerParticle", vs[vs.b2_fixtureContactFilterParticle = 65536] = "b2_fixtureContactFilterParticle", vs[vs.b2_particleContactFilterParticle = 131072] = "b2_particleContactFilterParticle";
    class Ps {
      constructor() {
        this.flags = 0, this.position = new it(), this.velocity = new it(), this.color = new ht(0, 0, 0, 0), this.lifetime = 0, this.userData = null, this.group = null;
      }
    }
    function Is(t, e, i) {
      const s = Math.ceil(Math.sqrt(t / (.01 * e)) * i);
      return X(s, 1, 8);
    }
    class Gs {
      constructor() {
        this.m_index = V;
      }
      GetIndex() {
        return this.m_index;
      }
      SetIndex(t) {
        this.m_index = t;
      }
    }
    (Ms = t.b2ParticleGroupFlag || (t.b2ParticleGroupFlag = {}))[Ms.b2_solidParticleGroup = 1] = "b2_solidParticleGroup", Ms[Ms.b2_rigidParticleGroup = 2] = "b2_rigidParticleGroup", Ms[Ms.b2_particleGroupCanBeEmpty = 4] = "b2_particleGroupCanBeEmpty", Ms[Ms.b2_particleGroupWillBeDestroyed = 8] = "b2_particleGroupWillBeDestroyed", Ms[Ms.b2_particleGroupNeedsUpdateDepth = 16] = "b2_particleGroupNeedsUpdateDepth", Ms[Ms.b2_particleGroupInternalMask = 24] = "b2_particleGroupInternalMask";
    class Ds {
      constructor() {
        this.flags = 0, this.groupFlags = 0, this.position = new it(), this.angle = 0, this.linearVelocity = new it(), this.angularVelocity = 0, this.color = new ht(), this.strength = 1, this.shapeCount = 0, this.stride = 0, this.particleCount = 0, this.lifetime = 0, this.userData = null, this.group = null;
      }
    }
    class Fs {
      constructor(t) {
        this.m_firstIndex = 0, this.m_lastIndex = 0, this.m_groupFlags = 0, this.m_strength = 1, this.m_prev = null, this.m_next = null, this.m_timestamp = -1, this.m_mass = 0, this.m_inertia = 0, this.m_center = new it(), this.m_linearVelocity = new it(), this.m_angularVelocity = 0, this.m_transform = new lt(), this.m_userData = null, this.m_system = t;
      }
      GetNext() {
        return this.m_next;
      }
      GetParticleSystem() {
        return this.m_system;
      }
      GetParticleCount() {
        return this.m_lastIndex - this.m_firstIndex;
      }
      GetBufferIndex() {
        return this.m_firstIndex;
      }
      ContainsParticle(t) {
        return this.m_firstIndex <= t && t < this.m_lastIndex;
      }
      GetAllParticleFlags() {
        if (!this.m_system.m_flagsBuffer.data) throw new Error();
        let t = 0;
        for (let e = this.m_firstIndex; e < this.m_lastIndex; e++) t |= this.m_system.m_flagsBuffer.data[e];
        return t;
      }
      GetGroupFlags() {
        return this.m_groupFlags;
      }
      SetGroupFlags(e) {
        e |= this.m_groupFlags & t.b2ParticleGroupFlag.b2_particleGroupInternalMask, this.m_system.SetGroupFlags(this, e);
      }
      GetMass() {
        return this.UpdateStatistics(), this.m_mass;
      }
      GetInertia() {
        return this.UpdateStatistics(), this.m_inertia;
      }
      GetCenter() {
        return this.UpdateStatistics(), this.m_center;
      }
      GetLinearVelocity() {
        return this.UpdateStatistics(), this.m_linearVelocity;
      }
      GetAngularVelocity() {
        return this.UpdateStatistics(), this.m_angularVelocity;
      }
      GetTransform() {
        return this.m_transform;
      }
      GetPosition() {
        return this.m_transform.p;
      }
      GetAngle() {
        return this.m_transform.q.GetAngle();
      }
      GetLinearVelocityFromWorldPoint(t, e) {
        const i = Fs.GetLinearVelocityFromWorldPoint_s_t0;
        return this.UpdateStatistics(), it.AddVCrossSV(this.m_linearVelocity, this.m_angularVelocity, it.SubVV(t, this.m_center, i), e);
      }
      GetUserData() {
        return this.m_userData;
      }
      SetUserData(t) {
        this.m_userData = t;
      }
      ApplyForce(t) {
        this.m_system.ApplyForce(this.m_firstIndex, this.m_lastIndex, t);
      }
      ApplyLinearImpulse(t) {
        this.m_system.ApplyLinearImpulse(this.m_firstIndex, this.m_lastIndex, t);
      }
      DestroyParticles(t) {
        if (this.m_system.m_world.IsLocked()) throw new Error();
        for (let e = this.m_firstIndex; e < this.m_lastIndex; e++) this.m_system.DestroyParticle(e, t);
      }
      UpdateStatistics() {
        if (!this.m_system.m_positionBuffer.data) throw new Error();
        if (!this.m_system.m_velocityBuffer.data) throw new Error();
        const t = new it(),
          e = new it();
        if (this.m_timestamp !== this.m_system.m_timestamp) {
          const i = this.m_system.GetParticleMass();
          this.m_mass = i * (this.m_lastIndex - this.m_firstIndex), this.m_center.SetZero(), this.m_linearVelocity.SetZero();
          for (let t = this.m_firstIndex; t < this.m_lastIndex; t++) this.m_center.SelfMulAdd(i, this.m_system.m_positionBuffer.data[t]), this.m_linearVelocity.SelfMulAdd(i, this.m_system.m_velocityBuffer.data[t]);
          if (this.m_mass > 0) {
            const t = 1 / this.m_mass;
            this.m_center.SelfMul(t), this.m_linearVelocity.SelfMul(t);
          }
          this.m_inertia = 0, this.m_angularVelocity = 0;
          for (let s = this.m_firstIndex; s < this.m_lastIndex; s++) it.SubVV(this.m_system.m_positionBuffer.data[s], this.m_center, t), it.SubVV(this.m_system.m_velocityBuffer.data[s], this.m_linearVelocity, e), this.m_inertia += i * it.DotVV(t, t), this.m_angularVelocity += i * it.CrossVV(t, e);
          this.m_inertia > 0 && (this.m_angularVelocity *= 1 / this.m_inertia), this.m_timestamp = this.m_system.m_timestamp;
        }
      }
    }
    Fs.GetLinearVelocityFromWorldPoint_s_t0 = new it();
    class Ts {
      constructor(t) {
        this.m_front = 0, this.m_back = 0, this.m_capacity = 0, this.m_buffer = k(t, t => null), this.m_capacity = t;
      }
      Push(t) {
        if (this.m_back >= this.m_capacity) {
          for (let t = this.m_front; t < this.m_back; t++) this.m_buffer[t - this.m_front] = this.m_buffer[t];
          this.m_back -= this.m_front, this.m_front = 0, this.m_back >= this.m_capacity && (this.m_capacity > 0 ? (this.m_buffer.concat(k(this.m_capacity, t => null)), this.m_capacity *= 2) : (this.m_buffer.concat(k(1, t => null)), this.m_capacity = 1));
        }
        this.m_buffer[this.m_back] = t, this.m_back++;
      }
      Pop() {
        this.m_buffer[this.m_front] = null, this.m_front++;
      }
      Empty() {
        return this.m_front === this.m_back;
      }
      Front() {
        const t = this.m_buffer[this.m_front];
        if (!t) throw new Error();
        return t;
      }
    }
    class Ls {
      constructor(t) {
        this.m_generatorCapacity = 0, this.m_generatorCount = 0, this.m_countX = 0, this.m_countY = 0, this.m_diagram = [], this.m_generatorBuffer = k(t, t => new Ls.Generator()), this.m_generatorCapacity = t;
      }
      AddGenerator(t, e, i) {
        const s = this.m_generatorBuffer[this.m_generatorCount++];
        s.center.Copy(t), s.tag = e, s.necessary = i;
      }
      Generate(t, e) {
        const s = 1 / t,
          o = new it(+i, +i),
          n = new it(-i, -i);
        let r = 0;
        for (let t = 0; t < this.m_generatorCount; t++) {
          const e = this.m_generatorBuffer[t];
          e.necessary && (it.MinV(o, e.center, o), it.MaxV(n, e.center, n), ++r);
        }
        if (0 === r) return this.m_countX = 0, void (this.m_countY = 0);
        o.x -= e, o.y -= e, n.x += e, n.y += e, this.m_countX = 1 + Math.floor(s * (n.x - o.x)), this.m_countY = 1 + Math.floor(s * (n.y - o.y)), this.m_diagram = [];
        const a = new Ts(4 * this.m_countX * this.m_countY);
        for (let t = 0; t < this.m_generatorCount; t++) {
          const e = this.m_generatorBuffer[t];
          e.center.SelfSub(o).SelfMul(s);
          const i = Math.floor(e.center.x),
            n = Math.floor(e.center.y);
          i >= 0 && n >= 0 && i < this.m_countX && n < this.m_countY && a.Push(new Ls.Task(i, n, i + n * this.m_countX, e));
        }
        for (; !a.Empty();) {
          const t = a.Front(),
            e = t.m_x,
            i = t.m_y,
            s = t.m_i,
            o = t.m_generator;
          a.Pop(), this.m_diagram[s] || (this.m_diagram[s] = o, e > 0 && a.Push(new Ls.Task(e - 1, i, s - 1, o)), i > 0 && a.Push(new Ls.Task(e, i - 1, s - this.m_countX, o)), e < this.m_countX - 1 && a.Push(new Ls.Task(e + 1, i, s + 1, o)), i < this.m_countY - 1 && a.Push(new Ls.Task(e, i + 1, s + this.m_countX, o)));
        }
        for (let t = 0; t < this.m_countY; t++) for (let e = 0; e < this.m_countX - 1; e++) {
          const i = e + t * this.m_countX,
            s = this.m_diagram[i],
            o = this.m_diagram[i + 1];
          s !== o && (a.Push(new Ls.Task(e, t, i, o)), a.Push(new Ls.Task(e + 1, t, i + 1, s)));
        }
        for (let t = 0; t < this.m_countY - 1; t++) for (let e = 0; e < this.m_countX; e++) {
          const i = e + t * this.m_countX,
            s = this.m_diagram[i],
            o = this.m_diagram[i + this.m_countX];
          s !== o && (a.Push(new Ls.Task(e, t, i, o)), a.Push(new Ls.Task(e, t + 1, i + this.m_countX, s)));
        }
        for (; !a.Empty();) {
          const t = a.Front(),
            e = t.m_x,
            i = t.m_y,
            s = t.m_i,
            o = t.m_generator;
          a.Pop();
          const n = this.m_diagram[s],
            r = o;
          if (n !== r) {
            const t = n.center.x - e,
              o = n.center.y - i,
              l = r.center.x - e,
              m = r.center.y - i,
              h = t * t + o * o,
              _ = l * l + m * m;
            h > _ && (this.m_diagram[s] = r, e > 0 && a.Push(new Ls.Task(e - 1, i, s - 1, r)), i > 0 && a.Push(new Ls.Task(e, i - 1, s - this.m_countX, r)), e < this.m_countX - 1 && a.Push(new Ls.Task(e + 1, i, s + 1, r)), i < this.m_countY - 1 && a.Push(new Ls.Task(e, i + 1, s + this.m_countX, r)));
          }
        }
      }
      GetNodes(t) {
        for (let e = 0; e < this.m_countY - 1; e++) for (let i = 0; i < this.m_countX - 1; i++) {
          const s = i + e * this.m_countX,
            o = this.m_diagram[s],
            n = this.m_diagram[s + 1],
            r = this.m_diagram[s + this.m_countX],
            a = this.m_diagram[s + 1 + this.m_countX];
          n !== r && (o !== n && o !== r && (o.necessary || n.necessary || r.necessary) && t(o.tag, n.tag, r.tag), a !== n && a !== r && (o.necessary || n.necessary || r.necessary) && t(n.tag, a.tag, r.tag));
        }
      }
    }
    function Rs(t, e, i) {
      const s = t[e];
      t[e] = t[i], t[i] = s;
    }
    function ks(t, e) {
      return t < e;
    }
    function qs(t) {
      let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      let i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : t.length - e;
      let s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ks;
      let o = e;
      const n = [];
      let r = 0;
      for (;;) {
        for (; o + 1 < i; i++) {
          const e = t[o + Math.floor(Math.random() * (i - o))];
          n[r++] = i;
          for (let n = o - 1;;) {
            for (; s(t[++n], e););
            for (; s(e, t[--i]););
            if (n >= i) break;
            Rs(t, n, i);
          }
        }
        if (0 === r) break;
        o = i, i = n[--r];
      }
      return t;
    }
    function zs(t) {
      let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      let i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : t.length - e;
      let s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ks;
      return qs(t, e, i, s);
    }
    function Es(t, e) {
      let i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : t.length;
      let s = 0;
      for (let o = 0; o < i; ++o) e(t[o]) || (o !== s ? Rs(t, s++, o) : ++s);
      return s;
    }
    function Js(t, e, i, s, o) {
      let n = i - e;
      for (; n > 0;) {
        const i = Math.floor(n / 2);
        let r = e + i;
        o(t[r], s) ? (e = ++r, n -= i + 1) : n = i;
      }
      return e;
    }
    function Os(t, e, i, s, o) {
      let n = i - e;
      for (; n > 0;) {
        const i = Math.floor(n / 2);
        let r = e + i;
        o(s, t[r]) ? n = i : (e = ++r, n -= i + 1);
      }
      return e;
    }
    function js(t, e, i, s) {
      let o = i;
      for (; e !== o;) Rs(t, e++, o++), o === s ? o = i : e === i && (i = o);
    }
    !function (t) {
      t.Generator = class {
        constructor() {
          this.center = new it(), this.tag = 0, this.necessary = !1;
        }
      }, t.Task = class {
        constructor(t, e, i, s) {
          this.m_x = t, this.m_y = e, this.m_i = i, this.m_generator = s;
        }
      };
    }(Ls || (Ls = {}));
    class Ns {
      constructor(t) {
        this.data = [], this.count = 0, this.capacity = 0, this.allocator = t;
      }
      Append() {
        return this.count >= this.capacity && this.Grow(), this.count++;
      }
      Reserve(t) {
        if (!(this.capacity >= t)) {
          for (let e = this.capacity; e < t; ++e) this.data[e] = this.allocator();
          this.capacity = t;
        }
      }
      Grow() {
        const t = this.capacity ? 2 * this.capacity : I;
        this.Reserve(t);
      }
      Free() {
        0 !== this.data.length && (this.data = [], this.capacity = 0, this.count = 0);
      }
      Shorten(t) {}
      Data() {
        return this.data;
      }
      GetCount() {
        return this.count;
      }
      SetCount(t) {
        this.count = t;
      }
      GetCapacity() {
        return this.capacity;
      }
      RemoveIf(t) {
        this.count = Es(this.data, t, this.count);
      }
      Unique(t) {
        this.count = function (t, e, i, s) {
          if (e === i) return i;
          let o = e;
          for (; ++e !== i;) s(t[o], t[e]) || Rs(t, ++o, e);
          return ++o;
        }(this.data, 0, this.count, t);
      }
    }
    class Xs extends cs {
      constructor(t) {
        super(), this.m_system = t;
      }
      ShouldQueryParticleSystem(t) {
        return !1;
      }
      ReportFixture(t) {
        if (t.IsSensor()) return !0;
        const e = t.GetShape(),
          i = e.GetChildCount();
        for (let e = 0; e < i; e++) {
          const i = t.GetAABB(e),
            s = this.m_system.GetInsideBoundsEnumerator(i);
          let o;
          for (; (o = s.GetNext()) >= 0;) this.ReportFixtureAndParticle(t, e, o);
        }
        return !0;
      }
      ReportParticle(t, e) {
        return !1;
      }
      ReportFixtureAndParticle(t, e, i) {}
    }
    class Us {
      constructor() {
        this.indexA = 0, this.indexB = 0, this.weight = 0, this.normal = new it(), this.flags = 0;
      }
      SetIndices(t, e) {
        this.indexA = t, this.indexB = e;
      }
      SetWeight(t) {
        this.weight = t;
      }
      SetNormal(t) {
        this.normal.Copy(t);
      }
      SetFlags(t) {
        this.flags = t;
      }
      GetIndexA() {
        return this.indexA;
      }
      GetIndexB() {
        return this.indexB;
      }
      GetWeight() {
        return this.weight;
      }
      GetNormal() {
        return this.normal;
      }
      GetFlags() {
        return this.flags;
      }
      IsEqual(t) {
        return this.indexA === t.indexA && this.indexB === t.indexB && this.flags === t.flags && this.weight === t.weight && this.normal.x === t.normal.x && this.normal.y === t.normal.y;
      }
      IsNotEqual(t) {
        return !this.IsEqual(t);
      }
      ApproximatelyEqual(t) {
        return this.indexA === t.indexA && this.indexB === t.indexB && this.flags === t.flags && O(this.weight - t.weight) < .01 && it.DistanceSquaredVV(this.normal, t.normal) < 1e-4;
      }
    }
    class Ws {
      constructor() {
        this.index = 0, this.weight = 0, this.normal = new it(), this.mass = 0;
      }
    }
    class Zs {
      constructor() {
        this.indexA = 0, this.indexB = 0, this.flags = 0, this.strength = 0, this.distance = 0;
      }
    }
    class Hs {
      constructor() {
        this.indexA = 0, this.indexB = 0, this.indexC = 0, this.flags = 0, this.strength = 0, this.pa = new it(0, 0), this.pb = new it(0, 0), this.pc = new it(0, 0), this.ka = 0, this.kb = 0, this.kc = 0, this.s = 0;
      }
    }
    class Qs {
      constructor() {
        this.strictContactCheck = !1, this.density = 1, this.gravityScale = 1, this.radius = 1, this.maxCount = 0, this.pressureStrength = .005, this.dampingStrength = 1, this.elasticStrength = .25, this.springStrength = .25, this.viscousStrength = .25, this.surfaceTensionPressureStrength = .2, this.surfaceTensionNormalStrength = .2, this.repulsiveStrength = 1, this.powderStrength = .5, this.ejectionStrength = .5, this.staticPressureStrength = .2, this.staticPressureRelaxation = .2, this.staticPressureIterations = 8, this.colorMixingStrength = .5, this.destroyByAge = !0, this.lifetimeGranularity = 1 / 60;
      }
      Copy(t) {
        return this.strictContactCheck = t.strictContactCheck, this.density = t.density, this.gravityScale = t.gravityScale, this.radius = t.radius, this.maxCount = t.maxCount, this.pressureStrength = t.pressureStrength, this.dampingStrength = t.dampingStrength, this.elasticStrength = t.elasticStrength, this.springStrength = t.springStrength, this.viscousStrength = t.viscousStrength, this.surfaceTensionPressureStrength = t.surfaceTensionPressureStrength, this.surfaceTensionNormalStrength = t.surfaceTensionNormalStrength, this.repulsiveStrength = t.repulsiveStrength, this.powderStrength = t.powderStrength, this.ejectionStrength = t.ejectionStrength, this.staticPressureStrength = t.staticPressureStrength, this.staticPressureRelaxation = t.staticPressureRelaxation, this.staticPressureIterations = t.staticPressureIterations, this.colorMixingStrength = t.colorMixingStrength, this.destroyByAge = t.destroyByAge, this.lifetimeGranularity = t.lifetimeGranularity, this;
      }
      Clone() {
        return new Qs().Copy(this);
      }
    }
    class Ys {
      constructor(t, e) {
        this.m_paused = !1, this.m_timestamp = 0, this.m_allParticleFlags = 0, this.m_needsUpdateAllParticleFlags = !1, this.m_allGroupFlags = 0, this.m_needsUpdateAllGroupFlags = !1, this.m_hasForce = !1, this.m_iterationIndex = 0, this.m_inverseDensity = 0, this.m_particleDiameter = 0, this.m_inverseDiameter = 0, this.m_squaredDiameter = 0, this.m_count = 0, this.m_internalAllocatedCapacity = 0, this.m_handleIndexBuffer = new Ys.UserOverridableBuffer(), this.m_flagsBuffer = new Ys.UserOverridableBuffer(), this.m_positionBuffer = new Ys.UserOverridableBuffer(), this.m_velocityBuffer = new Ys.UserOverridableBuffer(), this.m_forceBuffer = [], this.m_weightBuffer = [], this.m_staticPressureBuffer = [], this.m_accumulationBuffer = [], this.m_accumulation2Buffer = [], this.m_depthBuffer = [], this.m_colorBuffer = new Ys.UserOverridableBuffer(), this.m_groupBuffer = [], this.m_userDataBuffer = new Ys.UserOverridableBuffer(), this.m_stuckThreshold = 0, this.m_lastBodyContactStepBuffer = new Ys.UserOverridableBuffer(), this.m_bodyContactCountBuffer = new Ys.UserOverridableBuffer(), this.m_consecutiveContactStepsBuffer = new Ys.UserOverridableBuffer(), this.m_stuckParticleBuffer = new Ns(() => 0), this.m_proxyBuffer = new Ns(() => new Ys.Proxy()), this.m_contactBuffer = new Ns(() => new Us()), this.m_bodyContactBuffer = new Ns(() => new Ws()), this.m_pairBuffer = new Ns(() => new Zs()), this.m_triadBuffer = new Ns(() => new Hs()), this.m_expirationTimeBuffer = new Ys.UserOverridableBuffer(), this.m_indexByExpirationTimeBuffer = new Ys.UserOverridableBuffer(), this.m_timeElapsed = 0, this.m_expirationTimeBufferRequiresSorting = !1, this.m_groupCount = 0, this.m_groupList = null, this.m_def = new Qs(), this.m_prev = null, this.m_next = null, this.SetStrictContactCheck(t.strictContactCheck), this.SetDensity(t.density), this.SetGravityScale(t.gravityScale), this.SetRadius(t.radius), this.SetMaxParticleCount(t.maxCount), this.m_def = t.Clone(), this.m_world = e, this.SetDestructionByAge(this.m_def.destroyByAge);
      }
      static computeTag(t, e) {
        return (e + Ys.yOffset >>> 0 << Ys.yShift) + (Ys.xScale * t + Ys.xOffset >>> 0) >>> 0;
      }
      static computeRelativeTag(t, e, i) {
        return t + (i << Ys.yShift) + (e << Ys.xShift) >>> 0;
      }
      Drop() {
        for (; this.m_groupList;) this.DestroyParticleGroup(this.m_groupList);
        this.FreeUserOverridableBuffer(this.m_handleIndexBuffer), this.FreeUserOverridableBuffer(this.m_flagsBuffer), this.FreeUserOverridableBuffer(this.m_lastBodyContactStepBuffer), this.FreeUserOverridableBuffer(this.m_bodyContactCountBuffer), this.FreeUserOverridableBuffer(this.m_consecutiveContactStepsBuffer), this.FreeUserOverridableBuffer(this.m_positionBuffer), this.FreeUserOverridableBuffer(this.m_velocityBuffer), this.FreeUserOverridableBuffer(this.m_colorBuffer), this.FreeUserOverridableBuffer(this.m_userDataBuffer), this.FreeUserOverridableBuffer(this.m_expirationTimeBuffer), this.FreeUserOverridableBuffer(this.m_indexByExpirationTimeBuffer), this.FreeBuffer(this.m_forceBuffer, this.m_internalAllocatedCapacity), this.FreeBuffer(this.m_weightBuffer, this.m_internalAllocatedCapacity), this.FreeBuffer(this.m_staticPressureBuffer, this.m_internalAllocatedCapacity), this.FreeBuffer(this.m_accumulationBuffer, this.m_internalAllocatedCapacity), this.FreeBuffer(this.m_accumulation2Buffer, this.m_internalAllocatedCapacity), this.FreeBuffer(this.m_depthBuffer, this.m_internalAllocatedCapacity), this.FreeBuffer(this.m_groupBuffer, this.m_internalAllocatedCapacity);
      }
      CreateParticle(t) {
        if (this.m_world.IsLocked()) throw new Error();
        if (this.m_count >= this.m_internalAllocatedCapacity) {
          const t = this.m_count ? 2 * this.m_count : I;
          this.ReallocateInternalAllocatedBuffers(t);
        }
        if (this.m_count >= this.m_internalAllocatedCapacity) {
          if (!this.m_def.destroyByAge) return V;
          this.DestroyOldestParticle(0, !1), this.SolveZombie();
        }
        const i = this.m_count++;
        if (!this.m_flagsBuffer.data) throw new Error();
        if (this.m_flagsBuffer.data[i] = 0, this.m_lastBodyContactStepBuffer.data && (this.m_lastBodyContactStepBuffer.data[i] = 0), this.m_bodyContactCountBuffer.data && (this.m_bodyContactCountBuffer.data[i] = 0), this.m_consecutiveContactStepsBuffer.data && (this.m_consecutiveContactStepsBuffer.data[i] = 0), !this.m_positionBuffer.data) throw new Error();
        if (!this.m_velocityBuffer.data) throw new Error();
        this.m_positionBuffer.data[i] = (this.m_positionBuffer.data[i] || new it()).Copy(e(t.position, it.ZERO)), this.m_velocityBuffer.data[i] = (this.m_velocityBuffer.data[i] || new it()).Copy(e(t.velocity, it.ZERO)), this.m_weightBuffer[i] = 0, this.m_forceBuffer[i] = (this.m_forceBuffer[i] || new it()).SetZero(), this.m_staticPressureBuffer && (this.m_staticPressureBuffer[i] = 0), this.m_depthBuffer && (this.m_depthBuffer[i] = 0);
        const s = new ht().Copy(e(t.color, ht.ZERO));
        !this.m_colorBuffer.data && s.IsZero() || (this.m_colorBuffer.data = this.RequestBuffer(this.m_colorBuffer.data), this.m_colorBuffer.data[i] = (this.m_colorBuffer.data[i] || new ht()).Copy(s)), (this.m_userDataBuffer.data || t.userData) && (this.m_userDataBuffer.data = this.RequestBuffer(this.m_userDataBuffer.data), this.m_userDataBuffer.data[i] = t.userData), this.m_handleIndexBuffer.data && (this.m_handleIndexBuffer.data[i] = null);
        const o = this.m_proxyBuffer.data[this.m_proxyBuffer.Append()],
          n = e(t.lifetime, 0),
          r = n > 0;
        if (this.m_expirationTimeBuffer.data || r) {
          if (this.SetParticleLifetime(i, r ? n : this.ExpirationTimeToLifetime(-this.GetQuantizedTimeElapsed())), !this.m_indexByExpirationTimeBuffer.data) throw new Error();
          this.m_indexByExpirationTimeBuffer.data[i] = i;
        }
        o.index = i;
        const a = e(t.group, null);
        return this.m_groupBuffer[i] = a, a && (a.m_firstIndex < a.m_lastIndex ? (this.RotateBuffer(a.m_firstIndex, a.m_lastIndex, i), a.m_lastIndex = i + 1) : (a.m_firstIndex = i, a.m_lastIndex = i + 1)), this.SetParticleFlags(i, e(t.flags, 0)), i;
      }
      GetParticleHandleFromIndex(t) {
        this.m_handleIndexBuffer.data = this.RequestBuffer(this.m_handleIndexBuffer.data);
        let e = this.m_handleIndexBuffer.data[t];
        return e || ((e = new Gs()).SetIndex(t), this.m_handleIndexBuffer.data[t] = e, e);
      }
      DestroyParticle(e) {
        let i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        if (!this.m_flagsBuffer.data) throw new Error();
        let s = t.b2ParticleFlag.b2_zombieParticle;
        i && (s |= t.b2ParticleFlag.b2_destructionListenerParticle), this.SetParticleFlags(e, this.m_flagsBuffer.data[e] | s);
      }
      DestroyOldestParticle(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        const i = this.GetParticleCount();
        if (!this.m_indexByExpirationTimeBuffer.data) throw new Error();
        if (!this.m_expirationTimeBuffer.data) throw new Error();
        const s = this.m_indexByExpirationTimeBuffer.data[i - (t + 1)],
          o = this.m_indexByExpirationTimeBuffer.data[t];
        this.DestroyParticle(this.m_expirationTimeBuffer.data[s] > 0 ? s : o, e);
      }
      DestroyParticlesInShape(t, e) {
        let i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
        const s = Ys.DestroyParticlesInShape_s_aabb;
        if (this.m_world.IsLocked()) throw new Error();
        const o = new Ys.DestroyParticlesInShapeCallback(this, t, e, i),
          n = s;
        return t.ComputeAABB(n, e, 0), this.m_world.QueryAABB(o, n), o.Destroyed();
      }
      CreateParticleGroup(t) {
        const i = Ys.CreateParticleGroup_s_transform;
        if (this.m_world.IsLocked()) throw new Error();
        const s = i;
        s.SetPositionAngle(e(t.position, it.ZERO), e(t.angle, 0));
        const o = this.m_count;
        if (t.shape && this.CreateParticlesWithShapeForGroup(t.shape, t, s), t.shapes && this.CreateParticlesWithShapesForGroup(t.shapes, e(t.shapeCount, t.shapes.length), t, s), t.positionData) {
          const i = e(t.particleCount, t.positionData.length);
          for (let e = 0; e < i; e++) {
            const i = t.positionData[e];
            this.CreateParticleForGroup(t, s, i);
          }
        }
        const n = this.m_count;
        let r = new Fs(this);
        r.m_firstIndex = o, r.m_lastIndex = n, r.m_strength = e(t.strength, 1), r.m_userData = t.userData, r.m_transform.Copy(s), r.m_prev = null, r.m_next = this.m_groupList, this.m_groupList && (this.m_groupList.m_prev = r), this.m_groupList = r, ++this.m_groupCount;
        for (let t = o; t < n; t++) this.m_groupBuffer[t] = r;
        this.SetGroupFlags(r, e(t.groupFlags, 0));
        const a = new Ys.ConnectionFilter();
        return this.UpdateContacts(!0), this.UpdatePairsAndTriads(o, n, a), t.group && (this.JoinParticleGroups(t.group, r), r = t.group), r;
      }
      JoinParticleGroups(t, e) {
        if (this.m_world.IsLocked()) throw new Error();
        this.RotateBuffer(e.m_firstIndex, e.m_lastIndex, this.m_count), this.RotateBuffer(t.m_firstIndex, t.m_lastIndex, e.m_firstIndex);
        const i = new Ys.JoinParticleGroupsFilter(e.m_firstIndex);
        this.UpdateContacts(!0), this.UpdatePairsAndTriads(t.m_firstIndex, e.m_lastIndex, i);
        for (let i = e.m_firstIndex; i < e.m_lastIndex; i++) this.m_groupBuffer[i] = t;
        const s = t.m_groupFlags | e.m_groupFlags;
        this.SetGroupFlags(t, s), t.m_lastIndex = e.m_lastIndex, e.m_firstIndex = e.m_lastIndex, this.DestroyParticleGroup(e);
      }
      SplitParticleGroup(t) {
        this.UpdateContacts(!0);
        const e = t.GetParticleCount(),
          i = k(e, t => new Ys.ParticleListNode());
        Ys.InitializeParticleLists(t, i), this.MergeParticleListsInContact(t, i);
        const s = Ys.FindLongestParticleList(t, i);
        this.MergeZombieParticleListNodes(t, i, s), this.CreateParticleGroupsFromParticleList(t, i, s), this.UpdatePairsAndTriadsWithParticleList(t, i);
      }
      GetParticleGroupList() {
        return this.m_groupList;
      }
      GetParticleGroupCount() {
        return this.m_groupCount;
      }
      GetParticleCount() {
        return this.m_count;
      }
      GetMaxParticleCount() {
        return this.m_def.maxCount;
      }
      SetMaxParticleCount(t) {
        this.m_def.maxCount = t;
      }
      GetAllParticleFlags() {
        return this.m_allParticleFlags;
      }
      GetAllGroupFlags() {
        return this.m_allGroupFlags;
      }
      SetPaused(t) {
        this.m_paused = t;
      }
      GetPaused() {
        return this.m_paused;
      }
      SetDensity(t) {
        this.m_def.density = t, this.m_inverseDensity = 1 / this.m_def.density;
      }
      GetDensity() {
        return this.m_def.density;
      }
      SetGravityScale(t) {
        this.m_def.gravityScale = t;
      }
      GetGravityScale() {
        return this.m_def.gravityScale;
      }
      SetDamping(t) {
        this.m_def.dampingStrength = t;
      }
      GetDamping() {
        return this.m_def.dampingStrength;
      }
      SetStaticPressureIterations(t) {
        this.m_def.staticPressureIterations = t;
      }
      GetStaticPressureIterations() {
        return this.m_def.staticPressureIterations;
      }
      SetRadius(t) {
        this.m_particleDiameter = 2 * t, this.m_squaredDiameter = this.m_particleDiameter * this.m_particleDiameter, this.m_inverseDiameter = 1 / this.m_particleDiameter;
      }
      GetRadius() {
        return this.m_particleDiameter / 2;
      }
      GetPositionBuffer() {
        if (!this.m_positionBuffer.data) throw new Error();
        return this.m_positionBuffer.data;
      }
      GetVelocityBuffer() {
        if (!this.m_velocityBuffer.data) throw new Error();
        return this.m_velocityBuffer.data;
      }
      GetColorBuffer() {
        return this.m_colorBuffer.data = this.RequestBuffer(this.m_colorBuffer.data), this.m_colorBuffer.data;
      }
      GetGroupBuffer() {
        return this.m_groupBuffer;
      }
      GetWeightBuffer() {
        return this.m_weightBuffer;
      }
      GetUserDataBuffer() {
        return this.m_userDataBuffer.data = this.RequestBuffer(this.m_userDataBuffer.data), this.m_userDataBuffer.data;
      }
      GetFlagsBuffer() {
        if (!this.m_flagsBuffer.data) throw new Error();
        return this.m_flagsBuffer.data;
      }
      SetParticleFlags(e, i) {
        if (!this.m_flagsBuffer.data) throw new Error();
        const s = this.m_flagsBuffer.data[e];
        s & ~i && (this.m_needsUpdateAllParticleFlags = !0), ~this.m_allParticleFlags & i && (i & t.b2ParticleFlag.b2_tensileParticle && (this.m_accumulation2Buffer = this.RequestBuffer(this.m_accumulation2Buffer)), i & t.b2ParticleFlag.b2_colorMixingParticle && (this.m_colorBuffer.data = this.RequestBuffer(this.m_colorBuffer.data)), this.m_allParticleFlags |= i), this.m_flagsBuffer.data[e] = i;
      }
      GetParticleFlags(t) {
        if (!this.m_flagsBuffer.data) throw new Error();
        return this.m_flagsBuffer.data[t];
      }
      SetFlagsBuffer(t, e) {
        this.SetUserOverridableBuffer(this.m_flagsBuffer, t, e);
      }
      SetPositionBuffer(t, e) {
        this.SetUserOverridableBuffer(this.m_positionBuffer, t, e);
      }
      SetVelocityBuffer(t, e) {
        this.SetUserOverridableBuffer(this.m_velocityBuffer, t, e);
      }
      SetColorBuffer(t, e) {
        this.SetUserOverridableBuffer(this.m_colorBuffer, t, e);
      }
      SetUserDataBuffer(t, e) {
        this.SetUserOverridableBuffer(this.m_userDataBuffer, t, e);
      }
      GetContacts() {
        return this.m_contactBuffer.data;
      }
      GetContactCount() {
        return this.m_contactBuffer.count;
      }
      GetBodyContacts() {
        return this.m_bodyContactBuffer.data;
      }
      GetBodyContactCount() {
        return this.m_bodyContactBuffer.count;
      }
      GetPairs() {
        return this.m_pairBuffer.data;
      }
      GetPairCount() {
        return this.m_pairBuffer.count;
      }
      GetTriads() {
        return this.m_triadBuffer.data;
      }
      GetTriadCount() {
        return this.m_triadBuffer.count;
      }
      SetStuckThreshold(t) {
        this.m_stuckThreshold = t, t > 0 && (this.m_lastBodyContactStepBuffer.data = this.RequestBuffer(this.m_lastBodyContactStepBuffer.data), this.m_bodyContactCountBuffer.data = this.RequestBuffer(this.m_bodyContactCountBuffer.data), this.m_consecutiveContactStepsBuffer.data = this.RequestBuffer(this.m_consecutiveContactStepsBuffer.data));
      }
      GetStuckCandidates() {
        return this.m_stuckParticleBuffer.Data();
      }
      GetStuckCandidateCount() {
        return this.m_stuckParticleBuffer.GetCount();
      }
      ComputeCollisionEnergy() {
        if (!this.m_velocityBuffer.data) throw new Error();
        const t = Ys.ComputeCollisionEnergy_s_v,
          e = this.m_velocityBuffer.data;
        let i = 0;
        for (let s = 0; s < this.m_contactBuffer.count; s++) {
          const o = this.m_contactBuffer.data[s],
            n = o.indexA,
            r = o.indexB,
            a = o.normal,
            l = it.SubVV(e[r], e[n], t),
            m = it.DotVV(l, a);
          m < 0 && (i += m * m);
        }
        return .5 * this.GetParticleMass() * i;
      }
      SetStrictContactCheck(t) {
        this.m_def.strictContactCheck = t;
      }
      GetStrictContactCheck() {
        return this.m_def.strictContactCheck;
      }
      SetParticleLifetime(t, e) {
        const i = null === this.m_indexByExpirationTimeBuffer.data;
        if (this.m_expirationTimeBuffer.data = this.RequestBuffer(this.m_expirationTimeBuffer.data), this.m_indexByExpirationTimeBuffer.data = this.RequestBuffer(this.m_indexByExpirationTimeBuffer.data), i) {
          const t = this.GetParticleCount();
          for (let e = 0; e < t; ++e) this.m_indexByExpirationTimeBuffer.data[e] = e;
        }
        const s = e / this.m_def.lifetimeGranularity,
          o = s > 0 ? this.GetQuantizedTimeElapsed() + s : s;
        o !== this.m_expirationTimeBuffer.data[t] && (this.m_expirationTimeBuffer.data[t] = o, this.m_expirationTimeBufferRequiresSorting = !0);
      }
      GetParticleLifetime(t) {
        return this.ExpirationTimeToLifetime(this.GetExpirationTimeBuffer()[t]);
      }
      SetDestructionByAge(t) {
        t && this.GetExpirationTimeBuffer(), this.m_def.destroyByAge = t;
      }
      GetDestructionByAge() {
        return this.m_def.destroyByAge;
      }
      GetExpirationTimeBuffer() {
        return this.m_expirationTimeBuffer.data = this.RequestBuffer(this.m_expirationTimeBuffer.data), this.m_expirationTimeBuffer.data;
      }
      ExpirationTimeToLifetime(t) {
        return (t > 0 ? t - this.GetQuantizedTimeElapsed() : t) * this.m_def.lifetimeGranularity;
      }
      GetIndexByExpirationTimeBuffer() {
        if (this.GetParticleCount() ? this.SetParticleLifetime(0, this.GetParticleLifetime(0)) : this.m_indexByExpirationTimeBuffer.data = this.RequestBuffer(this.m_indexByExpirationTimeBuffer.data), !this.m_indexByExpirationTimeBuffer.data) throw new Error();
        return this.m_indexByExpirationTimeBuffer.data;
      }
      ParticleApplyLinearImpulse(t, e) {
        this.ApplyLinearImpulse(t, t + 1, e);
      }
      ApplyLinearImpulse(t, e, i) {
        if (!this.m_velocityBuffer.data) throw new Error();
        const s = this.m_velocityBuffer.data,
          o = e - t,
          n = o * this.GetParticleMass(),
          r = new it().Copy(i).SelfMul(1 / n);
        for (let i = t; i < e; i++) s[i].SelfAdd(r);
      }
      static IsSignificantForce(t) {
        return 0 !== t.x || 0 !== t.y;
      }
      ParticleApplyForce(t, e) {
        if (!this.m_flagsBuffer.data) throw new Error();
        Ys.IsSignificantForce(e) && this.ForceCanBeApplied(this.m_flagsBuffer.data[t]) && (this.PrepareForceBuffer(), this.m_forceBuffer[t].SelfAdd(e));
      }
      ApplyForce(t, e, i) {
        const s = new it().Copy(i).SelfMul(1 / (e - t));
        if (Ys.IsSignificantForce(s)) {
          this.PrepareForceBuffer();
          for (let i = t; i < e; i++) this.m_forceBuffer[i].SelfAdd(s);
        }
      }
      GetNext() {
        return this.m_next;
      }
      QueryAABB(t, e) {
        if (0 === this.m_proxyBuffer.count) return;
        const i = this.m_proxyBuffer.count,
          s = Js(this.m_proxyBuffer.data, 0, i, Ys.computeTag(this.m_inverseDiameter * e.lowerBound.x, this.m_inverseDiameter * e.lowerBound.y), Ys.Proxy.CompareProxyTag),
          o = Os(this.m_proxyBuffer.data, s, i, Ys.computeTag(this.m_inverseDiameter * e.upperBound.x, this.m_inverseDiameter * e.upperBound.y), Ys.Proxy.CompareTagProxy);
        if (!this.m_positionBuffer.data) throw new Error();
        const n = this.m_positionBuffer.data;
        for (let i = s; i < o; ++i) {
          const s = this.m_proxyBuffer.data[i],
            o = s.index,
            r = n[o];
          if (e.lowerBound.x < r.x && r.x < e.upperBound.x && e.lowerBound.y < r.y && r.y < e.upperBound.y && !t.ReportParticle(this, o)) break;
        }
      }
      QueryShapeAABB(t, e, i) {
        let s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        const o = Ys.QueryShapeAABB_s_aabb,
          n = o;
        e.ComputeAABB(n, i, s), this.QueryAABB(t, n);
      }
      QueryPointAABB(t, e) {
        let i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : h;
        const s = Ys.QueryPointAABB_s_aabb,
          o = s;
        o.lowerBound.Set(e.x - i, e.y - i), o.upperBound.Set(e.x + i, e.y + i), this.QueryAABB(t, o);
      }
      RayCast(t, e, i) {
        const s = Ys.RayCast_s_aabb,
          o = Ys.RayCast_s_p,
          n = Ys.RayCast_s_v,
          r = Ys.RayCast_s_n,
          a = Ys.RayCast_s_point;
        if (0 === this.m_proxyBuffer.count) return;
        if (!this.m_positionBuffer.data) throw new Error();
        const l = this.m_positionBuffer.data,
          m = s;
        it.MinV(e, i, m.lowerBound), it.MaxV(e, i, m.upperBound);
        let h = 1;
        const _ = it.SubVV(i, e, n),
          c = it.DotVV(_, _),
          u = this.GetInsideBoundsEnumerator(m);
        let d;
        for (; (d = u.GetNext()) >= 0;) {
          const i = it.SubVV(e, l[d], o),
            s = it.DotVV(i, _),
            n = it.DotVV(i, i),
            m = s * s - c * (n - this.m_squaredDiameter);
          if (m >= 0) {
            const o = H(m);
            let n = (-s - o) / c;
            if (n > h) continue;
            if (n < 0 && ((n = (-s + o) / c) < 0 || n > h)) continue;
            const l = it.AddVMulSV(i, n, _, r);
            l.Normalize();
            const u = t.ReportParticle(this, d, it.AddVMulSV(e, n, _, a), l, n);
            if ((h = j(h, u)) <= 0) break;
          }
        }
      }
      ComputeAABB(t) {
        const e = this.GetParticleCount();
        if (t.lowerBound.x = +i, t.lowerBound.y = +i, t.upperBound.x = -i, t.upperBound.y = -i, !this.m_positionBuffer.data) throw new Error();
        const s = this.m_positionBuffer.data;
        for (let i = 0; i < e; i++) {
          const e = s[i];
          it.MinV(t.lowerBound, e, t.lowerBound), it.MaxV(t.upperBound, e, t.upperBound);
        }
        t.lowerBound.x -= this.m_particleDiameter, t.lowerBound.y -= this.m_particleDiameter, t.upperBound.x += this.m_particleDiameter, t.upperBound.y += this.m_particleDiameter;
      }
      FreeBuffer(t, e) {
        null !== t && (t.length = 0);
      }
      FreeUserOverridableBuffer(t) {
        0 === t.userSuppliedCapacity && this.FreeBuffer(t.data, this.m_internalAllocatedCapacity);
      }
      ReallocateBuffer3(t, e, i) {
        if (i <= e) throw new Error();
        const s = t ? t.slice() : [];
        return s.length = i, s;
      }
      ReallocateBuffer5(t, e, i, s, o) {
        if (s <= i) throw new Error();
        if (e && !(s <= e)) throw new Error();
        return o && !t || e || (t = this.ReallocateBuffer3(t, i, s)), t;
      }
      ReallocateBuffer4(t, e, i, s) {
        return this.ReallocateBuffer5(t.data, t.userSuppliedCapacity, e, i, s);
      }
      RequestBuffer(t) {
        return t || (0 === this.m_internalAllocatedCapacity && this.ReallocateInternalAllocatedBuffers(I), (t = []).length = this.m_internalAllocatedCapacity), t;
      }
      ReallocateHandleBuffers(t) {
        this.m_handleIndexBuffer.data = this.ReallocateBuffer4(this.m_handleIndexBuffer, this.m_internalAllocatedCapacity, t, !0);
      }
      ReallocateInternalAllocatedBuffers(t) {
        function e(t, e) {
          return e && t > e ? e : t;
        }
        if (t = e(t, this.m_def.maxCount), t = e(t, this.m_flagsBuffer.userSuppliedCapacity), t = e(t, this.m_positionBuffer.userSuppliedCapacity), t = e(t, this.m_velocityBuffer.userSuppliedCapacity), t = e(t, this.m_colorBuffer.userSuppliedCapacity), t = e(t, this.m_userDataBuffer.userSuppliedCapacity), this.m_internalAllocatedCapacity < t) {
          this.ReallocateHandleBuffers(t), this.m_flagsBuffer.data = this.ReallocateBuffer4(this.m_flagsBuffer, this.m_internalAllocatedCapacity, t, !1);
          const e = this.m_stuckThreshold > 0;
          this.m_lastBodyContactStepBuffer.data = this.ReallocateBuffer4(this.m_lastBodyContactStepBuffer, this.m_internalAllocatedCapacity, t, e), this.m_bodyContactCountBuffer.data = this.ReallocateBuffer4(this.m_bodyContactCountBuffer, this.m_internalAllocatedCapacity, t, e), this.m_consecutiveContactStepsBuffer.data = this.ReallocateBuffer4(this.m_consecutiveContactStepsBuffer, this.m_internalAllocatedCapacity, t, e), this.m_positionBuffer.data = this.ReallocateBuffer4(this.m_positionBuffer, this.m_internalAllocatedCapacity, t, !1), this.m_velocityBuffer.data = this.ReallocateBuffer4(this.m_velocityBuffer, this.m_internalAllocatedCapacity, t, !1), this.m_forceBuffer = this.ReallocateBuffer5(this.m_forceBuffer, 0, this.m_internalAllocatedCapacity, t, !1), this.m_weightBuffer = this.ReallocateBuffer5(this.m_weightBuffer, 0, this.m_internalAllocatedCapacity, t, !1), this.m_staticPressureBuffer = this.ReallocateBuffer5(this.m_staticPressureBuffer, 0, this.m_internalAllocatedCapacity, t, !0), this.m_accumulationBuffer = this.ReallocateBuffer5(this.m_accumulationBuffer, 0, this.m_internalAllocatedCapacity, t, !1), this.m_accumulation2Buffer = this.ReallocateBuffer5(this.m_accumulation2Buffer, 0, this.m_internalAllocatedCapacity, t, !0), this.m_depthBuffer = this.ReallocateBuffer5(this.m_depthBuffer, 0, this.m_internalAllocatedCapacity, t, !0), this.m_colorBuffer.data = this.ReallocateBuffer4(this.m_colorBuffer, this.m_internalAllocatedCapacity, t, !0), this.m_groupBuffer = this.ReallocateBuffer5(this.m_groupBuffer, 0, this.m_internalAllocatedCapacity, t, !1), this.m_userDataBuffer.data = this.ReallocateBuffer4(this.m_userDataBuffer, this.m_internalAllocatedCapacity, t, !0), this.m_expirationTimeBuffer.data = this.ReallocateBuffer4(this.m_expirationTimeBuffer, this.m_internalAllocatedCapacity, t, !0), this.m_indexByExpirationTimeBuffer.data = this.ReallocateBuffer4(this.m_indexByExpirationTimeBuffer, this.m_internalAllocatedCapacity, t, !1), this.m_internalAllocatedCapacity = t;
        }
      }
      CreateParticleForGroup(t, i, s) {
        const o = new Ps();
        o.flags = e(t.flags, 0), lt.MulXV(i, s, o.position), it.AddVV(e(t.linearVelocity, it.ZERO), it.CrossSV(e(t.angularVelocity, 0), it.SubVV(o.position, e(t.position, it.ZERO), it.s_t0), it.s_t0), o.velocity), o.color.Copy(e(t.color, ht.ZERO)), o.lifetime = e(t.lifetime, 0), o.userData = t.userData, this.CreateParticle(o);
      }
      CreateParticlesStrokeShapeForGroup(i, s, o) {
        const n = Ys.CreateParticlesStrokeShapeForGroup_s_edge,
          r = Ys.CreateParticlesStrokeShapeForGroup_s_d,
          a = Ys.CreateParticlesStrokeShapeForGroup_s_p;
        let l = e(s.stride, 0);
        0 === l && (l = this.GetParticleStride());
        let m = 0;
        const h = i.GetChildCount();
        for (let e = 0; e < h; e++) {
          let h = null;
          i.GetType() === t.b2ShapeType.e_edgeShape ? h = i : (h = n, i.GetChildEdge(h, e));
          const _ = it.SubVV(h.m_vertex2, h.m_vertex1, r),
            c = _.Length();
          for (; m < c;) {
            const t = it.AddVMulSV(h.m_vertex1, m / c, _, a);
            this.CreateParticleForGroup(s, o, t), m += l;
          }
          m -= c;
        }
      }
      CreateParticlesFillShapeForGroup(t, i, s) {
        const o = Ys.CreateParticlesFillShapeForGroup_s_aabb,
          n = Ys.CreateParticlesFillShapeForGroup_s_p;
        let r = e(i.stride, 0);
        0 === r && (r = this.GetParticleStride());
        const a = lt.IDENTITY,
          l = o;
        t.ComputeAABB(l, a, 0);
        for (let e = Math.floor(l.lowerBound.y / r) * r; e < l.upperBound.y; e += r) for (let o = Math.floor(l.lowerBound.x / r) * r; o < l.upperBound.x; o += r) {
          const r = n.Set(o, e);
          t.TestPoint(a, r) && this.CreateParticleForGroup(i, s, r);
        }
      }
      CreateParticlesWithShapeForGroup(e, i, s) {
        switch (e.GetType()) {
          case t.b2ShapeType.e_edgeShape:
          case t.b2ShapeType.e_chainShape:
            this.CreateParticlesStrokeShapeForGroup(e, i, s);
            break;
          case t.b2ShapeType.e_polygonShape:
          case t.b2ShapeType.e_circleShape:
            this.CreateParticlesFillShapeForGroup(e, i, s);
        }
      }
      CreateParticlesWithShapesForGroup(t, e, i, s) {
        const o = new Ys.CompositeShape(t, e);
        this.CreateParticlesFillShapeForGroup(o, i, s);
      }
      CloneParticle(t, e) {
        const i = new Ps();
        if (!this.m_flagsBuffer.data) throw new Error();
        if (!this.m_positionBuffer.data) throw new Error();
        if (!this.m_velocityBuffer.data) throw new Error();
        i.flags = this.m_flagsBuffer.data[t], i.position.Copy(this.m_positionBuffer.data[t]), i.velocity.Copy(this.m_velocityBuffer.data[t]), this.m_colorBuffer.data && i.color.Copy(this.m_colorBuffer.data[t]), this.m_userDataBuffer.data && (i.userData = this.m_userDataBuffer.data[t]), i.group = e;
        const s = this.CreateParticle(i);
        if (this.m_handleIndexBuffer.data) {
          const e = this.m_handleIndexBuffer.data[t];
          e && e.SetIndex(s), this.m_handleIndexBuffer.data[s] = e, this.m_handleIndexBuffer.data[t] = null;
        }
        return this.m_lastBodyContactStepBuffer.data && (this.m_lastBodyContactStepBuffer.data[s] = this.m_lastBodyContactStepBuffer.data[t]), this.m_bodyContactCountBuffer.data && (this.m_bodyContactCountBuffer.data[s] = this.m_bodyContactCountBuffer.data[t]), this.m_consecutiveContactStepsBuffer.data && (this.m_consecutiveContactStepsBuffer.data[s] = this.m_consecutiveContactStepsBuffer.data[t]), this.m_hasForce && this.m_forceBuffer[s].Copy(this.m_forceBuffer[t]), this.m_staticPressureBuffer && (this.m_staticPressureBuffer[s] = this.m_staticPressureBuffer[t]), this.m_depthBuffer && (this.m_depthBuffer[s] = this.m_depthBuffer[t]), this.m_expirationTimeBuffer.data && (this.m_expirationTimeBuffer.data[s] = this.m_expirationTimeBuffer.data[t]), s;
      }
      DestroyParticlesInGroup(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        for (let i = t.m_firstIndex; i < t.m_lastIndex; i++) this.DestroyParticle(i, e);
      }
      DestroyParticleGroup(t) {
        this.m_world.m_destructionListener && this.m_world.m_destructionListener.SayGoodbyeParticleGroup(t), this.SetGroupFlags(t, 0);
        for (let e = t.m_firstIndex; e < t.m_lastIndex; e++) this.m_groupBuffer[e] = null;
        t.m_prev && (t.m_prev.m_next = t.m_next), t.m_next && (t.m_next.m_prev = t.m_prev), t === this.m_groupList && (this.m_groupList = t.m_next), --this.m_groupCount;
      }
      static ParticleCanBeConnected(e, i) {
        return 0 != (e & (t.b2ParticleFlag.b2_wallParticle | t.b2ParticleFlag.b2_springParticle | t.b2ParticleFlag.b2_elasticParticle)) || null !== i && 0 != (i.GetGroupFlags() & t.b2ParticleGroupFlag.b2_rigidParticleGroup);
      }
      UpdatePairsAndTriads(e, i, s) {
        const o = Ys.UpdatePairsAndTriads_s_dab,
          n = Ys.UpdatePairsAndTriads_s_dbc,
          r = Ys.UpdatePairsAndTriads_s_dca;
        if (!this.m_flagsBuffer.data) throw new Error();
        if (!this.m_positionBuffer.data) throw new Error();
        if (!this.m_velocityBuffer.data) throw new Error();
        const a = this.m_positionBuffer.data;
        let l = 0;
        for (let t = e; t < i; t++) l |= this.m_flagsBuffer.data[t];
        if (l & Ys.k_pairFlags) for (let o = 0; o < this.m_contactBuffer.count; o++) {
          const n = this.m_contactBuffer.data[o],
            r = n.indexA,
            l = n.indexB,
            m = this.m_flagsBuffer.data[r],
            h = this.m_flagsBuffer.data[l],
            _ = this.m_groupBuffer[r],
            c = this.m_groupBuffer[l];
          if (r >= e && r < i && l >= e && l < i && !((m | h) & t.b2ParticleFlag.b2_zombieParticle) && (m | h) & Ys.k_pairFlags && (s.IsNecessary(r) || s.IsNecessary(l)) && Ys.ParticleCanBeConnected(m, _) && Ys.ParticleCanBeConnected(h, c) && s.ShouldCreatePair(r, l)) {
            const t = this.m_pairBuffer.data[this.m_pairBuffer.Append()];
            t.indexA = r, t.indexB = l, t.flags = n.flags, t.strength = j(_ ? _.m_strength : 1, c ? c.m_strength : 1), t.distance = it.DistanceVV(a[r], a[l]);
          }
          zs(this.m_pairBuffer.data, 0, this.m_pairBuffer.count, Ys.ComparePairIndices), this.m_pairBuffer.Unique(Ys.MatchPairIndices);
        }
        if (l & Ys.k_triadFlags) {
          const l = new Ls(i - e);
          for (let o = e; o < i; o++) {
            const e = this.m_flagsBuffer.data[o],
              i = this.m_groupBuffer[o];
            e & t.b2ParticleFlag.b2_zombieParticle || !Ys.ParticleCanBeConnected(e, i) || l.AddGenerator(a[o], o, s.IsNecessary(o));
          }
          const m = this.GetParticleStride();
          l.Generate(m / 2, 2 * m);
          const h = this,
            _ = (t, e, i) => {
              if (!h.m_flagsBuffer.data) throw new Error();
              const l = h.m_flagsBuffer.data[t],
                m = h.m_flagsBuffer.data[e],
                _ = h.m_flagsBuffer.data[i];
              if ((l | m | _) & Ys.k_triadFlags && s.ShouldCreateTriad(t, e, i)) {
                const s = a[t],
                  c = a[e],
                  u = a[i],
                  d = it.SubVV(s, c, o),
                  p = it.SubVV(c, u, n),
                  f = it.SubVV(u, s, r),
                  y = P * h.m_squaredDiameter;
                if (it.DotVV(d, d) > y || it.DotVV(p, p) > y || it.DotVV(f, f) > y) return;
                const x = h.m_groupBuffer[t],
                  B = h.m_groupBuffer[e],
                  S = h.m_groupBuffer[i],
                  b = h.m_triadBuffer.data[h.m_triadBuffer.Append()];
                b.indexA = t, b.indexB = e, b.indexC = i, b.flags = l | m | _, b.strength = j(j(x ? x.m_strength : 1, B ? B.m_strength : 1), S ? S.m_strength : 1);
                const A = (s.x + c.x + u.x) / 3,
                  C = (s.y + c.y + u.y) / 3;
                b.pa.x = s.x - A, b.pa.y = s.y - C, b.pb.x = c.x - A, b.pb.y = c.y - C, b.pc.x = u.x - A, b.pc.y = u.y - C, b.ka = -it.DotVV(f, d), b.kb = -it.DotVV(d, p), b.kc = -it.DotVV(p, f), b.s = it.CrossVV(s, c) + it.CrossVV(c, u) + it.CrossVV(u, s);
              }
            };
          l.GetNodes(_), zs(this.m_triadBuffer.data, 0, this.m_triadBuffer.count, Ys.CompareTriadIndices), this.m_triadBuffer.Unique(Ys.MatchTriadIndices);
        }
      }
      UpdatePairsAndTriadsWithReactiveParticles() {
        const e = new Ys.ReactiveFilter(this.m_flagsBuffer);
        if (this.UpdatePairsAndTriads(0, this.m_count, e), !this.m_flagsBuffer.data) throw new Error();
        for (let e = 0; e < this.m_count; e++) this.m_flagsBuffer.data[e] &= ~t.b2ParticleFlag.b2_reactiveParticle;
        this.m_allParticleFlags &= ~t.b2ParticleFlag.b2_reactiveParticle;
      }
      static ComparePairIndices(t, e) {
        const i = t.indexA - e.indexA;
        return 0 !== i ? i < 0 : t.indexB < e.indexB;
      }
      static MatchPairIndices(t, e) {
        return t.indexA === e.indexA && t.indexB === e.indexB;
      }
      static CompareTriadIndices(t, e) {
        const i = t.indexA - e.indexA;
        if (0 !== i) return i < 0;
        const s = t.indexB - e.indexB;
        return 0 !== s ? s < 0 : t.indexC < e.indexC;
      }
      static MatchTriadIndices(t, e) {
        return t.indexA === e.indexA && t.indexB === e.indexB && t.indexC === e.indexC;
      }
      static InitializeParticleLists(t, e) {
        const i = t.GetBufferIndex(),
          s = t.GetParticleCount();
        for (let t = 0; t < s; t++) {
          const s = e[t];
          s.list = s, s.next = null, s.count = 1, s.index = t + i;
        }
      }
      MergeParticleListsInContact(t, e) {
        const i = t.GetBufferIndex();
        for (let s = 0; s < this.m_contactBuffer.count; s++) {
          const o = this.m_contactBuffer.data[s],
            n = o.indexA,
            r = o.indexB;
          if (!t.ContainsParticle(n) || !t.ContainsParticle(r)) continue;
          let a = e[n - i].list,
            l = e[r - i].list;
          if (a !== l) {
            if (a.count < l.count) {
              const t = a;
              a = l, l = t;
            }
            Ys.MergeParticleLists(a, l);
          }
        }
      }
      static MergeParticleLists(t, e) {
        for (let i = e;;) {
          i.list = t;
          const e = i.next;
          if (!e) {
            i.next = t.next;
            break;
          }
          i = e;
        }
        t.next = e, t.count += e.count, e.count = 0;
      }
      static FindLongestParticleList(t, e) {
        const i = t.GetParticleCount();
        let s = e[0];
        for (let t = 0; t < i; t++) {
          const i = e[t];
          s.count < i.count && (s = i);
        }
        return s;
      }
      MergeZombieParticleListNodes(e, i, s) {
        if (!this.m_flagsBuffer.data) throw new Error();
        const o = e.GetParticleCount();
        for (let e = 0; e < o; e++) {
          const o = i[e];
          o !== s && this.m_flagsBuffer.data[o.index] & t.b2ParticleFlag.b2_zombieParticle && Ys.MergeParticleListAndNode(s, o);
        }
      }
      static MergeParticleListAndNode(t, e) {
        e.list = t, e.next = t.next, t.next = e, t.count++, e.count = 0;
      }
      CreateParticleGroupsFromParticleList(e, i, s) {
        if (!this.m_flagsBuffer.data) throw new Error();
        const o = e.GetParticleCount(),
          n = new Ds();
        n.groupFlags = e.GetGroupFlags(), n.userData = e.GetUserData();
        for (let e = 0; e < o; e++) {
          const o = i[e];
          if (!o.count || o === s) continue;
          const r = this.CreateParticleGroup(n);
          for (let e = o; e; e = e.next) {
            const i = e.index,
              s = this.CloneParticle(i, r);
            this.m_flagsBuffer.data[i] |= t.b2ParticleFlag.b2_zombieParticle, e.index = s;
          }
        }
      }
      UpdatePairsAndTriadsWithParticleList(t, e) {
        const i = t.GetBufferIndex();
        for (let s = 0; s < this.m_pairBuffer.count; s++) {
          const o = this.m_pairBuffer.data[s],
            n = o.indexA,
            r = o.indexB;
          t.ContainsParticle(n) && (o.indexA = e[n - i].index), t.ContainsParticle(r) && (o.indexB = e[r - i].index);
        }
        for (let s = 0; s < this.m_triadBuffer.count; s++) {
          const o = this.m_triadBuffer.data[s],
            n = o.indexA,
            r = o.indexB,
            a = o.indexC;
          t.ContainsParticle(n) && (o.indexA = e[n - i].index), t.ContainsParticle(r) && (o.indexB = e[r - i].index), t.ContainsParticle(a) && (o.indexC = e[a - i].index);
        }
      }
      ComputeDepth() {
        const e = [];
        let s = 0;
        for (let i = 0; i < this.m_contactBuffer.count; i++) {
          const o = this.m_contactBuffer.data[i],
            n = o.indexA,
            r = o.indexB,
            a = this.m_groupBuffer[n],
            l = this.m_groupBuffer[r];
          a && a === l && a.m_groupFlags & t.b2ParticleGroupFlag.b2_particleGroupNeedsUpdateDepth && (e[s++] = o);
        }
        const o = [];
        let n = 0;
        for (let e = this.m_groupList; e; e = e.GetNext()) if (e.m_groupFlags & t.b2ParticleGroupFlag.b2_particleGroupNeedsUpdateDepth) {
          o[n++] = e, this.SetGroupFlags(e, e.m_groupFlags & ~t.b2ParticleGroupFlag.b2_particleGroupNeedsUpdateDepth);
          for (let t = e.m_firstIndex; t < e.m_lastIndex; t++) this.m_accumulationBuffer[t] = 0;
        }
        for (let t = 0; t < s; t++) {
          const i = e[t],
            s = i.indexA,
            o = i.indexB,
            n = i.weight;
          this.m_accumulationBuffer[s] += n, this.m_accumulationBuffer[o] += n;
        }
        for (let t = 0; t < n; t++) {
          const e = o[t];
          for (let t = e.m_firstIndex; t < e.m_lastIndex; t++) {
            const e = this.m_accumulationBuffer[t];
            this.m_depthBuffer[t] = e < .8 ? 0 : i;
          }
        }
        const r = H(this.m_count) >> 0;
        for (let t = 0; t < r; t++) {
          let t = !1;
          for (let i = 0; i < s; i++) {
            const s = e[i],
              o = s.indexA,
              n = s.indexB,
              r = 1 - s.weight,
              a = this.m_depthBuffer[o],
              l = this.m_depthBuffer[n],
              m = l + r,
              h = a + r;
            a > m && (this.m_depthBuffer[o] = m, t = !0), l > h && (this.m_depthBuffer[n] = h, t = !0);
          }
          if (!t) break;
        }
        for (let t = 0; t < n; t++) {
          const e = o[t];
          for (let t = e.m_firstIndex; t < e.m_lastIndex; t++) this.m_depthBuffer[t] < i ? this.m_depthBuffer[t] *= this.m_particleDiameter : this.m_depthBuffer[t] = 0;
        }
      }
      GetInsideBoundsEnumerator(t) {
        const e = Ys.computeTag(this.m_inverseDiameter * t.lowerBound.x - 1, this.m_inverseDiameter * t.lowerBound.y - 1),
          i = Ys.computeTag(this.m_inverseDiameter * t.upperBound.x + 1, this.m_inverseDiameter * t.upperBound.y + 1),
          s = this.m_proxyBuffer.count,
          o = Js(this.m_proxyBuffer.data, 0, s, e, Ys.Proxy.CompareProxyTag),
          n = Os(this.m_proxyBuffer.data, 0, s, i, Ys.Proxy.CompareTagProxy);
        return new Ys.InsideBoundsEnumerator(this, e, i, o, n);
      }
      UpdateAllParticleFlags() {
        if (!this.m_flagsBuffer.data) throw new Error();
        this.m_allParticleFlags = 0;
        for (let t = 0; t < this.m_count; t++) this.m_allParticleFlags |= this.m_flagsBuffer.data[t];
        this.m_needsUpdateAllParticleFlags = !1;
      }
      UpdateAllGroupFlags() {
        this.m_allGroupFlags = 0;
        for (let t = this.m_groupList; t; t = t.GetNext()) this.m_allGroupFlags |= t.m_groupFlags;
        this.m_needsUpdateAllGroupFlags = !1;
      }
      AddContact(t, e, i) {
        if (!this.m_flagsBuffer.data) throw new Error();
        if (!this.m_positionBuffer.data) throw new Error();
        const s = Ys.AddContact_s_d,
          o = this.m_positionBuffer.data,
          n = it.SubVV(o[e], o[t], s),
          r = it.DotVV(n, n);
        if (r < this.m_squaredDiameter) {
          let i = Z(r);
          isFinite(i) || (i = 198177537e11);
          const s = this.m_contactBuffer.data[this.m_contactBuffer.Append()];
          s.indexA = t, s.indexB = e, s.flags = this.m_flagsBuffer.data[t] | this.m_flagsBuffer.data[e], s.weight = 1 - r * i * this.m_inverseDiameter, it.MulSV(i, n, s.normal);
        }
      }
      FindContacts_Reference(t) {
        const e = this.m_proxyBuffer.count;
        this.m_contactBuffer.count = 0;
        for (let t = 0, i = 0; t < e; t++) {
          const s = Ys.computeRelativeTag(this.m_proxyBuffer.data[t].tag, 1, 0);
          for (let i = t + 1; i < e && !(s < this.m_proxyBuffer.data[i].tag); i++) this.AddContact(this.m_proxyBuffer.data[t].index, this.m_proxyBuffer.data[i].index, this.m_contactBuffer);
          const o = Ys.computeRelativeTag(this.m_proxyBuffer.data[t].tag, -1, 1);
          for (; i < e && !(o <= this.m_proxyBuffer.data[i].tag); i++);
          const n = Ys.computeRelativeTag(this.m_proxyBuffer.data[t].tag, 1, 1);
          for (let s = i; s < e && !(n < this.m_proxyBuffer.data[s].tag); s++) this.AddContact(this.m_proxyBuffer.data[t].index, this.m_proxyBuffer.data[s].index, this.m_contactBuffer);
        }
      }
      FindContacts(t) {
        this.FindContacts_Reference(t);
      }
      UpdateProxies_Reference(t) {
        if (!this.m_positionBuffer.data) throw new Error();
        const e = this.m_positionBuffer.data,
          i = this.m_inverseDiameter;
        for (let t = 0; t < this.m_proxyBuffer.count; ++t) {
          const s = this.m_proxyBuffer.data[t],
            o = s.index,
            n = e[o];
          s.tag = Ys.computeTag(i * n.x, i * n.y);
        }
      }
      UpdateProxies(t) {
        this.UpdateProxies_Reference(t);
      }
      SortProxies(t) {
        qs(this.m_proxyBuffer.data, 0, this.m_proxyBuffer.count, Ys.Proxy.CompareProxyProxy);
      }
      FilterContacts(e) {
        const i = this.GetParticleContactFilter();
        if (null === i) return;
        const s = this;
        this.m_contactBuffer.RemoveIf(e => 0 != (e.flags & t.b2ParticleFlag.b2_particleContactFilterParticle) && !i.ShouldCollideParticleParticle(s, e.indexA, e.indexB));
      }
      NotifyContactListenerPreContact(t) {
        const e = this.GetParticleContactListener();
        if (null !== e) throw t.Initialize(this.m_contactBuffer, this.m_flagsBuffer), new Error();
      }
      NotifyContactListenerPostContact(t) {
        const e = this.GetParticleContactListener();
        if (null !== e) {
          for (let t = 0; t < this.m_contactBuffer.count; ++t) {
            const i = this.m_contactBuffer.data[t];
            e.BeginContactParticleParticle(this, i);
          }
          throw new Error();
        }
      }
      static b2ParticleContactIsZombie(e) {
        return (e.flags & t.b2ParticleFlag.b2_zombieParticle) === t.b2ParticleFlag.b2_zombieParticle;
      }
      UpdateContacts(t) {
        this.UpdateProxies(this.m_proxyBuffer), this.SortProxies(this.m_proxyBuffer);
        const e = new Ys.b2ParticlePairSet();
        this.NotifyContactListenerPreContact(e), this.FindContacts(this.m_contactBuffer), this.FilterContacts(this.m_contactBuffer), this.NotifyContactListenerPostContact(e), t && this.m_contactBuffer.RemoveIf(Ys.b2ParticleContactIsZombie);
      }
      NotifyBodyContactListenerPreContact(t) {
        const e = this.GetFixtureContactListener();
        if (null !== e) throw t.Initialize(this.m_bodyContactBuffer, this.m_flagsBuffer), new Error();
      }
      NotifyBodyContactListenerPostContact(t) {
        const e = this.GetFixtureContactListener();
        if (null !== e) {
          for (let t = 0; t < this.m_bodyContactBuffer.count; t++) {
            const i = this.m_bodyContactBuffer.data[t];
            e.BeginContactFixtureParticle(this, i);
          }
          throw new Error();
        }
      }
      UpdateBodyContacts() {
        const t = Ys.UpdateBodyContacts_s_aabb,
          e = new Ys.FixtureParticleSet();
        if (this.NotifyBodyContactListenerPreContact(e), this.m_stuckThreshold > 0) {
          if (!this.m_bodyContactCountBuffer.data) throw new Error();
          if (!this.m_lastBodyContactStepBuffer.data) throw new Error();
          if (!this.m_consecutiveContactStepsBuffer.data) throw new Error();
          const t = this.GetParticleCount();
          for (let e = 0; e < t; e++) this.m_bodyContactCountBuffer.data[e] = 0, this.m_timestamp > this.m_lastBodyContactStepBuffer.data[e] + 1 && (this.m_consecutiveContactStepsBuffer.data[e] = 0);
        }
        this.m_bodyContactBuffer.SetCount(0), this.m_stuckParticleBuffer.SetCount(0);
        const i = t;
        this.ComputeAABB(i);
        const s = new Ys.UpdateBodyContactsCallback(this, this.GetFixtureContactFilter());
        this.m_world.QueryAABB(s, i), this.m_def.strictContactCheck && this.RemoveSpuriousBodyContacts(), this.NotifyBodyContactListenerPostContact(e);
      }
      Solve(e) {
        const i = Ys.Solve_s_subStep;
        if (0 !== this.m_count && (this.m_expirationTimeBuffer.data && this.SolveLifetimes(e), this.m_allParticleFlags & t.b2ParticleFlag.b2_zombieParticle && this.SolveZombie(), this.m_needsUpdateAllParticleFlags && this.UpdateAllParticleFlags(), this.m_needsUpdateAllGroupFlags && this.UpdateAllGroupFlags(), !this.m_paused)) for (this.m_iterationIndex = 0; this.m_iterationIndex < e.particleIterations; this.m_iterationIndex++) {
          ++this.m_timestamp;
          const s = i.Copy(e);
          if (s.dt /= e.particleIterations, s.inv_dt *= e.particleIterations, this.UpdateContacts(!1), this.UpdateBodyContacts(), this.ComputeWeight(), this.m_allGroupFlags & t.b2ParticleGroupFlag.b2_particleGroupNeedsUpdateDepth && this.ComputeDepth(), this.m_allParticleFlags & t.b2ParticleFlag.b2_reactiveParticle && this.UpdatePairsAndTriadsWithReactiveParticles(), this.m_hasForce && this.SolveForce(s), this.m_allParticleFlags & t.b2ParticleFlag.b2_viscousParticle && this.SolveViscous(), this.m_allParticleFlags & t.b2ParticleFlag.b2_repulsiveParticle && this.SolveRepulsive(s), this.m_allParticleFlags & t.b2ParticleFlag.b2_powderParticle && this.SolvePowder(s), this.m_allParticleFlags & t.b2ParticleFlag.b2_tensileParticle && this.SolveTensile(s), this.m_allGroupFlags & t.b2ParticleGroupFlag.b2_solidParticleGroup && this.SolveSolid(s), this.m_allParticleFlags & t.b2ParticleFlag.b2_colorMixingParticle && this.SolveColorMixing(), this.SolveGravity(s), this.m_allParticleFlags & t.b2ParticleFlag.b2_staticPressureParticle && this.SolveStaticPressure(s), this.SolvePressure(s), this.SolveDamping(s), this.m_allParticleFlags & Ys.k_extraDampingFlags && this.SolveExtraDamping(), this.m_allParticleFlags & t.b2ParticleFlag.b2_elasticParticle && this.SolveElastic(s), this.m_allParticleFlags & t.b2ParticleFlag.b2_springParticle && this.SolveSpring(s), this.LimitVelocity(s), this.m_allGroupFlags & t.b2ParticleGroupFlag.b2_rigidParticleGroup && this.SolveRigidDamping(), this.m_allParticleFlags & t.b2ParticleFlag.b2_barrierParticle && this.SolveBarrier(s), this.SolveCollision(s), this.m_allGroupFlags & t.b2ParticleGroupFlag.b2_rigidParticleGroup && this.SolveRigid(s), this.m_allParticleFlags & t.b2ParticleFlag.b2_wallParticle && this.SolveWall(), !this.m_positionBuffer.data) throw new Error();
          if (!this.m_velocityBuffer.data) throw new Error();
          for (let t = 0; t < this.m_count; t++) this.m_positionBuffer.data[t].SelfMulAdd(s.dt, this.m_velocityBuffer.data[t]);
        }
      }
      SolveCollision(t) {
        const e = Ys.SolveCollision_s_aabb;
        if (!this.m_positionBuffer.data) throw new Error();
        if (!this.m_velocityBuffer.data) throw new Error();
        const s = this.m_positionBuffer.data,
          o = this.m_velocityBuffer.data,
          n = e;
        n.lowerBound.x = +i, n.lowerBound.y = +i, n.upperBound.x = -i, n.upperBound.y = -i;
        for (let e = 0; e < this.m_count; e++) {
          const i = o[e],
            r = s[e],
            a = r.x + t.dt * i.x,
            l = r.y + t.dt * i.y;
          n.lowerBound.x = j(n.lowerBound.x, j(r.x, a)), n.lowerBound.y = j(n.lowerBound.y, j(r.y, l)), n.upperBound.x = N(n.upperBound.x, N(r.x, a)), n.upperBound.y = N(n.upperBound.y, N(r.y, l));
        }
        const r = new Ys.SolveCollisionCallback(this, t);
        this.m_world.QueryAABB(r, n);
      }
      LimitVelocity(t) {
        if (!this.m_velocityBuffer.data) throw new Error();
        const e = this.m_velocityBuffer.data,
          i = this.GetCriticalVelocitySquared(t);
        for (let t = 0; t < this.m_count; t++) {
          const s = e[t],
            o = it.DotVV(s, s);
          o > i && s.SelfMul(H(i / o));
        }
      }
      SolveGravity(t) {
        if (!this.m_velocityBuffer.data) throw new Error();
        const e = Ys.SolveGravity_s_gravity,
          i = this.m_velocityBuffer.data,
          s = it.MulSV(t.dt * this.m_def.gravityScale, this.m_world.GetGravity(), e);
        for (let t = 0; t < this.m_count; t++) i[t].SelfAdd(s);
      }
      SolveBarrier(e) {
        const i = Ys.SolveBarrier_s_aabb,
          s = Ys.SolveBarrier_s_va,
          o = Ys.SolveBarrier_s_vb,
          n = Ys.SolveBarrier_s_pba,
          r = Ys.SolveBarrier_s_vba,
          a = Ys.SolveBarrier_s_vc,
          l = Ys.SolveBarrier_s_pca,
          m = Ys.SolveBarrier_s_vca,
          h = Ys.SolveBarrier_s_qba,
          _ = Ys.SolveBarrier_s_qca,
          c = Ys.SolveBarrier_s_dv,
          u = Ys.SolveBarrier_s_f;
        if (!this.m_flagsBuffer.data) throw new Error();
        if (!this.m_positionBuffer.data) throw new Error();
        if (!this.m_velocityBuffer.data) throw new Error();
        const d = this.m_positionBuffer.data,
          p = this.m_velocityBuffer.data;
        for (let t = 0; t < this.m_count; t++) {
          const e = this.m_flagsBuffer.data[t];
          0 != (e & Ys.k_barrierWallFlags) && p[t].SetZero();
        }
        const f = G * e.dt,
          y = this.GetParticleMass();
        for (let x = 0; x < this.m_pairBuffer.count; x++) {
          const B = this.m_pairBuffer.data[x];
          if (B.flags & t.b2ParticleFlag.b2_barrierParticle) {
            const t = B.indexA,
              x = B.indexB,
              S = d[t],
              b = d[x],
              A = i;
            it.MinV(S, b, A.lowerBound), it.MaxV(S, b, A.upperBound);
            const C = this.m_groupBuffer[t],
              V = this.m_groupBuffer[x],
              g = this.GetLinearVelocity(C, t, S, s),
              w = this.GetLinearVelocity(V, x, b, o),
              v = it.SubVV(b, S, n),
              M = it.SubVV(w, g, r),
              P = this.GetInsideBoundsEnumerator(A);
            let I;
            for (; (I = P.GetNext()) >= 0;) {
              const t = d[I],
                i = this.m_groupBuffer[I];
              if (C !== i && V !== i) {
                const s = this.GetLinearVelocity(i, I, t, a),
                  o = it.SubVV(t, S, l),
                  n = it.SubVV(s, g, m),
                  r = it.CrossVV(M, n),
                  d = it.CrossVV(v, n) - it.CrossVV(o, M),
                  x = it.CrossVV(v, o);
                let B, b;
                const A = h,
                  C = _;
                if (0 === r) {
                  if (0 === d) continue;
                  if (!((b = -x / d) >= 0 && b < f)) continue;
                  if (it.AddVMulSV(v, b, M, A), it.AddVMulSV(o, b, n, C), !((B = it.DotVV(A, C) / it.DotVV(A, A)) >= 0 && B <= 1)) continue;
                } else {
                  const t = d * d - 4 * x * r;
                  if (t < 0) continue;
                  const e = H(t);
                  let i = (-d - e) / (2 * r),
                    s = (-d + e) / (2 * r);
                  if (i > s) {
                    const t = i;
                    i = s, s = t;
                  }
                  if (b = i, it.AddVMulSV(v, b, M, A), it.AddVMulSV(o, b, n, C), B = it.DotVV(A, C) / it.DotVV(A, A), !(b >= 0 && b < f && B >= 0 && B <= 1)) {
                    if (!((b = s) >= 0 && b < f)) continue;
                    if (it.AddVMulSV(v, b, M, A), it.AddVMulSV(o, b, n, C), !((B = it.DotVV(A, C) / it.DotVV(A, A)) >= 0 && B <= 1)) continue;
                  }
                }
                const V = c;
                V.x = g.x + B * M.x - s.x, V.y = g.y + B * M.y - s.y;
                const w = it.MulSV(y, V, u);
                if (i && this.IsRigidGroup(i)) {
                  const e = i.GetMass(),
                    s = i.GetInertia();
                  e > 0 && i.m_linearVelocity.SelfMulAdd(1 / e, w), s > 0 && (i.m_angularVelocity += it.CrossVV(it.SubVV(t, i.GetCenter(), it.s_t0), w) / s);
                } else p[I].SelfAdd(V);
                this.ParticleApplyForce(I, w.SelfMul(-e.inv_dt));
              }
            }
          }
        }
      }
      SolveStaticPressure(e) {
        if (!this.m_flagsBuffer.data) throw new Error();
        this.m_staticPressureBuffer = this.RequestBuffer(this.m_staticPressureBuffer);
        const i = this.GetCriticalPressure(e),
          s = this.m_def.staticPressureStrength * i,
          o = v * i,
          n = this.m_def.staticPressureRelaxation;
        for (let e = 0; e < this.m_def.staticPressureIterations; e++) {
          for (let t = 0; t < this.m_count; t++) this.m_accumulationBuffer[t] = 0;
          for (let e = 0; e < this.m_contactBuffer.count; e++) {
            const i = this.m_contactBuffer.data[e];
            if (i.flags & t.b2ParticleFlag.b2_staticPressureParticle) {
              const t = i.indexA,
                e = i.indexB,
                s = i.weight;
              this.m_accumulationBuffer[t] += s * this.m_staticPressureBuffer[e], this.m_accumulationBuffer[e] += s * this.m_staticPressureBuffer[t];
            }
          }
          for (let e = 0; e < this.m_count; e++) {
            const i = this.m_weightBuffer[e];
            if (this.m_flagsBuffer.data[e] & t.b2ParticleFlag.b2_staticPressureParticle) {
              const t = this.m_accumulationBuffer[e],
                r = (t + s * (i - w)) / (i + n);
              this.m_staticPressureBuffer[e] = X(r, 0, o);
            } else this.m_staticPressureBuffer[e] = 0;
          }
        }
      }
      ComputeWeight() {
        for (let t = 0; t < this.m_count; t++) this.m_weightBuffer[t] = 0;
        for (let t = 0; t < this.m_bodyContactBuffer.count; t++) {
          const e = this.m_bodyContactBuffer.data[t],
            i = e.index,
            s = e.weight;
          this.m_weightBuffer[i] += s;
        }
        for (let t = 0; t < this.m_contactBuffer.count; t++) {
          const e = this.m_contactBuffer.data[t],
            i = e.indexA,
            s = e.indexB,
            o = e.weight;
          this.m_weightBuffer[i] += o, this.m_weightBuffer[s] += o;
        }
      }
      SolvePressure(e) {
        const i = Ys.SolvePressure_s_f;
        if (!this.m_flagsBuffer.data) throw new Error();
        if (!this.m_positionBuffer.data) throw new Error();
        if (!this.m_velocityBuffer.data) throw new Error();
        const s = this.m_positionBuffer.data,
          o = this.m_velocityBuffer.data,
          n = this.GetCriticalPressure(e),
          r = this.m_def.pressureStrength * n,
          a = v * n;
        for (let t = 0; t < this.m_count; t++) {
          const e = this.m_weightBuffer[t],
            i = r * N(0, e - w);
          this.m_accumulationBuffer[t] = j(i, a);
        }
        if (this.m_allParticleFlags & Ys.k_noPressureFlags) for (let t = 0; t < this.m_count; t++) this.m_flagsBuffer.data[t] & Ys.k_noPressureFlags && (this.m_accumulationBuffer[t] = 0);
        if (this.m_allParticleFlags & t.b2ParticleFlag.b2_staticPressureParticle) for (let e = 0; e < this.m_count; e++) this.m_flagsBuffer.data[e] & t.b2ParticleFlag.b2_staticPressureParticle && (this.m_accumulationBuffer[e] += this.m_staticPressureBuffer[e]);
        const l = e.dt / (this.m_def.density * this.m_particleDiameter),
          m = this.GetParticleInvMass();
        for (let t = 0; t < this.m_bodyContactBuffer.count; t++) {
          const e = this.m_bodyContactBuffer.data[t],
            n = e.index,
            a = e.body,
            h = e.weight,
            _ = e.mass,
            c = e.normal,
            u = s[n],
            d = this.m_accumulationBuffer[n] + r * h,
            p = it.MulSV(l * h * _ * d, c, i);
          o[n].SelfMulSub(m, p), a.ApplyLinearImpulse(p, u, !0);
        }
        for (let t = 0; t < this.m_contactBuffer.count; t++) {
          const e = this.m_contactBuffer.data[t],
            s = e.indexA,
            n = e.indexB,
            r = e.weight,
            a = e.normal,
            m = this.m_accumulationBuffer[s] + this.m_accumulationBuffer[n],
            h = it.MulSV(l * r * m, a, i);
          o[s].SelfSub(h), o[n].SelfAdd(h);
        }
      }
      SolveDamping(t) {
        const e = Ys.SolveDamping_s_v,
          i = Ys.SolveDamping_s_f;
        if (!this.m_positionBuffer.data) throw new Error();
        if (!this.m_velocityBuffer.data) throw new Error();
        const s = this.m_positionBuffer.data,
          o = this.m_velocityBuffer.data,
          n = this.m_def.dampingStrength,
          r = 1 / this.GetCriticalVelocity(t),
          a = this.GetParticleInvMass();
        for (let t = 0; t < this.m_bodyContactBuffer.count; t++) {
          const l = this.m_bodyContactBuffer.data[t],
            m = l.index,
            h = l.body,
            _ = l.weight,
            c = l.mass,
            u = l.normal,
            d = s[m],
            p = it.SubVV(h.GetLinearVelocityFromWorldPoint(d, it.s_t0), o[m], e),
            f = it.DotVV(p, u);
          if (f < 0) {
            const t = N(n * _, j(-r * f, .5)),
              e = it.MulSV(t * c * f, u, i);
            o[m].SelfMulAdd(a, e), h.ApplyLinearImpulse(e.SelfNeg(), d, !0);
          }
        }
        for (let t = 0; t < this.m_contactBuffer.count; t++) {
          const s = this.m_contactBuffer.data[t],
            a = s.indexA,
            l = s.indexB,
            m = s.weight,
            h = s.normal,
            _ = it.SubVV(o[l], o[a], e),
            c = it.DotVV(_, h);
          if (c < 0) {
            const t = N(n * m, j(-r * c, .5)),
              e = it.MulSV(t * c, h, i);
            o[a].SelfAdd(e), o[l].SelfSub(e);
          }
        }
      }
      SolveRigidDamping() {
        const t = Ys.SolveRigidDamping_s_t0,
          e = Ys.SolveRigidDamping_s_t1,
          i = Ys.SolveRigidDamping_s_p,
          s = Ys.SolveRigidDamping_s_v,
          o = [0],
          n = [0],
          r = [0],
          a = [0],
          l = [0],
          m = [0];
        if (!this.m_positionBuffer.data) throw new Error();
        const h = this.m_positionBuffer.data,
          _ = this.m_def.dampingStrength;
        for (let i = 0; i < this.m_bodyContactBuffer.count; i++) {
          const c = this.m_bodyContactBuffer.data[i],
            u = c.index,
            d = this.m_groupBuffer[u];
          if (d && this.IsRigidGroup(d)) {
            const i = c.body,
              p = c.normal,
              f = c.weight,
              y = h[u],
              x = it.SubVV(i.GetLinearVelocityFromWorldPoint(y, t), d.GetLinearVelocityFromWorldPoint(y, e), s),
              B = it.DotVV(x, p);
            if (B < 0) {
              this.InitDampingParameterWithRigidGroupOrParticle(o, n, r, !0, d, u, y, p), this.InitDampingParameter(a, l, m, i.GetMass(), i.GetInertia() - i.GetMass() * i.GetLocalCenter().LengthSquared(), i.GetWorldCenter(), y, p);
              const t = _ * j(f, 1) * this.ComputeDampingImpulse(o[0], n[0], r[0], a[0], l[0], m[0], B);
              this.ApplyDamping(o[0], n[0], r[0], !0, d, u, t, p), i.ApplyLinearImpulse(it.MulSV(-t, p, it.s_t0), y, !0);
            }
          }
        }
        for (let c = 0; c < this.m_contactBuffer.count; c++) {
          const u = this.m_contactBuffer.data[c],
            d = u.indexA,
            p = u.indexB,
            f = u.normal,
            y = u.weight,
            x = this.m_groupBuffer[d],
            B = this.m_groupBuffer[p],
            S = this.IsRigidGroup(x),
            b = this.IsRigidGroup(B);
          if (x !== B && (S || b)) {
            const c = it.MidVV(h[d], h[p], i),
              u = it.SubVV(this.GetLinearVelocity(B, p, c, t), this.GetLinearVelocity(x, d, c, e), s),
              A = it.DotVV(u, f);
            if (A < 0) {
              this.InitDampingParameterWithRigidGroupOrParticle(o, n, r, S, x, d, c, f), this.InitDampingParameterWithRigidGroupOrParticle(a, l, m, b, B, p, c, f);
              const t = _ * y * this.ComputeDampingImpulse(o[0], n[0], r[0], a[0], l[0], m[0], A);
              this.ApplyDamping(o[0], n[0], r[0], S, x, d, t, f), this.ApplyDamping(a[0], l[0], m[0], b, B, p, -t, f);
            }
          }
        }
      }
      SolveExtraDamping() {
        const t = Ys.SolveExtraDamping_s_v,
          e = Ys.SolveExtraDamping_s_f;
        if (!this.m_flagsBuffer.data) throw new Error();
        if (!this.m_positionBuffer.data) throw new Error();
        if (!this.m_velocityBuffer.data) throw new Error();
        const i = this.m_velocityBuffer.data,
          s = this.m_positionBuffer.data,
          o = this.GetParticleInvMass();
        for (let n = 0; n < this.m_bodyContactBuffer.count; n++) {
          const r = this.m_bodyContactBuffer.data[n],
            a = r.index;
          if (this.m_flagsBuffer.data[a] & Ys.k_extraDampingFlags) {
            const n = r.body,
              l = r.mass,
              m = r.normal,
              h = s[a],
              _ = it.SubVV(n.GetLinearVelocityFromWorldPoint(h, it.s_t0), i[a], t),
              c = it.DotVV(_, m);
            if (c < 0) {
              const t = it.MulSV(.5 * l * c, m, e);
              i[a].SelfMulAdd(o, t), n.ApplyLinearImpulse(t.SelfNeg(), h, !0);
            }
          }
        }
      }
      SolveWall() {
        if (!this.m_flagsBuffer.data) throw new Error();
        if (!this.m_velocityBuffer.data) throw new Error();
        const e = this.m_velocityBuffer.data;
        for (let i = 0; i < this.m_count; i++) this.m_flagsBuffer.data[i] & t.b2ParticleFlag.b2_wallParticle && e[i].SetZero();
      }
      SolveRigid(e) {
        const i = Ys.SolveRigid_s_position,
          s = Ys.SolveRigid_s_rotation,
          o = Ys.SolveRigid_s_transform,
          n = Ys.SolveRigid_s_velocityTransform;
        if (!this.m_positionBuffer.data) throw new Error();
        if (!this.m_velocityBuffer.data) throw new Error();
        const r = this.m_positionBuffer.data,
          a = this.m_velocityBuffer.data;
        for (let l = this.m_groupList; l; l = l.GetNext()) if (l.m_groupFlags & t.b2ParticleGroupFlag.b2_rigidParticleGroup) {
          l.UpdateStatistics();
          const t = s;
          t.SetAngle(e.dt * l.m_angularVelocity);
          const m = it.AddVV(l.m_center, it.SubVV(it.MulSV(e.dt, l.m_linearVelocity, it.s_t0), at.MulRV(t, l.m_center, it.s_t1), it.s_t0), i),
            h = o;
          h.SetPositionRotation(m, t), lt.MulXX(h, l.m_transform, l.m_transform);
          const _ = n;
          _.p.x = e.inv_dt * h.p.x, _.p.y = e.inv_dt * h.p.y, _.q.s = e.inv_dt * h.q.s, _.q.c = e.inv_dt * (h.q.c - 1);
          for (let t = l.m_firstIndex; t < l.m_lastIndex; t++) lt.MulXV(_, r[t], a[t]);
        }
      }
      SolveElastic(e) {
        const i = Ys.SolveElastic_s_pa,
          s = Ys.SolveElastic_s_pb,
          o = Ys.SolveElastic_s_pc,
          n = Ys.SolveElastic_s_r,
          r = Ys.SolveElastic_s_t0;
        if (!this.m_positionBuffer.data) throw new Error();
        if (!this.m_velocityBuffer.data) throw new Error();
        const a = this.m_positionBuffer.data,
          l = this.m_velocityBuffer.data,
          m = e.inv_dt * this.m_def.elasticStrength;
        for (let h = 0; h < this.m_triadBuffer.count; h++) {
          const _ = this.m_triadBuffer.data[h];
          if (_.flags & t.b2ParticleFlag.b2_elasticParticle) {
            const t = _.indexA,
              h = _.indexB,
              c = _.indexC,
              u = _.pa,
              d = _.pb,
              p = _.pc,
              f = i.Copy(a[t]),
              y = s.Copy(a[h]),
              x = o.Copy(a[c]),
              B = l[t],
              S = l[h],
              b = l[c];
            f.SelfMulAdd(e.dt, B), y.SelfMulAdd(e.dt, S), x.SelfMulAdd(e.dt, b);
            const A = (f.x + y.x + x.x) / 3,
              C = (f.y + y.y + x.y) / 3;
            f.x -= A, f.y -= C, y.x -= A, y.y -= C, x.x -= A, x.y -= C;
            const V = n;
            V.s = it.CrossVV(u, f) + it.CrossVV(d, y) + it.CrossVV(p, x), V.c = it.DotVV(u, f) + it.DotVV(d, y) + it.DotVV(p, x);
            const g = V.s * V.s + V.c * V.c;
            let w = Z(g);
            isFinite(w) || (w = 198177537e11), V.s *= w, V.c *= w;
            const v = m * _.strength;
            at.MulRV(V, u, r), it.SubVV(r, f, r), it.MulSV(v, r, r), B.SelfAdd(r), at.MulRV(V, d, r), it.SubVV(r, y, r), it.MulSV(v, r, r), S.SelfAdd(r), at.MulRV(V, p, r), it.SubVV(r, x, r), it.MulSV(v, r, r), b.SelfAdd(r);
          }
        }
      }
      SolveSpring(e) {
        const i = Ys.SolveSpring_s_pa,
          s = Ys.SolveSpring_s_pb,
          o = Ys.SolveSpring_s_d,
          n = Ys.SolveSpring_s_f;
        if (!this.m_positionBuffer.data) throw new Error();
        if (!this.m_velocityBuffer.data) throw new Error();
        const r = this.m_positionBuffer.data,
          a = this.m_velocityBuffer.data,
          l = e.inv_dt * this.m_def.springStrength;
        for (let m = 0; m < this.m_pairBuffer.count; m++) {
          const h = this.m_pairBuffer.data[m];
          if (h.flags & t.b2ParticleFlag.b2_springParticle) {
            const t = h.indexA,
              m = h.indexB,
              _ = i.Copy(r[t]),
              c = s.Copy(r[m]),
              u = a[t],
              d = a[m];
            _.SelfMulAdd(e.dt, u), c.SelfMulAdd(e.dt, d);
            const p = it.SubVV(c, _, o),
              f = h.distance,
              y = p.Length(),
              x = l * h.strength,
              B = it.MulSV(x * (f - y) / y, p, n);
            u.SelfSub(B), d.SelfAdd(B);
          }
        }
      }
      SolveTensile(e) {
        const i = Ys.SolveTensile_s_weightedNormal,
          s = Ys.SolveTensile_s_s,
          o = Ys.SolveTensile_s_f;
        if (!this.m_velocityBuffer.data) throw new Error();
        const n = this.m_velocityBuffer.data;
        for (let t = 0; t < this.m_count; t++) this.m_accumulation2Buffer[t] = new it(), this.m_accumulation2Buffer[t].SetZero();
        for (let e = 0; e < this.m_contactBuffer.count; e++) {
          const s = this.m_contactBuffer.data[e];
          if (s.flags & t.b2ParticleFlag.b2_tensileParticle) {
            const t = s.indexA,
              e = s.indexB,
              o = s.weight,
              n = s.normal,
              r = it.MulSV((1 - o) * o, n, i);
            this.m_accumulation2Buffer[t].SelfSub(r), this.m_accumulation2Buffer[e].SelfAdd(r);
          }
        }
        const r = this.GetCriticalVelocity(e),
          a = this.m_def.surfaceTensionPressureStrength * r,
          l = this.m_def.surfaceTensionNormalStrength * r,
          m = M * r;
        for (let e = 0; e < this.m_contactBuffer.count; e++) {
          const i = this.m_contactBuffer.data[e];
          if (i.flags & t.b2ParticleFlag.b2_tensileParticle) {
            const t = i.indexA,
              e = i.indexB,
              r = i.weight,
              h = i.normal,
              _ = this.m_weightBuffer[t] + this.m_weightBuffer[e],
              c = it.SubVV(this.m_accumulation2Buffer[e], this.m_accumulation2Buffer[t], s),
              u = j(a * (_ - 2) + l * it.DotVV(c, h), m) * r,
              d = it.MulSV(u, h, o);
            n[t].SelfSub(d), n[e].SelfAdd(d);
          }
        }
      }
      SolveViscous() {
        const e = Ys.SolveViscous_s_v,
          i = Ys.SolveViscous_s_f;
        if (!this.m_flagsBuffer.data) throw new Error();
        if (!this.m_positionBuffer.data) throw new Error();
        if (!this.m_velocityBuffer.data) throw new Error();
        const s = this.m_positionBuffer.data,
          o = this.m_velocityBuffer.data,
          n = this.m_def.viscousStrength,
          r = this.GetParticleInvMass();
        for (let a = 0; a < this.m_bodyContactBuffer.count; a++) {
          const l = this.m_bodyContactBuffer.data[a],
            m = l.index;
          if (this.m_flagsBuffer.data[m] & t.b2ParticleFlag.b2_viscousParticle) {
            const t = l.body,
              a = l.weight,
              h = l.mass,
              _ = s[m],
              c = it.SubVV(t.GetLinearVelocityFromWorldPoint(_, it.s_t0), o[m], e),
              u = it.MulSV(n * h * a, c, i);
            o[m].SelfMulAdd(r, u), t.ApplyLinearImpulse(u.SelfNeg(), _, !0);
          }
        }
        for (let s = 0; s < this.m_contactBuffer.count; s++) {
          const r = this.m_contactBuffer.data[s];
          if (r.flags & t.b2ParticleFlag.b2_viscousParticle) {
            const t = r.indexA,
              s = r.indexB,
              a = r.weight,
              l = it.SubVV(o[s], o[t], e),
              m = it.MulSV(n * a, l, i);
            o[t].SelfAdd(m), o[s].SelfSub(m);
          }
        }
      }
      SolveRepulsive(e) {
        const i = Ys.SolveRepulsive_s_f;
        if (!this.m_velocityBuffer.data) throw new Error();
        const s = this.m_velocityBuffer.data,
          o = this.m_def.repulsiveStrength * this.GetCriticalVelocity(e);
        for (let e = 0; e < this.m_contactBuffer.count; e++) {
          const n = this.m_contactBuffer.data[e];
          if (n.flags & t.b2ParticleFlag.b2_repulsiveParticle) {
            const t = n.indexA,
              e = n.indexB;
            if (this.m_groupBuffer[t] !== this.m_groupBuffer[e]) {
              const r = n.weight,
                a = n.normal,
                l = it.MulSV(o * r, a, i);
              s[t].SelfSub(l), s[e].SelfAdd(l);
            }
          }
        }
      }
      SolvePowder(e) {
        const i = Ys.SolvePowder_s_f;
        if (!this.m_flagsBuffer.data) throw new Error();
        if (!this.m_positionBuffer.data) throw new Error();
        if (!this.m_velocityBuffer.data) throw new Error();
        const s = this.m_positionBuffer.data,
          o = this.m_velocityBuffer.data,
          n = this.m_def.powderStrength * this.GetCriticalVelocity(e),
          r = 1 - g,
          a = this.GetParticleInvMass();
        for (let e = 0; e < this.m_bodyContactBuffer.count; e++) {
          const l = this.m_bodyContactBuffer.data[e],
            m = l.index;
          if (this.m_flagsBuffer.data[m] & t.b2ParticleFlag.b2_powderParticle) {
            const t = l.weight;
            if (t > r) {
              const e = l.body,
                h = l.mass,
                _ = s[m],
                c = l.normal,
                u = it.MulSV(n * h * (t - r), c, i);
              o[m].SelfMulSub(a, u), e.ApplyLinearImpulse(u, _, !0);
            }
          }
        }
        for (let e = 0; e < this.m_contactBuffer.count; e++) {
          const s = this.m_contactBuffer.data[e];
          if (s.flags & t.b2ParticleFlag.b2_powderParticle) {
            const t = s.weight;
            if (t > r) {
              const e = s.indexA,
                a = s.indexB,
                l = s.normal,
                m = it.MulSV(n * (t - r), l, i);
              o[e].SelfSub(m), o[a].SelfAdd(m);
            }
          }
        }
      }
      SolveSolid(t) {
        const e = Ys.SolveSolid_s_f;
        if (!this.m_velocityBuffer.data) throw new Error();
        const i = this.m_velocityBuffer.data;
        this.m_depthBuffer = this.RequestBuffer(this.m_depthBuffer);
        const s = t.inv_dt * this.m_def.ejectionStrength;
        for (let t = 0; t < this.m_contactBuffer.count; t++) {
          const o = this.m_contactBuffer.data[t],
            n = o.indexA,
            r = o.indexB;
          if (this.m_groupBuffer[n] !== this.m_groupBuffer[r]) {
            const t = o.weight,
              a = o.normal,
              l = this.m_depthBuffer[n] + this.m_depthBuffer[r],
              m = it.MulSV(s * l * t, a, e);
            i[n].SelfSub(m), i[r].SelfAdd(m);
          }
        }
      }
      SolveForce(t) {
        if (!this.m_velocityBuffer.data) throw new Error();
        const e = this.m_velocityBuffer.data,
          i = t.dt * this.GetParticleInvMass();
        for (let t = 0; t < this.m_count; t++) e[t].SelfMulAdd(i, this.m_forceBuffer[t]);
        this.m_hasForce = !1;
      }
      SolveColorMixing() {
        if (!this.m_flagsBuffer.data) throw new Error();
        if (!this.m_colorBuffer.data) throw new Error();
        const e = .5 * this.m_def.colorMixingStrength;
        if (e) for (let i = 0; i < this.m_contactBuffer.count; i++) {
          const s = this.m_contactBuffer.data[i],
            o = s.indexA,
            n = s.indexB;
          if (this.m_flagsBuffer.data[o] & this.m_flagsBuffer.data[n] & t.b2ParticleFlag.b2_colorMixingParticle) {
            const t = this.m_colorBuffer.data[o],
              i = this.m_colorBuffer.data[n];
            ht.MixColors(t, i, e);
          }
        }
      }
      SolveZombie() {
        if (!this.m_flagsBuffer.data) throw new Error();
        if (!this.m_positionBuffer.data) throw new Error();
        if (!this.m_velocityBuffer.data) throw new Error();
        let e = 0;
        const i = [];
        for (let t = 0; t < this.m_count; t++) i[t] = V;
        let s = 0;
        for (let o = 0; o < this.m_count; o++) {
          const n = this.m_flagsBuffer.data[o];
          if (n & t.b2ParticleFlag.b2_zombieParticle) {
            const e = this.m_world.m_destructionListener;
            if (n & t.b2ParticleFlag.b2_destructionListenerParticle && e && e.SayGoodbyeParticle(this, o), this.m_handleIndexBuffer.data) {
              const t = this.m_handleIndexBuffer.data[o];
              t && (t.SetIndex(V), this.m_handleIndexBuffer.data[o] = null);
            }
            i[o] = V;
          } else {
            if (i[o] = e, o !== e) {
              if (this.m_handleIndexBuffer.data) {
                const t = this.m_handleIndexBuffer.data[o];
                t && t.SetIndex(e), this.m_handleIndexBuffer.data[e] = t;
              }
              this.m_flagsBuffer.data[e] = this.m_flagsBuffer.data[o], this.m_lastBodyContactStepBuffer.data && (this.m_lastBodyContactStepBuffer.data[e] = this.m_lastBodyContactStepBuffer.data[o]), this.m_bodyContactCountBuffer.data && (this.m_bodyContactCountBuffer.data[e] = this.m_bodyContactCountBuffer.data[o]), this.m_consecutiveContactStepsBuffer.data && (this.m_consecutiveContactStepsBuffer.data[e] = this.m_consecutiveContactStepsBuffer.data[o]), this.m_positionBuffer.data[e].Copy(this.m_positionBuffer.data[o]), this.m_velocityBuffer.data[e].Copy(this.m_velocityBuffer.data[o]), this.m_groupBuffer[e] = this.m_groupBuffer[o], this.m_hasForce && this.m_forceBuffer[e].Copy(this.m_forceBuffer[o]), this.m_staticPressureBuffer && (this.m_staticPressureBuffer[e] = this.m_staticPressureBuffer[o]), this.m_depthBuffer && (this.m_depthBuffer[e] = this.m_depthBuffer[o]), this.m_colorBuffer.data && this.m_colorBuffer.data[e].Copy(this.m_colorBuffer.data[o]), this.m_userDataBuffer.data && (this.m_userDataBuffer.data[e] = this.m_userDataBuffer.data[o]), this.m_expirationTimeBuffer.data && (this.m_expirationTimeBuffer.data[e] = this.m_expirationTimeBuffer.data[o]);
            }
            e++, s |= n;
          }
        }
        const o = {
          IsProxyInvalid: t => t.index < 0,
          IsContactInvalid: t => t.indexA < 0 || t.indexB < 0,
          IsBodyContactInvalid: t => t.index < 0,
          IsPairInvalid: t => t.indexA < 0 || t.indexB < 0,
          IsTriadInvalid: t => t.indexA < 0 || t.indexB < 0 || t.indexC < 0
        };
        for (let t = 0; t < this.m_proxyBuffer.count; t++) {
          const e = this.m_proxyBuffer.data[t];
          e.index = i[e.index];
        }
        this.m_proxyBuffer.RemoveIf(o.IsProxyInvalid);
        for (let t = 0; t < this.m_contactBuffer.count; t++) {
          const e = this.m_contactBuffer.data[t];
          e.indexA = i[e.indexA], e.indexB = i[e.indexB];
        }
        this.m_contactBuffer.RemoveIf(o.IsContactInvalid);
        for (let t = 0; t < this.m_bodyContactBuffer.count; t++) {
          const e = this.m_bodyContactBuffer.data[t];
          e.index = i[e.index];
        }
        this.m_bodyContactBuffer.RemoveIf(o.IsBodyContactInvalid);
        for (let t = 0; t < this.m_pairBuffer.count; t++) {
          const e = this.m_pairBuffer.data[t];
          e.indexA = i[e.indexA], e.indexB = i[e.indexB];
        }
        this.m_pairBuffer.RemoveIf(o.IsPairInvalid);
        for (let t = 0; t < this.m_triadBuffer.count; t++) {
          const e = this.m_triadBuffer.data[t];
          e.indexA = i[e.indexA], e.indexB = i[e.indexB], e.indexC = i[e.indexC];
        }
        if (this.m_triadBuffer.RemoveIf(o.IsTriadInvalid), this.m_indexByExpirationTimeBuffer.data) {
          let t = 0;
          for (let e = 0; e < this.m_count; e++) {
            const s = i[this.m_indexByExpirationTimeBuffer.data[e]];
            s !== V && (this.m_indexByExpirationTimeBuffer.data[t++] = s);
          }
        }
        for (let s = this.m_groupList; s; s = s.GetNext()) {
          let o = e,
            n = 0,
            r = !1;
          for (let t = s.m_firstIndex; t < s.m_lastIndex; t++) {
            const e = i[t];
            e >= 0 ? (o = j(o, e), n = N(n, e + 1)) : r = !0;
          }
          o < n ? (s.m_firstIndex = o, s.m_lastIndex = n, r && s.m_groupFlags & t.b2ParticleGroupFlag.b2_solidParticleGroup && this.SetGroupFlags(s, s.m_groupFlags | t.b2ParticleGroupFlag.b2_particleGroupNeedsUpdateDepth)) : (s.m_firstIndex = 0, s.m_lastIndex = 0, s.m_groupFlags & t.b2ParticleGroupFlag.b2_particleGroupCanBeEmpty || this.SetGroupFlags(s, s.m_groupFlags | t.b2ParticleGroupFlag.b2_particleGroupWillBeDestroyed));
        }
        this.m_count = e, this.m_allParticleFlags = s, this.m_needsUpdateAllParticleFlags = !1;
        for (let e = this.m_groupList; e;) {
          const i = e.GetNext();
          e.m_groupFlags & t.b2ParticleGroupFlag.b2_particleGroupWillBeDestroyed && this.DestroyParticleGroup(e), e = i;
        }
      }
      SolveLifetimes(t) {
        if (!this.m_expirationTimeBuffer.data) throw new Error();
        if (!this.m_indexByExpirationTimeBuffer.data) throw new Error();
        this.m_timeElapsed = this.LifetimeToExpirationTime(t.dt);
        const e = this.GetQuantizedTimeElapsed(),
          i = this.m_expirationTimeBuffer.data,
          s = this.m_indexByExpirationTimeBuffer.data,
          o = this.GetParticleCount();
        if (this.m_expirationTimeBufferRequiresSorting) {
          const t = (t, e) => {
            const s = i[t],
              o = i[e],
              n = s <= 0,
              r = o <= 0;
            return n === r ? s > o : n;
          };
          qs(s, 0, o, t), this.m_expirationTimeBufferRequiresSorting = !1;
        }
        for (let t = o - 1; t >= 0; --t) {
          const o = s[t],
            n = i[o];
          if (e < n || n <= 0) break;
          this.DestroyParticle(o);
        }
      }
      RotateBuffer(t, e, i) {
        if (t !== e && e !== i) {
          if (!this.m_flagsBuffer.data) throw new Error();
          if (!this.m_positionBuffer.data) throw new Error();
          if (!this.m_velocityBuffer.data) throw new Error();
          if (js(this.m_flagsBuffer.data, t, e, i), this.m_lastBodyContactStepBuffer.data && js(this.m_lastBodyContactStepBuffer.data, t, e, i), this.m_bodyContactCountBuffer.data && js(this.m_bodyContactCountBuffer.data, t, e, i), this.m_consecutiveContactStepsBuffer.data && js(this.m_consecutiveContactStepsBuffer.data, t, e, i), js(this.m_positionBuffer.data, t, e, i), js(this.m_velocityBuffer.data, t, e, i), js(this.m_groupBuffer, t, e, i), this.m_hasForce && js(this.m_forceBuffer, t, e, i), this.m_staticPressureBuffer && js(this.m_staticPressureBuffer, t, e, i), this.m_depthBuffer && js(this.m_depthBuffer, t, e, i), this.m_colorBuffer.data && js(this.m_colorBuffer.data, t, e, i), this.m_userDataBuffer.data && js(this.m_userDataBuffer.data, t, e, i), this.m_handleIndexBuffer.data) {
            js(this.m_handleIndexBuffer.data, t, e, i);
            for (let e = t; e < i; ++e) {
              const t = this.m_handleIndexBuffer.data[e];
              t && t.SetIndex(s(t.GetIndex()));
            }
          }
          if (this.m_expirationTimeBuffer.data) {
            js(this.m_expirationTimeBuffer.data, t, e, i);
            const o = this.GetParticleCount();
            if (!this.m_indexByExpirationTimeBuffer.data) throw new Error();
            const n = this.m_indexByExpirationTimeBuffer.data;
            for (let t = 0; t < o; ++t) n[t] = s(n[t]);
          }
          for (let t = 0; t < this.m_proxyBuffer.count; t++) {
            const e = this.m_proxyBuffer.data[t];
            e.index = s(e.index);
          }
          for (let t = 0; t < this.m_contactBuffer.count; t++) {
            const e = this.m_contactBuffer.data[t];
            e.indexA = s(e.indexA), e.indexB = s(e.indexB);
          }
          for (let t = 0; t < this.m_bodyContactBuffer.count; t++) {
            const e = this.m_bodyContactBuffer.data[t];
            e.index = s(e.index);
          }
          for (let t = 0; t < this.m_pairBuffer.count; t++) {
            const e = this.m_pairBuffer.data[t];
            e.indexA = s(e.indexA), e.indexB = s(e.indexB);
          }
          for (let t = 0; t < this.m_triadBuffer.count; t++) {
            const e = this.m_triadBuffer.data[t];
            e.indexA = s(e.indexA), e.indexB = s(e.indexB), e.indexC = s(e.indexC);
          }
          for (let t = this.m_groupList; t; t = t.GetNext()) t.m_firstIndex = s(t.m_firstIndex), t.m_lastIndex = s(t.m_lastIndex - 1) + 1;
        }
        function s(s) {
          return s < t ? s : s < e ? s + i - e : s < i ? s + t - e : s;
        }
      }
      GetCriticalVelocity(t) {
        return this.m_particleDiameter * t.inv_dt;
      }
      GetCriticalVelocitySquared(t) {
        const e = this.GetCriticalVelocity(t);
        return e * e;
      }
      GetCriticalPressure(t) {
        return this.m_def.density * this.GetCriticalVelocitySquared(t);
      }
      GetParticleStride() {
        return g * this.m_particleDiameter;
      }
      GetParticleMass() {
        const t = this.GetParticleStride();
        return this.m_def.density * t * t;
      }
      GetParticleInvMass() {
        const t = this.m_inverseDiameter * (1 / g);
        return this.m_inverseDensity * t * t;
      }
      GetFixtureContactFilter() {
        return this.m_allParticleFlags & t.b2ParticleFlag.b2_fixtureContactFilterParticle ? this.m_world.m_contactManager.m_contactFilter : null;
      }
      GetParticleContactFilter() {
        return this.m_allParticleFlags & t.b2ParticleFlag.b2_particleContactFilterParticle ? this.m_world.m_contactManager.m_contactFilter : null;
      }
      GetFixtureContactListener() {
        return this.m_allParticleFlags & t.b2ParticleFlag.b2_fixtureContactListenerParticle ? this.m_world.m_contactManager.m_contactListener : null;
      }
      GetParticleContactListener() {
        return this.m_allParticleFlags & t.b2ParticleFlag.b2_particleContactListenerParticle ? this.m_world.m_contactManager.m_contactListener : null;
      }
      SetUserOverridableBuffer(t, e, i) {
        t.data = e, t.userSuppliedCapacity = i;
      }
      SetGroupFlags(e, i) {
        const s = e.m_groupFlags;
        (s ^ i) & t.b2ParticleGroupFlag.b2_solidParticleGroup && (i |= t.b2ParticleGroupFlag.b2_particleGroupNeedsUpdateDepth), s & ~i && (this.m_needsUpdateAllGroupFlags = !0), ~this.m_allGroupFlags & i && (i & t.b2ParticleGroupFlag.b2_solidParticleGroup && (this.m_depthBuffer = this.RequestBuffer(this.m_depthBuffer)), this.m_allGroupFlags |= i), e.m_groupFlags = i;
      }
      static BodyContactCompare(t, e) {
        return t.index === e.index ? t.weight > e.weight : t.index < e.index;
      }
      RemoveSpuriousBodyContacts() {
        qs(this.m_bodyContactBuffer.data, 0, this.m_bodyContactBuffer.count, Ys.BodyContactCompare);
        const t = Ys.RemoveSpuriousBodyContacts_s_n,
          e = Ys.RemoveSpuriousBodyContacts_s_pos,
          i = Ys.RemoveSpuriousBodyContacts_s_normal,
          s = this;
        let o = -1,
          n = 0;
        this.m_bodyContactBuffer.count = Es(this.m_bodyContactBuffer.data, r => {
          if (r.index !== o && (n = 0, o = r.index), n++ > 3) return !0;
          const a = t.Copy(r.normal);
          if (a.SelfMul(s.m_particleDiameter * (1 - r.weight)), !s.m_positionBuffer.data) throw new Error();
          const l = it.AddVV(s.m_positionBuffer.data[r.index], a, e);
          if (!r.fixture.TestPoint(l)) {
            const t = r.fixture.GetShape().GetChildCount();
            for (let e = 0; e < t; e++) {
              const t = i,
                s = r.fixture.ComputeDistance(l, t, e);
              if (s < h) return !1;
            }
            return !0;
          }
          return !1;
        }, this.m_bodyContactBuffer.count);
      }
      DetectStuckParticle(t) {
        if (!(this.m_stuckThreshold <= 0)) {
          if (!this.m_bodyContactCountBuffer.data) throw new Error();
          if (!this.m_consecutiveContactStepsBuffer.data) throw new Error();
          if (!this.m_lastBodyContactStepBuffer.data) throw new Error();
          ++this.m_bodyContactCountBuffer.data[t], 2 === this.m_bodyContactCountBuffer.data[t] && (++this.m_consecutiveContactStepsBuffer.data[t], this.m_consecutiveContactStepsBuffer.data[t] > this.m_stuckThreshold && (this.m_stuckParticleBuffer.data[this.m_stuckParticleBuffer.Append()] = t)), this.m_lastBodyContactStepBuffer.data[t] = this.m_timestamp;
        }
      }
      ValidateParticleIndex(t) {
        return t >= 0 && t < this.GetParticleCount() && t !== V;
      }
      GetQuantizedTimeElapsed() {
        return Math.floor(this.m_timeElapsed / 4294967296);
      }
      LifetimeToExpirationTime(t) {
        return this.m_timeElapsed + Math.floor(t / this.m_def.lifetimeGranularity * 4294967296);
      }
      ForceCanBeApplied(e) {
        return !(e & t.b2ParticleFlag.b2_wallParticle);
      }
      PrepareForceBuffer() {
        if (!this.m_hasForce) {
          for (let t = 0; t < this.m_count; t++) this.m_forceBuffer[t].SetZero();
          this.m_hasForce = !0;
        }
      }
      IsRigidGroup(e) {
        return null !== e && 0 != (e.m_groupFlags & t.b2ParticleGroupFlag.b2_rigidParticleGroup);
      }
      GetLinearVelocity(t, e, i, s) {
        if (t && this.IsRigidGroup(t)) return t.GetLinearVelocityFromWorldPoint(i, s);
        if (!this.m_velocityBuffer.data) throw new Error();
        return s.Copy(this.m_velocityBuffer.data[e]);
      }
      InitDampingParameter(t, e, i, s, o, n, r, a) {
        t[0] = s > 0 ? 1 / s : 0, e[0] = o > 0 ? 1 / o : 0, i[0] = it.CrossVV(it.SubVV(r, n, it.s_t0), a);
      }
      InitDampingParameterWithRigidGroupOrParticle(e, i, s, o, n, r, a, l) {
        if (n && o) this.InitDampingParameter(e, i, s, n.GetMass(), n.GetInertia(), n.GetCenter(), a, l);else {
          if (!this.m_flagsBuffer.data) throw new Error();
          const o = this.m_flagsBuffer.data[r];
          this.InitDampingParameter(e, i, s, o & t.b2ParticleFlag.b2_wallParticle ? 0 : this.GetParticleMass(), 0, a, a, l);
        }
      }
      ComputeDampingImpulse(t, e, i, s, o, n, r) {
        const a = t + e * i * i + s + o * n * n;
        return a > 0 ? r / a : 0;
      }
      ApplyDamping(t, e, i, s, o, n, r, a) {
        if (o && s) o.m_linearVelocity.SelfMulAdd(r * t, a), o.m_angularVelocity += r * i * e;else {
          if (!this.m_velocityBuffer.data) throw new Error();
          this.m_velocityBuffer.data[n].SelfMulAdd(r * t, a);
        }
      }
    }
    Ys.xTruncBits = 12, Ys.yTruncBits = 12, Ys.tagBits = 32, Ys.yOffset = 1 << Ys.yTruncBits - 1, Ys.yShift = Ys.tagBits - Ys.yTruncBits, Ys.xShift = Ys.tagBits - Ys.yTruncBits - Ys.xTruncBits, Ys.xScale = 1 << Ys.xShift, Ys.xOffset = Ys.xScale * (1 << Ys.xTruncBits - 1), Ys.yMask = (1 << Ys.yTruncBits) - 1 << Ys.yShift, Ys.xMask = ~Ys.yMask, Ys.DestroyParticlesInShape_s_aabb = new Zt(), Ys.CreateParticleGroup_s_transform = new lt(), Ys.ComputeCollisionEnergy_s_v = new it(), Ys.QueryShapeAABB_s_aabb = new Zt(), Ys.QueryPointAABB_s_aabb = new Zt(), Ys.RayCast_s_aabb = new Zt(), Ys.RayCast_s_p = new it(), Ys.RayCast_s_v = new it(), Ys.RayCast_s_n = new it(), Ys.RayCast_s_point = new it(), Ys.k_pairFlags = t.b2ParticleFlag.b2_springParticle, Ys.k_triadFlags = t.b2ParticleFlag.b2_elasticParticle, Ys.k_noPressureFlags = t.b2ParticleFlag.b2_powderParticle | t.b2ParticleFlag.b2_tensileParticle, Ys.k_extraDampingFlags = t.b2ParticleFlag.b2_staticPressureParticle, Ys.k_barrierWallFlags = t.b2ParticleFlag.b2_barrierParticle | t.b2ParticleFlag.b2_wallParticle, Ys.CreateParticlesStrokeShapeForGroup_s_edge = new vi(), Ys.CreateParticlesStrokeShapeForGroup_s_d = new it(), Ys.CreateParticlesStrokeShapeForGroup_s_p = new it(), Ys.CreateParticlesFillShapeForGroup_s_aabb = new Zt(), Ys.CreateParticlesFillShapeForGroup_s_p = new it(), Ys.UpdatePairsAndTriads_s_dab = new it(), Ys.UpdatePairsAndTriads_s_dbc = new it(), Ys.UpdatePairsAndTriads_s_dca = new it(), Ys.AddContact_s_d = new it(), Ys.UpdateBodyContacts_s_aabb = new Zt(), Ys.Solve_s_subStep = new ps(), Ys.SolveCollision_s_aabb = new Zt(), Ys.SolveGravity_s_gravity = new it(), Ys.SolveBarrier_s_aabb = new Zt(), Ys.SolveBarrier_s_va = new it(), Ys.SolveBarrier_s_vb = new it(), Ys.SolveBarrier_s_pba = new it(), Ys.SolveBarrier_s_vba = new it(), Ys.SolveBarrier_s_vc = new it(), Ys.SolveBarrier_s_pca = new it(), Ys.SolveBarrier_s_vca = new it(), Ys.SolveBarrier_s_qba = new it(), Ys.SolveBarrier_s_qca = new it(), Ys.SolveBarrier_s_dv = new it(), Ys.SolveBarrier_s_f = new it(), Ys.SolvePressure_s_f = new it(), Ys.SolveDamping_s_v = new it(), Ys.SolveDamping_s_f = new it(), Ys.SolveRigidDamping_s_t0 = new it(), Ys.SolveRigidDamping_s_t1 = new it(), Ys.SolveRigidDamping_s_p = new it(), Ys.SolveRigidDamping_s_v = new it(), Ys.SolveExtraDamping_s_v = new it(), Ys.SolveExtraDamping_s_f = new it(), Ys.SolveRigid_s_position = new it(), Ys.SolveRigid_s_rotation = new at(), Ys.SolveRigid_s_transform = new lt(), Ys.SolveRigid_s_velocityTransform = new lt(), Ys.SolveElastic_s_pa = new it(), Ys.SolveElastic_s_pb = new it(), Ys.SolveElastic_s_pc = new it(), Ys.SolveElastic_s_r = new at(), Ys.SolveElastic_s_t0 = new it(), Ys.SolveSpring_s_pa = new it(), Ys.SolveSpring_s_pb = new it(), Ys.SolveSpring_s_d = new it(), Ys.SolveSpring_s_f = new it(), Ys.SolveTensile_s_weightedNormal = new it(), Ys.SolveTensile_s_s = new it(), Ys.SolveTensile_s_f = new it(), Ys.SolveViscous_s_v = new it(), Ys.SolveViscous_s_f = new it(), Ys.SolveRepulsive_s_f = new it(), Ys.SolvePowder_s_f = new it(), Ys.SolveSolid_s_f = new it(), Ys.RemoveSpuriousBodyContacts_s_n = new it(), Ys.RemoveSpuriousBodyContacts_s_pos = new it(), Ys.RemoveSpuriousBodyContacts_s_normal = new it(), function (e) {
      e.UserOverridableBuffer = class {
        constructor() {
          this.data = null, this.userSuppliedCapacity = 0;
        }
      }, e.Proxy = class {
        constructor() {
          this.index = V, this.tag = 0;
        }
        static CompareProxyProxy(t, e) {
          return t.tag < e.tag;
        }
        static CompareTagProxy(t, e) {
          return t < e.tag;
        }
        static CompareProxyTag(t, e) {
          return t.tag < e;
        }
      }, e.InsideBoundsEnumerator = class {
        constructor(t, i, s, o, n) {
          this.m_system = t, this.m_xLower = (i & e.xMask) >>> 0, this.m_xUpper = (s & e.xMask) >>> 0, this.m_yLower = (i & e.yMask) >>> 0, this.m_yUpper = (s & e.yMask) >>> 0, this.m_first = o, this.m_last = n;
        }
        GetNext() {
          for (; this.m_first < this.m_last;) {
            const t = (this.m_system.m_proxyBuffer.data[this.m_first].tag & e.xMask) >>> 0;
            if (t >= this.m_xLower && t <= this.m_xUpper) return this.m_system.m_proxyBuffer.data[this.m_first++].index;
            this.m_first++;
          }
          return V;
        }
      }, e.ParticleListNode = class {
        constructor() {
          this.next = null, this.count = 0, this.index = 0;
        }
      }, e.FixedSetAllocator = class {
        Allocate(t, e) {
          return e;
        }
        Clear() {}
        GetCount() {
          return 0;
        }
        Invalidate(t) {}
        GetValidBuffer() {
          return [];
        }
        GetBuffer() {
          return [];
        }
        SetCount(t) {}
      }, e.FixtureParticle = class {
        constructor(t, e) {
          this.second = V, this.first = t, this.second = e;
        }
      }, e.FixtureParticleSet = class extends e.FixedSetAllocator {
        Initialize(t, e) {}
        Find(t) {
          return V;
        }
      }, e.ParticlePair = class {
        constructor(t, e) {
          this.first = V, this.second = V, this.first = t, this.second = e;
        }
      }, e.b2ParticlePairSet = class extends e.FixedSetAllocator {
        Initialize(t, e) {}
        Find(t) {
          return V;
        }
      }, e.ConnectionFilter = class {
        IsNecessary(t) {
          return !0;
        }
        ShouldCreatePair(t, e) {
          return !0;
        }
        ShouldCreateTriad(t, e, i) {
          return !0;
        }
      }, e.DestroyParticlesInShapeCallback = class extends cs {
        constructor(t, e, i, s) {
          super(), this.m_callDestructionListener = !1, this.m_destroyed = 0, this.m_system = t, this.m_shape = e, this.m_xf = i, this.m_callDestructionListener = s, this.m_destroyed = 0;
        }
        ReportFixture(t) {
          return !1;
        }
        ReportParticle(t, e) {
          if (t !== this.m_system) return !1;
          if (!this.m_system.m_positionBuffer.data) throw new Error();
          return this.m_shape.TestPoint(this.m_xf, this.m_system.m_positionBuffer.data[e]) && (this.m_system.DestroyParticle(e, this.m_callDestructionListener), this.m_destroyed++), !0;
        }
        Destroyed() {
          return this.m_destroyed;
        }
      }, e.JoinParticleGroupsFilter = class extends e.ConnectionFilter {
        constructor(t) {
          super(), this.m_threshold = 0, this.m_threshold = t;
        }
        ShouldCreatePair(t, e) {
          return t < this.m_threshold && this.m_threshold <= e || e < this.m_threshold && this.m_threshold <= t;
        }
        ShouldCreateTriad(t, e, i) {
          return (t < this.m_threshold || e < this.m_threshold || i < this.m_threshold) && (this.m_threshold <= t || this.m_threshold <= e || this.m_threshold <= i);
        }
      }, e.CompositeShape = class extends Vi {
        constructor(e) {
          let i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : e.length;
          super(t.b2ShapeType.e_unknown, 0), this.m_shapeCount = 0, this.m_shapes = e, this.m_shapeCount = i;
        }
        Clone() {
          throw new Error();
        }
        GetChildCount() {
          return 1;
        }
        TestPoint(t, e) {
          for (let i = 0; i < this.m_shapeCount; i++) if (this.m_shapes[i].TestPoint(t, e)) return !0;
          return !1;
        }
        ComputeDistance(t, e, i, s) {
          return 0;
        }
        RayCast(t, e, i, s) {
          return !1;
        }
        ComputeAABB(t, e, s) {
          const o = new Zt();
          t.lowerBound.x = +i, t.lowerBound.y = +i, t.upperBound.x = -i, t.upperBound.y = -i;
          for (let i = 0; i < this.m_shapeCount; i++) {
            const s = this.m_shapes[i].GetChildCount();
            for (let n = 0; n < s; n++) {
              const s = o;
              this.m_shapes[i].ComputeAABB(s, e, n), t.Combine1(s);
            }
          }
        }
        ComputeMass(t, e) {}
        SetupDistanceProxy(t, e) {}
        ComputeSubmergedArea(t, e, i, s) {
          return 0;
        }
        Dump(t) {}
      }, e.ReactiveFilter = class extends e.ConnectionFilter {
        constructor(t) {
          super(), this.m_flagsBuffer = t;
        }
        IsNecessary(e) {
          if (!this.m_flagsBuffer.data) throw new Error();
          return 0 != (this.m_flagsBuffer.data[e] & t.b2ParticleFlag.b2_reactiveParticle);
        }
      };
      class s extends Xs {
        constructor(t, e) {
          super(t), this.m_contactFilter = e;
        }
        ShouldCollideFixtureParticle(e, i, s) {
          if (this.m_contactFilter) {
            const i = this.m_system.GetFlagsBuffer();
            if (i[s] & t.b2ParticleFlag.b2_fixtureContactFilterParticle) return this.m_contactFilter.ShouldCollideFixtureParticle(e, this.m_system, s);
          }
          return !0;
        }
        ReportFixtureAndParticle(i, s, o) {
          const n = e.UpdateBodyContactsCallback.ReportFixtureAndParticle_s_n,
            r = e.UpdateBodyContactsCallback.ReportFixtureAndParticle_s_rp;
          if (!this.m_system.m_flagsBuffer.data) throw new Error();
          if (!this.m_system.m_positionBuffer.data) throw new Error();
          const a = this.m_system.m_positionBuffer.data[o],
            l = n,
            m = i.ComputeDistance(a, l, s);
          if (m < this.m_system.m_particleDiameter && this.ShouldCollideFixtureParticle(i, this.m_system, o)) {
            const e = i.GetBody(),
              s = e.GetWorldCenter(),
              n = e.GetMass(),
              h = e.GetInertia() - n * e.GetLocalCenter().LengthSquared(),
              _ = n > 0 ? 1 / n : 0,
              c = h > 0 ? 1 / h : 0,
              u = this.m_system.m_flagsBuffer.data[o] & t.b2ParticleFlag.b2_wallParticle ? 0 : this.m_system.GetParticleInvMass(),
              d = it.SubVV(a, s, r),
              p = it.CrossVV(d, l),
              f = u + _ + c * p * p,
              y = this.m_system.m_bodyContactBuffer.data[this.m_system.m_bodyContactBuffer.Append()];
            y.index = o, y.body = e, y.fixture = i, y.weight = 1 - m * this.m_system.m_inverseDiameter, y.normal.Copy(l.SelfNeg()), y.mass = f > 0 ? 1 / f : 0, this.m_system.DetectStuckParticle(o);
          }
        }
      }
      s.ReportFixtureAndParticle_s_n = new it(), s.ReportFixtureAndParticle_s_rp = new it(), e.UpdateBodyContactsCallback = s;
      class o extends Xs {
        constructor(t, e) {
          super(t), this.m_step = e;
        }
        ReportFixtureAndParticle(i, s, o) {
          const n = e.SolveCollisionCallback.ReportFixtureAndParticle_s_p1,
            r = e.SolveCollisionCallback.ReportFixtureAndParticle_s_output,
            a = e.SolveCollisionCallback.ReportFixtureAndParticle_s_input,
            l = e.SolveCollisionCallback.ReportFixtureAndParticle_s_p,
            m = e.SolveCollisionCallback.ReportFixtureAndParticle_s_v,
            _ = e.SolveCollisionCallback.ReportFixtureAndParticle_s_f,
            c = i.GetBody();
          if (!this.m_system.m_positionBuffer.data) throw new Error();
          if (!this.m_system.m_velocityBuffer.data) throw new Error();
          const u = this.m_system.m_positionBuffer.data[o],
            d = this.m_system.m_velocityBuffer.data[o],
            p = r,
            f = a;
          if (0 === this.m_system.m_iterationIndex) {
            const e = lt.MulTXV(c.m_xf0, u, n);
            i.GetShape().GetType() === t.b2ShapeType.e_circleShape && (e.SelfSub(c.GetLocalCenter()), at.MulRV(c.m_xf0.q, e, e), at.MulTRV(c.m_xf.q, e, e), e.SelfAdd(c.GetLocalCenter())), lt.MulXV(c.m_xf, e, f.p1);
          } else f.p1.Copy(u);
          if (it.AddVMulSV(u, this.m_step.dt, d, f.p2), f.maxFraction = 1, i.RayCast(p, f, s)) {
            const t = p.normal,
              e = l;
            e.x = (1 - p.fraction) * f.p1.x + p.fraction * f.p2.x + h * t.x, e.y = (1 - p.fraction) * f.p1.y + p.fraction * f.p2.y + h * t.y;
            const i = m;
            i.x = this.m_step.inv_dt * (e.x - u.x), i.y = this.m_step.inv_dt * (e.y - u.y), this.m_system.m_velocityBuffer.data[o].Copy(i);
            const s = _;
            s.x = this.m_step.inv_dt * this.m_system.GetParticleMass() * (d.x - i.x), s.y = this.m_step.inv_dt * this.m_system.GetParticleMass() * (d.y - i.y), this.m_system.ParticleApplyForce(o, s);
          }
        }
        ReportParticle(t, e) {
          return !1;
        }
      }
      o.ReportFixtureAndParticle_s_p1 = new it(), o.ReportFixtureAndParticle_s_output = new Wt(), o.ReportFixtureAndParticle_s_input = new Ut(), o.ReportFixtureAndParticle_s_p = new it(), o.ReportFixtureAndParticle_s_v = new it(), o.ReportFixtureAndParticle_s_f = new it(), e.SolveCollisionCallback = o;
    }(Ys || (Ys = {}));
    class Ks {
      constructor(t) {
        this.m_newFixture = !1, this.m_locked = !1, this.m_clearForces = !0, this.m_contactManager = new us(), this.m_bodyList = null, this.m_jointList = null, this.m_particleSystemList = null, this.m_bodyCount = 0, this.m_jointCount = 0, this.m_gravity = new it(), this.m_allowSleep = !0, this.m_destructionListener = null, this.m_debugDraw = null, this.m_inv_dt0 = 0, this.m_warmStarting = !0, this.m_continuousPhysics = !0, this.m_subStepping = !1, this.m_stepComplete = !0, this.m_profile = new ds(), this.m_island = new ws(), this.s_stack = [], this.m_controllerList = null, this.m_controllerCount = 0, this.m_gravity.Copy(t);
      }
      SetDestructionListener(t) {
        this.m_destructionListener = t;
      }
      SetContactFilter(t) {
        this.m_contactManager.m_contactFilter = t;
      }
      SetContactListener(t) {
        this.m_contactManager.m_contactListener = t;
      }
      SetDebugDraw(t) {
        this.m_debugDraw = t;
      }
      CreateBody() {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (this.IsLocked()) throw new Error();
        const e = new Fi(t, this);
        return e.m_prev = null, e.m_next = this.m_bodyList, this.m_bodyList && (this.m_bodyList.m_prev = e), this.m_bodyList = e, ++this.m_bodyCount, e;
      }
      DestroyBody(t) {
        if (this.IsLocked()) throw new Error();
        let e = t.m_jointList;
        for (; e;) {
          const i = e;
          e = e.next, this.m_destructionListener && this.m_destructionListener.SayGoodbyeJoint(i.joint), this.DestroyJoint(i.joint), t.m_jointList = e;
        }
        t.m_jointList = null;
        let i = t.m_controllerList;
        for (; i;) {
          const e = i;
          i = i.nextController, e.controller.RemoveBody(t);
        }
        let s = t.m_contactList;
        for (; s;) {
          const t = s;
          s = s.next, this.m_contactManager.Destroy(t.contact);
        }
        t.m_contactList = null;
        let o = t.m_fixtureList;
        for (; o;) {
          const e = o;
          o = o.m_next, this.m_destructionListener && this.m_destructionListener.SayGoodbyeFixture(e), e.DestroyProxies(), e.Destroy(), t.m_fixtureList = o, t.m_fixtureCount -= 1;
        }
        t.m_fixtureList = null, t.m_fixtureCount = 0, t.m_prev && (t.m_prev.m_next = t.m_next), t.m_next && (t.m_next.m_prev = t.m_prev), t === this.m_bodyList && (this.m_bodyList = t.m_next), --this.m_bodyCount;
      }
      static _Joint_Create(e, i) {
        switch (e.type) {
          case t.b2JointType.e_distanceJoint:
            return new qi(e);
          case t.b2JointType.e_mouseJoint:
            return new ji(e);
          case t.b2JointType.e_prismaticJoint:
            return new Ni(e);
          case t.b2JointType.e_revoluteJoint:
            return new Ui(e);
          case t.b2JointType.e_pulleyJoint:
            return new Xi(e);
          case t.b2JointType.e_gearJoint:
            return new Ji(e);
          case t.b2JointType.e_wheelJoint:
            return new Hi(e);
          case t.b2JointType.e_weldJoint:
            return new Zi(e);
          case t.b2JointType.e_frictionJoint:
            return new Ei(e);
          case t.b2JointType.e_ropeJoint:
            return new Wi(e);
          case t.b2JointType.e_motorJoint:
            return new Oi(e);
          case t.b2JointType.e_areaJoint:
            return new zi(e);
        }
        throw new Error();
      }
      static _Joint_Destroy(t, e) {}
      CreateJoint(t) {
        if (this.IsLocked()) throw new Error();
        const e = Ks._Joint_Create(t, null);
        e.m_prev = null, e.m_next = this.m_jointList, this.m_jointList && (this.m_jointList.m_prev = e), this.m_jointList = e, ++this.m_jointCount, e.m_edgeA.prev = null, e.m_edgeA.next = e.m_bodyA.m_jointList, e.m_bodyA.m_jointList && (e.m_bodyA.m_jointList.prev = e.m_edgeA), e.m_bodyA.m_jointList = e.m_edgeA, e.m_edgeB.prev = null, e.m_edgeB.next = e.m_bodyB.m_jointList, e.m_bodyB.m_jointList && (e.m_bodyB.m_jointList.prev = e.m_edgeB), e.m_bodyB.m_jointList = e.m_edgeB;
        const i = t.bodyA,
          s = t.bodyB;
        if (!t.collideConnected) {
          let t = s.GetContactList();
          for (; t;) t.other === i && t.contact.FlagForFiltering(), t = t.next;
        }
        return e;
      }
      DestroyJoint(t) {
        if (this.IsLocked()) throw new Error();
        const e = t.m_collideConnected;
        t.m_prev && (t.m_prev.m_next = t.m_next), t.m_next && (t.m_next.m_prev = t.m_prev), t === this.m_jointList && (this.m_jointList = t.m_next);
        const i = t.m_bodyA,
          s = t.m_bodyB;
        if (i.SetAwake(!0), s.SetAwake(!0), t.m_edgeA.prev && (t.m_edgeA.prev.next = t.m_edgeA.next), t.m_edgeA.next && (t.m_edgeA.next.prev = t.m_edgeA.prev), t.m_edgeA === i.m_jointList && (i.m_jointList = t.m_edgeA.next), t.m_edgeA.prev = null, t.m_edgeA.next = null, t.m_edgeB.prev && (t.m_edgeB.prev.next = t.m_edgeB.next), t.m_edgeB.next && (t.m_edgeB.next.prev = t.m_edgeB.prev), t.m_edgeB === s.m_jointList && (s.m_jointList = t.m_edgeB.next), t.m_edgeB.prev = null, t.m_edgeB.next = null, Ks._Joint_Destroy(t, null), --this.m_jointCount, !e) {
          let t = s.GetContactList();
          for (; t;) t.other === i && t.contact.FlagForFiltering(), t = t.next;
        }
      }
      CreateParticleSystem(t) {
        if (this.IsLocked()) throw new Error();
        const e = new Ys(t, this);
        return e.m_prev = null, e.m_next = this.m_particleSystemList, this.m_particleSystemList && (this.m_particleSystemList.m_prev = e), this.m_particleSystemList = e, e;
      }
      DestroyParticleSystem(t) {
        if (this.IsLocked()) throw new Error();
        t.m_prev && (t.m_prev.m_next = t.m_next), t.m_next && (t.m_next.m_prev = t.m_prev), t === this.m_particleSystemList && (this.m_particleSystemList = t.m_next);
      }
      CalculateReasonableParticleIterations(t) {
        return null === this.m_particleSystemList ? 1 : Is(this.m_gravity.Length(), function (t) {
          let e = i;
          for (let i = t.GetParticleSystemList(); null !== i; i = i.m_next) e = j(e, i.GetRadius());
          return e;
        }(this), t);
      }
      Step(t, e, i) {
        let s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.CalculateReasonableParticleIterations(t);
        const o = Ks.Step_s_stepTimer.Reset();
        this.m_newFixture && (this.m_contactManager.FindNewContacts(), this.m_newFixture = !1), this.m_locked = !0;
        const n = Ks.Step_s_step;
        n.dt = t, n.velocityIterations = e, n.positionIterations = i, n.particleIterations = s, n.inv_dt = t > 0 ? 1 / t : 0, n.dtRatio = this.m_inv_dt0 * t, n.warmStarting = this.m_warmStarting;
        const r = Ks.Step_s_timer.Reset();
        if (this.m_contactManager.Collide(), this.m_profile.collide = r.GetMilliseconds(), this.m_stepComplete && n.dt > 0) {
          const t = Ks.Step_s_timer.Reset();
          for (let t = this.m_particleSystemList; t; t = t.m_next) t.Solve(n);
          this.Solve(n), this.m_profile.solve = t.GetMilliseconds();
        }
        if (this.m_continuousPhysics && n.dt > 0) {
          const t = Ks.Step_s_timer.Reset();
          this.SolveTOI(n), this.m_profile.solveTOI = t.GetMilliseconds();
        }
        n.dt > 0 && (this.m_inv_dt0 = n.inv_dt), this.m_clearForces && this.ClearForces(), this.m_locked = !1, this.m_profile.step = o.GetMilliseconds();
      }
      ClearForces() {
        for (let t = this.m_bodyList; t; t = t.m_next) t.m_force.SetZero(), t.m_torque = 0;
      }
      DrawParticleSystem(t) {
        if (null === this.m_debugDraw) return;
        const e = t.GetParticleCount();
        if (e) {
          const i = t.GetRadius(),
            s = t.GetPositionBuffer();
          if (t.m_colorBuffer.data) {
            const o = t.GetColorBuffer();
            this.m_debugDraw.DrawParticles(s, i, o, e);
          } else this.m_debugDraw.DrawParticles(s, i, null, e);
        }
      }
      DrawDebugData() {
        if (null === this.m_debugDraw) return;
        const e = this.m_debugDraw.GetFlags(),
          i = Ks.DrawDebugData_s_color.SetRGB(0, 0, 0);
        if (e & t.b2DrawFlags.e_shapeBit) for (let e = this.m_bodyList; e; e = e.m_next) {
          const s = e.m_xf;
          this.m_debugDraw.PushTransform(s);
          for (let s = e.GetFixtureList(); s; s = s.m_next) e.IsActive() ? e.GetType() === t.b2BodyType.b2_staticBody ? (i.SetRGB(.5, .9, .5), this.DrawShape(s, i)) : e.GetType() === t.b2BodyType.b2_kinematicBody ? (i.SetRGB(.5, .5, .9), this.DrawShape(s, i)) : e.IsAwake() ? (i.SetRGB(.9, .7, .7), this.DrawShape(s, i)) : (i.SetRGB(.6, .6, .6), this.DrawShape(s, i)) : (i.SetRGB(.5, .5, .3), this.DrawShape(s, i));
          this.m_debugDraw.PopTransform(s);
        }
        if (e & t.b2DrawFlags.e_particleBit) for (let t = this.m_particleSystemList; t; t = t.m_next) this.DrawParticleSystem(t);
        if (e & t.b2DrawFlags.e_jointBit) for (let t = this.m_jointList; t; t = t.m_next) this.DrawJoint(t);
        if (e & t.b2DrawFlags.e_aabbBit) {
          i.SetRGB(.9, .3, .9);
          const t = Ks.DrawDebugData_s_vs;
          for (let e = this.m_bodyList; e; e = e.m_next) if (e.IsActive()) for (let s = e.GetFixtureList(); s; s = s.m_next) for (let e = 0; e < s.m_proxyCount; ++e) {
            const o = s.m_proxies[e],
              n = o.treeNode.aabb;
            t[0].Set(n.lowerBound.x, n.lowerBound.y), t[1].Set(n.upperBound.x, n.lowerBound.y), t[2].Set(n.upperBound.x, n.upperBound.y), t[3].Set(n.lowerBound.x, n.upperBound.y), this.m_debugDraw.DrawPolygon(t, 4, i);
          }
        }
        if (e & t.b2DrawFlags.e_centerOfMassBit) for (let t = this.m_bodyList; t; t = t.m_next) {
          const e = Ks.DrawDebugData_s_xf;
          e.q.Copy(t.m_xf.q), e.p.Copy(t.GetWorldCenter()), this.m_debugDraw.DrawTransform(e);
        }
        if (e & t.b2DrawFlags.e_controllerBit) for (let t = this.m_controllerList; t; t = t.m_next) t.Draw(this.m_debugDraw);
      }
      QueryAABB(t, e, i) {
        if (this.m_contactManager.m_broadPhase.Query(e, e => {
          const s = e.userData,
            o = s.fixture;
          return t ? t.ReportFixture(o) : !i || i(o);
        }), t instanceof cs) for (let i = this.m_particleSystemList; i; i = i.m_next) t.ShouldQueryParticleSystem(i) && i.QueryAABB(t, e);
      }
      QueryAllAABB(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        return this.QueryAABB(null, t, t => (e.push(t), !0)), e;
      }
      QueryPointAABB(t, e, i) {
        if (this.m_contactManager.m_broadPhase.QueryPoint(e, e => {
          const s = e.userData,
            o = s.fixture;
          return t ? t.ReportFixture(o) : !i || i(o);
        }), t instanceof cs) for (let i = this.m_particleSystemList; i; i = i.m_next) t.ShouldQueryParticleSystem(i) && i.QueryPointAABB(t, e);
      }
      QueryAllPointAABB(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        return this.QueryPointAABB(null, t, t => (e.push(t), !0)), e;
      }
      QueryFixtureShape(t, e, i, s, o) {
        const n = Ks.QueryFixtureShape_s_aabb;
        if (e.ComputeAABB(n, s, i), this.m_contactManager.m_broadPhase.Query(n, n => {
          const r = n.userData,
            a = r.fixture;
          if (te(e, i, a.GetShape(), r.childIndex, s, a.GetBody().GetTransform())) {
            if (t) return t.ReportFixture(a);
            if (o) return o(a);
          }
          return !0;
        }), t instanceof cs) for (let e = this.m_particleSystemList; e; e = e.m_next) t.ShouldQueryParticleSystem(e) && e.QueryAABB(t, n);
      }
      QueryAllFixtureShape(t, e, i) {
        let s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
        return this.QueryFixtureShape(null, t, e, i, t => (s.push(t), !0)), s;
      }
      QueryFixturePoint(t, e, i) {
        if (this.m_contactManager.m_broadPhase.QueryPoint(e, s => {
          const o = s.userData,
            n = o.fixture;
          if (n.TestPoint(e)) {
            if (t) return t.ReportFixture(n);
            if (i) return i(n);
          }
          return !0;
        }), t) for (let i = this.m_particleSystemList; i; i = i.m_next) t.ShouldQueryParticleSystem(i) && i.QueryPointAABB(t, e);
      }
      QueryAllFixturePoint(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        return this.QueryFixturePoint(null, t, t => (e.push(t), !0)), e;
      }
      RayCast(t, e, i, s) {
        const o = Ks.RayCast_s_input;
        if (o.maxFraction = 1, o.p1.Copy(e), o.p2.Copy(i), this.m_contactManager.m_broadPhase.RayCast(o, (o, n) => {
          const r = n.userData,
            a = r.fixture,
            l = r.childIndex,
            m = Ks.RayCast_s_output,
            h = a.RayCast(m, o, l);
          if (h) {
            const o = m.fraction,
              n = Ks.RayCast_s_point;
            if (n.Set((1 - o) * e.x + o * i.x, (1 - o) * e.y + o * i.y), t) return t.ReportFixture(a, n, m.normal, o);
            if (s) return s(a, n, m.normal, o);
          }
          return o.maxFraction;
        }), t) for (let s = this.m_particleSystemList; s; s = s.m_next) t.ShouldQueryParticleSystem(s) && s.RayCast(t, e, i);
      }
      RayCastOne(t, e) {
        let i = null,
          s = 1;
        return this.RayCast(null, t, e, (t, e, o, n) => (n < s && (s = n, i = t), s)), i;
      }
      RayCastAll(t, e) {
        let i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        return this.RayCast(null, t, e, (t, e, s, o) => (i.push(t), 1)), i;
      }
      GetBodyList() {
        return this.m_bodyList;
      }
      GetJointList() {
        return this.m_jointList;
      }
      GetParticleSystemList() {
        return this.m_particleSystemList;
      }
      GetContactList() {
        return this.m_contactManager.m_contactList;
      }
      SetAllowSleeping(t) {
        if (t !== this.m_allowSleep && (this.m_allowSleep = t, !this.m_allowSleep)) for (let t = this.m_bodyList; t; t = t.m_next) t.SetAwake(!0);
      }
      GetAllowSleeping() {
        return this.m_allowSleep;
      }
      SetWarmStarting(t) {
        this.m_warmStarting = t;
      }
      GetWarmStarting() {
        return this.m_warmStarting;
      }
      SetContinuousPhysics(t) {
        this.m_continuousPhysics = t;
      }
      GetContinuousPhysics() {
        return this.m_continuousPhysics;
      }
      SetSubStepping(t) {
        this.m_subStepping = t;
      }
      GetSubStepping() {
        return this.m_subStepping;
      }
      GetProxyCount() {
        return this.m_contactManager.m_broadPhase.GetProxyCount();
      }
      GetBodyCount() {
        return this.m_bodyCount;
      }
      GetJointCount() {
        return this.m_jointCount;
      }
      GetContactCount() {
        return this.m_contactManager.m_contactCount;
      }
      GetTreeHeight() {
        return this.m_contactManager.m_broadPhase.GetTreeHeight();
      }
      GetTreeBalance() {
        return this.m_contactManager.m_broadPhase.GetTreeBalance();
      }
      GetTreeQuality() {
        return this.m_contactManager.m_broadPhase.GetTreeQuality();
      }
      SetGravity(t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
        if (!it.IsEqualToV(this.m_gravity, t) && (this.m_gravity.Copy(t), e)) for (let t = this.m_bodyList; t; t = t.m_next) t.SetAwake(!0);
      }
      GetGravity() {
        return this.m_gravity;
      }
      IsLocked() {
        return this.m_locked;
      }
      SetAutoClearForces(t) {
        this.m_clearForces = t;
      }
      GetAutoClearForces() {
        return this.m_clearForces;
      }
      ShiftOrigin(t) {
        if (this.IsLocked()) throw new Error();
        for (let e = this.m_bodyList; e; e = e.m_next) e.m_xf.p.SelfSub(t), e.m_sweep.c0.SelfSub(t), e.m_sweep.c.SelfSub(t);
        for (let e = this.m_jointList; e; e = e.m_next) e.ShiftOrigin(t);
        this.m_contactManager.m_broadPhase.ShiftOrigin(t);
      }
      GetContactManager() {
        return this.m_contactManager;
      }
      GetProfile() {
        return this.m_profile;
      }
      Dump(e) {
        if (this.m_locked) return;
        e("const g: b2Vec2 = new b2Vec2(%.15f, %.15f);\n", this.m_gravity.x, this.m_gravity.y), e("this.m_world.SetGravity(g);\n"), e("const bodies: b2Body[] = [];\n"), e("const joints: b2Joint[] = [];\n");
        let i = 0;
        for (let t = this.m_bodyList; t; t = t.m_next) t.m_islandIndex = i, t.Dump(e), ++i;
        i = 0;
        for (let t = this.m_jointList; t; t = t.m_next) t.m_index = i, ++i;
        for (let i = this.m_jointList; i; i = i.m_next) i.m_type !== t.b2JointType.e_gearJoint && (e("{\n"), i.Dump(e), e("}\n"));
        for (let i = this.m_jointList; i; i = i.m_next) i.m_type === t.b2JointType.e_gearJoint && (e("{\n"), i.Dump(e), e("}\n"));
      }
      DrawJoint(e) {
        if (null === this.m_debugDraw) return;
        const i = e.GetBodyA(),
          s = e.GetBodyB(),
          o = i.m_xf,
          n = s.m_xf,
          r = o.p,
          a = n.p,
          l = e.GetAnchorA(Ks.DrawJoint_s_p1),
          m = e.GetAnchorB(Ks.DrawJoint_s_p2),
          h = Ks.DrawJoint_s_color.SetRGB(.5, .8, .8);
        switch (e.m_type) {
          case t.b2JointType.e_distanceJoint:
            this.m_debugDraw.DrawSegment(l, m, h);
            break;
          case t.b2JointType.e_pulleyJoint:
            {
              const t = e,
                i = t.GetGroundAnchorA(),
                s = t.GetGroundAnchorB();
              this.m_debugDraw.DrawSegment(i, l, h), this.m_debugDraw.DrawSegment(s, m, h), this.m_debugDraw.DrawSegment(i, s, h);
              break;
            }
          case t.b2JointType.e_mouseJoint:
            {
              const t = Ks.DrawJoint_s_c;
              t.Set(0, 1, 0), this.m_debugDraw.DrawPoint(l, 4, t), this.m_debugDraw.DrawPoint(m, 4, t), t.Set(.8, .8, .8), this.m_debugDraw.DrawSegment(l, m, t);
              break;
            }
          default:
            this.m_debugDraw.DrawSegment(r, l, h), this.m_debugDraw.DrawSegment(l, m, h), this.m_debugDraw.DrawSegment(a, m, h);
        }
      }
      DrawShape(e, i) {
        if (null === this.m_debugDraw) return;
        const s = e.GetShape();
        switch (s.m_type) {
          case t.b2ShapeType.e_circleShape:
            {
              const t = s,
                e = t.m_p,
                o = t.m_radius,
                n = it.UNITX;
              this.m_debugDraw.DrawSolidCircle(e, o, n, i);
              break;
            }
          case t.b2ShapeType.e_edgeShape:
            {
              const t = s,
                e = t.m_vertex1,
                o = t.m_vertex2;
              this.m_debugDraw.DrawSegment(e, o, i);
              break;
            }
          case t.b2ShapeType.e_chainShape:
            {
              const t = s,
                e = t.m_count,
                o = t.m_vertices,
                n = Ks.DrawShape_s_ghostColor.SetRGBA(.75 * i.r, .75 * i.g, .75 * i.b, i.a);
              let r = o[0];
              if (this.m_debugDraw.DrawPoint(r, 4, i), t.m_hasPrevVertex) {
                const e = t.m_prevVertex;
                this.m_debugDraw.DrawSegment(e, r, n), this.m_debugDraw.DrawCircle(e, .1, n);
              }
              for (let t = 1; t < e; ++t) {
                const e = o[t];
                this.m_debugDraw.DrawSegment(r, e, i), this.m_debugDraw.DrawPoint(e, 4, i), r = e;
              }
              if (t.m_hasNextVertex) {
                const e = t.m_nextVertex;
                this.m_debugDraw.DrawSegment(e, r, n), this.m_debugDraw.DrawCircle(e, .1, n);
              }
              break;
            }
          case t.b2ShapeType.e_polygonShape:
            {
              const t = s,
                e = t.m_count,
                o = t.m_vertices;
              this.m_debugDraw.DrawSolidPolygon(o, e, i);
              break;
            }
        }
      }
      Solve(e) {
        for (let t = this.m_bodyList; t; t = t.m_next) t.m_xf0.Copy(t.m_xf);
        for (let t = this.m_controllerList; t; t = t.m_next) t.Step(e);
        this.m_profile.solveInit = 0, this.m_profile.solveVelocity = 0, this.m_profile.solvePosition = 0;
        const i = this.m_island;
        i.Initialize(this.m_bodyCount, this.m_contactManager.m_contactCount, this.m_jointCount, null, this.m_contactManager.m_contactListener);
        for (let t = this.m_bodyList; t; t = t.m_next) t.m_islandFlag = !1;
        for (let t = this.m_contactManager.m_contactList; t; t = t.m_next) t.m_islandFlag = !1;
        for (let t = this.m_jointList; t; t = t.m_next) t.m_islandFlag = !1;
        const s = this.s_stack;
        for (let o = this.m_bodyList; o; o = o.m_next) {
          if (o.m_islandFlag) continue;
          if (!o.IsAwake() || !o.IsActive()) continue;
          if (o.GetType() === t.b2BodyType.b2_staticBody) continue;
          i.Clear();
          let n = 0;
          for (s[n++] = o, o.m_islandFlag = !0; n > 0;) {
            const e = s[--n];
            if (!e) throw new Error();
            if (i.AddBody(e), e.m_awakeFlag = !0, e.GetType() !== t.b2BodyType.b2_staticBody) {
              for (let t = e.m_contactList; t; t = t.next) {
                const e = t.contact;
                if (e.m_islandFlag) continue;
                if (!e.IsEnabled() || !e.IsTouching()) continue;
                const o = e.m_fixtureA.m_isSensor,
                  r = e.m_fixtureB.m_isSensor;
                if (o || r) continue;
                i.AddContact(e), e.m_islandFlag = !0;
                const a = t.other;
                if (!a) throw new Error();
                a.m_islandFlag || (s[n++] = a, a.m_islandFlag = !0);
              }
              for (let t = e.m_jointList; t; t = t.next) {
                if (t.joint.m_islandFlag) continue;
                const e = t.other;
                e.IsActive() && (i.AddJoint(t.joint), t.joint.m_islandFlag = !0, e.m_islandFlag || (s[n++] = e, e.m_islandFlag = !0));
              }
            }
          }
          const r = new ds();
          i.Solve(r, e, this.m_gravity, this.m_allowSleep), this.m_profile.solveInit += r.solveInit, this.m_profile.solveVelocity += r.solveVelocity, this.m_profile.solvePosition += r.solvePosition;
          for (let e = 0; e < i.m_bodyCount; ++e) {
            const s = i.m_bodies[e];
            s.GetType() === t.b2BodyType.b2_staticBody && (s.m_islandFlag = !1);
          }
        }
        for (let t = 0; t < s.length && s[t]; ++t) s[t] = null;
        const o = new ct();
        for (let e = this.m_bodyList; e; e = e.m_next) e.m_islandFlag && e.GetType() !== t.b2BodyType.b2_staticBody && e.SynchronizeFixtures();
        this.m_contactManager.FindNewContacts(), this.m_profile.broadphase = o.GetMilliseconds();
      }
      SolveTOI(e) {
        const i = this.m_island;
        if (i.Initialize(2 * d, d, 0, null, this.m_contactManager.m_contactListener), this.m_stepComplete) {
          for (let t = this.m_bodyList; t; t = t.m_next) t.m_islandFlag = !1, t.m_sweep.alpha0 = 0;
          for (let t = this.m_contactManager.m_contactList; t; t = t.m_next) t.m_toiFlag = !1, t.m_islandFlag = !1, t.m_toiCount = 0, t.m_toi = 1;
        }
        for (;;) {
          let o = null,
            n = 1;
          for (let e = this.m_contactManager.m_contactList; e; e = e.m_next) {
            if (!e.IsEnabled()) continue;
            if (e.m_toiCount > u) continue;
            let i = 1;
            if (e.m_toiFlag) i = e.m_toi;else {
              const s = e.GetFixtureA(),
                o = e.GetFixtureB();
              if (s.IsSensor() || o.IsSensor()) continue;
              const n = s.GetBody(),
                r = o.GetBody(),
                a = n.m_type,
                l = r.m_type,
                m = n.IsAwake() && a !== t.b2BodyType.b2_staticBody,
                h = r.IsAwake() && l !== t.b2BodyType.b2_staticBody;
              if (!m && !h) continue;
              const _ = n.IsBullet() || a !== t.b2BodyType.b2_dynamicBody,
                c = r.IsBullet() || l !== t.b2BodyType.b2_dynamicBody;
              if (!_ && !c) continue;
              let u = n.m_sweep.alpha0;
              n.m_sweep.alpha0 < r.m_sweep.alpha0 ? (u = r.m_sweep.alpha0, n.m_sweep.Advance(u)) : r.m_sweep.alpha0 < n.m_sweep.alpha0 && (u = n.m_sweep.alpha0, r.m_sweep.Advance(u));
              const d = e.GetChildIndexA(),
                p = e.GetChildIndexB(),
                f = Ks.SolveTOI_s_toi_input;
              f.proxyA.SetShape(s.GetShape(), d), f.proxyB.SetShape(o.GetShape(), p), f.sweepA.Copy(n.m_sweep), f.sweepB.Copy(r.m_sweep), f.tMax = 1;
              const y = Ks.SolveTOI_s_toi_output;
              Me(y, f);
              const x = y.t;
              i = y.state === t.b2TOIOutputState.e_touching ? j(u + (1 - u) * x, 1) : 1, e.m_toi = i, e.m_toiFlag = !0;
            }
            i < n && (o = e, n = i);
          }
          if (null === o || 1 - 10 * s < n) {
            this.m_stepComplete = !0;
            break;
          }
          const r = o.GetFixtureA(),
            a = o.GetFixtureB(),
            l = r.GetBody(),
            m = a.GetBody(),
            h = Ks.SolveTOI_s_backup1.Copy(l.m_sweep),
            _ = Ks.SolveTOI_s_backup2.Copy(m.m_sweep);
          if (l.Advance(n), m.Advance(n), o.Update(this.m_contactManager.m_contactListener), o.m_toiFlag = !1, ++o.m_toiCount, !o.IsEnabled() || !o.IsTouching()) {
            o.SetEnabled(!1), l.m_sweep.Copy(h), m.m_sweep.Copy(_), l.SynchronizeTransform(), m.SynchronizeTransform();
            continue;
          }
          l.SetAwake(!0), m.SetAwake(!0), i.Clear(), i.AddBody(l), i.AddBody(m), i.AddContact(o), l.m_islandFlag = !0, m.m_islandFlag = !0, o.m_islandFlag = !0;
          for (let e = 0; e < 2; ++e) {
            const s = 0 === e ? l : m;
            if (s.m_type === t.b2BodyType.b2_dynamicBody) for (let e = s.m_contactList; e && i.m_bodyCount !== i.m_bodyCapacity && i.m_contactCount !== i.m_contactCapacity; e = e.next) {
              const o = e.contact;
              if (o.m_islandFlag) continue;
              const r = e.other;
              if (r.m_type === t.b2BodyType.b2_dynamicBody && !s.IsBullet() && !r.IsBullet()) continue;
              const a = o.m_fixtureA.m_isSensor,
                l = o.m_fixtureB.m_isSensor;
              if (a || l) continue;
              const m = Ks.SolveTOI_s_backup.Copy(r.m_sweep);
              r.m_islandFlag || r.Advance(n), o.Update(this.m_contactManager.m_contactListener), o.IsEnabled() && o.IsTouching() ? (o.m_islandFlag = !0, i.AddContact(o), r.m_islandFlag || (r.m_islandFlag = !0, r.m_type !== t.b2BodyType.b2_staticBody && r.SetAwake(!0), i.AddBody(r))) : (r.m_sweep.Copy(m), r.SynchronizeTransform());
            }
          }
          const c = Ks.SolveTOI_s_subStep;
          c.dt = (1 - n) * e.dt, c.inv_dt = 1 / c.dt, c.dtRatio = 1, c.positionIterations = 20, c.velocityIterations = e.velocityIterations, c.particleIterations = e.particleIterations, c.warmStarting = !1, i.SolveTOI(c, l.m_islandIndex, m.m_islandIndex);
          for (let e = 0; e < i.m_bodyCount; ++e) {
            const s = i.m_bodies[e];
            if (s.m_islandFlag = !1, s.m_type === t.b2BodyType.b2_dynamicBody) {
              s.SynchronizeFixtures();
              for (let t = s.m_contactList; t; t = t.next) t.contact.m_toiFlag = !1, t.contact.m_islandFlag = !1;
            }
          }
          if (this.m_contactManager.FindNewContacts(), this.m_subStepping) {
            this.m_stepComplete = !1;
            break;
          }
        }
      }
      AddController(t) {
        return t.m_next = this.m_controllerList, t.m_prev = null, this.m_controllerList && (this.m_controllerList.m_prev = t), this.m_controllerList = t, ++this.m_controllerCount, t;
      }
      RemoveController(t) {
        return t.m_prev && (t.m_prev.m_next = t.m_next), t.m_next && (t.m_next.m_prev = t.m_prev), this.m_controllerList === t && (this.m_controllerList = t.m_next), --this.m_controllerCount, t.m_prev = null, t.m_next = null, t;
      }
    }
    Ks.Step_s_step = new ps(), Ks.Step_s_stepTimer = new ct(), Ks.Step_s_timer = new ct(), Ks.DrawDebugData_s_color = new ht(0, 0, 0), Ks.DrawDebugData_s_vs = it.MakeArray(4), Ks.DrawDebugData_s_xf = new lt(), Ks.QueryFixtureShape_s_aabb = new Zt(), Ks.RayCast_s_input = new Ut(), Ks.RayCast_s_output = new Wt(), Ks.RayCast_s_point = new it(), Ks.DrawJoint_s_p1 = new it(), Ks.DrawJoint_s_p2 = new it(), Ks.DrawJoint_s_color = new ht(.5, .8, .8), Ks.DrawJoint_s_c = new ht(), Ks.DrawShape_s_ghostColor = new ht(), Ks.SolveTOI_s_subStep = new ps(), Ks.SolveTOI_s_backup = new mt(), Ks.SolveTOI_s_backup1 = new mt(), Ks.SolveTOI_s_backup2 = new mt(), Ks.SolveTOI_s_toi_input = new de(), Ks.SolveTOI_s_toi_output = new ye();
    class $s {
      constructor(t, e) {
        this.prevBody = null, this.nextBody = null, this.prevController = null, this.nextController = null, this.controller = t, this.body = e;
      }
    }
    class to {
      constructor() {
        this.m_bodyList = null, this.m_bodyCount = 0, this.m_prev = null, this.m_next = null;
      }
      GetNext() {
        return this.m_next;
      }
      GetPrev() {
        return this.m_prev;
      }
      GetBodyList() {
        return this.m_bodyList;
      }
      AddBody(t) {
        const e = new $s(this, t);
        e.nextBody = this.m_bodyList, e.prevBody = null, this.m_bodyList && (this.m_bodyList.prevBody = e), this.m_bodyList = e, ++this.m_bodyCount, e.nextController = t.m_controllerList, e.prevController = null, t.m_controllerList && (t.m_controllerList.prevController = e), t.m_controllerList = e, ++t.m_controllerCount;
      }
      RemoveBody(t) {
        if (this.m_bodyCount <= 0) throw new Error();
        let e = this.m_bodyList;
        for (; e && e.body !== t;) e = e.nextBody;
        if (null === e) throw new Error();
        e.prevBody && (e.prevBody.nextBody = e.nextBody), e.nextBody && (e.nextBody.prevBody = e.prevBody), this.m_bodyList === e && (this.m_bodyList = e.nextBody), --this.m_bodyCount, e.nextController && (e.nextController.prevController = e.prevController), e.prevController && (e.prevController.nextController = e.nextController), t.m_controllerList === e && (t.m_controllerList = e.nextController), --t.m_controllerCount;
      }
      Clear() {
        for (; this.m_bodyList;) this.RemoveBody(this.m_bodyList.body);
        this.m_bodyCount = 0;
      }
    }
    class eo extends to {
      constructor() {
        super(...arguments), this.A = new it(0, 0);
      }
      Step(t) {
        const e = it.MulSV(t.dt, this.A, eo.Step_s_dtA);
        for (let t = this.m_bodyList; t; t = t.nextBody) {
          const i = t.body;
          i.IsAwake() && i.SetLinearVelocity(it.AddVV(i.GetLinearVelocity(), e, it.s_t0));
        }
      }
      Draw(t) {}
    }
    eo.Step_s_dtA = new it();
    class io extends to {
      constructor() {
        super(...arguments), this.G = 1, this.invSqr = !0;
      }
      Step(t) {
        if (this.invSqr) for (let t = this.m_bodyList; t; t = t.nextBody) {
          const e = t.body,
            i = e.GetWorldCenter(),
            o = e.GetMass();
          for (let n = this.m_bodyList; n && n !== t; n = n.nextBody) {
            const t = n.body,
              r = t.GetWorldCenter(),
              a = t.GetMass(),
              l = r.x - i.x,
              m = r.y - i.y,
              h = l * l + m * m;
            if (h < s) continue;
            const _ = io.Step_s_f.Set(l, m);
            _.SelfMul(this.G / h / H(h) * o * a), e.IsAwake() && e.ApplyForce(_, i), t.IsAwake() && t.ApplyForce(_.SelfMul(-1), r);
          }
        } else for (let t = this.m_bodyList; t; t = t.nextBody) {
          const e = t.body,
            i = e.GetWorldCenter(),
            o = e.GetMass();
          for (let n = this.m_bodyList; n && n !== t; n = n.nextBody) {
            const t = n.body,
              r = t.GetWorldCenter(),
              a = t.GetMass(),
              l = r.x - i.x,
              m = r.y - i.y,
              h = l * l + m * m;
            if (h < s) continue;
            const _ = io.Step_s_f.Set(l, m);
            _.SelfMul(this.G / h * o * a), e.IsAwake() && e.ApplyForce(_, i), t.IsAwake() && t.ApplyForce(_.SelfMul(-1), r);
          }
        }
      }
      Draw(t) {}
    }
    io.Step_s_f = new it();
    class so extends to {
      constructor() {
        super(...arguments), this.T = new nt(), this.maxTimestep = 0;
      }
      Step(t) {
        let e = t.dt;
        if (!(e <= s)) {
          e > this.maxTimestep && this.maxTimestep > 0 && (e = this.maxTimestep);
          for (let t = this.m_bodyList; t; t = t.nextBody) {
            const i = t.body;
            if (!i.IsAwake()) continue;
            const s = i.GetWorldVector(nt.MulMV(this.T, i.GetLocalVector(i.GetLinearVelocity(), it.s_t0), it.s_t1), so.Step_s_damping);
            i.SetLinearVelocity(it.AddVV(i.GetLinearVelocity(), it.MulSV(e, s, it.s_t0), it.s_t1));
          }
        }
      }
      Draw(t) {}
      SetAxisAligned(t, e) {
        this.T.ex.x = -t, this.T.ex.y = 0, this.T.ey.x = 0, this.T.ey.y = -e, this.maxTimestep = t > 0 || e > 0 ? 1 / N(t, e) : 0;
      }
    }
    so.Step_s_damping = new it();
    class oo {
      constructor() {
        this.m_count = 0, this.m_ps = [], this.m_p0s = [], this.m_vs = [], this.m_ims = [], this.m_Ls = [], this.m_as = [], this.m_gravity = new it(), this.m_damping = 0, this.m_k2 = 1, this.m_k3 = .1;
      }
      GetVertexCount() {
        return this.m_count;
      }
      GetVertices() {
        return this.m_ps;
      }
      Initialize(t) {
        this.m_count = t.count, this.m_ps = it.MakeArray(this.m_count), this.m_p0s = it.MakeArray(this.m_count), this.m_vs = it.MakeArray(this.m_count), this.m_ims = q(this.m_count);
        for (let e = 0; e < this.m_count; ++e) {
          this.m_ps[e].Copy(t.vertices[e]), this.m_p0s[e].Copy(t.vertices[e]), this.m_vs[e].SetZero();
          const i = t.masses[e];
          this.m_ims[e] = i > 0 ? 1 / i : 0;
        }
        const e = this.m_count - 1,
          i = this.m_count - 2;
        this.m_Ls = q(e), this.m_as = q(i);
        for (let t = 0; t < e; ++t) {
          const e = this.m_ps[t],
            i = this.m_ps[t + 1];
          this.m_Ls[t] = it.DistanceVV(e, i);
        }
        for (let t = 0; t < i; ++t) {
          const e = this.m_ps[t],
            i = this.m_ps[t + 1],
            s = this.m_ps[t + 2],
            o = it.SubVV(i, e, it.s_t0),
            n = it.SubVV(s, i, it.s_t1),
            r = it.CrossVV(o, n),
            a = it.DotVV(o, n);
          this.m_as[t] = et(r, a);
        }
        this.m_gravity.Copy(t.gravity), this.m_damping = t.damping, this.m_k2 = t.k2, this.m_k3 = t.k3;
      }
      Step(t, e) {
        if (0 === t) return;
        const i = Math.exp(-t * this.m_damping);
        for (let e = 0; e < this.m_count; ++e) this.m_p0s[e].Copy(this.m_ps[e]), this.m_ims[e] > 0 && this.m_vs[e].SelfMulAdd(t, this.m_gravity), this.m_vs[e].SelfMul(i), this.m_ps[e].SelfMulAdd(t, this.m_vs[e]);
        for (let t = 0; t < e; ++t) this.SolveC2(), this.SolveC3(), this.SolveC2();
        const s = 1 / t;
        for (let t = 0; t < this.m_count; ++t) it.MulSV(s, it.SubVV(this.m_ps[t], this.m_p0s[t], it.s_t0), this.m_vs[t]);
      }
      SolveC2() {
        const t = this.m_count - 1;
        for (let e = 0; e < t; ++e) {
          const t = this.m_ps[e],
            i = this.m_ps[e + 1],
            s = it.SubVV(i, t, oo.s_d),
            o = s.Normalize(),
            n = this.m_ims[e],
            r = this.m_ims[e + 1];
          if (n + r === 0) continue;
          const a = n / (n + r),
            l = r / (n + r);
          t.SelfMulSub(this.m_k2 * a * (this.m_Ls[e] - o), s), i.SelfMulAdd(this.m_k2 * l * (this.m_Ls[e] - o), s);
        }
      }
      SetAngle(t) {
        const e = this.m_count - 2;
        for (let i = 0; i < e; ++i) this.m_as[i] = t;
      }
      SolveC3() {
        const t = this.m_count - 2;
        for (let e = 0; e < t; ++e) {
          const t = this.m_ps[e],
            i = this.m_ps[e + 1],
            s = this.m_ps[e + 2],
            o = this.m_ims[e],
            r = this.m_ims[e + 1],
            a = this.m_ims[e + 2],
            l = it.SubVV(i, t, oo.s_d1),
            m = it.SubVV(s, i, oo.s_d2),
            h = l.LengthSquared(),
            _ = m.LengthSquared();
          if (h * _ == 0) continue;
          const c = it.CrossVV(l, m),
            u = it.DotVV(l, m);
          let d = et(c, u);
          const p = it.MulSV(-1 / h, l.SelfSkew(), oo.s_Jd1),
            f = it.MulSV(1 / _, m.SelfSkew(), oo.s_Jd2),
            y = it.NegV(p, oo.s_J1),
            x = it.SubVV(p, f, oo.s_J2),
            B = f;
          let S = o * it.DotVV(y, y) + r * it.DotVV(x, x) + a * it.DotVV(B, B);
          if (0 === S) continue;
          S = 1 / S;
          let b = d - this.m_as[e];
          for (; b > n;) b = (d -= 2 * n) - this.m_as[e];
          for (; b < -n;) b = (d += 2 * n) - this.m_as[e];
          const A = -this.m_k3 * S * b;
          t.SelfMulAdd(o * A, y), i.SelfMulAdd(r * A, x), s.SelfMulAdd(a * A, B);
        }
      }
      Draw(t) {
        const e = new ht(.4, .5, .7);
        for (let i = 0; i < this.m_count - 1; ++i) t.DrawSegment(this.m_ps[i], this.m_ps[i + 1], e);
      }
    }
    oo.s_d = new it(), oo.s_d1 = new it(), oo.s_d2 = new it(), oo.s_Jd1 = new it(), oo.s_Jd2 = new it(), oo.s_J1 = new it(), oo.s_J2 = new it(), t.b2Assert = function (t) {
      for (var _len = arguments.length, e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        e[_key - 1] = arguments[_key];
      }
      if (!t) throw new Error(...e);
    }, t.b2Maybe = e, t.b2_maxFloat = i, t.b2_epsilon = s, t.b2_epsilon_sq = o, t.b2_pi = n, t.b2_maxManifoldPoints = r, t.b2_maxPolygonVertices = a, t.b2_aabbExtension = l, t.b2_aabbMultiplier = m, t.b2_linearSlop = h, t.b2_angularSlop = _, t.b2_polygonRadius = c, t.b2_maxSubSteps = u, t.b2_maxTOIContacts = d, t.b2_velocityThreshold = p, t.b2_maxLinearCorrection = f, t.b2_maxAngularCorrection = y, t.b2_maxTranslation = x, t.b2_maxTranslationSquared = B, t.b2_maxRotation = S, t.b2_maxRotationSquared = b, t.b2_baumgarte = A, t.b2_toiBaumgarte = C, t.b2_invalidParticleIndex = V, t.b2_maxParticleIndex = 2147483647, t.b2_particleStride = g, t.b2_minParticleWeight = w, t.b2_maxParticlePressure = v, t.b2_maxParticleForce = M, t.b2_maxTriadDistance = 2, t.b2_maxTriadDistanceSquared = P, t.b2_minParticleSystemBufferCapacity = I, t.b2_barrierCollisionTime = G, t.b2_timeToSleep = D, t.b2_linearSleepTolerance = F, t.b2_angularSleepTolerance = T, t.b2Alloc = function (t) {
      return null;
    }, t.b2Free = function (t) {}, t.b2Log = function (t) {}, t.b2Version = L, t.b2_version = R, t.b2_branch = "master", t.b2_commit = "fbf51801d80fc389d43dc46524520e89043b6faf", t.b2ParseInt = function (t) {
      return parseInt(t, 10);
    }, t.b2ParseUInt = function (t) {
      return Math.abs(parseInt(t, 10));
    }, t.b2MakeArray = k, t.b2MakeNullArray = function (t) {
      const e = [];
      for (let i = 0; i < t; ++i) e.push(null);
      return e;
    }, t.b2MakeNumberArray = q, t.b2_pi_over_180 = z, t.b2_180_over_pi = E, t.b2_two_pi = J, t.b2Abs = O, t.b2Min = j, t.b2Max = N, t.b2Clamp = X, t.b2Swap = function (t, e) {
      const i = t[0];
      t[0] = e[0], e[0] = i;
    }, t.b2IsValid = U, t.b2Sq = W, t.b2InvSqrt = Z, t.b2Sqrt = H, t.b2Pow = Q, t.b2DegToRad = function (t) {
      return t * z;
    }, t.b2RadToDeg = function (t) {
      return t * E;
    }, t.b2Cos = Y, t.b2Sin = K, t.b2Acos = $, t.b2Asin = tt, t.b2Atan2 = et, t.b2NextPowerOfTwo = function (t) {
      return t |= t >> 1 & 2147483647, t |= t >> 2 & 1073741823, t |= t >> 4 & 268435455, t |= t >> 8 & 16777215, 1 + (t |= t >> 16 & 65535);
    }, t.b2IsPowerOfTwo = function (t) {
      return t > 0 && 0 == (t & t - 1);
    }, t.b2Random = function () {
      return 2 * Math.random() - 1;
    }, t.b2RandomRange = function (t, e) {
      return (e - t) * Math.random() + t;
    }, t.b2Vec2 = it, t.b2Vec2_zero = st, t.b2Vec3 = ot, t.b2Mat22 = nt, t.b2Mat33 = rt, t.b2Rot = at, t.b2Transform = lt, t.b2Sweep = mt, t.b2Color = ht, t.b2Draw = class {
      constructor() {
        this.m_drawFlags = 0;
      }
      SetFlags(t) {
        this.m_drawFlags = t;
      }
      GetFlags() {
        return this.m_drawFlags;
      }
      AppendFlags(t) {
        this.m_drawFlags |= t;
      }
      ClearFlags(t) {
        this.m_drawFlags &= ~t;
      }
    }, t.b2Timer = ct, t.b2Counter = class {
      constructor() {
        this.m_count = 0, this.m_min_count = 0, this.m_max_count = 0;
      }
      GetCount() {
        return this.m_count;
      }
      GetMinCount() {
        return this.m_min_count;
      }
      GetMaxCount() {
        return this.m_max_count;
      }
      ResetCount() {
        const t = this.m_count;
        return this.m_count = 0, t;
      }
      ResetMinCount() {
        this.m_min_count = 0;
      }
      ResetMaxCount() {
        this.m_max_count = 0;
      }
      Increment() {
        this.m_count++, this.m_max_count < this.m_count && (this.m_max_count = this.m_count);
      }
      Decrement() {
        this.m_count--, this.m_min_count > this.m_count && (this.m_min_count = this.m_count);
      }
    }, t.b2GrowableStack = ut, t.b2BlockAllocator = class {}, t.b2StackAllocator = class {}, t.b2ContactFeature = Et, t.b2ContactID = Jt, t.b2ManifoldPoint = Ot, t.b2Manifold = jt, t.b2WorldManifold = Nt, t.b2GetPointStates = function (e, i, s, o) {
      let n;
      for (n = 0; n < s.pointCount; ++n) {
        const i = s.points[n].id,
          r = i.key;
        e[n] = t.b2PointState.b2_removeState;
        for (let i = 0, s = o.pointCount; i < s; ++i) if (o.points[i].id.key === r) {
          e[n] = t.b2PointState.b2_persistState;
          break;
        }
      }
      for (; n < r; ++n) e[n] = t.b2PointState.b2_nullState;
      for (n = 0; n < o.pointCount; ++n) {
        const e = o.points[n].id,
          r = e.key;
        i[n] = t.b2PointState.b2_addState;
        for (let e = 0, o = s.pointCount; e < o; ++e) if (s.points[e].id.key === r) {
          i[n] = t.b2PointState.b2_persistState;
          break;
        }
      }
      for (; n < r; ++n) i[n] = t.b2PointState.b2_nullState;
    }, t.b2ClipVertex = Xt, t.b2RayCastInput = Ut, t.b2RayCastOutput = Wt, t.b2AABB = Zt, t.b2TestOverlapAABB = Ht, t.b2ClipSegmentToLine = Qt, t.b2TestOverlapShape = te, t.b2DistanceProxy = dt, t.b2SimplexCache = pt, t.b2DistanceInput = ft, t.b2DistanceOutput = yt, t.b2ShapeCastInput = class {
      constructor() {
        this.proxyA = new dt(), this.proxyB = new dt(), this.transformA = new lt(), this.transformB = new lt(), this.translationB = new it();
      }
    }, t.b2ShapeCastOutput = class {
      constructor() {
        this.point = new it(), this.normal = new it(), this.lambda = 0, this.iterations = 0;
      }
    }, t.b2_gjk_reset = function () {
      t.b2_gjkCalls = 0, t.b2_gjkIters = 0, t.b2_gjkMaxIters = 0;
    }, t.b2SimplexVertex = xt, t.b2Simplex = Bt, t.b2Distance = Mt, t.b2ShapeCast = function (t, e) {
      t.iterations = 0, t.lambda = 1, t.normal.SetZero(), t.point.SetZero();
      const i = e.proxyA,
        s = e.proxyB,
        o = N(i.m_radius, c),
        n = N(s.m_radius, c),
        r = o + n,
        a = e.transformA,
        l = e.transformB,
        m = e.translationB,
        _ = Pt.Set(0, 0);
      let u = 0;
      const d = It;
      d.m_count = 0;
      const p = d.m_vertices;
      let f = i.GetSupport(at.MulTRV(a.q, it.NegV(m, it.s_t1), it.s_t0)),
        y = lt.MulXV(a, i.GetVertex(f), Gt),
        x = s.GetSupport(at.MulTRV(l.q, m, it.s_t0)),
        B = lt.MulXV(l, s.GetVertex(x), Dt);
      const S = it.SubVV(y, B, Ft),
        b = N(c, r - c),
        A = .5 * h;
      let C = 0;
      for (; C < 20 && O(S.Length() - b) > A;) {
        t.iterations += 1, f = i.GetSupport(at.MulTRV(a.q, it.NegV(S, it.s_t1), it.s_t0)), y = lt.MulXV(a, i.GetVertex(f), Gt), x = s.GetSupport(at.MulTRV(l.q, S, it.s_t0)), B = lt.MulXV(l, s.GetVertex(x), Dt);
        const e = it.SubVV(y, B, Tt);
        S.Normalize();
        const o = it.DotVV(S, e),
          n = it.DotVV(S, m);
        if (o - b > u * n) {
          if (n <= 0) return !1;
          if ((u = (o - b) / n) > 1) return !1;
          _.Copy(S).SelfNeg(), d.m_count = 0;
        }
        const r = p[d.m_count];
        switch (r.indexA = x, r.wA.Copy(B).SelfMulAdd(u, m), r.indexB = f, r.wB.Copy(y), r.w.Copy(r.wB).SelfSub(r.wA), r.a = 1, d.m_count += 1, d.m_count) {
          case 1:
            break;
          case 2:
            d.Solve2();
            break;
          case 3:
            d.Solve3();
        }
        if (3 === d.m_count) return !1;
        d.GetClosestPoint(S), ++C;
      }
      const V = Lt,
        g = Rt;
      return d.GetWitnessPoints(V, g), S.LengthSquared() > 0 && (_.Copy(S).SelfNeg(), _.Normalize()), t.normal.Copy(_), t.lambda = u, t.iterations = C, !0;
    }, t.b2Pair = oe, t.b2BroadPhase = ne, t.b2PairLessThan = re, t.b2TreeNode = ie, t.b2DynamicTree = se, t.b2_toi_reset = function () {
      t.b2_toiTime = 0, t.b2_toiMaxTime = 0, t.b2_toiCalls = 0, t.b2_toiIters = 0, t.b2_toiMaxIters = 0, t.b2_toiRootIters = 0, t.b2_toiMaxRootIters = 0;
    }, t.b2TOIInput = de, t.b2TOIOutput = ye, t.b2SeparationFunction = xe, t.b2TimeOfImpact = Me, t.b2CollideCircles = Ge, t.b2CollidePolygonAndCircle = Le, t.b2CollidePolygons = oi, t.b2CollideEdgeAndCircle = ui, t.b2CollideEdgeAndPolygon = xi, t.b2MassData = Bi, t.b2Shape = Vi, t.b2CircleShape = gi, t.b2PolygonShape = wi, t.b2EdgeShape = vi, t.b2ChainShape = Mi, t.b2Filter = Pi, t.b2FixtureDef = Ii, t.b2FixtureProxy = Gi, t.b2Fixture = Di, t.b2BodyDef = class {
      constructor() {
        this.type = t.b2BodyType.b2_staticBody, this.position = new it(0, 0), this.angle = 0, this.linearVelocity = new it(0, 0), this.angularVelocity = 0, this.linearDamping = 0, this.angularDamping = 0, this.allowSleep = !0, this.awake = !0, this.fixedRotation = !1, this.bullet = !1, this.active = !0, this.userData = null, this.gravityScale = 1;
      }
    }, t.b2Body = Fi, t.b2World = Ks, t.b2DestructionListener = class {
      SayGoodbyeJoint(t) {}
      SayGoodbyeFixture(t) {}
      SayGoodbyeParticleGroup(t) {}
      SayGoodbyeParticle(t, e) {}
    }, t.b2ContactFilter = ms, t.b2ContactImpulse = hs, t.b2ContactListener = _s, t.b2QueryCallback = cs, t.b2RayCastCallback = class {
      ReportFixture(t, e, i, s) {
        return s;
      }
      ReportParticle(t, e, i, s, o) {
        return 0;
      }
      ShouldQueryParticleSystem(t) {
        return !0;
      }
    }, t.b2Island = ws, t.b2Profile = ds, t.b2TimeStep = ps, t.b2Position = fs, t.b2Velocity = ys, t.b2SolverData = xs, t.b2ContactManager = us, t.b2MixFriction = Qi, t.b2MixRestitution = Yi, t.b2ContactEdge = Ki, t.b2Contact = $i, t.b2ContactRegister = as, t.b2ContactFactory = ls, t.g_blockSolve = Bs, t.b2VelocityConstraintPoint = Ss, t.b2ContactVelocityConstraint = bs, t.b2ContactPositionConstraint = As, t.b2ContactSolverDef = Cs, t.b2PositionSolverManifold = Vs, t.b2ContactSolver = gs, t.b2CircleContact = ts, t.b2PolygonContact = es, t.b2PolygonAndCircleContact = is, t.b2EdgeAndCircleContact = ss, t.b2EdgeAndPolygonContact = os, t.b2ChainAndCircleContact = ns, t.b2ChainAndPolygonContact = rs, t.b2Jacobian = class {
      constructor() {
        this.linear = new it(), this.angularA = 0, this.angularB = 0;
      }
      SetZero() {
        return this.linear.SetZero(), this.angularA = 0, this.angularB = 0, this;
      }
      Set(t, e, i) {
        return this.linear.Copy(t), this.angularA = e, this.angularB = i, this;
      }
    }, t.b2JointEdge = Ti, t.b2JointDef = Li, t.b2Joint = Ri, t.b2AreaJointDef = class extends Li {
      constructor() {
        super(t.b2JointType.e_areaJoint), this.bodies = [], this.frequencyHz = 0, this.dampingRatio = 0;
      }
      AddBody(t) {
        this.bodies.push(t), 1 === this.bodies.length ? this.bodyA = t : 2 === this.bodies.length && (this.bodyB = t);
      }
    }, t.b2AreaJoint = zi, t.b2DistanceJointDef = ki, t.b2DistanceJoint = qi, t.b2FrictionJointDef = class extends Li {
      constructor() {
        super(t.b2JointType.e_frictionJoint), this.localAnchorA = new it(), this.localAnchorB = new it(), this.maxForce = 0, this.maxTorque = 0;
      }
      Initialize(t, e, i) {
        this.bodyA = t, this.bodyB = e, this.bodyA.GetLocalPoint(i, this.localAnchorA), this.bodyB.GetLocalPoint(i, this.localAnchorB);
      }
    }, t.b2FrictionJoint = Ei, t.b2GearJointDef = class extends Li {
      constructor() {
        super(t.b2JointType.e_gearJoint), this.ratio = 1;
      }
    }, t.b2GearJoint = Ji, t.b2MotorJointDef = class extends Li {
      constructor() {
        super(t.b2JointType.e_motorJoint), this.linearOffset = new it(0, 0), this.angularOffset = 0, this.maxForce = 1, this.maxTorque = 1, this.correctionFactor = .3;
      }
      Initialize(t, e) {
        this.bodyA = t, this.bodyB = e, this.bodyA.GetLocalPoint(this.bodyB.GetPosition(), this.linearOffset);
        const i = this.bodyA.GetAngle(),
          s = this.bodyB.GetAngle();
        this.angularOffset = s - i;
      }
    }, t.b2MotorJoint = Oi, t.b2MouseJointDef = class extends Li {
      constructor() {
        super(t.b2JointType.e_mouseJoint), this.target = new it(), this.maxForce = 0, this.frequencyHz = 5, this.dampingRatio = .7;
      }
    }, t.b2MouseJoint = ji, t.b2PrismaticJointDef = class extends Li {
      constructor() {
        super(t.b2JointType.e_prismaticJoint), this.localAnchorA = new it(), this.localAnchorB = new it(), this.localAxisA = new it(1, 0), this.referenceAngle = 0, this.enableLimit = !1, this.lowerTranslation = 0, this.upperTranslation = 0, this.enableMotor = !1, this.maxMotorForce = 0, this.motorSpeed = 0;
      }
      Initialize(t, e, i, s) {
        this.bodyA = t, this.bodyB = e, this.bodyA.GetLocalPoint(i, this.localAnchorA), this.bodyB.GetLocalPoint(i, this.localAnchorB), this.bodyA.GetLocalVector(s, this.localAxisA), this.referenceAngle = this.bodyB.GetAngle() - this.bodyA.GetAngle();
      }
    }, t.b2PrismaticJoint = Ni, t.b2_minPulleyLength = 2, t.b2PulleyJointDef = class extends Li {
      constructor() {
        super(t.b2JointType.e_pulleyJoint), this.groundAnchorA = new it(-1, 1), this.groundAnchorB = new it(1, 1), this.localAnchorA = new it(-1, 0), this.localAnchorB = new it(1, 0), this.lengthA = 0, this.lengthB = 0, this.ratio = 1, this.collideConnected = !0;
      }
      Initialize(t, e, i, s, o, n, r) {
        this.bodyA = t, this.bodyB = e, this.groundAnchorA.Copy(i), this.groundAnchorB.Copy(s), this.bodyA.GetLocalPoint(o, this.localAnchorA), this.bodyB.GetLocalPoint(n, this.localAnchorB), this.lengthA = it.DistanceVV(o, i), this.lengthB = it.DistanceVV(n, s), this.ratio = r;
      }
    }, t.b2PulleyJoint = Xi, t.b2RevoluteJointDef = class extends Li {
      constructor() {
        super(t.b2JointType.e_revoluteJoint), this.localAnchorA = new it(0, 0), this.localAnchorB = new it(0, 0), this.referenceAngle = 0, this.enableLimit = !1, this.lowerAngle = 0, this.upperAngle = 0, this.enableMotor = !1, this.motorSpeed = 0, this.maxMotorTorque = 0;
      }
      Initialize(t, e, i) {
        this.bodyA = t, this.bodyB = e, this.bodyA.GetLocalPoint(i, this.localAnchorA), this.bodyB.GetLocalPoint(i, this.localAnchorB), this.referenceAngle = this.bodyB.GetAngle() - this.bodyA.GetAngle();
      }
    }, t.b2RevoluteJoint = Ui, t.b2RopeJointDef = class extends Li {
      constructor() {
        super(t.b2JointType.e_ropeJoint), this.localAnchorA = new it(-1, 0), this.localAnchorB = new it(1, 0), this.maxLength = 0;
      }
    }, t.b2RopeJoint = Wi, t.b2WeldJointDef = class extends Li {
      constructor() {
        super(t.b2JointType.e_weldJoint), this.localAnchorA = new it(), this.localAnchorB = new it(), this.referenceAngle = 0, this.frequencyHz = 0, this.dampingRatio = 0;
      }
      Initialize(t, e, i) {
        this.bodyA = t, this.bodyB = e, this.bodyA.GetLocalPoint(i, this.localAnchorA), this.bodyB.GetLocalPoint(i, this.localAnchorB), this.referenceAngle = this.bodyB.GetAngle() - this.bodyA.GetAngle();
      }
    }, t.b2WeldJoint = Zi, t.b2WheelJointDef = class extends Li {
      constructor() {
        super(t.b2JointType.e_wheelJoint), this.localAnchorA = new it(0, 0), this.localAnchorB = new it(0, 0), this.localAxisA = new it(1, 0), this.enableMotor = !1, this.maxMotorTorque = 0, this.motorSpeed = 0, this.frequencyHz = 2, this.dampingRatio = .7;
      }
      Initialize(t, e, i, s) {
        this.bodyA = t, this.bodyB = e, this.bodyA.GetLocalPoint(i, this.localAnchorA), this.bodyB.GetLocalPoint(i, this.localAnchorB), this.bodyA.GetLocalVector(s, this.localAxisA);
      }
    }, t.b2WheelJoint = Hi, t.b2ControllerEdge = $s, t.b2Controller = to, t.b2BuoyancyController = class extends to {
      constructor() {
        super(...arguments), this.normal = new it(0, 1), this.offset = 0, this.density = 0, this.velocity = new it(0, 0), this.linearDrag = 0, this.angularDrag = 0, this.useDensity = !1, this.useWorldGravity = !0, this.gravity = new it(0, 0);
      }
      Step(t) {
        if (this.m_bodyList) {
          this.useWorldGravity && this.gravity.Copy(this.m_bodyList.body.GetWorld().GetGravity());
          for (let t = this.m_bodyList; t; t = t.nextBody) {
            const e = t.body;
            if (!e.IsAwake()) continue;
            const i = new it(),
              o = new it();
            let n = 0,
              r = 0;
            for (let t = e.GetFixtureList(); t; t = t.m_next) {
              const s = new it(),
                a = t.GetShape().ComputeSubmergedArea(this.normal, this.offset, e.GetTransform(), s);
              n += a, i.x += a * s.x, i.y += a * s.y;
              let l = 0;
              l = this.useDensity ? t.GetDensity() : 1, r += a * l, o.x += a * s.x * l, o.y += a * s.y * l;
            }
            if (i.x /= n, i.y /= n, o.x /= r, o.y /= r, n < s) continue;
            const a = this.gravity.Clone().SelfNeg();
            a.SelfMul(this.density * n), e.ApplyForce(a, o);
            const l = e.GetLinearVelocityFromWorldPoint(i, new it());
            l.SelfSub(this.velocity), l.SelfMul(-this.linearDrag * n), e.ApplyForce(l, i), e.ApplyTorque(-e.GetInertia() / e.GetMass() * n * e.GetAngularVelocity() * this.angularDrag);
          }
        }
      }
      Draw(t) {
        const e = 100,
          i = new it(),
          s = new it();
        i.x = this.normal.x * this.offset + this.normal.y * e, i.y = this.normal.y * this.offset - this.normal.x * e, s.x = this.normal.x * this.offset - this.normal.y * e, s.y = this.normal.y * this.offset + this.normal.x * e;
        const o = new ht(0, 0, .8);
        t.DrawSegment(i, s, o);
      }
    }, t.b2ConstantAccelController = eo, t.b2ConstantForceController = class extends to {
      constructor() {
        super(...arguments), this.F = new it(0, 0);
      }
      Step(t) {
        for (let t = this.m_bodyList; t; t = t.nextBody) {
          const e = t.body;
          e.IsAwake() && e.ApplyForce(this.F, e.GetWorldCenter());
        }
      }
      Draw(t) {}
    }, t.b2GravityController = io, t.b2TensorDampingController = so, t.b2ParticleDef = Ps, t.b2CalculateParticleIterations = Is, t.b2ParticleHandle = Gs, t.b2ParticleGroupDef = Ds, t.b2ParticleGroup = Fs, t.b2GrowableBuffer = Ns, t.b2FixtureParticleQueryCallback = Xs, t.b2ParticleContact = Us, t.b2ParticleBodyContact = Ws, t.b2ParticlePair = Zs, t.b2ParticleTriad = Hs, t.b2ParticleSystemDef = Qs, t.b2ParticleSystem = Ys, t.b2RopeDef = class {
      constructor() {
        this.vertices = [], this.count = 0, this.masses = [], this.gravity = new it(0, 0), this.damping = .1, this.k2 = .9, this.k3 = .1;
      }
    }, t.b2Rope = oo, Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }(e);
}, function (t, e) {
  t.exports = require("react");
}, function (t, e, i) {
  "use strict";

  var s = i(4);
  function o() {}
  function n() {}
  n.resetWarningCache = o, t.exports = function () {
    function t(t, e, i, o, n, r) {
      if (r !== s) {
        var a = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw a.name = "Invariant Violation", a;
      }
    }
    function e() {
      return t;
    }
    t.isRequired = t;
    var i = {
      array: t,
      bool: t,
      func: t,
      number: t,
      object: t,
      string: t,
      symbol: t,
      any: t,
      arrayOf: e,
      element: t,
      elementType: t,
      instanceOf: e,
      node: t,
      objectOf: e,
      oneOf: e,
      oneOfType: e,
      shape: e,
      exact: e,
      checkPropTypes: n,
      resetWarningCache: o
    };
    return i.PropTypes = i, i;
  };
}, function (t, e, i) {
  "use strict";

  t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}, function (t, e, i) {
  "use strict";

  i.r(e);
  var s = i(2),
    o = i.n(s),
    n = i(0),
    r = i.n(n),
    a = i(1),
    l = function (t, e) {
      return t * e;
    },
    m = function (t, e) {
      return t / e;
    },
    h = function (t, e, i, s) {
      return {
        x: t + i / 2,
        y: e + s / 2
      };
    },
    _ = function (t, e, i, s, o, n, r) {
      var a,
        m = function (t, e, i, s) {
          return {
            left: t - i / 2,
            top: e - s / 2
          };
        }(l(s, r), l(o, r), e, i),
        h = m.left,
        _ = m.top,
        c = "translate(".concat(h, "px,").concat(_, "px) rotate(").concat(n, "rad)");
      a = c, t.style.transform = a;
    },
    c = function (t, e, i, s, o) {
      var n = new a.b2BodyDef();
      n.type = a.b2BodyType.b2_staticBody;
      var r = new a.b2FixtureDef();
      r.shape = new a.b2PolygonShape(), r.density = 1, r.friction = .5, r.restitution = 0, r.shape.SetAsBox(m(i / 2, o), m(e / 2, o)), n.position.x = m(i / 2, o), n.position.y = m(e / 2, o);
      var l = s.CreateBody(n).CreateFixture(r);
      l.m_body.SetUserData({
        category: "_LEFT_WALL_"
      }), r.shape.SetAsBox(m(t / 2, o), m(i / 2, o)), n.position.x = m(t / 2, o), n.position.y = m(e, o), (l = s.CreateBody(n).CreateFixture(r)).m_body.SetUserData({
        category: "_BOTTOM_WALL_"
      }), r.shape.SetAsBox(m(t / 2, o), m(i / 2, o)), n.position.x = m(t / 2, o), n.position.y = m(i / 2, o), (l = s.CreateBody(n).CreateFixture(r)).m_body.SetUserData({
        category: "_TOP_WALL_"
      }), r.shape.SetAsBox(m(i / 2, o), m(e / 2, o)), n.position.x = m(t, o), n.position.y = m(e / 2, o), (l = s.CreateBody(n).CreateFixture(r)).m_body.SetUserData({
        category: "_RIGHT_WALL_"
      });
    },
    u = function (t, e, i) {
      return t.TWO_NUMBERS_OPTIONAL ? Array.isArray(t[e]) && 2 == t[e].length && t[e].every(Number.isFinite) ? null : new Error("".concat(e, " needs to be an array of two numbers")) : null;
    };
  function d() {
    return this.contact.GetFixtureA().m_body.GetUserData().category;
  }
  function p() {
    return this.contact.GetFixtureB().m_body.GetUserData().category;
  }
  function f(t) {
    return (f = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }
  function y() {
    return (y = Object.assign || function (t) {
      for (var e = 1; e < arguments.length; e++) {
        var i = arguments[e];
        for (var s in i) Object.prototype.hasOwnProperty.call(i, s) && (t[s] = i[s]);
      }
      return t;
    }).apply(this, arguments);
  }
  function x(t, e) {
    if (null == t) return {};
    var i,
      s,
      o = function (t, e) {
        if (null == t) return {};
        var i,
          s,
          o = {},
          n = Object.keys(t);
        for (s = 0; s < n.length; s++) i = n[s], e.indexOf(i) >= 0 || (o[i] = t[i]);
        return o;
      }(t, e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(t);
      for (s = 0; s < n.length; s++) i = n[s], e.indexOf(i) >= 0 || Object.prototype.propertyIsEnumerable.call(t, i) && (o[i] = t[i]);
    }
    return o;
  }
  function B(t, e) {
    for (var i = 0; i < e.length; i++) {
      var s = e[i];
      s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(t, s.key, s);
    }
  }
  function S(t) {
    return (S = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    })(t);
  }
  function b(t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
  }
  function A(t, e) {
    return (A = Object.setPrototypeOf || function (t, e) {
      return t.__proto__ = e, t;
    })(t, e);
  }
  function C(t, e, i) {
    return e in t ? Object.defineProperty(t, e, {
      value: i,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = i, t;
  }
  var V = o.a.createContext(),
    g = V.Provider,
    w = (V.Consumer, function (t) {
      function e(t) {
        var i, s, o;
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, e), s = this, o = S(e).call(this, t), i = !o || "object" !== f(o) && "function" != typeof o ? b(s) : o, C(b(i), "renderPhysics", function () {
          for (var t = i.world.m_bodyList; t; t = t.m_next) if (t.IsAwake()) {
            var e = t.GetUserData();
            if (e && e.dom) if (e.removed) i.world.DestroyBody(t);else {
              var s = t.GetPosition(),
                o = s.x,
                n = s.y,
                r = t.GetAngle();
              e.rc && _(e.dom, e.rc.width, e.rc.height, o, n, r, i.SCALE);
            }
          }
        }), C(b(i), "physLoop", function () {
          i.rafId = void 0, i.world.Step(1 / 60, 10, 10), i.world.ClearForces(), i.renderPhysics(), i.physLoopStart();
        }), C(b(i), "physLoopStart", function () {
          i.rafId || (i.rafId = window.requestAnimationFrame(i.physLoop));
        });
        var n = t.width,
          r = t.height,
          l = t.gravity,
          m = void 0 === l ? [0, 10] : l,
          h = t.allowSleep,
          u = void 0 === h || h,
          y = t.scaleFactor,
          B = void 0 === y ? 60 : y,
          A = t.enclosed,
          V = void 0 === A || A,
          g = t.enclosureThickness,
          w = void 0 === g ? 3 : g,
          v = (t.children, t.style),
          M = void 0 === v ? {} : v,
          P = x(t, ["width", "height", "gravity", "allowSleep", "scaleFactor", "enclosed", "enclosureThickness", "children", "style"]);
        i.restProps = P, i.SCALE = B, i.world = new a.b2World(new a.b2Vec2(m[0], m[1]), u), window.world = i.world, V && c(n, r, w, i.world, i.SCALE), i.worldChangeStatus = 0, i._contactCbProcess = function (t, e) {
          var s = i.SCALE,
            o = t.GetFixtureA().m_body.GetUserData();
          o && (o[e] = !0);
          var n = {
            SCALE: s,
            contact: t
          };
          o && o.rc && o.rc.props[e] && (n.getOthersCategory = p, o.rc.props[e](n));
          var r = t.GetFixtureB().m_body.GetUserData();
          r && (r[e] = !0), r && r.rc && r.rc.props[e] && (n.getOthersCategory = d, r.rc.props[e](n));
        }, i._contactListener = {
          BeginContact: function (t) {
            i._contactCbProcess(t, "onBeginContact");
          },
          EndContact: function (t) {
            i._contactCbProcess(t, "onEndContact");
          },
          PreSolve: function (t, e) {},
          PostSolve: function (t, e) {}
        }, i.world.SetContactListener(i._contactListener);
        var I = {
          width: n,
          height: r,
          position: "relative",
          overlow: "hidden",
          boxSizing: "border-box",
          padding: w
        };
        return i.worldStyle = function (t) {
          for (var e = 1; e < arguments.length; e++) {
            var i = null != arguments[e] ? arguments[e] : {},
              s = Object.keys(i);
            "function" == typeof Object.getOwnPropertySymbols && (s = s.concat(Object.getOwnPropertySymbols(i).filter(function (t) {
              return Object.getOwnPropertyDescriptor(i, t).enumerable;
            }))), s.forEach(function (e) {
              C(t, e, i[e]);
            });
          }
          return t;
        }({}, I, M), i;
      }
      var i, n, r;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && A(t, e);
      }(e, s["Component"]), i = e, (n = [{
        key: "componentDidMount",
        value: function () {
          this.physLoopStart();
        }
      }, {
        key: "componentWillUnmount",
        value: function () {
          this.rafId && (window.cancelAnimationFrame(this.rafId), this.rafId = void 0);
        }
      }, {
        key: "render",
        value: function () {
          var t = this.props,
            e = t.className,
            i = void 0 === e ? "Box2dWorld" : e,
            s = t.children;
          return o.a.createElement("div", y({
            className: i
          }, this.restProps, {
            style: this.worldStyle
          }), o.a.createElement(g, {
            value: this
          }, s));
        }
      }]) && B(i.prototype, n), r && B(i, r), e;
    }());
  w.propTypes = {
    width: r.a.number.isRequired,
    height: r.a.number.isRequired,
    gravity: u,
    enclosed: r.a.bool,
    allowSleep: r.a.bool,
    scaleFactor: r.a.number,
    enclosureThickness: r.a.number
  };
  var v = w;
  function M(t) {
    return (M = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }
  function P(t) {
    for (var e = 1; e < arguments.length; e++) {
      var i = null != arguments[e] ? arguments[e] : {},
        s = Object.keys(i);
      "function" == typeof Object.getOwnPropertySymbols && (s = s.concat(Object.getOwnPropertySymbols(i).filter(function (t) {
        return Object.getOwnPropertyDescriptor(i, t).enumerable;
      }))), s.forEach(function (e) {
        q(t, e, i[e]);
      });
    }
    return t;
  }
  function I() {
    return (I = Object.assign || function (t) {
      for (var e = 1; e < arguments.length; e++) {
        var i = arguments[e];
        for (var s in i) Object.prototype.hasOwnProperty.call(i, s) && (t[s] = i[s]);
      }
      return t;
    }).apply(this, arguments);
  }
  function G(t, e) {
    return function (t) {
      if (Array.isArray(t)) return t;
    }(t) || function (t, e) {
      var i = [],
        s = !0,
        o = !1,
        n = void 0;
      try {
        for (var r, a = t[Symbol.iterator](); !(s = (r = a.next()).done) && (i.push(r.value), !e || i.length !== e); s = !0);
      } catch (t) {
        o = !0, n = t;
      } finally {
        try {
          s || null == a.return || a.return();
        } finally {
          if (o) throw n;
        }
      }
      return i;
    }(t, e) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }();
  }
  function D(t, e, i, s, o, n, r) {
    try {
      var a = t[n](r),
        l = a.value;
    } catch (t) {
      return void i(t);
    }
    a.done ? e(l) : Promise.resolve(l).then(s, o);
  }
  function F(t) {
    return function () {
      var e = this,
        i = arguments;
      return new Promise(function (s, o) {
        var n = t.apply(e, i);
        function r(t) {
          D(n, s, o, r, a, "next", t);
        }
        function a(t) {
          D(n, s, o, r, a, "throw", t);
        }
        r(void 0);
      });
    };
  }
  function T(t, e) {
    for (var i = 0; i < e.length; i++) {
      var s = e[i];
      s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(t, s.key, s);
    }
  }
  function L(t) {
    return (L = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    })(t);
  }
  function R(t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
  }
  function k(t, e) {
    return (k = Object.setPrototypeOf || function (t, e) {
      return t.__proto__ = e, t;
    })(t, e);
  }
  function q(t, e, i) {
    return e in t ? Object.defineProperty(t, e, {
      value: i,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = i, t;
  }
  var z = function (t) {
      var e = t.body,
        i = t.gravityScale,
        o = void 0 === i ? 1 : i,
        n = t.sleep,
        r = void 0 === n || n;
      return Object(s.useEffect)(function () {
        e && (e.SetGravityScale(o), e.SetLinearDamping(.8));
      }, [e, o]), Object(s.useEffect)(function () {
        e && e.SetSleepingAllowed(r);
      }, [e, r]), null;
    },
    E = function (t) {
      function e(t) {
        var i, s, o;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, e), s = this, o = L(e).call(this, t), i = !o || "object" !== M(o) && "function" != typeof o ? R(s) : o, q(R(i), "createFixturesForInline", function (t, e, s) {
          for (var o = i.context, n = i.el.getBoundingClientRect(), r = i.el.offsetWidth / 2, l = n.height / 2, h = o.SCALE, _ = Array.from(s).filter(function (t) {
              return t.width > 0 && t.height > 0;
            }), c = n.left, u = (n.top, _[0]), d = 0; d < _.length; d++) {
            var p = _[d],
              f = (p.left - c + (p.right - c)) / 2 - r,
              y = p.top - u.top + p.height / 2 - l;
            t.shape = new a.b2PolygonShape(), t.shape.SetAsBox(m(p.width / 2, h), m(p.height / 2, h), new a.b2Vec2(m(f, h), m(y, h)));
            e.CreateFixture(t);
          }
        }), q(R(i), "physicsInit", F(_regeneratorRuntime.mark(function t() {
          var e, s, o, n, r, l, _, c, u, d, p, f, y, x, B, S, b, A, C, V, g, w, v, M, P, I, G, D, F, T, L, k, q, z, E;
          return _regeneratorRuntime.wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                if (e = i.props, s = e.fixed, o = void 0 !== s && s, n = e.restitution, r = void 0 === n ? .1 : n, l = e.friction, _ = void 0 === l ? .5 : l, c = e.density, u = void 0 === c ? 1 : c, d = e.shape, p = void 0 === d ? "box" : d, f = e.category, y = void 0 === f ? null : f, x = e.data, B = e.width, S = e.height, b = e.left, A = e.top, C = e.initialForce, V = e.initialImpulse, g = e.bullet, w = i.context, (v = new a.b2BodyDef()).type = o ? a.b2BodyType.b2_staticBody : a.b2BodyType.b2_dynamicBody, (M = new a.b2FixtureDef()).shape = new a.b2PolygonShape(), M.density = u, M.friction = _, M.restitution = r, P = w.SCALE, i.el.style.overflow = "visible", I = B || i.el.offsetWidth, G = S || i.el.offsetHeight, D = "left" in i.props ? b : i.el.offsetLeft, F = "top" in i.props ? A : i.el.offsetTop, i.width = I, i.height = G, T = h(D, F, I, G), L = T.x, k = T.y, v.position.x = m(L, w.SCALE), v.position.y = m(k, w.SCALE), q = w.world.CreateBody(v), "box" !== p) {
                  t.next = 23;
                  break;
                }
                (z = i.el.getClientRects()).length > 1 ? (console.log("inline element detected", z), i.createFixturesForInline(M, q, z)) : (M.shape = new a.b2PolygonShape(), M.shape.SetAsBox(m(I / 2, P), m(G / 2, P)), q.CreateFixture(M)), t.next = 32;
                break;
              case 23:
                if ("circle" !== p) {
                  t.next = 31;
                  break;
                }
                if (G == I) {
                  t.next = 26;
                  break;
                }
                throw new Error("For shape circle, height and width should be same");
              case 26:
                M.shape = new a.b2CircleShape(m(G / 2, P)), q.CreateFixture(M), i.setState({
                  circleRadius: G / 2
                }), t.next = 32;
                break;
              case 31:
                throw new Error("Unknown shape ".concat(p, ", only box and circle supported for now"));
              case 32:
                E = {
                  category: y,
                  dom: i.el,
                  rc: R(i)
                }, x && (E.data = x), q.SetUserData(E), i.body = q, g && i.body.SetBullet(g), C && i.applyForce(C), V && i.applyImpulse(V), i.setState({
                  domHeight: G,
                  domWidth: I,
                  physicsInited: !0
                });
              case 40:
              case "end":
                return t.stop();
            }
          }, t);
        }))), q(R(i), "applyForce", function (t) {
          var e = G(t, 2),
            s = e[0],
            o = e[1];
          i.body && i.body.ApplyForce(new a.b2Vec2(s, o), i.body.GetWorldCenter());
        }), q(R(i), "applyImpulse", function (t) {
          var e = G(t, 2),
            s = e[0],
            o = e[1];
          i.body && i.body.ApplyLinearImpulse(new a.b2Vec2(s, o), i.body.GetWorldCenter());
        }), i.state = {
          physicsInited: !1,
          domWidth: null,
          domHeight: null,
          circleRadius: null
        }, i.width = null, i.height = null, i;
      }
      var i, n, r;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && k(t, e);
      }(e, s["Component"]), i = e, (n = [{
        key: "componentWillUnmount",
        value: function () {
          if (this.body) {
            var t = this.body.GetUserData();
            t.removed = !0, this.body.SetUserData(t), this.body.SetAwake(!0);
          }
        }
      }, {
        key: "componentDidMount",
        value: function () {
          "waitFor" in this.props ? this.props.waitFor && this.physicsInit() : this.physicsInit();
        }
      }, {
        key: "componentDidUpdate",
        value: function (t, e) {
          "waitFor" in this.props && (this.state.physicsInited || this.props.waitFor && this.physicsInit());
        }
      }, {
        key: "render",
        value: function () {
          var t = this,
            e = this.state,
            i = e.physicsInited,
            n = e.domHeight,
            r = e.domWidth,
            a = e.circleRadius,
            l = this.props.hideUntil,
            m = void 0 === l || l,
            h = this.props.children.props.style,
            _ = void 0 === h ? {} : h,
            c = i ? {
              position: "absolute",
              display: "block",
              left: 0,
              top: 0,
              height: n,
              width: r,
              willChange: "transform"
            } : m ? {
              visibility: "hidden"
            } : {};
          return i && a && (c.borderRadius = a), o.a.createElement(s.Fragment, null, o.a.createElement(z, I({
            body: this.body
          }, this.props)), o.a.cloneElement(this.props.children, {
            ref: function (e) {
              t.el = e;
            },
            style: P({}, _, c)
          }));
        }
      }]) && T(i.prototype, n), r && T(i, r), e;
    }();
  q(E, "_internalType", "Box2dObject"), E.propTypes = {
    children: r.a.element.isRequired,
    height: r.a.number,
    width: r.a.number,
    left: r.a.number,
    top: r.a.number,
    density: r.a.number,
    friction: r.a.number,
    restitution: r.a.number,
    bullet: r.a.bool,
    onBeginContact: r.a.func,
    onEndContact: r.a.func,
    shape: r.a.oneOf(["circle", "box"]),
    initialForce: u,
    initialImpulse: u,
    category: r.a.string
  }, E.contextType = V;
  var J = E;
  i.d(e, "World", function () {
    return O;
  }), i.d(e, "Item", function () {
    return j;
  });
  var O = v,
    j = J;
  e.default = {
    World: O,
    Item: j
  };
}]);